import { red } from '@material-ui/core/colors';
import { createTheme, makeStyles, useTheme } from '@material-ui/core/styles';
import React, { useState, useCallback, useEffect, useReducer, useRef, Fragment } from 'react';
import Cookies from 'js-cookie';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTranslation, withTranslation } from 'react-i18next';
import clsx from 'clsx';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import { FormControl, InputLabel, Input, InputAdornment, Typography, FormHelperText, Tooltip as Tooltip$1, IconButton as IconButton$1, Dialog as Dialog$1, DialogTitle as DialogTitle$1, DialogContent as DialogContent$1, DialogActions as DialogActions$1, Button as Button$1, CircularProgress, Select as Select$1, MenuItem as MenuItem$1, FormControlLabel as FormControlLabel$1, Switch, Chip, Menu, Card, CardContent, CardActions, TextField, Box as Box$1, FormGroup as FormGroup$1, TableContainer, Paper as Paper$2, Table, TableHead, TableRow, TableCell, TableBody, LinearProgress as LinearProgress$1, OutlinedInput, Checkbox as Checkbox$1, ListItemText, List as List$1, ListItem as ListItem$1, Divider as Divider$1, Fade, FormLabel as FormLabel$1 } from '@material-ui/core';
import Link from '@material-ui/core/Link';
import { KeyboardDateTimePicker, DateTimePicker, MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { Paper as Paper$1 } from '@material-ui/core/';
import Divider from '@material-ui/core/Divider';
import Typography$1 from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import SaveIcon from '@material-ui/icons/Save';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import '@material-ui/icons/BuildOutlined';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import '@material-ui/icons/Visibility';
import Snackbar from '@material-ui/core/Snackbar';
import Alert$2 from '@material-ui/lab/Alert';
import { Dashboard, Visibility, AspectRatio, AddCircleRounded, TrackChanges, ExpandMore, AccessTime, Warning, SettingsOverscanTwoTone, Info } from '@material-ui/icons';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl$1 from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import AccountCircle from '@material-ui/icons/AccountCircle';
import InputAdornment$1 from '@material-ui/core/InputAdornment';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import LinearProgress from '@material-ui/core/LinearProgress';
import MyLocationIcon from '@material-ui/icons/MyLocation';
import PersonIcon from '@material-ui/icons/Person';
import HomeIcon from '@material-ui/icons/Home';
import Select from '@material-ui/core/Select';
import FormLabel from '@material-ui/core/FormLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import CancelIcon from '@material-ui/icons/Cancel';
import TimelineIcon from '@material-ui/icons/Timeline';
import Grid from '@material-ui/core/Grid';
import DoneIcon from '@material-ui/icons/Done';
import { withLeaflet, Path, TileLayer, GeoJSON, FeatureGroup, Popup, MapControl, Marker, Map, LayersControl, Polygon, CircleMarker } from 'react-leaflet';
import ChartComponent, { Line, Pie, Bar, Doughnut } from 'react-chartjs-2';
import L$1, { Browser, Control, DomEvent, DomUtil } from 'leaflet';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import NotListedLocationIcon from '@material-ui/icons/NotListedLocation';
import PieChartIcon from '@material-ui/icons/PieChart';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ImageIcon from '@material-ui/icons/Image';
import DescriptionIcon from '@material-ui/icons/Description';
import 'chartjs-plugin-zoom';
import 'chartjs-chart-box-and-violin-plot';
import { WindRose } from 'react-windrose-chart';
import AppBar from '@material-ui/core/AppBar';
import Chip$1 from '@material-ui/core/Chip';
import FaceIcon from '@material-ui/icons/Face';
import MenuIcon from '@material-ui/icons/Menu';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import Avatar from '@material-ui/core/Avatar';
import LanguageIcon from '@material-ui/icons/Language';
import Control$1 from 'react-leaflet-control';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';
import 'leaflet-svg-shape-markers';
import CircularProgress$1 from '@material-ui/core/CircularProgress';
import '@material-ui/core/Input';
import Box from '@material-ui/core/Box';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useSelector } from 'react-redux';
import 'reselect';
import CanvasLayer from 'react-leaflet-canvas-layer';
import proj4 from 'proj4';
import inside from 'point-in-geopolygon';
import { EditControl } from 'react-leaflet-draw';
import { OpenStreetMapProvider, GeoSearchControl } from 'leaflet-geosearch';
import '@material-ui/core/DialogContentText';
import Icon from '@material-ui/core/Icon';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import Brightness1Icon from '@material-ui/icons/Brightness1';
import ScatterPlotIcon from '@material-ui/icons/ScatterPlot';
import FilterDramaIcon from '@material-ui/icons/FilterDrama';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import Slider from '@material-ui/core/Slider';
import FormGroup from '@material-ui/core/FormGroup';
import Switch$1 from '@material-ui/core/Switch';
import ScheduleIcon from '@material-ui/icons/Schedule';
import CalendarToday from '@material-ui/icons/CalendarToday';
import Checkbox from '@material-ui/core/Checkbox';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import SkipPreviousIcon from '@material-ui/icons/SkipPrevious';
import FastRewindIcon from '@material-ui/icons/FastRewind';
import SkipNextIcon from '@material-ui/icons/SkipNext';
import FastForwardIcon from '@material-ui/icons/FastForward';
import StopIcon from '@material-ui/icons/Stop';
import { Chart as Chart$1 } from 'chart.js';
import 'proj4leaflet';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText$1 from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import CommentIcon from '@material-ui/icons/Comment';
import CloseIcon from '@material-ui/icons/Close';
import RoomIcon from '@material-ui/icons/Room';
import TextField$1 from '@material-ui/core/TextField';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Container from '@material-ui/core/Container';
import { useAriaAppStore as useAriaAppStore$1 } from '@ses-air-solutions/react-common';

var AriaLogo = "aria-logo-trans~QoKOaIyk.png";

var theme = createTheme({
  themeName: 'ARIA Technologies theme',
  palette: {
    primary: {
      main: '#3ba4b3'
    },
    secondary: {
      main: '#84b61e'
    },
    error: {
      main: red.A400
    },
    background: {
      "default": '#fff'
    }
  }
});

var AriaAppStore = {
  title: undefined,
  project: 'ARIAVIEW',
  site: 'NOSDO',
  "case": 'NOSDO',
  timezone: -parseInt(new Date().getTimezoneOffset() / 60),
  withSourcesContribution: true,
  leftPanel: true,
  user: {},
  window_type: 'monitoring',
  map: {},
  controls: {},
  extraction_zones: {},
  measure_zones: {},
  allow_simulation: false,
  chart_type: 'line',
  chart_types: ['line', 'observations', 'meteo', 'sources_contribution', 'line_simulation'],
  services: {
    timeseries: {
      receptors: {
        name: 'points/ts/',
        method: 'POST',
        paths: [],
        observationType: ''
      },
      weather_sensors: {
        name: 'ariaview/observations',
        method: 'GET',
        observationType: 'met'
      },
      emission_sensors: {
        name: 'ariaview/observations',
        method: 'GET',
        observationType: 'aq'
      }
    }
  },
  datasets: [],
  is_atomic: false,
  data_type: 'airq',
  markers_colors: {},
  domain_nesting: {
    xno: 516880,
    yno: 5030640,
    xse: 517760,
    yse: 5029660,
    epsg: 32632
  },
  weather_sensors: [{
    y: 45.427456,
    x: 9.219986,
    id: '1131',
    name: '*VW304  SUEZ'
  }],
  weather_sensor: {},
  weather_monitoring_sensor: {},
  weather_data: undefined,
  emission_sensors: {},
  receptors: {},
  complains: [],
  selectedComplaint: {},
  complain: {
    isFormOpened: false,
    lon: undefined,
    lat: undefined,
    content: undefined
  },
  dataset: {},
  variable: {},
  external_sources: true,
  date: undefined,
  timeframe: undefined,
  klevel: 0,
  timeseries: {
    datedeb: {
      value: new Date(new Date().getTime() - 24 * 60 * 60 * 1000),
      max: new Date()
    },
    datefin: {
      value: new Date(),
      max: new Date(),
      min: new Date(new Date().getTime() - 24 * 60 * 60 * 1000)
    }
  },
  palette: undefined,
  regulations: undefined,
  client: {}
};

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _readOnlyError(name) {
  throw new TypeError("\"" + name + "\" is read-only");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var AriaAppReducer = function AriaAppReducer(state, action) {
  var _extends2;
  switch (action.type) {
    case 'SET_DATA_TYPE_MODIFIER':
      return Object.assign(_extends({}, state), {
        data_type_modifier: _extends({}, state.data_type_modifier, action.value)
      });
    case 'SET_DATATYPE':
      return Object.assign(_extends({}, state), {
        data_type: action.value
      });
    case 'SET_WIND_ANIMATION':
      return Object.assign(_extends({}, state), {
        windAnimation: action.value
      });
    case 'SET_WIND_RESULT':
      return Object.assign(_extends({}, state), {
        windy: action.value
      });
    case 'SET_CLIENT':
      return Object.assign(_extends({}, state), {
        client: action.value
      });
    case 'SET_CLIENT_TOKEN':
      return Object.assign(_extends({}, state), {
        client: _extends({}, state.client, {
          token: action.value
        })
      });
    case 'SET_PROJECT':
      return Object.assign(_extends({}, state), {
        project: action.value
      });
    case 'SET_CASE':
      return Object.assign(_extends({}, state), {
        "case": action.value
      });
    case 'SET_OPACITY':
      return Object.assign(_extends({}, state), {
        map: _extends({}, state.model, {
          opacity: action.value
        })
      });
    case 'SET_WINDOW_TYPE':
      return Object.assign(_extends({}, state), {
        window_type: action.value
      });
    case 'SET_DERIVED_VARIABLE':
      return Object.assign(_extends({}, state), {
        derived_variable: action.value
      });
    case 'SET_KLEVEL':
      return Object.assign(_extends({}, state), {
        klevel: action.value
      });
    case 'SET_DATASETS':
      return Object.assign(_extends({}, state), {
        datasets: action.value
      });
    case 'SET_DATASET':
      return Object.assign(_extends({}, state), {
        dataset: action.value
      });
    case 'SET_VARIABLE':
      return Object.assign(_extends({}, state), {
        variable: action.value
      });
    case 'SET_EXTERNAL_SOURCES':
      return Object.assign(_extends({}, state), {
        external_sources: action.value
      });
    case 'SET_DATE':
      return Object.assign(_extends({}, state), {
        date: action.value
      });
    case 'SET_TIMEFRAME':
      return Object.assign(_extends({}, state), {
        timeframe: action.value
      });
    case 'SET_IS_ATOMIC':
      return Object.assign(_extends({}, state), {
        is_atomic: action.value
      });
    case 'SET_PALETTE':
      return Object.assign(_extends({}, state), {
        palette: action.value
      });
    case 'SET_REGULATIONS':
      return Object.assign(_extends({}, state), {
        regulations: action.value
      });
    case 'SET_WEATHER_SENSORS':
      return Object.assign(_extends({}, state), {
        weather_sensors: action.value
      });
    case 'SET_WEATHER_DATA':
      return Object.assign(_extends({}, state), {
        weather_data: action.value
      });
    case 'SET_EXTRACTION_WEATHER_SENSOR':
      return Object.assign(_extends({}, state), {
        weather_sensor: action.value
      });
    case 'SET_MONITORING_WEATHER_SENSOR':
      return Object.assign(_extends({}, state), {
        weather_monitoring_sensor: action.value
      });
    case 'SET_EMISSION_SENSORS':
      return Object.assign(_extends({}, state), {
        emission_sensors: action.value
      });
    case 'SET_EXTRACTION_ZONES':
      return Object.assign(_extends({}, state), {
        extraction_zones: action.value
      });
    case 'SET_MARKERS_COLORS':
      return Object.assign(_extends({}, state), {
        markers_colors: action.value
      });
    case 'ADD_EXTRACTION_ZONES':
      return Object.assign(_extends({}, state), {
        extraction_zones: _extends({}, state.extraction_zones, {
          infoType: action.value.infoType || state.extraction_zones.infoType,
          type: action.value.type || state.extraction_zones.type,
          features: _extends({}, state.extraction_zones.features, action.value.features),
          layers: _extends({}, state.extraction_zones.layers, action.value.layers)
        })
      });
    case 'ADD_MEASURE_ZONES':
      return Object.assign(_extends({}, state), {
        measure_zones: _extends({}, state.measure_zones, {
          infoType: action.value.infoType || state.measure_zones.infoType,
          type: action.value.type || state.measure_zones.type,
          features: _extends({}, state.measure_zones.features, action.value.features),
          layers: _extends({}, state.measure_zones.layers, action.value.layers)
        })
      });
    case 'SET_CHART_TYPE':
      return Object.assign(_extends({}, state), {
        chart_type: action.value
      });
    case 'SET_OPEN_CHART':
      return Object.assign(_extends({}, state), {
        chart_open: action.value
      });
    case 'SET_COMPLAIN':
      return Object.assign(_extends({}, state), {
        complain: action.value
      });
    case 'SET_SELECTED_COMPLAINT':
      return Object.assign(_extends({}, state), {
        selectedComplaint: action.value
      });
    case 'SET_COMPLAINS':
      return Object.assign(_extends({}, state), {
        complains: action.value
      });
    case 'TOGGLE_COMPLAIN_FORM':
      return Object.assign(_extends({}, state), {
        complain: _extends({}, state.complain, {
          isFormOpened: action.value
        })
      });
    case 'SET_POL_GROUP':
      return Object.assign(_extends({}, state), {
        pol_group: action.value
      });
    case 'SET_TIMESERIES':
      return Object.assign(_extends({}, state), {
        timeseries: action.value
      });
    case 'SET_TIMESERIES_STARTDATE':
      return Object.assign(_extends({}, state), {
        timeseries: _extends({}, state.timeseries, {
          startDate: action.value
        })
      });
    case 'SET_TIMESERIES_ENDDATE':
      return Object.assign(_extends({}, state), {
        timeseries: _extends({}, state.timeseries, {
          endDate: action.value
        })
      });
    case 'SET_RECEPTORS':
      return Object.assign(_extends({}, state), {
        receptors: action.value
      });
    case 'SET_CURRENT_SENSOR':
      return Object.assign(_extends({}, state), {
        currentSensor: action.value
      });
    case 'SET_RECEPTOR_VALUE':
      console.log('action: ', action);
      return Object.assign(_extends({}, state), {
        receptors: _extends({}, state.receptors, (_extends2 = {}, _extends2[action.id] = _extends({}, state.receptors[action.id], {
          value: action.value
        }), _extends2))
      });
    case 'SET_BACKGROUND_POLLUTION_VALUE':
      return Object.assign(_extends({}, state), {
        background_pollution: _extends({}, state.background_pollution, {
          value: action.value
        })
      });
    case 'SET_BACKGROUND_POLLUTION_USED':
      return Object.assign(_extends({}, state), {
        background_pollution: _extends({}, state.background_pollution, {
          used: action.value
        })
      });
    case 'ADD_TASK':
      return Object.assign(_extends({}, state), {
        items: [].concat(state.items, [action.value])
      });
    case 'DELETE_LAST_TASK':
      return Object.assign(_extends({}, state), {
        items: state.items.slice(0, state.items.length - 1)
      });
    default:
      {
        throw new Error("Unsupported action type: " + action.type);
      }
  }
};

var AriaAppStoreContext = React.createContext();
var AriaAppStoreProvider = function AriaAppStoreProvider(_ref) {
  var store = _ref.store,
    reducer = _ref.reducer,
    children = _ref.children;
  var userStore = store || AriaAppStore;
  var userReducer = reducer || AriaAppReducer;
  var _React$useReducer = React.useReducer(userReducer, userStore),
    _store = _React$useReducer[0],
    _dispatch = _React$useReducer[1];
  var value = React.useMemo(function () {
    return [_store, _dispatch];
  }, [_store]);
  return /*#__PURE__*/React.createElement(AriaAppStoreContext.Provider, {
    value: value,
    children: children
  });
};
var useAriaAppStore = function useAriaAppStore() {
  var context = React.useContext(AriaAppStoreContext);
  if (!context) {
    throw new Error("useAriaAppStore must be used within a AriaAppStoreProvider");
  }
  var store = context[0],
    dispatch = context[1];
  return [store, dispatch];
};

var TokenKey = 'Bearer__' + process.env.REACT_APP_PROJECT;
var UserKey = 'UserInfo__' + process.env.REACT_APP_PROJECT;
var UserIdKey = 'UserId__' + process.env.REACT_APP_PROJECT;
var ExpiredTime = 7;
var CookieParams = {
  expires: ExpiredTime
};
if (!process.env.REACT_APP_API_NOT_SECURED) {
  CookieParams['secure'] = 'true';
  CookieParams['samesite'] = 'None';
}
function setUser(user, group) {
  var key = UserKey;
  if (group) {
    key = key + "__" + group;
  }
  console.log('CookieParams: ', CookieParams);
  return Cookies.set(key, user, CookieParams);
}
function getUser(group) {
  var key = UserKey;
  if (group) {
    key = key + "__" + group;
  }
  return Cookies.get(key);
}
function removeUser() {
  return Cookies.remove(UserKey);
}
function getToken(group) {
  var key = TokenKey;
  if (group) {
    key = key + "__" + group;
  }
  return Cookies.get(key);
}
function setToken(token, group) {
  var key = TokenKey;
  if (group) {
    key = key + "__" + group;
  }
  return Cookies.set(key, token, CookieParams);
}
function removeToken() {
  return Cookies.remove(TokenKey);
}

function addAlpha(color, opacity) {
  var _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
  return color + _opacity.toString(16).toUpperCase();
}
var hashCode = function hashCode(str) {
  var hash = 0,
    i,
    chr;
  if (!str) return hash;
  if (str.length === 0) return hash;
  for (i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0;
  }
  return hash;
};
function log(obj, title, type) {
  if (process.env.NODE_ENV === 'development') {
    var ctitle = title ? '%c ' + title + ': ' : '%c Info: ';
    var bkg = 'blue';
    if (type === 'error') {
      bkg = 'red';
    } else if (type === 'warning') {
      bkg = 'orange';
    } else if (type === 'info') {
      bkg = 'green';
    }
    console.log(ctitle, 'color: white;background: ' + bkg + ';padding: 5px;', obj);
  }
}
function getUrlService(service, pp, qp, withoutEncodeURI, withNocache) {
  var _service = service;
  var _baseApi = process.env.REACT_APP_BASE_API;
  var ver;
  if (typeof service !== 'string' && typeof service === 'object') {
    if (service.base) _baseApi = service.base;
    if (!service.name) {
      console.error('sevice.name is undefined!', service);
      _service = undefined;
    } else {
      _service = service.name;
    }
    if (service.version !== undefined) {
      if (typeof service.version === 'string') {
        ver = service.version.length === 0 ? '' : service.version + '/';
      }
    }
  }
  if (ver === undefined) {
    if (!!process.env.REACT_APP_API_VERSION && process.env.REACT_APP_API_VERSION !== 'v1') {
      ver = process.env.REACT_APP_API_VERSION + '/';
    } else {
      ver = '';
    }
  }
  var ps = getPathParam(pp, withoutEncodeURI);
  var qs = '';
  if (typeof qp === 'object') {
    if (!('apikey' in qp)) {
      qs = getQueryParam(_extends({
        apikey: getToken()
      }, qp), withoutEncodeURI);
    } else {
      qs = getQueryParam(_extends({}, qp), withoutEncodeURI);
    }
  } else {
    qs = getQueryParam({
      apikey: getToken(),
      nocache: nocache
    }, withoutEncodeURI);
  }
  var nocache = new Date().getTime();
  var nc = withNocache ? "&nocache=" + nocache : '';
  var url = _baseApi + "/" + ver + _service + "/" + ps + "?" + qs + nc;
  return url;
}
function variableToAtmotrackField(variable) {
  if (variable) {
    return variable === 'PM2.5' ? 'pm25' : variable.toLowerCase();
  }
}
function getColorFromScale(colors, levels, val) {
  var llen = levels.length;
  var clen = colors.length;
  var belowMinColor = 'transparent';
  var aboveMaxColor = '#000';
  var errorColor = '#666';
  var lastCId = clen - 1;
  if (clen < llen - 1 || clen > llen + 1) {
    console.warn('The number of colors has to be equal to the number of levels + 1');
    return errorColor;
  }
  if (clen == llen + 1) {
    belowMinColor = colors[0];
    aboveMaxColor = colors[clen - 1];
    lastCId = clen - 2;
  }
  if (val < levels[0]) return belowMinColor;
  if (val > levels[llen - 1]) return aboveMaxColor;
  var cId = lastCId;
  for (var index = llen - 2; index > 0; index--) {
    if (val >= levels[index]) {
      return colors[cId];
    }
    cId--;
  }
  return colors[cId];
}
function parseTime(time, cFormat, utc) {
  if (utc === void 0) {
    utc = false;
  }
  if (arguments.length === 0) {
    return null;
  }
  var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  var date;
  if (typeof time === 'object') {
    date = time;
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000;
    date = new Date(time);
  }
  var formatObj = {
    y: utc ? date.getUTCFullYear() : date.getFullYear(),
    m: utc ? date.getUTCMonth() + 1 : date.getMonth() + 1,
    d: utc ? date.getUTCDate() : date.getDate(),
    h: utc ? date.getUTCHours() : date.getHours(),
    i: utc ? date.getUTCMinutes() : date.getMinutes(),
    s: utc ? date.getUTCSeconds() : date.getSeconds(),
    a: utc ? date.getUTCDay() : date.getDay()
  };
  var time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, function (result, key) {
    var value = formatObj[key];
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}
function formatTime(time, option) {
  time = +time * 1000;
  var d = new Date(time);
  var now = Date.now();
  var diff = (now - d) / 1000;
  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
  }
}
function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  var search = url.substring(url.lastIndexOf('?') + 1);
  var obj = {};
  var reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, function (rs, $1, $2) {
    var name = decodeURIComponent($1);
    var val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}
function cleanArray(actual) {
  var newArray = [];
  for (var i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
}
function getQueryParam(json, withoutEncodeURI) {
  if (!json) return '';
  return cleanArray(Object.keys(json).map(function (key) {
    if (json[key] === undefined) return '';
    return withoutEncodeURI ? key + '=' + json[key] : encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
  })).join('&');
}
function getPathParam(arr, withoutEncodeURI) {
  if (!arr) return '';
  if (!Array.isArray(arr)) return '';
  if (Array.isArray(arr) && arr.length === 0) return '';
  return arr.map(function (p) {
    return withoutEncodeURI ? p : encodeURIComponent(p);
  }).join('/');
}
function param2Obj(url) {
  var search = url.split('?')[1];
  if (!search) {
    return {};
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
}
function html2Text(val) {
  var div = document.createElement('div');
  div.innerHTML = val;
  return div.textContent || div.innerText;
}
function objectMerge(target, source) {
  if (typeof target !== 'object') {
    target = {};
  }
  if (Array.isArray(source)) {
    return source.slice();
  }
  Object.keys(source).forEach(function (property) {
    var sourceProperty = source[property];
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty);
    } else {
      target[property] = sourceProperty;
    }
  });
  return target;
}
function scrollTo(element, to, duration) {
  if (duration <= 0) return;
  var difference = to - element.scrollTop;
  var perTick = difference / duration * 10;
  setTimeout(function () {
    console.log(new Date());
    element.scrollTop = element.scrollTop + perTick;
    if (element.scrollTop === to) return;
    scrollTo(element, to, duration - 10);
  }, 10);
}
function toggleClass(element, className) {
  if (!element || !className) {
    return;
  }
  var classString = element.className;
  var nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += '' + className;
  } else {
    classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length);
  }
  element.className = classString;
}
var pickerOptions = [{
  text: '今天',
  onClick: function onClick(picker) {
    var end = new Date();
    var start = new Date(new Date().toDateString());
    end.setTime(start.getTime());
    picker.$emit('pick', [start, end]);
  }
}, {
  text: '最近一周',
  onClick: function onClick(picker) {
    var end = new Date(new Date().toDateString());
    var start = new Date();
    start.setTime(end.getTime() - 3600 * 1000 * 24 * 7);
    picker.$emit('pick', [start, end]);
  }
}, {
  text: '最近一个月',
  onClick: function onClick(picker) {
    var end = new Date(new Date().toDateString());
    var start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
    picker.$emit('pick', [start, end]);
  }
}, {
  text: '最近三个月',
  onClick: function onClick(picker) {
    var end = new Date(new Date().toDateString());
    var start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
    picker.$emit('pick', [start, end]);
  }
}];
function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90;
  } else {
    return new Date(new Date().toDateString());
  }
}
function debounce(func, wait, immediate) {
  var timeout, args, context, timestamp, result;
  var later = function later() {
    var last = +new Date() - timestamp;
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    context = this;
    timestamp = +new Date();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }
    return result;
  };
}
function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'shallowClone');
  }
  var targetObj = source.constructor === Array ? [] : {};
  Object.keys(source).forEach(function (keys) {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
}
function uniqueArr(arr) {
  return Array.from(new Set(arr));
}
function meanOfArray(arr) {
  if (!arr || arr.length == 0) return null;
  return arr.reduce(function (a, b) {
    return a + b;
  }, 0) / arr.length;
}
function isEmpty(str) {
  var notEmpty = !!str;
  if (Array.isArray(str)) {
    return !(notEmpty && str.length > 0);
  } else if (typeof str === 'object') {
    return !(notEmpty && Object.keys(str).length > 0);
  } else {
    var _isEmpty = !(notEmpty && typeof str === 'string' && !!str.trim());
    return _isEmpty;
  }
}
function hexToR(h) {
  return parseInt(cutHex(h).substring(0, 2), 16);
}
function hexToG(h) {
  return parseInt(cutHex(h).substring(2, 4), 16);
}
function hexToB(h) {
  return parseInt(cutHex(h).substring(4, 6), 16);
}
function cutHex(h) {
  return h.charAt(0) == '#' ? h.substring(1, 7) : h;
}
function hexToRGB(hex) {
  return ["rgb(" + hexToR(hex) + "," + hexToG(hex) + "," + hexToB(hex) + ")", "rgba(" + hexToR(hex) + "," + hexToG(hex) + "," + hexToB(hex) + ", 0.5)"];
}
function hexToRGBA(hex) {
  return "rgba(" + hexToR(hex) + "," + hexToG(hex) + "," + hexToB(hex) + ", 0.5)";
}

var index = {
  __proto__: null,
  addAlpha: addAlpha,
  hashCode: hashCode,
  log: log,
  getUrlService: getUrlService,
  variableToAtmotrackField: variableToAtmotrackField,
  getColorFromScale: getColorFromScale,
  parseTime: parseTime,
  formatTime: formatTime,
  getQueryObject: getQueryObject,
  cleanArray: cleanArray,
  getQueryParam: getQueryParam,
  getPathParam: getPathParam,
  param2Obj: param2Obj,
  html2Text: html2Text,
  objectMerge: objectMerge,
  scrollTo: scrollTo,
  toggleClass: toggleClass,
  pickerOptions: pickerOptions,
  getTime: getTime,
  debounce: debounce,
  deepClone: deepClone,
  uniqueArr: uniqueArr,
  meanOfArray: meanOfArray,
  isEmpty: isEmpty,
  hexToRGB: hexToRGB,
  hexToRGBA: hexToRGBA
};

function Alert(props) {
  return /*#__PURE__*/React.createElement(Alert$2, _extends({
    elevation: 6,
    variant: "filled"
  }, props));
}
var ReportButton = function ReportButton(_ref) {
  var tooltip = _ref.tooltip,
    icon = _ref.icon,
    downloadUrl = _ref.downloadUrl;
  var classes = useStyles();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _React$useState = React.useState(false),
    openAlert = _React$useState[0],
    setOpenAlert = _React$useState[1];
  var handleClose = function handleClose(event, reason) {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };
  var onClickHandler = React.useCallback(function () {
    var _url = undefined;
    if (typeof downloadUrl === 'function') {
      _url = downloadUrl();
    } else if (typeof downloadUrl === 'string') {
      if (!isEmpty(downloadUrl)) {
        _url = downloadUrl;
      }
    } else {
      console.warn("Download URL is empty !");
    }
    if (_url) {
      fetch(_url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf'
        }
      }).then(function (response) {
        if (response.status === 500) {
          var errmsg = response.statusText;
          return Promise.reject(new Error(errmsg));
        }
        return response.blob();
      }).then(function (blob) {
        var pdfBlob = new Blob([blob], {
          type: 'application/pdf'
        });
        var url = window.URL.createObjectURL(pdfBlob);
        window.open(url, '_blank').focus();
      })["catch"](function (error) {
        setOpenAlert(true);
        console.error(error.toString());
      });
    }
  }, [downloadUrl]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tooltip, {
    title: tooltip
  }, /*#__PURE__*/React.createElement(IconButton, {
    color: "inherit",
    "aria-label": "Report",
    onClick: onClickHandler
  }, icon || /*#__PURE__*/React.createElement(DescriptionOutlinedIcon, null))), /*#__PURE__*/React.createElement(Snackbar, {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    open: openAlert,
    autoHideDuration: 10000,
    onClose: handleClose
  }, /*#__PURE__*/React.createElement(Alert, {
    onClose: handleClose,
    severity: "warning"
  }, t('ControlPanel.Report_not_found'))));
};
var useStyles = makeStyles(function (theme) {
  return {
    root: {}
  };
});
var AriaReportButton = function AriaReportButton(_ref2) {
  var cadence = _ref2.cadence,
    icon = _ref2.icon,
    useAriaStore = _ref2.useAriaStore;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  var store = {};
  if (useAriaStore) {
    var _useAriaAppStore = useAriaAppStore();
    store = _useAriaAppStore[0];
  } else if (useContext) {
    var context = React.useContext(ExportDataContext);
    if (!Array.isArray(context)) {
      throw new Error("AriaDatetimeWindowSelect => ExportDataContext return non array object");
    }
    store = context[0];
  }
  log(store, 'Store in AriaReportButton', 'warning');
  var getDownloadUrl = React.useCallback(function () {
    if (!isEmpty(store['project']) && !isEmpty(store['case']) && !isEmpty(store['variable'])) {
      var qp = {
        date: parseTime(store['date'], '{y}-{m}-{d}'),
        cadence: cadence
      };
      var dUrl = getUrlService("ariaview/report", [store['project'], store['case'], store['variable'] ? store['variableFileMap'][store['variable'].name] : 'undefined'], qp);
      log(dUrl, 'Report download url: ', 'info');
      return dUrl;
    } else {
      return undefined;
    }
  }, [store['project'], store['case'], store['variable'], store['date'], store['variableFileMap'], cadence]);
  return /*#__PURE__*/React.createElement(ReportButton, {
    tooltip: t("ControlPanel.Report_" + cadence),
    icon: icon,
    downloadUrl: getDownloadUrl()
  });
};
AriaReportButton.propTypes = {};

var useStyles$1 = makeStyles(function (theme) {
  return {
    toolbarVertical: {
      marginTop: theme.spacing(2.5),
      padding: theme.spacing(0),
      width: theme.spacing(5),
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'end'
    },
    toolbarHorizontal: {
      padding: theme.spacing(0),
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'end'
    },
    leftGroup: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'start'
    },
    rightGroup: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'end'
    }
  };
});
var AppToolbar = function AppToolbar(_ref) {
  var orientation = _ref.orientation,
    children = _ref.children,
    onClickHideControlPanel = _ref.onClickHideControlPanel,
    onOpenExportControl = _ref.onOpenExportControl,
    drawerIsOpen = _ref.drawerIsOpen,
    helpFilename = _ref.helpFilename,
    infoFilename = _ref.infoFilename,
    buttons = _ref.buttons;
  var classes = useStyles$1();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0],
    dispatch = _useAriaAppStore[1];
  var monthly = false;
  var daily = false;
  var window_type = store['window_type'];
  if (store['reports'] !== undefined) {
    monthly = store['reports'].monthly;
    daily = store['reports'].daily;
  }
  var _React$useState = React.useState(drawerIsOpen),
    openDrawer = _React$useState[0],
    setOpenDrawer = _React$useState[1];
  var onAideClickHandler = React.useCallback(function () {
    window.open(helpFilename || 'Help.pdf', '_blank').focus();
  }, []);
  var onInfoClickHandler = React.useCallback(function () {
    window.open(infoFilename || 'Info.pdf', '_blank').focus();
  }, []);
  var onExportClickHandler = React.useCallback(function () {
    if (typeof onOpenExportControl === 'function') {
      onOpenExportControl();
    }
  }, []);
  var onTooltipClick = function onTooltipClick(type) {
    dispatch({
      type: 'SET_WINDOW_TYPE',
      value: type
    });
    dispatch({
      type: 'SET_OPEN_CHART',
      value: 'TIMEFRAME'
    });
  };
  React.useEffect(function () {
    setOpenDrawer(drawerIsOpen);
  }, [drawerIsOpen]);
  React.useEffect(function () {
    if (window_type === 'dashboard') {
      setOpenDrawer(false);
      onClickHideControlPanel(false);
    }
  }, [window_type]);
  return /*#__PURE__*/React.createElement(Toolbar, {
    className: orientation == 'vertical' ? classes.toolbarVertical : classes.toolbarHorizontal
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.leftGroup
  }, buttons && buttons.indexOf('DashBoard') !== -1 && /*#__PURE__*/React.createElement(Tooltip, {
    title: t("Dashboard.Dashboard")
  }, /*#__PURE__*/React.createElement(IconButton, {
    color: window_type == "dashboard" ? 'inherit' : 'primary',
    onClick: function onClick() {
      return onTooltipClick('dashboard');
    }
  }, /*#__PURE__*/React.createElement(Dashboard, null))), buttons && buttons.indexOf('Monitoring') !== -1 && /*#__PURE__*/React.createElement(Tooltip, {
    title: t("Dashboard.Monitoring")
  }, /*#__PURE__*/React.createElement(IconButton, {
    color: window_type == "monitoring" ? 'inherit' : 'primary',
    onClick: function onClick() {
      return onTooltipClick('monitoring');
    }
  }, /*#__PURE__*/React.createElement(Visibility, null))), buttons && buttons.indexOf('Help') !== -1 && /*#__PURE__*/React.createElement(Tooltip, {
    title: t('ControlPanel.Help')
  }, /*#__PURE__*/React.createElement(IconButton, {
    color: "primary",
    "aria-label": "Aide",
    onClick: onAideClickHandler
  }, /*#__PURE__*/React.createElement(HelpOutlineIcon, null))), buttons && buttons.indexOf('Info') !== -1 && /*#__PURE__*/React.createElement(Tooltip, {
    title: t('ControlPanel.Info')
  }, /*#__PURE__*/React.createElement(IconButton, {
    color: "primary",
    "aria-label": "Info",
    onClick: onInfoClickHandler
  }, /*#__PURE__*/React.createElement(InfoOutlinedIcon, null))), buttons && buttons.indexOf('Report') !== -1 && /*#__PURE__*/React.createElement(React.Fragment, null, daily && /*#__PURE__*/React.createElement(AriaReportButton, {
    icon: /*#__PURE__*/React.createElement(DescriptionOutlinedIcon, null),
    cadence: "daily",
    useAriaStore: true
  }), monthly && /*#__PURE__*/React.createElement(AriaReportButton, {
    icon: /*#__PURE__*/React.createElement(FileCopyOutlinedIcon, null),
    cadence: "monthly",
    useAriaStore: true
  }))), children, buttons && buttons.indexOf('Export') !== -1 && /*#__PURE__*/React.createElement("div", {
    className: classes.rightGroup
  }, /*#__PURE__*/React.createElement(Tooltip, {
    title: t('ControlPanel.Export')
  }, /*#__PURE__*/React.createElement(IconButton, {
    color: "inherit",
    "aria-label": "Export",
    onClick: onExportClickHandler
  }, /*#__PURE__*/React.createElement(SaveIcon, null)))), /*#__PURE__*/React.createElement(Divider, {
    style: {
      width: '100%'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.rightGroup
  }, window_type != 'dashboard' && /*#__PURE__*/React.createElement(Tooltip, {
    title: openDrawer ? t('ControlPanel.Hide_ControlPanel') : t('ControlPanel.Show_ControlPanel')
  }, /*#__PURE__*/React.createElement(IconButton, {
    color: "inherit",
    "aria-label": "Hide-control-panel",
    onClick: function onClick(e) {
      setOpenDrawer(function (x) {
        return !x;
      });
      if (typeof onClickHideControlPanel === 'function') {
        onClickHideControlPanel(!openDrawer);
      }
    }
  }, openDrawer ? /*#__PURE__*/React.createElement(ChevronLeftIcon, null) : /*#__PURE__*/React.createElement(ChevronRightIcon, null)))));
};
AppToolbar.propTypes = {};

var _excluded = ["label", "helperText", "prefix", "fullWidth"];
var useStyles$2 = makeStyles(function (theme) {
  return {
    formControl: {
      margin: theme.spacing(1),
      marginBottom: theme.spacing(2),
      minWidth: '50%'
    }
  };
});
var useField = function useField(_ref) {
  _objectDestructuringEmpty(_ref);
  var field = {};
  var meta = {};
  return [field, meta];
};
var AriaInput = (function (_ref2) {
  var label = _ref2.label,
    helperText = _ref2.helperText,
    prefix = _ref2.prefix,
    fullWidth = _ref2.fullWidth,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded);
  var classes = useStyles$2();
  var _useField = useField(props),
    field = _useField[0],
    meta = _useField[1];
  return /*#__PURE__*/React.createElement(FormControl, {
    fullWidth: fullWidth,
    className: classes.formControl,
    required: true
  }, label && /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: props.id || props.name
  }, label), /*#__PURE__*/React.createElement(Input, _extends({
    required: true,
    id: props.id || props.name,
    startAdornment: prefix && /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption"
    }, prefix))
  }, field, props)), meta.touched && meta.error ? /*#__PURE__*/React.createElement(Typography, {
    color: "error",
    variant: "caption"
  }, meta.error) : null, helperText && /*#__PURE__*/React.createElement(FormHelperText, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption"
  }, helperText)));
});

var _excluded$1 = ["store_key", "radio_type", "label", "options", "selected", "disabled", "fullWidth", "onSelectHandler"];
var useStyles$3 = makeStyles(function (theme) {
  return {
    formControl: {
      margin: theme.spacing(1),
      marginBottom: theme.spacing(2),
      minWidth: '50%'
    },
    select: {
      marginTop: theme.spacing(1)
    }
  };
});
var AriaSelect = (function (_ref) {
  var store_key = _ref.store_key,
    radio_type = _ref.radio_type,
    label = _ref.label,
    options = _ref.options,
    selected = _ref.selected,
    disabled = _ref.disabled,
    fullWidth = _ref.fullWidth,
    onSelectHandler = _ref.onSelectHandler,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  var classes = useStyles$3();
  var _useState = useState(''),
    option = _useState[0],
    setOption = _useState[1];
  var _useAriaAppStore = useAriaAppStore(),
    dispatch = _useAriaAppStore[1];
  var onSelectChangeHandler = useCallback(function (event, options) {
    var selectedOption = event.target.value;
    var gotOption = options.find(function (opt) {
      if (typeof opt === 'object') {
        return opt.value === selectedOption;
      } else {
        return opt === selectedOption;
      }
    });
    setOption(gotOption);
    if (typeof onSelectHandler === 'function') {
      onSelectHandler(selectedOption);
    }
    if (store_key && dispatch) {
      if (!radio_type) {
        dispatch({
          type: "SET_" + store_key.toUpperCase(),
          value: selectedOption
        });
      } else {
        var _value;
        dispatch({
          type: "SET_" + store_key.toUpperCase(),
          value: (_value = {}, _value[radio_type] = selectedOption, _value)
        });
      }
    }
  }, [onSelectHandler]);
  useEffect(function () {
    if (typeof selected === 'string') {
      setOption(selected);
      if (typeof onSelectHandler === 'function') {
        onSelectHandler(selected);
      }
      if (store_key && dispatch) {
        if (!radio_type) {
          dispatch({
            type: "SET_" + store_key.toUpperCase(),
            value: selected
          });
        } else {
          var _value2;
          dispatch({
            type: "SET_" + store_key.toUpperCase(),
            value: (_value2 = {}, _value2[radio_type] = selected, _value2)
          });
        }
      }
    }
  }, [selected]);
  return /*#__PURE__*/React.createElement(FormControl$1, {
    fullWidth: fullWidth,
    className: classes.formControl
  }, label && /*#__PURE__*/React.createElement(FormLabel, {
    htmlFor: "date-model"
  }, label), /*#__PURE__*/React.createElement(Select, _extends({
    className: classes.select,
    disabled: disabled,
    value: typeof option === 'object' ? option.value : option,
    onChange: function onChange(e) {
      return onSelectChangeHandler(e, options);
    },
    inputProps: {
      name: 'date-model',
      id: 'date-model'
    }
  }, props), options.map(function (option, index) {
    if (typeof option === 'object') {
      return /*#__PURE__*/React.createElement(MenuItem, {
        key: index,
        value: option.value
      }, option.label);
    } else if (typeof option === 'string') {
      return /*#__PURE__*/React.createElement(MenuItem, {
        key: index,
        value: option
      }, option);
    }
  })));
});

var useStyles$4 = makeStyles(function (theme) {
  return {
    container: {
      display: 'flex',
      flexWrap: 'wrap'
    },
    formControl: {
      margin: theme.spacing(1),
      marginBottom: theme.spacing(2),
      minWidth: '50%'
    },
    margin: {
      margin: theme.spacing(1)
    },
    radioGroup: {
      display: 'flex',
      justifyContent: 'space-around'
    },
    divider: {
      height: '2px',
      width: '100%',
      marginBottom: theme.spacing(3)
    },
    location: {
      display: 'flex',
      justifyContent: 'space-around',
      marginLeft: theme.spacing(6)
    }
  };
});
function AriaComplainFormDialog(_ref) {
  var title = _ref.title,
    opened = _ref.opened;
  var classes = useStyles$4();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _React$useState = React.useState(undefined),
    error = _React$useState[0],
    setError = _React$useState[1];
  var _React$useState2 = React.useState(false),
    isLoading = _React$useState2[0],
    setIsLoading = _React$useState2[1];
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0],
    dispatch = _useAriaAppStore[1];
  var complainFormIsOpened = store['complain'] ? store['complain'].isFormOpened : false;
  var complainLon = store['complain'] ? store['complain'].lon : undefined;
  var complainLat = store['complain'] ? store['complain'].lat : undefined;
  var frmObj = React.useRef(null);
  var _React$useState3 = React.useState(opened || false),
    open = _React$useState3[0],
    setOpen = _React$useState3[1];
  var _React$useState4 = React.useState(new Date()),
    selectedDate = _React$useState4[0],
    setSelectedDate = _React$useState4[1];
  var _React$useState5 = React.useState('complain'),
    complainType = _React$useState5[0],
    setComplainType = _React$useState5[1];
  var handleComplainTypeChange = function handleComplainTypeChange(event) {
    setComplainType(event.target.value);
  };
  var handleClickOK = React.useCallback(function (e) {
    setError(false);
    if (frmObj && frmObj.current) {
      var frmData = new FormData(frmObj.current);
      log(frmData.get('email'), "COMPLAIN FORM DATA");
      log(frmData.get('comment'), "COMPLAIN FORM DATA");
      setIsLoading(true);
      var qp = {};
      var pp;
      if (process.env.REACT_APP_API_VERSION !== 'v1') {
        pp = [];
      }
      var frmDataObj = {};
      frmData.forEach(function (value, key) {
        frmDataObj[key] = value;
      });
      if (!('start_date' in frmDataObj)) {
        frmDataObj['start_date'] = selectedDate;
      }
      log(selectedDate, "selectedDate");
      frmDataObj['start_date'] = parseTime(selectedDate, '{y}-{m}-{d} {h}:{i}:{s}', true);
      frmDataObj['client'] = process.env.REACT_APP_CLIENT_NAME;
      var _url = getUrlService('ariaview/complains', pp, qp);
      log(_url, 'Call service add complain');
      log(frmDataObj, 'Form complain data');
      if (Object.values(frmDataObj).includes('')) {
        log(frmDataObj, 'EMPTY FORM FIELD');
        setIsLoading(false);
        setError(true);
      } else {
        fetch(_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json; charset=UTF-8'
          },
          body: JSON.stringify(frmDataObj)
        }).then(function (response) {
          return response.json();
        }).then(function (json) {
          setIsLoading(false);
          log(json);
          if (json.data.comment) {
            dispatch({
              type: 'SET_COMPLAIN',
              value: _extends({
                isFormOpened: false
              }, json.data)
            });
            setError(false);
          }
        })["catch"](function (error) {
          setError(error.toString());
          setIsLoading(false);
        });
      }
    }
  }, [frmObj, selectedDate]);
  var handleClickCancel = React.useCallback(function (e) {
    setError(false);
    dispatch({
      type: 'TOGGLE_COMPLAIN_FORM',
      value: false
    });
  }, []);
  var handleClose = function handleClose() {
    dispatch({
      type: 'TOGGLE_COMPLAIN_FORM',
      value: false
    });
  };
  var handleDateChange = function handleDateChange(d) {
    if (d) {
      setSelectedDate(d.toDate());
    }
  };
  React.useEffect(function () {
    setOpen(complainFormIsOpened);
  }, [complainFormIsOpened]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Dialog, {
    disableEscapeKeyDown: true,
    open: open,
    onClose: handleClose
  }, /*#__PURE__*/React.createElement(DialogTitle, null, title), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement("form", {
    className: classes.container,
    ref: frmObj
  }, /*#__PURE__*/React.createElement(FormControl$1, {
    fullWidth: true,
    className: classes.formControl
  }, /*#__PURE__*/React.createElement(RadioGroup, {
    name: "type",
    className: classes.radioGroup,
    row: true,
    "aria-label": "position",
    value: complainType,
    onChange: handleComplainTypeChange
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "complain",
    control: /*#__PURE__*/React.createElement(Radio, null),
    label: t("Complain.Complain"),
    labelPlacement: "start"
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "maintenance",
    control: /*#__PURE__*/React.createElement(Radio, null),
    label: t("Complain.Maintenance"),
    labelPlacement: "start"
  }))), /*#__PURE__*/React.createElement(Divider, {
    className: classes.divider
  }), /*#__PURE__*/React.createElement(FormControl$1, {
    fullWidth: true,
    className: classes.formControl
  }, /*#__PURE__*/React.createElement(KeyboardDateTimePicker, {
    disableToolbar: true,
    autoOk: true,
    name: "start_date",
    variant: "inline",
    ampm: false,
    label: t("Complain.Start_date"),
    value: selectedDate,
    onChange: handleDateChange,
    onError: console.log,
    format: "yyyy-MM-DD HH:mm:ss"
  })), /*#__PURE__*/React.createElement(AriaInput, {
    fullWidth: true,
    label: t('Complain.Observer_name'),
    name: 'observer_name',
    type: 'text',
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment$1, {
      position: "start"
    }, /*#__PURE__*/React.createElement(PersonIcon, null))
  }), /*#__PURE__*/React.createElement(AriaInput, {
    fullWidth: true,
    label: t('Complain.Address'),
    name: 'address',
    type: 'text',
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment$1, {
      position: "start"
    }, /*#__PURE__*/React.createElement(HomeIcon, null))
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.location
  }, /*#__PURE__*/React.createElement(AriaInput, {
    label: t('Complain.Latitude'),
    name: 'lat',
    type: 'number',
    prefix: '°',
    value: complainLat,
    readOnly: true,
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment$1, {
      position: "start"
    }, /*#__PURE__*/React.createElement(MyLocationIcon, null))
  }), /*#__PURE__*/React.createElement(AriaInput, {
    label: t('Complain.Longitude'),
    name: 'lon',
    type: 'number',
    value: complainLon,
    prefix: '°',
    readOnly: true,
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment$1, {
      position: "start"
    }, /*#__PURE__*/React.createElement(MyLocationIcon, null))
  })), /*#__PURE__*/React.createElement(AriaInput, {
    fullWidth: true,
    label: t('Complain.Comment'),
    name: 'comment',
    type: 'textarea',
    multiline: true,
    minRows: 2,
    maxRows: 4,
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment$1, {
      position: "start"
    }, /*#__PURE__*/React.createElement(AccountCircle, null))
  }))), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(Button, {
    onClick: handleClickCancel,
    color: "primary"
  }, t('Complain.Cancel')), /*#__PURE__*/React.createElement(Button, {
    onClick: handleClickOK,
    color: "primary"
  }, t('Complain.OK'))), isLoading ? /*#__PURE__*/React.createElement(LinearProgress, {
    className: classes.linearProgress
  }) : error && /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, "Form Incorrectly Filled: All Fields required")));
}

var useStyles$5 = makeStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      justifyContent: 'space-around',
      marginBottom: theme.spacing(1.5),
      marginTop: theme.spacing(1)
    },
    formControl: {
      margin: theme.spacing(1),
      marginBottom: theme.spacing(1),
      width: '100%',
      minWidth: '50%'
    },
    pickers: {
      margin: theme.spacing(0)
    },
    alignCenter: {
      textAlign: 'center'
    },
    alignLeft: {
      textAlign: 'left'
    },
    alignRight: {
      textAlign: 'right'
    },
    selectEmpty: {
      marginTop: theme.spacing(2)
    },
    hidden: {
      display: 'None'
    }
  };
});
var AriaDatetimeWindowSelect = (function (_ref) {
  var disabled = _ref.disabled,
    idatedeb = _ref.idatedeb,
    idatefin = _ref.idatefin,
    autoOK = _ref.autoOK,
    onChangeCallback = _ref.onChangeCallback,
    onValidateCallback = _ref.onValidateCallback,
    useAriaStore = _ref.useAriaStore;
  var classes = useStyles$5();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var store = {},
    dispatch = undefined;
  if (useAriaStore) {
    var _useAriaAppStore = useAriaAppStore();
    store = _useAriaAppStore[0];
    dispatch = _useAriaAppStore[1];
  }
  log(store, 'Store in AriaDatetimeWindowSelect');
  var _useState = useState(idatedeb || {}),
    datedeb = _useState[0],
    setDatedeb = _useState[1];
  var _useState2 = useState(idatefin || {}),
    datefin = _useState2[0],
    setDatefin = _useState2[1];
  var _React$useState = React.useState(disabled),
    datesHasModified = _React$useState[0],
    setDatesHasModified = _React$useState[1];
  if (!isEmpty(store)) {
    if (!store['timeseries']) throw new Error("[timeseries] in not present in the store!");
    React.useEffect(function () {
      setDatedeb(store['timeseries'].datedeb);
    }, [store['timeseries'].datedeb]);
    React.useEffect(function () {
      setDatefin(store['timeseries'].datefin);
    }, [store['timeseries'].datefin]);
  }
  var dateChangeHandler = function dateChangeHandler(type) {
    return function (selectedDate) {
      log(selectedDate.toDate(), 'Selected date onChange handler: ');
      if (type == 'datedeb') {
        setDatedeb(function (d) {
          return _extends({}, d, {
            value: selectedDate.toDate()
          });
        });
        setDatefin(function (d) {
          return _extends({}, d, {
            min: selectedDate.toDate()
          });
        });
      } else if (type == 'datefin') {
        setDatedeb(function (d) {
          return _extends({}, d, {
            max: selectedDate.toDate()
          });
        });
        setDatefin(function (d) {
          return _extends({}, d, {
            value: selectedDate.toDate()
          });
        });
      }
      setDatesHasModified(true);
    };
  };
  var onDateWidgetCloseHandler = React.useCallback(function (type) {
    return function () {
      log(type, "onDateWidgetCloseHandler");
      if (autoOK) {
        if (typeof onChangeCallback === 'function') {
          onChangeCallback(datedeb, datefin);
        }
        if (!!dispatch) {
          dispatch({
            type: 'SET_TIMESERIES',
            value: {
              datedeb: datedeb,
              datefin: datefin
            }
          });
        }
        setDatesHasModified(false);
      }
    };
  }, [datedeb, datefin, autoOK]);
  var validateHandler = React.useCallback(function () {
    if (!autoOK) {
      if (!!dispatch) {
        dispatch({
          type: 'SET_TIMESERIES',
          value: {
            datedeb: datedeb,
            datefin: datefin
          }
        });
      }
      if (typeof onChangeCallback === 'function') {
        onValidateCallback();
      }
      setDatesHasModified(false);
    }
  }, [autoOK, datedeb, datefin]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(DateTimePicker, {
    style: {
      maxWidth: '150px'
    },
    inputVariant: "outlined",
    variant: "inline",
    label: t("Chart.Start_date"),
    disableToolbar: true,
    disabled: disabled,
    autoOk: true,
    minutesStep: 60,
    ampm: false,
    value: datedeb.value,
    onChange: dateChangeHandler('datedeb'),
    onClose: onDateWidgetCloseHandler('datedeb'),
    onError: console.log,
    minDate: datedeb.min,
    maxDate: datedeb.max,
    format: "DD/MM HH:mm"
  }), /*#__PURE__*/React.createElement(DateTimePicker, {
    style: {
      maxWidth: '150px'
    },
    inputVariant: "outlined",
    label: t("Chart.End_date"),
    variant: "inline",
    disableToolbar: true,
    disabled: disabled,
    autoOk: true,
    minutesStep: 60,
    ampm: false,
    value: datefin.value,
    onChange: dateChangeHandler('datefin'),
    onClose: onDateWidgetCloseHandler('datefin'),
    onError: console.log,
    minDate: datefin.min,
    maxDate: datefin.max,
    format: "DD/MM HH:mm"
  }), !autoOK && /*#__PURE__*/React.createElement(IconButton, {
    onClick: validateHandler,
    color: "primary",
    size: "small",
    disabled: disabled || !datesHasModified
  }, /*#__PURE__*/React.createElement(DoneIcon, null)));
});

var ExportDataContext$1 = React.createContext([{}, null]);
var contextData = {
  dataset: 'ARIAVIEW_NOSDO_RESULT_LcS',
  site: 'NOSDO',
  chrono: {
    datedeb: {
      value: new Date(new Date().getTime() - 24 * 60 * 60 * 1000)
    },
    datefin: {
      value: new Date()
    },
    autoValidate: 0
  },
  receptors: {
    'R1': {
      id: 'R1',
      name: 'I.T.S.O.S. "Albe Steiner" - ViaS. Dionigi, Milano',
      x: 517022,
      y: 5031079,
      epsg: 32632
    },
    'R2': {
      id: 'R2',
      name: 'Scuola dell\'infanzia "A.Osimo" - Via A. Osimo, Milano',
      x: 517671,
      y: 5031264,
      epsg: 32632
    },
    'R3': {
      id: 'R3',
      name: 'Scuola Sec. I Grado"Lombardini" - Via Mincio, Milano',
      x: 517073,
      y: 5031756,
      epsg: 32632
    },
    'R4': {
      id: 'R4',
      name: 'Scuola Sec. I grado “A.Toscanini” - Via dei Guarneri, Milano',
      x: 516036,
      y: 5030300,
      epsg: 32632
    },
    'R5': {
      id: 'R5',
      name: 'Scuola Primaria "Wolf Ferrari" - Via E. Wolf Ferrari, Milano',
      x: 516000,
      y: 5030848,
      epsg: 32632
    },
    'R6': {
      id: 'R6',
      name: 'Scuole Paritarie "Regina Mundi" - Via C.Boncompagni, Milano',
      x: 517757,
      y: 5031862,
      epsg: 32632
    },
    'R7': {
      id: 'R7',
      name: 'Abbazia di Chiaravalle - Via Sant\'Arialdo, Milano',
      x: 518450,
      y: 5029243,
      epsg: 32632
    },
    'R8': {
      id: 'R8',
      name: 'Abitazioni - Via F.G. Pizzi, Milano',
      x: 515875,
      y: 5031545,
      epsg: 32632
    },
    'R9': {
      id: 'R9',
      name: 'IEO - Istituto Europeo di Oncologia - Via G.Ripamonti, Milano',
      x: 516256,
      y: 5028980,
      epsg: 32632
    },
    'R10': {
      id: 'R10',
      name: 'Scuola Primaria "M. Candia"- Via Vallarsa, Milano',
      x: 516449,
      y: 5032134,
      epsg: 32632
    },
    'R11': {
      id: 'R11',
      name: 'Abitazioni - Via Z. Bugatto, Milano',
      x: 515452,
      y: 5030662,
      epsg: 32632
    },
    'R12': {
      id: 'R12',
      name: 'Scuola Primaria "R. Pezzani"- Viale Puglie, Milano',
      x: 517582,
      y: 5032373,
      epsg: 32632
    },
    'R13': {
      id: 'R13',
      name: 'I.C. Statale "P. Sottocorno"- Via Monte Piana, Milano',
      x: 519320,
      y: 5030831,
      epsg: 32632
    },
    'R14': {
      id: 'R14',
      name: 'Scuola dell\'Infanzia"Savinio"- Via Savinio, Milano',
      x: 519143,
      y: 5031595,
      epsg: 32632
    },
    'R15': {
      id: 'R15',
      name: 'Scuola Primaria "Antonini"- Via G. Antonini, Milano',
      x: 515217,
      y: 5031502,
      epsg: 32632
    },
    'R16': {
      id: 'R16',
      name: 'Abitazioni - Via Rogoredo, S. Donato Milanese',
      x: 519777,
      y: 5030192,
      epsg: 32632
    },
    'R17': {
      id: 'R17',
      name: 'Abitazioni - Via delle Cascine, fraz. Sorigherio, S. Donato Milanese',
      x: 518177,
      y: 5028150,
      epsg: 32632
    },
    'R18': {
      id: 'R18',
      name: 'Scuola Primaria "S. Giovanni Bosco"- Via L. Sordello, Milano',
      x: 519224,
      y: 5032309,
      epsg: 32632
    },
    'R19': {
      id: 'R19',
      name: 'Scuola Primaria "I. Calvino"- Via Unica Poasco, fraz. Poasco, S. Donato Milanese',
      x: 517998,
      y: 5027654,
      epsg: 32632
    }
  }
};
var ExportReducer = function ExportReducer(state, action) {
  switch (action.type) {
    case 'SET_DATES':
      return Object.assign(_extends({}, state), {
        chrono: _extends({}, state.chrono, {
          datedeb: action.datedeb,
          datefin: action.datefin
        })
      });
    case 'SET_CHRONO':
      return Object.assign(_extends({}, state), {
        chrono: action.value
      });
    case 'SET_AUTO_VALIDATE':
      return Object.assign(_extends({}, state), {
        chrono: _extends({}, state.chrono, {
          autoValidate: action.value
        })
      });
    default:
      {
        throw new Error("Unsupported action type: " + action.type);
      }
  }
};
var ExportDataProvider = function ExportDataProvider(props) {
  var _React$useReducer = React.useReducer(ExportReducer, contextData),
    store = _React$useReducer[0],
    dispatch = _React$useReducer[1];
  var value = React.useMemo(function () {
    return [store, dispatch];
  }, [store]);
  return /*#__PURE__*/React.createElement(ExportDataContext$1.Provider, _extends({
    value: value
  }, props));
};

// A type of promise-like that resolves synchronously and supports only one observer

const _iteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))) : "@@iterator";

const _asyncIteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator"))) : "@@asyncIterator";

// Asynchronously call a function and send errors to recovery continuation
function _catch(body, recover) {
	try {
		var result = body();
	} catch(e) {
		return recover(e);
	}
	if (result && result.then) {
		return result.then(void 0, recover);
	}
	return result;
}

var dataFetchReducer = function dataFetchReducer(state, action) {
  switch (action.type) {
    case 'FETCH_REQUEST':
      return _extends({}, state, {
        isLoading: true,
        hasError: false
      });
    case 'FETCH_SUCCESS':
      return _extends({}, state, {
        isLoading: false,
        hasError: false,
        response: action.payload
      });
    case 'FETCH_FAILURE':
      return _extends({}, state, {
        isLoading: false,
        hasError: action.message
      });
    default:
      throw new Error();
  }
};
var useFetch = function useFetch(url, options, deps, onSuccess) {
  var _useReducer = useReducer(dataFetchReducer, {
      isLoading: false,
      hasError: false,
      response: []
    }),
    state = _useReducer[0],
    dispatch = _useReducer[1];
  var _deps = Array.isArray(deps) ? deps : [];
  useEffect(function () {
    var didCancel = false;
    var fetchData = function fetchData(url, options, onSuccess) {
      try {
        dispatch({
          type: 'FETCH_REQUEST'
        });
        return Promise.resolve(_catch(function () {
          return Promise.resolve(fetch(url, _extends({}, options, {
            headers: {
              'Content-Type': 'application/json; charset=UTF-8'
            }
          }))).then(function (resp) {
            return function () {
              if (resp.status === 403) {
                var jr = resp.json();
                dispatch({
                  type: 'FETCH_FAILURE',
                  message: jr.message
                });
              } else return function () {
                if (resp.status === 401) {
                  var errmsg = resp.statusText || 'No handled error';
                  dispatch({
                    type: 'FETCH_FAILURE',
                    message: errmsg
                  });
                } else {
                  return Promise.resolve(resp.json()).then(function (json) {
                    if (!!json) {
                      if (!!json.data) {
                        var resul = json.data;
                        if (!didCancel) {
                          if (!resul.error) {
                            dispatch({
                              type: 'FETCH_SUCCESS',
                              payload: resul
                            });
                            if (typeof onSuccess === 'function') {
                              onSuccess(resul);
                            }
                          } else {
                            dispatch({
                              type: 'FETCH_FAILURE',
                              message: resul.error
                            });
                          }
                        }
                      } else {
                        dispatch({
                          type: 'FETCH_SUCCESS',
                          payload: json
                        });
                        if (typeof onSuccess === 'function') {
                          onSuccess(json);
                        }
                      }
                    } else {
                      throw new Error("API function is not valid!");
                    }
                  });
                }
              }();
            }();
          });
        }, function (error) {
          if (!didCancel) {
            dispatch({
              type: 'FETCH_FAILURE',
              message: error.toString()
            });
          }
        }));
      } catch (e) {
        return Promise.reject(e);
      }
    };
    fetchData(url, options, onSuccess);
    return function () {
      didCancel = true;
    };
  }, [].concat(_deps));
  return state;
};

var useFetchAria = function useFetchAria(service, path, query, options, deps, onSuccess) {
  var isOK = true;
  for (var dep in deps) {
    isOK &= !isEmpty(dep);
  }
  if (isOK) {
    var fullUrl = getUrlService(service, path, query);
    log(fullUrl, 'URL service: ', 'info');
    return useFetch(fullUrl, options, deps, onSuccess);
  } else {
    log(deps, 'Dependencies contain <undefined>', 'warning');
  }
  return {
    isLoading: false,
    hasError: false,
    response: undefined
  };
};

var useStyles$6 = makeStyles(function (theme) {
  var _chart;
  return {
    hidden: {
      display: 'None'
    },
    bottomLinearProgress: {
      position: 'absolute',
      bottom: 0,
      left: 16,
      zIndex: 1,
      width: '95%'
    },
    chart: (_chart = {
      height: '35vh'
    }, _chart[theme.breakpoints.down('md')] = {
      height: '65vh'
    }, _chart)
  };
});
var DEFAULT_DATASET = {
  label: 'Référence',
  fill: false,
  borderColor: 'rgb(119,136,153)',
  backgroundColor: 'rgb(63, 81, 181)',
  pointBackgroundColor: [],
  pointBorderWidth: 1,
  pointHoverRadius: 6,
  pointHoverBackgroundColor: 'rgba(63, 81, 181, 1.0)',
  pointHoverBorderColor: 'rgb(220,220,220)',
  pointHoverBorderWidth: 2,
  pointRadius: [],
  pointHitRadius: 10,
  data: []
};
var AriaChartReceptors = (function (_ref) {
  var htmlId = _ref.htmlId,
    variable = _ref.variable,
    chrono = _ref.chrono,
    extractionZone = _ref.extractionZone,
    onLoadingChange = _ref.onLoadingChange,
    onDataChange = _ref.onDataChange,
    useContext = _ref.useContext,
    useAriaStore = _ref.useAriaStore,
    options = _ref.options,
    withChart = _ref.withChart;
  var classes = useStyles$6();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var store = {
      chrono: chrono
    };
  if (useAriaStore) {
    var _useAriaAppStore = useAriaAppStore();
  } else if (useContext) {
    var context = React.useContext(ExportDataContext$1);
    if (!Array.isArray(context)) {
      throw new Error("AriaDatetimeWindowSelect => ExportDataContext return non array object");
    }
    store = context[0];
  }
  log(store, 'Store in AriaChart', 'warning');
  var _React$useState = React.useState(variable || store['variable'] || ''),
    currentVariable = _React$useState[0],
    setCurrentVariable = _React$useState[1];
  var _React$useState2 = React.useState('atomic'),
    selectedDataFile = _React$useState2[0];
  var _React$useState3 = React.useState(options),
    chartOptions = _React$useState3[0];
  var getExtractionZone = React.useCallback(function () {
    log(extractionZone, "extractionZone", "error");
    var _extractionZone = undefined;
    if (!isEmpty(extractionZone)) {
      _extractionZone = extractionZone;
    }
    return _extractionZone;
  }, [extractionZone]);
  React.useEffect(function () {
    setCurrentVariable(variable);
  }, [variable]);
  var _useFetchAria = useFetchAria('points/ts', [store['dataset']], {
      variables: currentVariable.value,
      epsg: 32632,
      is_atomic: 1,
      start_date: store['chrono'] ? store['chrono'].datedeb.value ? parseTime(store['chrono'].datedeb.value, '{y}-{m}-{d}T{h}:{i}:{s}') : undefined : undefined,
      end_date: store['chrono'] ? store['chrono'].datefin.value ? parseTime(store['chrono'].datefin.value, '{y}-{m}-{d}T{h}:{i}:{s}') : undefined : undefined
    }, {
      method: 'POST',
      body: JSON.stringify(getExtractionZone())
    }, [currentVariable, store['chrono'].datedeb.value, store['chrono'].datefin.value, getExtractionZone]),
    isLoading = _useFetchAria.isLoading,
    hasError = _useFetchAria.hasError,
    tsdata = _useFetchAria.response;
  log(tsdata, 'tsdata');
  var computeChartDataset = React.useMemo(function () {
    if (tsdata) {
      var chartData = {
        labels: [],
        datasets: []
      };
      try {
        var varnames = Object.keys(tsdata);
        if (isEmpty(varnames)) return chartData;
        if (varnames.indexOf(currentVariable.value) === -1) return chartData;
        var datafiles = Object.keys(tsdata[currentVariable.value]);
        if (isEmpty(datafiles)) return chartData;
        if (datafiles.indexOf(selectedDataFile) === -1) return chartData;
        var pnts = Object.keys(tsdata[currentVariable.value][selectedDataFile].values);
        if (isEmpty(pnts)) return chartData;
        var tims = tsdata[currentVariable.value][selectedDataFile].times;
        pnts.forEach(function (pnt, id) {
          var vals = tsdata[currentVariable.value][selectedDataFile].values[pnt];
          chartData.datasets.push(Object.assign({}, DEFAULT_DATASET));
          var cnt = chartData.datasets.length - 1;
          chartData.datasets[cnt].backgroundColor = "rgb(" + Math.random() * 255 + ", " + Math.random() * 255 + ", " + Math.random() * 255 + ")";
          chartData.datasets[cnt].borderColor = "rgb(" + Math.random() * 255 + ", " + Math.random() * 255 + ", " + Math.random() * 255 + ")";
          if (!chartData.times && chartData.labels.length == 0) {
            chartData.times = tims;
            var timeLabels = tims.map(function (time) {
              return parseTime(time, chartOptions.datetimeFormat);
            });
            chartData.labels = timeLabels;
          }
          chartData.datasets[cnt].data = vals;
          chartData.datasets[cnt].label = "" + pnt;
        });
        return chartData;
      } catch (err) {
        if (process.env.NODE_ENV === 'development') {
          log(err.message, 'Error found in compute the chart data', 'error');
        }
        return chartData;
      }
    } else {
      return DEFAULT_DATASET;
    }
  }, [tsdata, currentVariable.value, selectedDataFile, chartOptions]);
  React.useEffect(function () {
    if (computeChartDataset) {
      if (typeof onDataChange === 'function') {
        onDataChange(computeChartDataset);
      }
    }
  }, [computeChartDataset]);
  React.useEffect(function () {
    if (typeof onLoadingChange === 'function') {
      onLoadingChange(isLoading);
    }
  }, [isLoading]);
  return /*#__PURE__*/React.createElement(Paper, {
    elevation: 0,
    className: isLoading ? '' : classes.chart
  }, isLoading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography$1, {
    color: "textSecondary",
    variant: "body1"
  }, t('Chart.Chart_is_loading') + "..."), /*#__PURE__*/React.createElement(LinearProgress, {
    className: classes.linearProgress
  })) : hasError ? /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, t('Chart.Error_loading_message')) : withChart && /*#__PURE__*/React.createElement(Line, {
    id: htmlId,
    data: computeChartDataset,
    options: {
      maintainAspectRatio: false,
      responsive: true,
      animation: false,
      title: {
        display: true,
        text: "" + t('ExportDialog.Chart_title')
      },
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: currentVariable.title + ' (' + currentVariable.unit + ')'
          },
          ticks: {
            beginAtZero: true,
            min: 0
          }
        }],
        xAxes: [{
          scaleLabel: {
            display: true,
            labelString: t('Chart.Time')
          }
        }]
      }
    },
    redraw: true
  }));
});

var useStyles$7 = makeStyles(function (theme) {
  var _chart;
  return {
    hidden: {
      display: 'None'
    },
    bottomLinearProgress: {
      position: 'absolute',
      bottom: 0,
      left: 16,
      zIndex: 1,
      width: '95%'
    },
    chart: (_chart = {
      height: '35vh'
    }, _chart[theme.breakpoints.down('md')] = {
      height: '65vh'
    }, _chart)
  };
});
var DEFAULT_DATASET$1 = {
  label: 'Référence',
  fill: false,
  borderColor: 'rgb(119,136,153)',
  backgroundColor: 'rgb(63, 81, 181)',
  pointBackgroundColor: [],
  pointBorderWidth: 1,
  pointHoverRadius: 6,
  pointHoverBackgroundColor: 'rgba(63, 81, 181, 1.0)',
  pointHoverBorderColor: 'rgb(220,220,220)',
  pointHoverBorderWidth: 2,
  pointRadius: [],
  pointHitRadius: 10,
  data: []
};
var AriaChartObservations = (function (_ref) {
  var htmlId = _ref.htmlId,
    variable = _ref.variable,
    chrono = _ref.chrono,
    extractionZone = _ref.extractionZone,
    onLoadingChange = _ref.onLoadingChange,
    onDataChange = _ref.onDataChange,
    useContext = _ref.useContext,
    useAriaStore = _ref.useAriaStore,
    options = _ref.options,
    withChart = _ref.withChart;
  var classes = useStyles$7();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var store = {
      chrono: chrono
    };
  if (useAriaStore) {
    var _useAriaAppStore = useAriaAppStore();
  } else if (useContext) {
    var context = React.useContext(ExportDataContext$1);
    if (!Array.isArray(context)) {
      throw new Error("AriaDatetimeWindowSelect => ExportDataContext return non array object");
    }
    store = context[0];
  }
  log(store, 'Store in AriaChart', 'warning');
  var _React$useState = React.useState(variable || store['variable'] || ''),
    currentVariable = _React$useState[0];
  var _React$useState2 = React.useState('atomic'),
    selectedDataFile = _React$useState2[0];
  var _React$useState3 = React.useState(options),
    chartOptions = _React$useState3[0];
  var getExtractionZone = React.useCallback(function () {
    log(extractionZone, "extractionZone", "error");
    var _extractionZone = undefined;
    if (!isEmpty(extractionZone)) {
      _extractionZone = extractionZone;
    }
    return _extractionZone;
  }, [extractionZone]);
  var getObservationSensors = React.useMemo(function () {
    var _extractionZone = undefined;
    if (!isEmpty(extractionZone)) {
      _extractionZone = Object.keys(extractionZone);
      _extractionZone = _extractionZone.join("#");
    }
    return _extractionZone;
  }, [extractionZone]);
  var _useFetchAria = useFetchAria('ariaview/observations', [], {
      epsg: 32632,
      is_atomic: 1,
      site: store['site'],
      obs_type: 'aq',
      timezone: store["timezone"],
      stations: getObservationSensors,
      start_date: store['chrono'] ? store['chrono'].datedeb.value ? parseTime(store['chrono'].datedeb.value, '{y}-{m}-{d}T{h}:{i}:{s}') : undefined : undefined,
      end_date: store['chrono'] ? store['chrono'].datefin.value ? parseTime(store['chrono'].datefin.value, '{y}-{m}-{d}T{h}:{i}:{s}') : undefined : undefined
    }, {
      method: 'GET',
      body: JSON.stringify(getExtractionZone())
    }, [currentVariable.name, store['chrono'].datedeb.value, store['chrono'].datefin.value, getExtractionZone, getObservationSensors]),
    isLoading = _useFetchAria.isLoading,
    hasError = _useFetchAria.hasError,
    tsdata = _useFetchAria.response;
  log(tsdata, 'tsdata');
  var computeChartDataset = React.useMemo(function () {
    if (tsdata) {
      var chartData = {
        labels: [],
        datasets: []
      };
      try {
        var varnames = Object.keys(tsdata);
        if (isEmpty(varnames)) return chartData;
        if (varnames.indexOf(currentVariable.name) === -1) return chartData;
        var datafiles = Object.keys(tsdata[currentVariable.name]);
        if (isEmpty(datafiles)) return chartData;
        if (datafiles.indexOf(selectedDataFile) === -1) return chartData;
        var pnts = Object.keys(tsdata[currentVariable.name][selectedDataFile].values);
        if (isEmpty(pnts)) return chartData;
        var tims = tsdata[currentVariable.name][selectedDataFile].times;
        pnts.forEach(function (pnt, id) {
          var vals = tsdata[currentVariable.name][selectedDataFile].values[pnt];
          chartData.datasets.push(Object.assign({}, DEFAULT_DATASET$1));
          var cnt = chartData.datasets.length - 1;
          chartData.datasets[cnt].backgroundColor = "rgb(" + Math.random() * 255 + ", " + Math.random() * 255 + ", " + Math.random() * 255 + ")";
          chartData.datasets[cnt].borderColor = "rgb(" + Math.random() * 255 + ", " + Math.random() * 255 + ", " + Math.random() * 255 + ")";
          if (!chartData.times && chartData.labels.length == 0) {
            chartData.times = tims;
            var timeLabels = tims.map(function (time) {
              return parseTime(time, chartOptions.datetimeFormat);
            });
            chartData.labels = timeLabels;
          }
          chartData.datasets[cnt].data = vals;
          chartData.datasets[cnt].label = "" + pnt;
        });
        return chartData;
      } catch (err) {
        if (process.env.NODE_ENV === 'development') {
          log(err.message, 'Error found in compute the chart data', 'error');
        }
        return chartData;
      }
    } else {
      return DEFAULT_DATASET$1;
    }
  }, [tsdata, currentVariable.name, selectedDataFile, chartOptions]);
  React.useEffect(function () {
    if (computeChartDataset) {
      if (typeof onDataChange === 'function') {
        onDataChange(computeChartDataset);
      }
    }
  }, [computeChartDataset]);
  React.useEffect(function () {
    if (typeof onLoadingChange === 'function') {
      onLoadingChange(isLoading);
    }
  }, [isLoading]);
  return /*#__PURE__*/React.createElement(Paper, {
    elevation: 0,
    className: isLoading ? '' : classes.chart
  }, isLoading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography$1, {
    color: "textSecondary",
    variant: "body1"
  }, t('Chart.Chart_is_loading') + "..."), /*#__PURE__*/React.createElement(LinearProgress, {
    className: classes.linearProgress
  })) : hasError ? /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, t('Chart.Error_loading_message')) : withChart && /*#__PURE__*/React.createElement(Line, {
    id: htmlId,
    data: computeChartDataset,
    options: {
      maintainAspectRatio: false,
      responsive: true,
      animation: false,
      title: {
        display: true,
        text: "" + t('ExportDialog.Chart_title')
      },
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: currentVariable.title + ' (' + currentVariable.unit + ')'
          },
          ticks: {
            beginAtZero: true,
            min: 0
          }
        }],
        xAxes: [{
          scaleLabel: {
            display: true,
            labelString: t('Chart.Time')
          }
        }]
      }
    },
    redraw: true
  }));
});

var useStyles$8 = makeStyles(function (theme) {
  var _chart;
  return {
    hidden: {
      display: 'None'
    },
    bottomLinearProgress: {
      position: 'absolute',
      bottom: 0,
      left: 16,
      zIndex: 1,
      width: '95%'
    },
    chart: (_chart = {
      height: '35vh'
    }, _chart[theme.breakpoints.down('md')] = {
      height: '65vh'
    }, _chart)
  };
});
var DEFAULT_DATASET$2 = {
  label: 'Référence',
  fill: false,
  borderColor: 'rgb(119,136,153)',
  backgroundColor: 'rgb(63, 81, 181)',
  pointBackgroundColor: [],
  pointBorderWidth: 1,
  pointHoverRadius: 6,
  pointHoverBackgroundColor: 'rgba(63, 81, 181, 1.0)',
  pointHoverBorderColor: 'rgb(220,220,220)',
  pointHoverBorderWidth: 2,
  pointRadius: [],
  pointHitRadius: 10,
  data: []
};
var AriaChartWeather = (function (_ref) {
  var htmlId = _ref.htmlId,
    variable = _ref.variable,
    chrono = _ref.chrono,
    apiService = _ref.apiService,
    extractionZone = _ref.extractionZone,
    onLoadingChange = _ref.onLoadingChange,
    onDataChange = _ref.onDataChange,
    useContext = _ref.useContext,
    useAriaStore = _ref.useAriaStore,
    options = _ref.options,
    withChart = _ref.withChart;
  var classes = useStyles$8();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var store = {
      chrono: chrono
    };
  if (useAriaStore) {
    var _useAriaAppStore = useAriaAppStore();
  } else if (useContext) {
    var context = React.useContext(ExportDataContext$1);
    if (!Array.isArray(context)) {
      throw new Error("AriaDatetimeWindowSelect => ExportDataContext return non array object");
    }
    store = context[0];
  }
  log(store, 'Store in AriaChart', 'warning');
  var _React$useState = React.useState(variable || store['variable'] || ''),
    currentVariable = _React$useState[0];
  var _React$useState2 = React.useState('atomic'),
    selectedDataFile = _React$useState2[0];
  var _React$useState3 = React.useState(options),
    chartOptions = _React$useState3[0];
  var getExtractionZone = React.useCallback(function () {
    log(extractionZone, "extractionZone", "error");
    var _extractionZone = undefined;
    if (!isEmpty(extractionZone)) {
      _extractionZone = extractionZone;
    }
    return _extractionZone;
  }, [extractionZone]);
  var _useFetchAria = useFetchAria('ariaview/observations', [], {
      epsg: 32632,
      is_atomic: 1,
      site: store['site'],
      obs_type: 'met',
      timezone: store["timezone"],
      start_date: store['chrono'] ? store['chrono'].datedeb.value ? parseTime(store['chrono'].datedeb.value, '{y}-{m}-{d}T{h}:{i}:{s}') : undefined : undefined,
      end_date: store['chrono'] ? store['chrono'].datefin.value ? parseTime(store['chrono'].datefin.value, '{y}-{m}-{d}T{h}:{i}:{s}') : undefined : undefined
    }, {
      method: 'GET',
      body: JSON.stringify(getExtractionZone())
    }, [currentVariable.name, store['chrono'].datedeb.value, store['chrono'].datefin.value, getExtractionZone, apiService]),
    isLoading = _useFetchAria.isLoading,
    hasError = _useFetchAria.hasError,
    tsdata = _useFetchAria.response;
  log(tsdata, 'tsdata');
  var computeChartDataset = React.useMemo(function () {
    if (tsdata) {
      var chartData = {
        labels: [],
        datasets: []
      };
      try {
        var varnames = Object.keys(tsdata);
        if (isEmpty(varnames)) return chartData;
        if (varnames.indexOf(currentVariable.name) === -1) return chartData;
        var datafiles = Object.keys(tsdata[currentVariable.name]);
        if (isEmpty(datafiles)) return chartData;
        if (datafiles.indexOf(selectedDataFile) === -1) return chartData;
        var pnts = Object.keys(tsdata[currentVariable.name][selectedDataFile].values);
        if (isEmpty(pnts)) return chartData;
        var tims = tsdata[currentVariable.name][selectedDataFile].times;
        pnts.forEach(function (pnt, id) {
          var vals = tsdata[currentVariable.name][selectedDataFile].values[pnt];
          chartData.datasets.push(Object.assign({}, DEFAULT_DATASET$2));
          var cnt = chartData.datasets.length - 1;
          chartData.datasets[cnt].backgroundColor = "rgb(" + Math.random() * 255 + ", " + Math.random() * 255 + ", " + Math.random() * 255 + ")";
          chartData.datasets[cnt].borderColor = "rgb(" + Math.random() * 255 + ", " + Math.random() * 255 + ", " + Math.random() * 255 + ")";
          if (!chartData.times && chartData.labels.length == 0) {
            chartData.times = tims;
            var timeLabels = tims.map(function (time) {
              return parseTime(time, chartOptions.datetimeFormat);
            });
            chartData.labels = timeLabels;
          }
          chartData.datasets[cnt].data = vals;
          chartData.datasets[cnt].label = "" + pnt;
        });
        return chartData;
      } catch (err) {
        if (process.env.NODE_ENV === 'development') {
          log(err.message, 'Error found in compute the chart data', 'error');
        }
        return chartData;
      }
    } else {
      return DEFAULT_DATASET$2;
    }
  }, [tsdata, currentVariable.name, selectedDataFile, chartOptions]);
  React.useEffect(function () {
    if (computeChartDataset) {
      if (typeof onDataChange === 'function') {
        onDataChange(computeChartDataset);
      }
    }
  }, [computeChartDataset]);
  React.useEffect(function () {
    if (typeof onLoadingChange === 'function') {
      onLoadingChange(isLoading);
    }
  }, [isLoading]);
  return /*#__PURE__*/React.createElement(Paper, {
    elevation: 0,
    className: isLoading ? '' : classes.chart
  }, isLoading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography$1, {
    color: "textSecondary",
    variant: "body1"
  }, t('Chart.Chart_is_loading') + "..."), /*#__PURE__*/React.createElement(LinearProgress, {
    className: classes.linearProgress
  })) : hasError ? /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, t('Chart.Error_loading_message')) : withChart && /*#__PURE__*/React.createElement(Line, {
    id: htmlId,
    data: computeChartDataset,
    options: {
      maintainAspectRatio: false,
      responsive: true,
      animation: false,
      title: {
        display: true,
        text: "" + t('ExportDialog.Chart_title')
      },
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: currentVariable.title + ' (' + currentVariable.unit + ')'
          },
          ticks: {
            beginAtZero: true,
            min: 0
          }
        }],
        xAxes: [{
          scaleLabel: {
            display: true,
            labelString: t('Chart.Time')
          }
        }]
      }
    },
    redraw: true
  }));
});

function write2Image(canvasId) {
  var canvas = document.getElementById(canvasId);
  var context = canvas.getContext('2d');
  context.fillStyle = 'gray';
  var url_base64png = canvas.toDataURL('image/png');
  var link = document.getElementById('download');
  if (!link) {
    link = document.createElement('a');
    link.setAttribute('id', 'download');
  }
  link.download = "ChartImage.png";
  link.href = url_base64png;
  link.click();
}
function writeToCSVLine(chartData, variable, typeGraphic) {
  log(chartData, 'chartData');
  var csvContent = [];
  csvContent[0] = [];
  var header = ['id', 'name', 'timeserie', 'location', 'geometry'];
  var datasets = chartData.datasets;
  var timeframes = chartData.times;
  var markers = [];
  datasets.forEach(function (ds) {
    markers.push({
      label: ds.label
    });
  });
  var varlabel = variable ? variable.title || 'variable' : 'variable';
  if (typeGraphic === 'boxplot') {
    header.push(varname + "_min");
    header.push(varname + "_max");
    header.push(varname + "_mediane");
    header.push(varname + "_q1");
    header.push(varname + "_q3");
  } else {
    header.push(varlabel);
  }
  csvContent[0] = header;
  var il = 0;
  var _loop = function _loop() {
    var lat = null;
    var lng = null;
    var loc = '-';
    var geom = '-';
    try {
      geom = 'POINT';
      lat = im.lat ? im.lat.toFixed(5) : '-';
      lng = im.lon ? im.lon.toFixed(5) : '-';
      loc = "[" + lat + ", " + lng + "]";
    } catch (e) {}
    if (typeGraphic === 'line' || typeGraphic === 'season_cycle') ; else if (typeGraphic === 'boxplot') ; else {
      datasets.forEach(function (ds) {
        var dat = ds.data;
        var lbl = ds.label;
        dat.forEach(function (d, di) {
          il++;
          csvContent[il] = [];
          var dtstr = parseTime(timeframes[di], '{y}-{m}-{d} {h}h');
          var dline = [il, lbl, dtstr, loc, geom, d.toFixed(3)];
          csvContent[il] = dline;
        });
      });
    }
  };
  for (var im in markers) {
    _loop();
  }
  var fileContent = '';
  csvContent.forEach(function (line, id) {
    fileContent += line.join(';') + '\r\n';
  });
  writeContentToFile(fileContent, 'csv');
}
function writeContentToFile(csvContent, fileType) {
  var type = fileType || 'csv';
  var blob = new Blob([csvContent], {
    encoding: 'UTF-8',
    type: 'text/' + type + ';charset=UTF-8'
  });
  if (Browser.ie) {
    window.navigator.msSaveBlob(blob, 'timeseries.' + type);
  } else {
    var url = URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'timeseries.' + type);
    var clickEvent = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: false
    });
    link.dispatchEvent(clickEvent);
  }
}

var useStyles$9 = makeStyles(function (theme) {
  return {
    formControl: {
      margin: theme.spacing(1),
      marginBottom: theme.spacing(2),
      width: '95%',
      minWidth: '50%'
    },
    marginLabel: {
      marginBottom: theme.spacing(2)
    },
    selectEmpty: {
      marginTop: theme.spacing(2)
    },
    hidden: {
      display: 'None'
    }
  };
});
var ZONETYPES = [{
  value: 'receptors',
  label: 'Receptors'
}, {
  value: 'emission_sensors',
  label: 'Observations'
}, {
  value: 'weather_sensors',
  label: 'Weathers'
}];
var OBS_VARIABLES = [{
  value: 'H2S',
  label: 'H2S'
}, {
  value: 'OU',
  label: 'OU'
}, {
  value: 'VOC',
  label: 'VOC'
}, {
  value: 'NH3',
  label: 'NH3'
}];
var AriaExportControl = (function (_ref) {
  var title = _ref.title,
    hidden = _ref.hidden,
    disabled = _ref.disabled,
    opened = _ref.opened,
    onCloseCallback = _ref.onCloseCallback,
    useAriaStore = _ref.useAriaStore;
  var classes = useStyles$9();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var chartHtmlId = 'chart-export-dialog';
  var theme = useTheme();
  var fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  var store = {};
  if (useAriaStore) {
    var _useAriaAppStore = useAriaAppStore();
    store = _useAriaAppStore[0];
  }
  log(store, 'Store in AriaExportDialog', 'error');
  var _React$useState = React.useState(false),
    setOpen = _React$useState[1];
  var _useState = useState(false),
    chartIsLoading = _useState[0],
    setChartIsLoading = _useState[1];
  var _useState2 = useState(undefined),
    chartData = _useState2[0],
    setChartData = _useState2[1];
  var _React$useState2 = React.useState("receptors"),
    zoneType = _React$useState2[0],
    setZoneType = _React$useState2[1];
  var _React$useState3 = React.useState([]),
    exportVariables = _React$useState3[0],
    setExportVariables = _React$useState3[1];
  var _React$useState4 = React.useState({}),
    exportVariable = _React$useState4[0],
    setExportVariable = _React$useState4[1];
  React.useEffect(function () {
    setOpen(opened);
  }, [opened]);
  React.useEffect(function () {
    if (zoneType === 'receptors') {
      log(store['dataset'], 'STORE DATASET', 'error');
      if (store['dataset'] && store['dataset'].variables) {
        var vars = store['dataset'].variables.map(function (v) {
          return {
            value: v.name,
            unit: v.unit,
            label: v.title
          };
        });
        if (vars.length > 0) {
          setExportVariables(vars);
          setExportVariable(vars[0]);
        }
      }
    } else if (zoneType === 'emission_sensors') {
      setExportVariables(OBS_VARIABLES);
      setExportVariable(OBS_VARIABLES[0]);
    }
  }, [zoneType, store['dataset']]);
  var handleClose = function handleClose() {
    setOpen(false);
    if (typeof onCloseCallback === 'function') {
      onCloseCallback(false);
    }
  };
  var validateDateChangeHandler = function validateDateChangeHandler() {};
  var onChartLoadingChangeHandler = React.useCallback(function (isLoading) {
    setChartIsLoading(isLoading);
  }, []);
  var onSaveImageClickHandler = React.useCallback(function (e) {
    if (!isEmpty(chartHtmlId)) {
      write2Image(chartHtmlId);
    }
  }, [chartHtmlId]);
  var onSaveChartDataHandler = React.useCallback(function () {
    var grpData = chartData;
    if (grpData && !isEmpty(exportVariable)) {
      writeToCSVLine(grpData, exportVariable);
    }
  }, [chartData, exportVariable]);
  var onChartDataChangeHandler = React.useCallback(function (cData) {
    setChartData(cData);
  }, []);
  var onSelectZoneTypeHandler = React.useCallback(function (zType) {
    setZoneType(zType);
  }, []);
  var onSelectVariableHandler = React.useCallback(function (evar, opts) {
    if (Array.isArray(exportVariables) && exportVariables.length > 0) {
      var found = exportVariables.find(function (_var) {
        return _var.value === evar;
      });
      if (found) {
        setExportVariable(found);
      }
    }
  }, [exportVariables]);
  log(exportVariable, 'exportVariable');
  log(exportVariables, 'exportVariables');
  return /*#__PURE__*/React.createElement(ExportDataProvider, null, /*#__PURE__*/React.createElement(FormControl$1, {
    fullWidth: true,
    className: hidden ? classes.hidden : classes.formControl,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(FormLabel, {
    htmlFor: "date-model",
    className: classes.marginLabel
  }, title), /*#__PURE__*/React.createElement(Paper, {
    elevation: 0,
    style: {
      overflowX: 'hidden'
    }
  }, /*#__PURE__*/React.createElement(MuiPickersUtilsProvider, {
    utils: MomentUtils
  }, /*#__PURE__*/React.createElement(AriaDatetimeWindowSelect, {
    title: t('ExportDialog.Timewindow_selector_title'),
    disabled: chartIsLoading,
    dataContext: ExportDataContext$1,
    onValidateCallback: validateDateChangeHandler
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(AriaSelect, {
    label: t('ExportDialog.Select_data_type'),
    fullWidth: true,
    options: ZONETYPES,
    selected: zoneType,
    onSelectHandler: onSelectZoneTypeHandler
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(AriaSelect, {
    label: t('ExportDialog.Select_variable'),
    fullWidth: true,
    options: exportVariables,
    selected: typeof exportVariable === 'object' ? exportVariable.value : exportVariable,
    onSelectHandler: onSelectVariableHandler
  })), zoneType === 'receptors' && /*#__PURE__*/React.createElement(AriaChartReceptors, {
    htmlId: chartHtmlId,
    variable: exportVariable,
    extractionZone: store[zoneType],
    useContext: true,
    options: {
      datetimeFormat: '{y}-{m}-{d} {h}h'
    },
    onLoadingChange: onChartLoadingChangeHandler,
    onDataChange: onChartDataChangeHandler
  }), zoneType === 'emission_sensors' && /*#__PURE__*/React.createElement(AriaChartObservations, {
    htmlId: chartHtmlId,
    variable: exportVariable,
    extractionZone: store[zoneType],
    useContext: true,
    options: {
      datetimeFormat: '{y}-{m}-{d} {h}h'
    },
    onLoadingChange: onChartLoadingChangeHandler,
    onDataChange: onChartDataChangeHandler
  }), zoneType === 'weather_sensors' && /*#__PURE__*/React.createElement(AriaChartWeather, {
    htmlId: chartHtmlId,
    variable: exportVariable,
    extractionZone: store[zoneType],
    useContext: true,
    options: {
      datetimeFormat: '{y}-{m}-{d} {h}h'
    },
    onLoadingChange: onChartLoadingChangeHandler,
    onDataChange: onChartDataChangeHandler
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      margin: 'auto'
    }
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "icon-cancel-button"
  }, /*#__PURE__*/React.createElement(IconButton, {
    color: "primary",
    "aria-label": "Cancel button",
    component: "span",
    onClick: handleClose
  }, /*#__PURE__*/React.createElement(CancelIcon, null))), /*#__PURE__*/React.createElement("label", {
    htmlFor: "icon-save-csv-button"
  }, /*#__PURE__*/React.createElement(IconButton, {
    color: "primary",
    "aria-label": "Save picture",
    component: "span",
    onClick: onSaveChartDataHandler
  }, /*#__PURE__*/React.createElement(TimelineIcon, null))), /*#__PURE__*/React.createElement("label", {
    htmlFor: "icon-save-image-button"
  }, /*#__PURE__*/React.createElement(IconButton, {
    color: "primary",
    "aria-label": "Save picture",
    component: "span",
    onClick: onSaveImageClickHandler
  }, /*#__PURE__*/React.createElement(PhotoCamera, null))))));
});

var useStyles$a = makeStyles(function (theme) {
  return {
    root: {
      height: '100%',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'row'
    },
    container: {
      overflow: 'auto',
      flexGrow: 1,
      padding: theme.spacing(2),
      marginBottom: theme.spacing(6)
    }
  };
});
var AriaControlPanel = (function (_ref) {
  var withToolbar = _ref.withToolbar,
    helpFilename = _ref.helpFilename,
    infoFilename = _ref.infoFilename,
    onClickHideControlPanel = _ref.onClickHideControlPanel,
    drawerIsOpen = _ref.drawerIsOpen,
    toolbarButtons = _ref.toolbarButtons,
    children = _ref.children;
  var classes = useStyles$a();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAriaAppStore = useAriaAppStore(),
    dispatch = _useAriaAppStore[1];
  var _React$useState = React.useState(false),
    openExportControl = _React$useState[0],
    setOpenExportControl = _React$useState[1];
  var _React$useState2 = React.useState(false),
    setIsOpen = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    error = _React$useState3[0],
    setError = _React$useState3[1];
  var onOpenExportControlHandler = React.useCallback(function () {
    setOpenExportControl(true);
  }, []);
  var onCloseExportControlHandler = React.useCallback(function () {
    setOpenExportControl(false);
  }, []);
  var onOpenModalHandler = React.useCallback(function (onOpenModal) {
    setIsOpen(onOpenModal);
  }, []);
  React.useEffect(function () {
    setError(false);
    var _url = getUrlService('clients', [process.env.REACT_APP_CLIENT_NAME], {});
    log(_url, 'URL getClient service called from AriaLayout', 'info');
    fetch(_url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (resp) {
      return resp.json();
    }).then(function (json) {
      if (json.data) {
        dispatch({
          type: 'SET_CLIENT_TOKEN',
          value: json.data.token
        });
      }
    })["catch"](function (error) {
      setError(error.toString());
      log(error, 'Cannot get client from API', 'error');
      console.error('Cannot get client from API');
    });
  }, [dispatch]);
  return /*#__PURE__*/React.createElement(Paper$1, {
    className: classes.root,
    elevation: 0
  }, withToolbar && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AppToolbar, {
    orientation: "vertical",
    drawerIsOpen: drawerIsOpen,
    buttons: withToolbar && toolbarButtons,
    onClickHideControlPanel: onClickHideControlPanel,
    helpFilename: helpFilename,
    infoFilename: infoFilename,
    onOpenExportControl: onOpenExportControlHandler,
    onOpenModal: onOpenModalHandler
  }), /*#__PURE__*/React.createElement(Divider, {
    orientation: "vertical",
    flexItem: true
  })), !error ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("form", {
    className: classes.container,
    noValidate: true,
    autoComplete: "off"
  }, children, openExportControl && /*#__PURE__*/React.createElement(AriaExportControl, {
    title: t('ControlPanel.Export_data'),
    onCloseCallback: onCloseExportControlHandler,
    useAriaStore: true
  })), /*#__PURE__*/React.createElement(AriaComplainFormDialog, null)) : /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, t('ControlPanel.Cannot_load_variables_from_server')));
});

var BoxPlot = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(BoxPlot, _React$Component);
  function BoxPlot() {
    return _React$Component.apply(this, arguments) || this;
  }
  var _proto = BoxPlot.prototype;
  _proto.render = function render() {
    var _this = this;
    return /*#__PURE__*/React.createElement(ChartComponent, _extends({}, this.props, {
      ref: function ref(_ref) {
        return _this.chartInstance = _ref && _ref.chartInstance;
      },
      type: "boxplot"
    }));
  };
  return BoxPlot;
}(React.Component);

var useStyles$b = makeStyles(function (theme) {
  return {
    formControl: {
      margin: theme.spacing(1),
      marginBottom: theme.spacing(2),
      width: '90%',
      marginLeft: '5%'
    },
    formLabel: {}
  };
});
var AriaRadioInput = (function (_ref) {
  var store_key = _ref.store_key,
    radio_type = _ref.radio_type,
    withLabel = _ref.withLabel,
    buttons = _ref.buttons,
    selected = _ref.selected,
    disabled = _ref.disabled,
    selectHandler = _ref.selectHandler,
    children = _ref.children;
  var classes = useStyles$b();
  var _useAriaAppStore = useAriaAppStore(),
    dispatch = _useAriaAppStore[1];
  var _useState = useState(selected),
    butval = _useState[0],
    setButval = _useState[1];
  var handleChange = function handleChange(event) {
    var radioOption = event.target.value;
    setButval(radioOption);
    if (typeof selectHandler === 'function') {
      selectHandler(radioOption);
    }
    if (store_key && dispatch) {
      if (!radio_type) {
        dispatch({
          type: "SET_" + store_key.toUpperCase(),
          value: radioOption
        });
      } else {
        var _value;
        dispatch({
          type: "SET_" + store_key.toUpperCase(),
          value: (_value = {}, _value[radio_type] = radioOption, _value)
        });
      }
    }
  };
  return /*#__PURE__*/React.createElement(FormControl$1, {
    className: classes.formControl,
    disabled: disabled
  }, withLabel && /*#__PURE__*/React.createElement(FormLabel, {
    className: classes.formLabel
  }, withLabel), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 0,
    direction: "column",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(RadioGroup, {
    value: butval,
    onChange: handleChange,
    row: true
  }, buttons && buttons.map(function (but, id) {
    return /*#__PURE__*/React.createElement(FormControlLabel, {
      key: id,
      value: but.value,
      control: /*#__PURE__*/React.createElement(Radio, {
        color: "secondary"
      }),
      label: but.label,
      labelPlacement: "end"
    });
  }))), children && /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, children)));
});

var useStyles$c = makeStyles(function (theme) {
  return {
    root: {
      width: '100%',
      textAlign: 'center'
    },
    toolbar: {
      display: 'flex',
      flexDirection: 'row',
      padding: 0
    },
    chart: {
      height: '30vh',
      width: '90%',
      marginLeft: '7%'
    }
  };
});
var AriaMeteoChart = (function (_ref) {
  var saveDataCB = _ref.saveDataCB,
    timeOptions = _ref.timeOptions;
  var classes = useStyles$c();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var chartRef = useRef({});
  var _React$useState = React.useState(false),
    loading = _React$useState[0],
    setIsLoading = _React$useState[1];
  var _React$useState2 = React.useState(false),
    error = _React$useState2[0],
    setError = _React$useState2[1];
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0];
  var tz = store['timezone'];
  var timeseries = store['timeseries'];
  var metsta = store['weather_sensor'];
  var client = store['client'];
  var _React$useState3 = React.useState(undefined),
    weatherData = _React$useState3[0],
    setWeatherData = _React$useState3[1];
  var _React$useState4 = React.useState(undefined),
    weatherVariables = _React$useState4[0],
    setWeatherVariables = _React$useState4[1];
  var _React$useState5 = React.useState('temperature'),
    selectedWeatherVariable = _React$useState5[0],
    setSelectedWeatherVariable = _React$useState5[1];
  var _React$useState6 = React.useState({}),
    weatherUnits = _React$useState6[0],
    setWeatherUnits = _React$useState6[1];
  var transVariableLabel = useCallback(function (selectedWeatherVariable) {
    if (selectedWeatherVariable == 'temperature') {
      return t('Chart.Temperature');
    } else if (selectedWeatherVariable == 'humidity') {
      return t('Chart.Humidity');
    } else if (selectedWeatherVariable == 'pressure') {
      return t('Chart.Pressure');
    } else if (selectedWeatherVariable == 'solar_radiation') {
      return t('Chart.Solar_radiation');
    } else if (selectedWeatherVariable == 'total_rain') {
      return t('Chart.Total_rain');
    } else if (selectedWeatherVariable == 'rain') {
      return t('Chart.Rain');
    } else if (selectedWeatherVariable == 'wind_average') {
      return t('Chart.Wind_average');
    } else if (selectedWeatherVariable == 'wind_direction') {
      return t('Chart.Wind_direction');
    } else {
      return selectedWeatherVariable;
    }
  }, []);
  var useOptions = useCallback(function (variable, weatherUnits, title) {
    var opts = {
      zoom: {
        mode: 'x',
        enabled: true
      },
      pan: {
        mode: 'x',
        enabled: true
      },
      maintainAspectRatio: false,
      responsive: true,
      animation: false,
      title: {
        display: title ? true : false,
        text: title
      },
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: transVariableLabel(variable) + " (" + (weatherUnits[variable] || '-') + ")"
          },
          ticks: {
            beginAtZero: true
          }
        }],
        xAxes: [{
          type: 'time',
          time: timeOptions,
          ticks: {
            autoSkip: true,
            autoSkipPadding: 20,
            maxRotation: 0,
            minRotation: 0
          },
          scaleLabel: {
            display: true,
            labelString: t('Chart.Time')
          }
        }]
      }
    };
    return opts;
  }, [transVariableLabel]);
  var getMeteoData = useCallback(function () {
    var measureDataset = {
      label: 'Mesure',
      fill: false,
      borderColor: 'rgb(255, 140, 0)',
      backgroundColor: 'rgb(255, 140, 0)',
      pointBackgroundColor: [],
      pointBorderWidth: 1,
      pointHoverRadius: 6,
      pointHoverBackgroundColor: 'rgba(255, 140, 0, 1.0)',
      pointHoverBorderColor: 'rgb(220,220,220)',
      pointHoverBorderWidth: 2,
      pointRadius: [],
      pointHitRadius: 10,
      data: []
    };
    var obsChartData = {
      labels: [],
      datasets: []
    };
    if (weatherData && selectedWeatherVariable) {
      log(weatherData, 'WEATHER DATA CHART');
      log(selectedWeatherVariable, 'selected');
      if (weatherData.timeframes && weatherData.timeframes.length > 0) {
        var timeLabels = weatherData.timeframes.map(function (time) {
          return new Date(time);
        });
        obsChartData.labels = timeLabels;
        obsChartData.times = weatherData.timeframes;
      }
      obsChartData.datasets.push(Object.assign({}, measureDataset));
      var vals = weatherData.data.map(function (d) {
        var outval = NaN;
        if (d[selectedWeatherVariable] !== null) {
          outval = Number(d[selectedWeatherVariable]);
        }
        return outval;
      });
      obsChartData.datasets[0].data = vals;
      obsChartData.datasets[0].label = "" + transVariableLabel(selectedWeatherVariable);
    }
    return obsChartData;
  }, [weatherData, selectedWeatherVariable]);
  var onSelectVariableHandler = React.useCallback(function (v) {
    setSelectedWeatherVariable(v);
  }, []);
  React.useEffect(function () {
    if (!metsta || !metsta.id) return;
    if (!timeseries) return;
    if (!timeseries.datedeb || !timeseries.datefin) return;
    if (!client || !client.token) return;
    var isMounted = true;
    if (timeseries.datedeb.value instanceof Date && timeseries.datefin.value instanceof Date) {
      setIsLoading(true);
      setError(false);
      var startDate = timeseries.datedeb.value;
      var endDate = timeseries.datefin.value;
      var pp = [metsta.id];
      var qp = {
        obs_type: 'met',
        start_date: parseTime(startDate, '{y}-{m}-{d}T{h}:{i}:{s}'),
        end_date: parseTime(endDate, '{y}-{m}-{d}T{h}:{i}:{s}'),
        timezone: tz
      };
      var _url = getUrlService({
        version: process.env.REACT_APP_OBS_API_VERSION || '',
        name: process.env.REACT_APP_OBS_API + '/stations'
      }, pp, qp);
      log(_url, 'URL meteo services', 'info');
      fetch(_url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          'X-ARIA-CLIENT-TOKEN': client.token
        }
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        if (!isMounted) return;
        setIsLoading(false);
        if (json.data) {
          log(json.data, '*** Meteo response: ');
          var measures = json.data.measures;
          if (Array.isArray(measures.data) && measures.data.length > 0) {
            var vars = [];
            measures.data.map(function (vlist) {
              Object.keys(vlist).map(function (v) {
                if (vars.indexOf(v) === -1) {
                  vars.push(v);
                }
              });
            });
            if (vars.indexOf('FDI') >= 0) {
              vars.splice(vars.indexOf('FDI'), 1);
            }
            if (vars.indexOf('timeframe') >= 0) {
              vars.splice(vars.indexOf('timeframe'), 1);
            }
            var varObjs = vars.map(function (v) {
              return {
                label: transVariableLabel(v),
                value: v
              };
            });
            setWeatherVariables(varObjs);
            setSelectedWeatherVariable(vars[0]);
          }
          if (measures.units) {
            setWeatherUnits(measures.units);
          }
          setWeatherData(measures);
          if (typeof saveDataCB == 'function') {
            saveDataCB(measures);
          }
        }
      })["catch"](function (error) {
        setError(error.toString());
        setIsLoading(false);
      });
    }
    return function () {
      isMounted = false;
    };
  }, [timeseries, transVariableLabel, metsta, tz, client]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, Array.isArray(weatherVariables) && /*#__PURE__*/React.createElement(AriaSelect, {
    options: weatherVariables,
    selected: selectedWeatherVariable,
    onSelectHandler: onSelectVariableHandler
  }), /*#__PURE__*/React.createElement(Paper, {
    elevation: 0,
    className: loading ? '' : classes.chart
  }, loading ? /*#__PURE__*/React.createElement(LinearProgress, {
    className: classes.linearProgress
  }) : error ? /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, t('Chart.Error_loading_message')) : /*#__PURE__*/React.createElement(Line, {
    id: 'chart_widget',
    ref: chartRef,
    data: getMeteoData(),
    options: useOptions(selectedWeatherVariable, weatherUnits),
    redraw: true,
    height: 300
  })));
});

var useStyles$d = makeStyles(function (theme) {
  var _chart;
  return {
    root: {
      width: '100%'
    },
    toolbar: {
      display: 'flex',
      flexDirection: 'row',
      padding: 0
    },
    chart: (_chart = {
      height: '35vh'
    }, _chart[theme.breakpoints.down('sm')] = {
      height: '65vh'
    }, _chart)
  };
});
var AriaObservationChart = (function (_ref) {
  var saveDataCB = _ref.saveDataCB;
  var classes = useStyles$d();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var chartRef = useRef({});
  var _React$useState = React.useState(false),
    loading = _React$useState[0],
    setIsLoading = _React$useState[1];
  var _React$useState2 = React.useState(false),
    error = _React$useState2[0],
    setError = _React$useState2[1];
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0];
  var tz = store['timezone'];
  var timeseries = store['timeseries'];
  var project = store['project'];
  var sensor = store['currentSensor'];
  var _React$useState3 = React.useState(undefined),
    weatherData = _React$useState3[0],
    setWeatherData = _React$useState3[1];
  var _React$useState4 = React.useState(undefined),
    weatherVariables = _React$useState4[0],
    setWeatherVariables = _React$useState4[1];
  var _React$useState5 = React.useState('temperature'),
    selectedWeatherVariable = _React$useState5[0],
    setSelectedWeatherVariable = _React$useState5[1];
  var _React$useState6 = React.useState({}),
    setWeatherUnits = _React$useState6[1];
  var transVariableLabel = useCallback(function (selectedWeatherVariable) {
    if (selectedWeatherVariable == "temperature") {
      return t('Chart.Temperature');
    } else if (selectedWeatherVariable == "humidity") {
      return t('Chart.Humidity');
    } else if (selectedWeatherVariable == "pressure") {
      return t('Chart.Pressure');
    } else if (selectedWeatherVariable == "solar_radiation") {
      return t('Chart.Solar_radiation');
    } else if (selectedWeatherVariable == "Rainfall") {
      return t('Chart.Total_rain');
    } else if (selectedWeatherVariable == "wind_average") {
      return t('Chart.Wind_average');
    } else if (selectedWeatherVariable == "wind_direction") {
      return t('Chart.Wind_direction');
    } else {
      return selectedWeatherVariable;
    }
  }, []);
  var useOptions = useCallback(function (observationStationLabel) {
    var opts = {
      maintainAspectRatio: false,
      responsive: true,
      animation: false,
      tooltips: {
        mode: 'index',
        callbacks: {
          label: function label(tooltipItem, data) {
            var val = tooltipItem.yLabel.toFixed(3);
            return val;
          }
        }
      },
      title: {
        display: true,
        text: "" + observationStationLabel
      },
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: "" + t('Chart.Measures')
          },
          ticks: {
            beginAtZero: true,
            min: 0
          }
        }],
        xAxes: [{
          scaleLabel: {
            display: true,
            labelString: t('Chart.Time')
          }
        }],
        y: {
          suggestedMin: 0
        }
      }
    };
    return opts;
  }, [transVariableLabel]);
  var getObservationsData = useCallback(function () {
    var measureDataset = {
      label: 'Mesure',
      fill: false,
      borderColor: 'rgb(255, 140, 0)',
      backgroundColor: 'rgb(255, 140, 0)',
      pointBackgroundColor: [],
      pointBorderWidth: 1,
      pointHoverRadius: 6,
      pointHoverBackgroundColor: 'rgba(255, 140, 0, 1.0)',
      pointHoverBorderColor: 'rgb(220,220,220)',
      pointHoverBorderWidth: 2,
      pointRadius: [],
      pointHitRadius: 10,
      data: []
    };
    var obsChartData = {
      labels: [],
      datasets: []
    };
    if (weatherData && selectedWeatherVariable) {
      log(weatherData, 'WEATHER DATA CHART');
      log(selectedWeatherVariable, 'selected');
      if (weatherData.timeframes && weatherData.timeframes.length > 0) {
        var timeLabels = weatherData.timeframes.map(function (time) {
          return parseTime(time, '{y}-{m}-{d} {h}:{i}');
        });
        obsChartData.labels = timeLabels;
        obsChartData.times = weatherData.timeframes;
      }
      obsChartData.datasets.push(Object.assign({}, measureDataset));
      var vals = weatherData.data.map(function (d) {
        return Number(d[selectedWeatherVariable]);
      });
      obsChartData.datasets[0].data = vals;
      obsChartData.datasets[0].label = "" + transVariableLabel(selectedWeatherVariable);
    }
    return obsChartData;
  }, [weatherData, selectedWeatherVariable]);
  var onSelectVariableHandler = React.useCallback(function (v) {
    setSelectedWeatherVariable(v);
  }, []);
  React.useEffect(function () {
    if (!project) return;
    if (isEmpty(sensor)) return;
    if (!timeseries) return;
    if (!timeseries.datedeb || !timeseries.datefin) return;
    var isMounted = true;
    if (timeseries.datedeb.value instanceof Date && timeseries.datefin.value instanceof Date) {
      setIsLoading(true);
      setError(false);
      var startDate = timeseries.datedeb.value;
      var endDate = timeseries.datefin.value;
      var pp = [sensor.id];
      var qp = {
        obs_type: 'aq',
        site: project.toLowerCase(),
        start_date: parseTime(startDate, '{y}-{m}-{d}T{h}:{i}:{s}'),
        end_date: parseTime(endDate, '{y}-{m}-{d}T{h}:{i}:{s}'),
        timezone: tz
      };
      var _url = getUrlService(project.toLowerCase() + "/observations", pp, qp);
      log(_url, 'URL Observation services', 'info');
      fetch(_url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        }
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        if (!isMounted) return;
        setIsLoading(false);
        if (json.data) {
          log(json.data, '*** Observation response: ');
          if (Array.isArray(json.data.data) && json.data.data.length > 0) {
            var vars = Object.keys(json.data.data[0]);
            if (vars.indexOf('FDI') !== -1) {
              vars.splice(vars.indexOf('FDI'), 1);
            }
            var varObjs = vars.map(function (v) {
              return {
                label: transVariableLabel(v),
                value: v
              };
            });
            setWeatherVariables(varObjs);
            setSelectedWeatherVariable(vars[0]);
          }
          if (json.data.units) {
            setWeatherUnits(json.data.units);
          }
          setWeatherData(json.data);
          if (typeof saveDataCB == 'function') {
            saveDataCB(json.data);
          }
        }
      })["catch"](function (error) {
        setError(error.toString());
        setIsLoading(false);
      });
    }
    return function () {
      isMounted = false;
    };
  }, [project, timeseries, transVariableLabel, sensor, tz]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.toolbar
  }, Array.isArray(weatherVariables) && /*#__PURE__*/React.createElement(AriaSelect, {
    fullWidth: true,
    options: weatherVariables,
    selected: selectedWeatherVariable,
    onSelectHandler: onSelectVariableHandler
  })), /*#__PURE__*/React.createElement(Paper, {
    elevation: 0,
    className: loading ? '' : classes.chart
  }, loading ? /*#__PURE__*/React.createElement(LinearProgress, {
    className: classes.linearProgress
  }) : error ? /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, t('Chart.Error_loading_message')) : /*#__PURE__*/React.createElement(Line, {
    id: 'chart_widget',
    ref: chartRef,
    data: getObservationsData(),
    options: useOptions(selectedWeatherVariable),
    redraw: true,
    height: 300
  })));
});

function getPercentile(data, percentile) {
  data.sort(numSort);
  var index = percentile / 100 * data.length;
  var result;
  if (Math.floor(index) == index) {
    result = (data[index - 1] + data[index]) / 2;
  } else {
    result = data[Math.floor(index)];
  }
  return result;
}
function numSort(a, b) {
  return a - b;
}
function getBoxValues(data) {
  var boxValues = {};
  boxValues.low = Math.min.apply(Math, data).toFixed(3);
  boxValues.q1 = getPercentile(data, 25).toFixed(3);
  boxValues.median = getPercentile(data, 50).toFixed(3);
  boxValues.q3 = getPercentile(data, 75).toFixed(3);
  boxValues.high = Math.max.apply(Math, data).toFixed(3);
  return boxValues;
}
function write2ImagePollutionRose(canvasId) {
  var canvas = document.getElementById(canvasId);
  var svg;
  for (var _iterator = _createForOfIteratorHelperLoose(canvas.children), _step; !(_step = _iterator()).done;) {
    var child = _step.value;
    svg = child.children[0];
  }
  var svgRect = svg.getBoundingClientRect();
  var canvas2 = document.createElement('canvas');
  canvas2.width = svgRect.width;
  canvas2.height = svgRect.width;
  var ctx = canvas2.getContext('2d');
  ctx.fillStyle = 'white';
  ctx.fillRect(0, 0, canvas2.width, canvas2.height);
  var svgString = new XMLSerializer().serializeToString(svg);
  var img = new Image();
  img.onload = function () {
    ctx.drawImage(img, 0, 0);
    var imageDataUri = canvas2.toDataURL('image/png');
    var link = document.createElement('a');
    link.download = 'ChartImage.png';
    link.href = imageDataUri;
    link.click();
  };
  img.src = 'data:image/svg+xml;base64,' + btoa(svgString);
}
function write2Image$1(canvasId) {
  var canvas = document.getElementById(canvasId);
  var context = canvas.getContext('2d');
  context.fillStyle = 'gray';
  var url_base64png = canvas.toDataURL('image/png');
  var link = document.getElementById('download');
  if (!link) {
    link = document.createElement('a');
    link.setAttribute('id', 'download');
  }
  link.download = "ChartImage.png";
  link.href = url_base64png;
  link.click();
}
function writeWeatherToCSVLine(layers, chartData) {
  log(chartData, 'chartData');
  log(layers, 'LAYERS');
  if (Object.keys(layers).length == 0) {
    console.error('No layer found in the first argument');
    return;
  }
  var staname = Object.keys(layers)[0];
  var csvContent = [];
  csvContent[0] = [];
  var header = ['id', 'name', 'timeserie'];
  var datasets = chartData.data;
  var times = chartData.timeframes;
  var units = chartData.units;
  var varlbls = [];
  var vars = Object.keys(units);
  vars.forEach(function (v) {
    varlbls.push(v + "-" + units[v]);
  });
  header = header.concat(varlbls);
  csvContent[0] = header;
  var il = 0;
  times.forEach(function (d, di) {
    il++;
    csvContent[il] = [];
    var dtstr;
    dtstr = d;
    var dline = [il, staname, dtstr];
    vars.forEach(function (v) {
      var dat = datasets[di][v];
      dline.push(dat);
    });
    csvContent[il] = dline;
  });
  var fileContent = '';
  csvContent.forEach(function (line, id) {
    fileContent += line.join(';') + '\r\n';
  });
  writeContentToFile$1(fileContent, 'csv');
}
function writeObsToCSVLine(staname, layers, chartData) {
  try {
    log(chartData, 'chartData');
    log(layers, 'LAYERS');
    var csvContent = [];
    csvContent[0] = [];
    var header = ['id', 'name', 'timeserie'];
    var datasets = chartData.datasets;
    var times = chartData.labels;
    var tfs = chartData.timeframes;
    var vars = [];
    var varIds = {};
    datasets.forEach(function (d, i) {
      vars.push(d.label);
      header.push(d.label);
      varIds[d.label] = i;
    });
    csvContent[0] = header;
    var il = 0;
    times.forEach(function (d, di) {
      il++;
      csvContent[il] = [];
      var dtstr;
      dtstr = parseTime(d, '{y}-{m}-{d}T{h}:{i}:{s}', false);
      var dline = [il, staname, dtstr];
      vars.forEach(function (v) {
        dline.push(datasets[varIds[v]].data[di]);
      });
      csvContent[il] = dline;
    });
    var fileContent = '';
    csvContent.forEach(function (line, id) {
      log(line.join(';') + '\r\n', id);
      fileContent += line.join(';') + '\r\n';
    });
    log(fileContent);
    writeContentToFile$1(fileContent, 'csv');
  } catch (error) {
    alert(error);
    return;
  }
}
function writeToCSVLine$1(varname, markers, layers, typeGraphic, chartData, varlabel, markerPrefix) {
  log(chartData, 'chartData');
  var csvContent = [];
  csvContent[0] = [];
  var header = ['id', 'name', 'timeserie', 'location', 'geometry'];
  if (typeGraphic === 'line' || typeGraphic === 'line_simulation') {
    header = ['id', 'name', 'timeserie', 'location', 'geometry'];
  } else if (typeGraphic === 'boxplot') {
    header = ['id', 'name', 'type', 'location', 'geometry'];
  } else if (typeGraphic === 'season_cycle') {
    header = ['id', 'name', 'timeserie', 'location', 'geometry'];
  }
  var datasets = chartData.datasets;
  var times = chartData.labels;
  var timeframes = chartData.times;
  if (typeGraphic === 'boxplot') {
    header.push(varname + "_min");
    header.push(varname + "_max");
    header.push(varname + "_mediane");
    header.push(varname + "_q1");
    header.push(varname + "_q3");
  } else {
    header.push(varlabel || varname);
  }
  csvContent[0] = header;
  var il = 0;
  var _markers = undefined;
  if (markers.length == 0) {
    _markers = Object.keys(layers);
  } else {
    _markers = markers;
  }
  var _loop = function _loop(im) {
    var lat = null;
    var lng = null;
    var loc = '-';
    var geom = '-';
    var l = layers[_markers[im]];
    try {
      geom = 'POINT';
      lat = l.getLatLng().lat.toFixed(5);
      lng = l.getLatLng().lng.toFixed(5);
      loc = "[" + lat + ", " + lng + "]";
    } catch (e) {
      geom = 'POLYGON';
      var latlngs = l.getLatLngs()[0];
      var locs = [];
      latlngs.forEach(function (latlng) {
        locs.push("[" + latlng.lat.toFixed(5) + ", " + latlng.lng.toFixed(5) + "]");
      });
      loc = "[" + locs.join(',') + "]";
    }
    if (typeGraphic === 'line' || typeGraphic === 'season_cycle') {
      datasets.forEach(function (ds) {
        var dat = ds.data;
        var lbl = ds.label;
        if (markerPrefix) {
          lbl = markerPrefix + "-" + lbl;
        }
        dat.forEach(function (d, di) {
          il++;
          csvContent[il] = [];
          var dtstr;
          dtstr = times[di];
          if (timeframes) {
            dtstr = parseTime(timeframes[di], '{y}-{m}-{d} {h}h');
          }
          var dline = [il, lbl, dtstr, loc, geom, d.toFixed(3)];
          csvContent[il] = dline;
        });
      });
    } else if (typeGraphic === 'boxplot') {
      if (datasets.length == 3) {
        datasets.forEach(function (ds) {
          var dat = ds.data[im];
          var lbl = ds.label;
          if (!dat) return;
          il++;
          var d = getBoxValues(dat);
          var dline = [il, times[im], lbl, loc, geom, d['low'], d['high'], d['median'], d['q1'], d['q3']];
          csvContent[il] = dline;
        });
      } else {
        csvContent[0] = 'The number of dataset for Boxplot is not equal to 3. [Historique, 2050, 2100]';
      }
    } else if (typeGraphic === 'line_simulation') {
      datasets.forEach(function (ds) {
        var dat = ds.data;
        var lbl = ds.label;
        if (markerPrefix) {
          lbl = markerPrefix + "-" + lbl;
        }
        dat.forEach(function (d, di) {
          il++;
          csvContent[il] = [];
          var dtstr;
          dtstr = parseTime(times[di], '{y}-{m}-{d}T{h}:{i}:{s}');
          if (timeframes) {
            dtstr = parseTime(timeframes[di], '{y}-{m}-{d} {h}h00');
          }
          var dline = [il, lbl, dtstr, loc, geom, d.toFixed(3)];
          csvContent[il] = dline;
        });
      });
    }
  };
  for (var im in _markers) {
    _loop(im);
  }
  var fileContent = '';
  csvContent.forEach(function (line, id) {
    fileContent += line.join(';') + '\r\n';
  });
  writeContentToFile$1(fileContent, 'csv');
}
function writeContentToFile$1(csvContent, fileType) {
  var type = fileType || 'csv';
  var blob = new Blob([csvContent], {
    encoding: 'UTF-8',
    type: 'text/' + type + ';charset=UTF-8'
  });
  if (Browser.ie) {
    window.navigator.msSaveBlob(blob, 'timeseries.' + type);
  } else {
    var url = URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'timeseries.' + type);
    var clickEvent = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: false
    });
    link.dispatchEvent(clickEvent);
  }
}

function useCompare(val) {
  var prevVal = usePrevious(val);
  return prevVal !== val;
}
function usePrevious(value) {
  var ref = useRef();
  useEffect(function () {
    ref.current = value;
  });
  return ref.current;
}

var NCOLORS = 5;
var FixedColors = [hexToRGB('#742e98'), hexToRGB('#feb236'), hexToRGB('#d64161'), hexToRGB('#86af49'), hexToRGB('#4db2fa')];
var dynamicColors = function dynamicColors() {
  var r = Math.floor(Math.random() * 255);
  var g = Math.floor(Math.random() * 255);
  var b = Math.floor(Math.random() * 255);
  return ["rgb(" + r + "," + g + "," + b + ")", "rgba(" + r + "," + g + "," + b + "),0.5"];
};
function computeChartData(time, datetimeFormat, selectedDataFile, tsdata, datasetColors, pointColors, label, regroup) {
  if (regroup === void 0) {
    regroup = false;
  }
  var defaultDataset = {
    label: 'Référence',
    fill: false,
    borderColor: 'rgb(119,136,153)',
    backgroundColor: 'rgb(63, 81, 181)',
    pointBackgroundColor: [],
    pointBorderWidth: 1,
    pointHoverRadius: 6,
    pointHoverBackgroundColor: 'rgba(63, 81, 181, 1.0)',
    pointHoverBorderColor: 'rgb(220,220,220)',
    pointHoverBorderWidth: 2,
    pointRadius: [],
    pointHitRadius: 10,
    data: []
  };
  var boundDataset = {
    label: 'Scénario 1',
    fill: false,
    borderColor: 'rgb(119,136,153)',
    backgroundColor: 'rgb(169,169,169)',
    pointBackgroundColor: [],
    pointBorderWidth: 1,
    pointHoverRadius: 3,
    pointHoverBackgroundColor: 'rgba(0, 200, 200, 1.0)',
    pointHoverBorderColor: 'rgb(220,220,220)',
    pointHoverBorderWidth: 2,
    pointRadius: [],
    pointHitRadius: 5,
    data: []
  };
  var addColorObject = function addColorObject(pnt) {
    var cid = Object.keys(datasetColors).length;
    if (!(pnt in datasetColors)) {
      if (cid > NCOLORS) datasetColors[pnt] = dynamicColors();else {
        if (Array.isArray(pointColors)) {
          datasetColors[pnt] = pointColors[cid];
        } else {
          datasetColors[pnt] = FixedColors[cid];
        }
      }
    }
    return datasetColors[pnt];
  };
  var chartData = {
    labels: [],
    datasets: []
  };
  try {
    var pnts = Object.keys(tsdata);
    if (pnts.length == 0) {
      return chartData;
    }
    log(selectedDataFile, 'selectedDataFile in computeChartData: ');
    if (isEmpty(selectedDataFile)) return chartData;
    log(tsdata, 'tsdata in computeChartData: ');
    pnts.forEach(function (pnt, id) {
      if (!(pnt in datasetColors)) {
        addColorObject(pnt);
      }
      var clrs = datasetColors[pnt];
      if (!clrs) return;
      var fill_q10 = -1;
      var fill_q90 = -1;
      var _loop = function _loop() {
        if (!(selectedDataFile in tsdata[pnt][vname])) return "continue";
        var vals = tsdata[pnt][vname][selectedDataFile].values;
        var tims = tsdata[pnt][vname][selectedDataFile].times;
        if (vname.endsWith('_Q10') || vname.endsWith('_Q90')) {
          chartData.datasets.push(Object.assign({}, boundDataset));
        } else {
          chartData.datasets.push(Object.assign({}, defaultDataset));
        }
        var cnt = chartData.datasets.length - 1;
        if (vname.endsWith('_Q10')) {
          fill_q10 = cnt;
        }
        if (vname.endsWith('_Q90')) {
          fill_q90 = cnt;
        }
        if (fill_q10 > 0 && fill_q90 > 0) {
          chartData.datasets[fill_q10].fill = fill_q90;
          fill_q10 = -1;
          fill_q90 = -1;
        }
        if (vname.endsWith('_Q10') || vname.endsWith('_Q90')) {
          chartData.datasets[cnt].backgroundColor = clrs.secondary || hexToRGBA(clrs.primary) || clrs[1];
          chartData.datasets[cnt].borderColor = clrs.secondary || hexToRGBA(clrs.primary) || clrs[1];
        } else {
          chartData.datasets[cnt].backgroundColor = clrs.primary || clrs[0];
          chartData.datasets[cnt].borderColor = clrs.primary || clrs[0];
        }
        if (!chartData.times && chartData.labels.length == 0) {
          chartData.times = tims;
          var timeLabels = tims.map(function (time) {
            return new Date(time);
          });
          chartData.labels = timeLabels;
        }
        chartData.datasets[cnt].data = vals;
        if (regroup && cnt > 0) {
          chartData.datasets[0].data = chartData.datasets[0].data.map(function (value, id) {
            return value + chartData.datasets[cnt].data[id];
          });
        }
        chartData.datasets[cnt].label = label ? label : "" + pnt;
        log(time, 'On Effect timeseries with current timeframe: ');
        for (var i = 0; i < chartData.datasets[cnt].data.length; i++) {
          if (vname.endsWith('_Q10') || vname.endsWith('_Q90')) {
            chartData.datasets[cnt].pointRadius[i] = 0;
            chartData.datasets[cnt].pointBackgroundColor[i] = clrs.secondary || hexToRGBA(clrs.primary) || clrs[1];
          } else {
            chartData.datasets[cnt].pointRadius[i] = 3;
          }
        }
      };
      for (var vname in tsdata[pnt]) {
        var _ret = _loop();
        if (_ret === "continue") continue;
      }
    });
    return chartData;
  } catch (err) {
    if (process.env.NODE_ENV === 'development') {
      console.warn(err.message);
    }
    return chartData;
  }
}

var useStyles$e = makeStyles(function (theme) {
  return {
    root: {
      width: '100%',
      textAlign: 'center'
    },
    toolbar: {
      display: 'flex',
      flexDirection: 'row',
      padding: 0
    },
    chart: {
      width: '90%',
      marginLeft: '7%'
    },
    buttonExpand: {
      marginTop: '-60px',
      display: 'flex',
      justifyContent: 'flex-end',
      maxWidth: '400px'
    }
  };
});
var AriaPollutionRose = (function (_ref) {
  var selectedPollutantRose = _ref.selectedPollutantRose,
    selectedTumblingAverage = _ref.selectedTumblingAverage,
    removeOutlier = _ref.removeOutlier;
  var classes = useStyles$e();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _React$useState = React.useState(false),
    loading = _React$useState[0],
    setLoading = _React$useState[1];
  var _React$useState2 = React.useState(false),
    error = _React$useState2[0],
    setError = _React$useState2[1];
  var _React$useState3 = React.useState(undefined),
    roseData = _React$useState3[0],
    setRoseData = _React$useState3[1];
  var _React$useState4 = React.useState(false),
    open = _React$useState4[0],
    setOpen = _React$useState4[1];
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0];
  var tz = store['timezone'];
  var timeseries = store['timeseries'];
  var client = store['client'];
  var interestedZone = store['extraction_zones'];
  var metsta = store['weather_monitoring_sensor'];
  React.useEffect(function () {
    setLoading(true);
    setError(false);
    setRoseData(undefined);
    var startDate = timeseries.datedeb.value;
    var endDate = timeseries.datefin.value;
    if (Object.keys(interestedZone.features).length > 0 && selectedPollutantRose) {
      var stationId = Object.keys(interestedZone.features)[0];
      var pp = [stationId, 'rose'];
      var qp = {
        obs_type: 'aq',
        start_date: parseTime(startDate, '{y}-{m}-{d}T{h}:{i}:{s}'),
        end_date: parseTime(endDate, '{y}-{m}-{d}T{h}:{i}:{s}'),
        timezone: tz,
        variable: selectedPollutantRose,
        meteo_origin: metsta.id
      };
      if (removeOutlier) {
        qp['qa_qc'] = 'True';
      } else {
        qp['qa_qc'] = 'False';
      }
      if (selectedTumblingAverage.value) {
        qp['tav'] = selectedTumblingAverage.value;
      }
      var _url = getUrlService({
        version: process.env.REACT_APP_OBS_API_VERSION || '',
        name: process.env.REACT_APP_OBS_API + '/stations'
      }, pp, qp, true);
      log(_url, 'URL Get AQ pollution Rose');
      fetch(_url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          'X-ARIA-CLIENT-TOKEN': client.token
        }
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        setLoading(false);
        if (json.data) {
          setRoseData(json.data);
        }
        if (json.error) {
          if (json.error.message) setError(true);
        }
      });
    } else {
      setLoading(false);
      setError(true);
    }
  }, [timeseries, selectedPollutantRose, interestedZone, selectedTumblingAverage, removeOutlier]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Paper, {
    elevation: 0,
    className: loading ? '' : classes.chart
  }, loading ? /*#__PURE__*/React.createElement(LinearProgress, {
    className: classes.linearProgress
  }) : error ? /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, t('Chart.Error_loading_message')) : /*#__PURE__*/React.createElement("div", null, roseData && roseData.chartData && roseData.columns && /*#__PURE__*/React.createElement("div", {
    id: 'chart_widget',
    style: {
      height: '350px',
      width: '500px'
    }
  }, /*#__PURE__*/React.createElement(WindRose, {
    width: 400,
    height: 350,
    data: roseData.chartData,
    columns: roseData.columns
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonExpand
  }, /*#__PURE__*/React.createElement(Tooltip$1, {
    title: ''
  }, /*#__PURE__*/React.createElement(IconButton$1, {
    color: "inherit",
    "aria-label": "save",
    onClick: function onClick() {
      return setOpen(true);
    }
  }, /*#__PURE__*/React.createElement(AspectRatio, null)))))), /*#__PURE__*/React.createElement(Dialog$1, {
    fullWidth: true,
    open: open
  }, /*#__PURE__*/React.createElement(DialogTitle$1, null, t('Map.Pollution_rose'), " "), /*#__PURE__*/React.createElement(DialogContent$1, {
    style: {
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement("div", {
    id: 'chart_widget_big',
    style: {
      width: '700px',
      height: '500px'
    }
  }, roseData && roseData.chartData && roseData.columns && /*#__PURE__*/React.createElement(WindRose, {
    width: 500,
    height: 500,
    data: roseData.chartData,
    columns: roseData.columns
  }))), /*#__PURE__*/React.createElement(DialogActions$1, null, /*#__PURE__*/React.createElement(Button$1, {
    color: "primary",
    onClick: function onClick() {
      return setOpen(false);
    }
  }, "Retour"))));
});

function searchColorByRegulation(data, regulation) {
  if (data == null || data == undefined || !regulation) {
    return '#a3a3a3';
  }
  var possibleThresholds = [];
  var maxLevelThreshold = 0;
  var thresholds = regulation['Thresholds'];
  for (var _iterator = _createForOfIteratorHelperLoose(thresholds), _step; !(_step = _iterator()).done;) {
    var thresh = _step.value;
    if (eval(data.toString() + thresh['Operator'] + thresh['Level'].toString())) {
      possibleThresholds.push(thresh);
      maxLevelThreshold = thresh['Level'] > maxLevelThreshold ? thresh['Level'] : maxLevelThreshold;
    }
  }
  if (possibleThresholds.length == 0) {
    return '#a3a3a3';
  }
  var finalThreshold = possibleThresholds.filter(function (pThresh) {
    return pThresh['Level'] == maxLevelThreshold;
  });
  return finalThreshold[0].Color;
}
function searchRegulationByPollutant(regulations, pollutant) {
  var startName = 'ATMO_';
  if (!regulations || !pollutant) return undefined;
  for (var _iterator2 = _createForOfIteratorHelperLoose(regulations), _step2; !(_step2 = _iterator2()).done;) {
    var regulation = _step2.value;
    if (regulation.Name == startName + pollutant) {
      return regulation;
    }
  }
  return undefined;
}
function verifyListSensorsIdentical(list1, list2) {
  if (list1.length != list2.length) return false;
  for (var i = 0; i < list1.length; i++) {
    if (list1[i].labelAirQualityStation != list2[i].labelAirQualityStation) {
      return false;
    }
  }
  return true;
}

var useStyles$f = makeStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      textAlign: 'center',
      width: '100%',
      height: '100%'
    },
    toolbar: {
      display: 'flex',
      flexDirection: 'row',
      padding: 0
    },
    chart: {
      height: '30vh',
      width: '90%',
      marginLeft: '7%',
      marginTop: '-1%'
    },
    loading: {
      display: 'flex',
      justifyContent: 'center',
      height: '100%',
      alignItems: 'center'
    }
  };
});
var AriaContributionSources = (function (_ref) {
  var userinfo = _ref.userinfo,
    variable = _ref.variable,
    filteredFeatures = _ref.filteredFeatures,
    selectedMarker = _ref.selectedMarker,
    time = _ref.time,
    epsg = _ref.epsg;
  var classes = useStyles$f();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0];
  var _React$useState = React.useState({}),
    pdata = _React$useState[0],
    setPdata = _React$useState[1];
  var _React$useState2 = React.useState(undefined),
    contributionData = _React$useState2[0],
    setContributionData = _React$useState2[1];
  var case_dataset = store['dataset'].name;
  var _React$useState3 = React.useState(false),
    loading = _React$useState3[0],
    setLoading = _React$useState3[1];
  var _React$useState4 = React.useState(undefined),
    pollutant = _React$useState4[0],
    setPollutant = _React$useState4[1];
  var chartPieRef = React.useRef({});
  var backgroundPollutionValue = store['background_pollution'] && store['background_pollution'].used ? store['background_pollution'].value : 0;
  useEffect(function () {
    if (Object.keys(filteredFeatures[0]).length > 0) {
      setLoading(true);
      if (!(time instanceof Date)) return;
      log(time, 'Source contrib time: ');
      var feats = Object.keys(filteredFeatures[0]);
      var selectedMarkerCopy = selectedMarker;
      if (!selectedMarker || feats.length === 1) {
        selectedMarkerCopy = feats[0];
      }
      if (feats.length > 0) {
        var pp = [];
        var qp = {
          dataset: case_dataset,
          epsg: epsg,
          date_time: parseTime(time, '{y}-{m}-{d}T{h}:{i}:{s}', true),
          lat: filteredFeatures[0][selectedMarkerCopy].lat,
          lon: filteredFeatures[0][selectedMarkerCopy].lon
        };
        var _url = getUrlService('ariaview/sources_contribution', pp, qp, true);
        log(_url, 'URL Get sources_contribution');
        fetch(_url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json; charset=UTF-8'
          }
        }).then(function (response) {
          return response.json();
        }).then(function (json) {
          log(json, 'SOURCE CONTRIBUTIONS');
          setLoading(false);
          if (json.data) {
            setPdata(json.data);
            setPollutant(Object.keys(json.data)[0]);
          }
        });
      }
    }
  }, [time, epsg, filteredFeatures, selectedMarker]);
  React.useEffect(function () {
    log(pdata, 'PIE DATA HERE ');
    var priv = store['private_sources'];
    var pieData = {
      labels: [],
      datasets: [{
        label: 'Dataset 1',
        data: [],
        backgroundColor: ['red', 'orange', 'green', 'blue', 'purple', 'black', 'brown', 'pink', 'yellow']
      }]
    };
    if (pdata && pollutant) {
      log(pdata, 'PIE DATA', 'error');
      var group = variable.group;
      log(group, 'GROUP');
      log();
      var grp = 0;
      var contrib = pdata[group];
      if (priv && userinfo != 'ariote' && userinfo != 'Interne_SUEZ') {
        var sum = 0;
        Object.keys(pdata).map(function (inst) {
          if (inst === group) {
            log(pdata[inst], 'PDATA');
            Object.keys(pdata[inst]).map(function (v) {
              if (!pdata[inst][v].label.includes(userinfo) && pdata[inst][v].is_total === 0) {
                log(v, pdata[inst][v].label);
                sum += pdata[inst][v].value;
                delete pdata[inst][v];
              }
            });
          }
        });
        var others = {
          'OTHERS': {
            'is_total': 0,
            'label': 'Ext.',
            'value': sum
          }
        };
        Object.assign(pdata[group], others);
        log(pdata, 'PDATA');
      }
      if (backgroundPollutionValue) {
        contrib['backgroundPollution'] = {
          value: backgroundPollutionValue,
          is_total: 0,
          label: t('ControlPanel.Background_Pollution')
        };
      }
      var tt = 1;
      for (var c in contrib) {
        if (contrib[c].is_total == 1) {
          tt = Number(contrib[c].value);
          if (backgroundPollutionValue) tt += backgroundPollutionValue;
          break;
        }
      }
      for (var _c in contrib) {
        if (contrib[_c].is_total == 1) continue;
        var val = 100 * (Number(contrib[_c].value) / tt);
        pieData.datasets[grp].data.push(val);
        var label = contrib[_c].label.split('-')[1] ? contrib[_c].label.split('-')[1] : contrib[_c].label;
        pieData.labels.push(label);
      }
    }
    setContributionData(pieData);
  }, [pdata, pollutant, backgroundPollutionValue]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, Object.keys(filteredFeatures[0]).length > 0 && /*#__PURE__*/React.createElement(Typography$1, {
    className: Object.keys(filteredFeatures[0]).length > 1 ? classes.typo : null,
    color: 'primary',
    variant: "h4"
  }, filteredFeatures[0][Object.keys(filteredFeatures[0])[0]].name + ' :  ', /*#__PURE__*/React.createElement(Typography$1, null, "  ", parseTime(time, '{d}/{m}/{y}  {h}:{i}'))), /*#__PURE__*/React.createElement("div", {
    className: classes.chart
  }, loading ? /*#__PURE__*/React.createElement("div", {
    className: classes.loading
  }, " ", /*#__PURE__*/React.createElement(CircularProgress, null), " ") : contributionData && /*#__PURE__*/React.createElement(Pie, {
    id: 'chart_widget',
    ref: chartPieRef,
    data: contributionData,
    height: 300,
    redraw: true,
    options: {
      legend: {
        position: 'right'
      },
      title: {
        display: true
      },
      maintainAspectRatio: false,
      responsive: true,
      animation: false,
      tooltips: {
        callbacks: {
          label: function label(tooltipItem, data) {
            var dataset = data.datasets[tooltipItem.datasetIndex];
            var currentValue = dataset.data[tooltipItem.index];
            var currentLabel = data.labels[tooltipItem.index];
            return currentLabel + ":" + currentValue.toFixed(1) + "%";
          }
        }
      }
    }
  })));
});

var useStyles$g = makeStyles(function (theme) {
  return {
    root: {
      width: '100%',
      height: '100%',
      textAlign: 'center'
    },
    toolbar: {
      display: 'flex',
      flexDirection: 'row',
      padding: 0
    },
    chart: {
      width: '90%',
      marginLeft: '7%'
    },
    buttonExpand: {
      marginTop: '-60px',
      display: 'flex',
      justifyContent: 'flex-end',
      maxWidth: '400px'
    },
    linearProgress: {
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      placeContent: 'center'
    }
  };
});
var AriaTimeseriesReceptors = (function (_ref) {
  var chartRef = _ref.chartRef,
    lineSimulationData = _ref.lineSimulationData,
    setLineSimulationData = _ref.setLineSimulationData,
    date = _ref.date,
    variable = _ref.variable,
    lastRequestIdRef = _ref.lastRequestIdRef,
    filteredFeatures = _ref.filteredFeatures,
    domain = _ref.domain,
    epsg = _ref.epsg,
    addBackgroundColors = _ref.addBackgroundColors,
    backgroundRules = _ref.backgroundRules,
    dataset = _ref.dataset,
    timeOptions = _ref.timeOptions;
  var classes = useStyles$g();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0];
  var is_atomic = Number(store['is_atomic']);
  var _React$useState = React.useState(false),
    loading = _React$useState[0],
    setLoading = _React$useState[1];
  var _React$useState2 = React.useState(false);
  var _React$useState3 = React.useState(''),
    selectedDataFile = _React$useState3[0],
    setSelectedDataFile = _React$useState3[1];
  var tz = store['timezone'];
  var timeseries = store['timeseries'];
  var client = store['client'];
  var _React$useState4 = React.useState({}),
    tsdata = _React$useState4[0],
    setTsdata = _React$useState4[1];
  var derived_variable = store['derived_variable'];
  var variables_initial = store["dataset"].variables;
  var backgroundPollutionValue = store['background_pollution'] && store['background_pollution'].used ? store['background_pollution'].value : 0;
  React.useEffect(function () {
    if (Object.keys(filteredFeatures[0]).length > 0 && !isEmpty(variable.name) && !isEmpty(dataset)) {
      setLoading(true);
      var qp = {};
      var qpInitial = {};
      var pp;
      if (process.env.REACT_APP_API_VERSION !== 'v1') {
        var startDate = timeseries.datedeb.value;
        var endDate = timeseries.datefin.value;
        qp = {
          variables: variable.name,
          domain: domain,
          epsg: epsg,
          start_date: parseTime(startDate, '{y}-{m}-{d}T{h}:{i}:{s}', true),
          end_date: parseTime(endDate, '{y}-{m}-{d}T{h}:{i}:{s}', true),
          is_atomic: is_atomic,
          tsmin: -1000,
          derived_variable: derived_variable === undefined ? undefined : derived_variable.name
        };
        pp = ['ts', dataset];
      }
      var group = variable.group;
      var variable_is_total = [];
      variables_initial.map(function (dv) {
        if (dv.group == group && dv.isTotal == 1) variable_is_total.push(dv.name);
      });
      if (no_simulation(derived_variable)) {
        qp.derived_variable = undefined;
        qp.variables = variable_is_total;
      }
      qpInitial = _extends({}, qp, {
        derived_variable: undefined,
        variables: variable_is_total
      });
      log(filteredFeatures, 'etape 1 ');
      if (Object.keys(filteredFeatures[0]).length > 0) {
        var fetchList = [];
        var _url = getUrlService('points', pp, qp, true);
        var _urlInitialEmissions = getUrlService('points', pp, qpInitial, true);
        log(_url, 'URL Get timeseries');
        log(_urlInitialEmissions, 'URL Get timeseries initial');
        fetchList.push(fetch(_urlInitialEmissions, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json; charset=UTF-8'
          },
          body: JSON.stringify(filteredFeatures[0])
        }));
        if (_url != _urlInitialEmissions) {
          fetchList.push(fetch(_url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json; charset=UTF-8'
            },
            body: JSON.stringify(filteredFeatures[0])
          }));
        }
        var requestId = ++lastRequestIdRef.current;
        Promise.all(fetchList).then(function (res) {
          return Promise.all(res.map(function (r) {
            return r.json();
          }));
        }).then(function (dataJSON) {
          log(dataJSON, 'dataJSON');
          if (requestId === lastRequestIdRef.current) {
            setLoading(false);
            setTsdata(dataJSON);
          }
        });
      }
    }
  }, [dataset, date, timeseries, domain, epsg, variable, filteredFeatures[0], tz, client, derived_variable]);
  React.useEffect(function () {
    if (!tsdata[0]) return;
    var colors = ['#ababab', 'purple'];
    var tsdataInitial = tsdata[0].data;
    setSelectedDataFile(Object.keys(tsdataInitial[Object.keys(tsdataInitial)[0]])[0]);
    if (!selectedDataFile) return;
    var _lineData = {};
    _lineData['labels'] = tsdataInitial[Object.keys(tsdataInitial)[0]][selectedDataFile].times.map(function (time) {
      return new Date(time);
    });
    var lineDatasets = [];
    if (tsdata[1] && tsdata[1].data) {
      var tsdataScenario = tsdata[1].data;
      var datasetScenario = createDataset(tsdataScenario[Object.keys(tsdataScenario)[0]][selectedDataFile], 'Scenario', colors.pop(), backgroundPollutionValue);
      lineDatasets.push(datasetScenario);
    }
    var datasetInitial = createDataset(tsdataInitial[Object.keys(tsdataInitial)[0]][selectedDataFile], 'Situation Acutelle', colors.pop(), backgroundPollutionValue);
    lineDatasets.push(datasetInitial);
    _lineData["datasets"] = lineDatasets;
    setLineSimulationData(_lineData);
  }, [date, selectedDataFile, tsdata, backgroundPollutionValue]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, loading ? /*#__PURE__*/React.createElement("div", {
    className: classes.linearProgress
  }, /*#__PURE__*/React.createElement(CircularProgress, null)) : lineSimulationData && /*#__PURE__*/React.createElement(Line, {
    id: 'chart_widget',
    ref: chartRef,
    data: lineSimulationData,
    plugins: [{
      beforeDraw: addBackgroundColors
    }],
    options: {
      backgroundRules: backgroundRules,
      zoom: {
        enabled: true,
        mode: 'x'
      },
      pan: {
        enabled: true,
        mode: 'x'
      },
      legend: {
        position: 'right'
      },
      maintainAspectRatio: false,
      responsive: true,
      tooltips: {
        mode: 'index',
        callbacks: {
          label: function label(tooltipItem, data) {
            var val = tooltipItem.yLabel.toFixed(3);
            return "" + val;
          }
        }
      },
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: variable.title.split("-")[0] + ' (' + variable.unit + ')'
          },
          ticks: {
            beginAtZero: true,
            min: 0
          }
        }],
        xAxes: [{
          type: 'time',
          time: timeOptions,
          ticks: {
            autoSkip: true,
            autoSkipPadding: 20,
            maxRotation: 0,
            minRotation: 0
          },
          scaleLabel: {
            display: true,
            labelString: t('Chart.Time')
          }
        }]
      }
    }
  }));
});
function no_simulation(variablesD) {
  if (!variablesD && !variablesD.variables) return true;
  for (var dv in variablesD.variables) {
    if (variablesD.variables[dv].transform == 1 && variablesD.variables[dv].transformA != 1) {
      return false;
    }
  }
  return true;
}
function createDataset(serie, label, color, backgroundPollution) {
  if (backgroundPollution === void 0) {
    backgroundPollution = 0;
  }
  var values = serie.values[Object.keys(serie.values)[0]].map(function (val) {
    return val + backgroundPollution;
  });
  return {
    label: label,
    data: values,
    fill: false,
    borderColor: color,
    backgroundColor: color,
    pointBorderWidth: 1,
    pointHoverRadius: 6,
    pointHoverBackgroundColor: color,
    pointHoverBorderColor: color,
    pointHoverBorderWidth: 2,
    pointHitRadius: 10
  };
}

var useStyles$h = makeStyles(function (theme) {
  return {
    root: {
      width: '100%',
      display: 'flex'
    },
    toolbar: {
      padding: 0
    },
    chart: {
      height: '30vh',
      width: '85%',
      marginLeft: '1%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    selectContrib: {
      margin: '0 10%',
      textAlign: 'center',
      justifyContent: 'space-between',
      display: 'grid',
      gridTemplateColumns: '1fr 0fr 1fr ',
      whiteSpace: 'nowrap'
    },
    typo: {
      top: '15px',
      position: 'relative'
    },
    parameters: {
      alignSelf: 'center',
      overflowY: 'auto',
      maxHeight: '30vh'
    },
    selectStep: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: theme.spacing(1.5)
    }
  };
});
function Alert$1(props) {
  return /*#__PURE__*/React.createElement(Alert$2, _extends({
    elevation: 6,
    variant: "filled"
  }, props));
}
var useOptions = function useOptions(variable, unit, xLabel, chartTitle) {
  return {
    maintainAspectRatio: false,
    responsive: true,
    animation: false,
    title: {
      display: chartTitle ? true : false,
      text: chartTitle
    },
    legend: {
      labels: {
        padding: 30,
        filter: function filter(item, chart) {
          if (item.text) {
            return !item.text.includes('_Q10') && !item.text.includes('_Q90');
          } else {
            return true;
          }
        }
      }
    },
    tooltips: {
      mode: 'index',
      callbacks: {
        label: function label(tooltipItem, data) {
          var val = tooltipItem.yLabel.toFixed(3);
          var dsID = tooltipItem.datasetIndex;
          if (dsID % 3 == 1) {
            return "q10:" + val;
          } else if (dsID % 3 == 2) {
            return "q90:" + val;
          } else if (dsID % 3 == 0) {
            return "" + val;
          }
        }
      }
    },
    scales: {
      yAxes: [{
        scaleLabel: {
          display: true,
          labelString: variable + ' (' + unit + ')'
        },
        ticks: {
          beginAtZero: true,
          min: 0
        }
      }],
      xAxes: [{
        ticks: {
          autoSkip: true,
          autoSkipPadding: 20,
          maxRotation: 0,
          minRotation: 0
        },
        scaleLabel: {
          display: true,
          labelString: xLabel
        }
      }]
    }
  };
};
var SEASON_CYCLE_LABELS = ['JANVIER', 'FEVRIER', 'MARS', 'AVRIL', 'MAI', 'JUIN', 'JUILLET', 'AOUT', 'SEPTEMBRE', 'OCTOBRE', 'NOVEMBRE', 'DECEMBRE'];
var PERIODS = ['Historique', '2050', '2100'];
var DEFAULT_DATASET$3 = {
  label: 'Référence',
  fill: false,
  borderColor: 'rgb(119,136,153)',
  backgroundColor: 'rgb(63, 81, 181)',
  pointBackgroundColor: [],
  pointBorderWidth: 1,
  pointHoverRadius: 10,
  pointHoverBackgroundColor: 'rgba(63, 81, 181, 1.0)',
  pointHoverBorderColor: 'rgb(220,220,220)',
  pointHoverBorderWidth: 2,
  pointRadius: [],
  pointHitRadius: 10,
  data: []
};
var FixedColors$1 = ['#6b5b95', '#feb236', '#d64161', '#86af49', '#ff7b25', '#1FF3CF', '#0310AB', '#9E169E', '#845842'];
var datasetColors = {};
var dynamicColors$1 = function dynamicColors() {
  var r = Math.floor(Math.random() * 255);
  var g = Math.floor(Math.random() * 255);
  var b = Math.floor(Math.random() * 255);
  return "rgb(" + r + "," + g + "," + b + ")";
};
var AriaTimeseries = (function (_ref) {
  var userinfo = _ref.userinfo,
    dataset = _ref.dataset,
    date = _ref.date,
    domain = _ref.domain,
    epsg = _ref.epsg,
    measure_points = _ref.measure_points,
    modifier = _ref.modifier,
    stats = _ref.stats,
    time = _ref.time,
    timeavg = _ref.timeavg,
    variable = _ref.variable,
    datetimeFormat = _ref.datetimeFormat,
    data_type = _ref.data_type,
    onMounted = _ref.onMounted,
    onResult = _ref.onResult,
    onStartingService = _ref.onStartingService,
    onNoFeature = _ref.onNoFeature,
    onRunningExtraction = _ref.onRunningExtraction,
    isVariableReadFromAPI = _ref.isVariableReadFromAPI;
  var classes = useStyles$h();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var chartRef = useRef({});
  var chartObsRef = useRef({});
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0],
    dispatch = _useAriaAppStore[1];
  var interestedZone = store['extraction_zones'];
  log(interestedZone, 'interestedZone in timeseries ');
  var _React$useState = React.useState({
      'Row': {
        label: 'Row',
        timestampValue: ''
      },
      '1min': {
        label: '1min',
        timestampValue: '60'
      },
      '5min': {
        label: '5min',
        timestampValue: '300'
      },
      '15min': {
        label: '15min',
        timestampValue: '900'
      },
      '30min': {
        label: '30min',
        timestampValue: '1800'
      },
      '1H': {
        label: '1H',
        timestampValue: '3600'
      },
      '3H': {
        label: '3H',
        timestampValue: '10800'
      },
      '12H': {
        label: '12H',
        timestampValue: '43200'
      },
      '1D': {
        label: '1D',
        timestampValue: '86400'
      },
      'auto': {
        label: 'auto',
        timestampValue: ''
      }
    }),
    tumblingAverageAvailable = _React$useState[0],
    setTumblingAverageAvailable = _React$useState[1];
  var chartType = store['chart_type'];
  var tz = store['timezone'];
  var timeseries = store['timeseries'];
  var client = store['client'];
  var _React$useState2 = React.useState(undefined),
    lineSimulationData = _React$useState2[0],
    setLineSimulationData = _React$useState2[1];
  var derived_variable = store['derived_variable'];
  var POLS = undefined;
  var keepPOLS = store['emission_charts'].pols;
  var pUnits = store['emission_charts'].pUnits;
  var NCOLORS = keepPOLS.length;
  var pointColors = store['pointColors'];
  var storeTitle = store['controls'].chart && store['controls'].chart.title;
  var regulations = store['regulations'];
  var _React$useState3 = React.useState(false),
    loading = _React$useState3[0],
    setLoading = _React$useState3[1];
  var _React$useState4 = React.useState(false),
    error = _React$useState4[0],
    setError = _React$useState4[1];
  var _React$useState5 = React.useState({}),
    tsdata = _React$useState5[0];
  var _React$useState6 = React.useState(undefined),
    observations = _React$useState6[0],
    setObservations = _React$useState6[1];
  var _React$useState7 = React.useState(undefined),
    observationsMultipleSensors = _React$useState7[0],
    setObservationsMultipleSensors = _React$useState7[1];
  var _React$useState8 = React.useState([{}, [], [], {}]),
    filteredFeatures = _React$useState8[0],
    setFilteredFeatures = _React$useState8[1];
  var _React$useState9 = React.useState(undefined),
    meteoData = _React$useState9[0],
    setMeteoData = _React$useState9[1];
  var _React$useState10 = React.useState([]),
    extractionPoints = _React$useState10[0];
  var _React$useState11 = React.useState(''),
    extractionPoint = _React$useState11[0],
    setExtractionPoint = _React$useState11[1];
  var _React$useState12 = React.useState('Historique'),
    period = _React$useState12[0],
    setPeriod = _React$useState12[1];
  var _React$useState13 = React.useState('multipoint'),
    bpmode = _React$useState13[0],
    setBpmode = _React$useState13[1];
  var _React$useState14 = React.useState([]),
    dataFiles = _React$useState14[0];
  var _React$useState15 = React.useState(''),
    selectedDataFile = _React$useState15[0];
  var _React$useState16 = React.useState(undefined),
    pollutant = _React$useState16[0],
    setPollutant = _React$useState16[1];
  var _React$useState17 = React.useState(undefined),
    selectedPollutant = _React$useState17[0],
    setSelectedPollutant = _React$useState17[1];
  var _React$useState18 = React.useState(keepPOLS[3]),
    selectedPollutantRose = _React$useState18[0],
    setSelectedPollutantRose = _React$useState18[1];
  var _React$useState19 = React.useState(['PM10', 'PM2.5', 'NO2']),
    combinedPollutants = _React$useState19[0],
    setCombinedPollutants = _React$useState19[1];
  var _React$useState20 = React.useState(false),
    useValidatedValues = _React$useState20[0],
    setUseValidatedValues = _React$useState20[1];
  var _React$useState21 = React.useState({
      id: 'auto',
      label: 'auto',
      timestampValue: ''
    }),
    selectedTumblingAverage = _React$useState21[0],
    setSelectedTumblingAverage = _React$useState21[1];
  var _React$useState22 = React.useState(undefined),
    setObservationStationName = _React$useState22[1];
  var _React$useState23 = React.useState(''),
    observationStationLabel = _React$useState23[0],
    setObservationStationLabel = _React$useState23[1];
  var _React$useState24 = React.useState(undefined),
    receptorLabel = _React$useState24[0];
  var _React$useState25 = React.useState(undefined),
    selectedMarker = _React$useState25[0],
    setSelectedMarker = _React$useState25[1];
  var data_type_modifier = store['data_type_modifier'];
  var modifierValue = modifier;
  var timeavgValue = timeavg;
  var modifier_stats = stats;
  if (data_type_modifier && typeof data_type_modifier === 'object') {
    modifierValue = data_type_modifier['modifier'];
    timeavgValue = data_type_modifier['timeavgValue'];
    modifier_stats = data_type_modifier['stats'] + ',q10,q90';
  }
  var _React$useState26 = React.useState(''),
    snackbarMessage = _React$useState26[0],
    setSnackbarMessage = _React$useState26[1];
  var modifierHasChanged = useCompare(modifierValue);
  var variableHasChanged = useCompare(variable.name);
  var options = useOptions(variable.title, variable.unit, t('Chart.Time'));
  var timeOptions = {
    parser: 'MM-DD-YYYY HH:mm',
    tooltipFormat: 'DD/MM/YYYY HH:mm',
    displayFormats: {
      'millisecond': 'HH:mm:ss',
      'second': 'HH:mm:ss',
      'minute': 'DD/MM HH:mm',
      'hour': 'DD/MM HH:mm ',
      'day': 'DD/MM/YYYY ',
      'month': 'MM/YYYY',
      'year': 'YYYY'
    }
  };
  var _React$useState27 = React.useState(undefined),
    currentRegulation = _React$useState27[0],
    setCurrentRegulation = _React$useState27[1];
  var _React$useState28 = React.useState(undefined),
    backgroundRules = _React$useState28[0],
    setBackgroundRules = _React$useState28[1];
  function addBackgroundColors(chart) {
    var rules = chart.chart.options.backgroundRules;
    if (!rules) return;
    var ctx = chart.chart.ctx;
    var yAxis = chart.chart.scales["y-axis-0"];
    var xaxis = chart.chart.scales["x-axis-0"];
    for (var i = 0; i < rules.length; ++i) {
      var yAxisSegement = rules[i].yAxisSegement > yAxis.ticksAsNumbers[0] ? yAxis.ticksAsNumbers[0] : rules[i].yAxisSegement;
      var yAxisPosStart = yAxis.height - yAxisSegement * yAxis.height / yAxis.ticksAsNumbers[0] + chart.chart.controller.chartArea.top;
      var yAxisPosEnd = i === 0 ? yAxis.height : yAxis.height - rules[i - 1].yAxisSegement * yAxis.height / yAxis.ticksAsNumbers[0];
      ctx.fillStyle = rules[i].backgroundColor;
      if (yAxisPosEnd - yAxisPosStart + chart.chart.controller.chartArea.top < 0) {
        ctx.fillRect(xaxis.left, yAxisPosStart, xaxis.width, 0);
      } else {
        ctx.fillRect(xaxis.left, yAxisPosStart, xaxis.width, yAxisPosEnd - yAxisPosStart + chart.chart.controller.chartArea.top);
      }
    }
  }
  var lastRequestIdRef = React.useRef(0);
  React.useEffect(function () {
    if (!regulations) return;
    var pollutantDisplayed = undefined;
    if (chartType === 'observations') {
      pollutantDisplayed = selectedPollutant;
    } else if (chartType === 'line' || chartType === 'line_simulation') {
      pollutantDisplayed = variable.group;
    }
    setCurrentRegulation(searchRegulationByPollutant(regulations, pollutantDisplayed));
  }, [regulations, selectedPollutant, variable, chartType]);
  React.useEffect(function () {
    if (!currentRegulation) {
      setBackgroundRules(undefined);
    } else {
      var backgroundRulesOfPullutant = [];
      var thresholds = currentRegulation['Thresholds'];
      thresholds.forEach(function (thresh, index) {
        var level = 0;
        if (thresholds[index + 1]) {
          level = thresholds[index + 1].Level;
        } else {
          level = Infinity;
        }
        if (thresh.Color) {
          backgroundRulesOfPullutant.push({
            backgroundColor: addAlpha(thresh.Color, 0.2),
            yAxisSegement: level
          });
        }
      });
      setBackgroundRules(backgroundRulesOfPullutant);
    }
  }, [currentRegulation]);
  React.useEffect(function () {
    var fF = {};
    var rmObjs = [];
    var chartObjs = [];
    var sF = {};
    log('*********** Run MEMO filteredFeatures ***********');
    if (modifierHasChanged || variableHasChanged) {
      log(modifierHasChanged, 'modifierHasChanged: ', 'info');
      log(variableHasChanged, 'variableHasChanged: ', 'info');
      for (var f in interestedZone.features) {
        if (interestedZone.features[f].type === 'AQ') {
          sF[f] = interestedZone.features[f];
        } else if (interestedZone.features[f].type === 'VIRTUAL') {
          fF[f] = interestedZone.features[f];
        } else {
          fF[f] = interestedZone.features[f];
        }
      }
      setFilteredFeatures([fF, rmObjs, chartObjs, sF]);
    } else {
      if (interestedZone.features) {
        var newFeats = Object.keys(interestedZone.features);
        log(extractionPoints, 'extractionPoints');
        for (var _f in interestedZone.features) {
          if (extractionPoints.indexOf(_f) === -1) {
            if (interestedZone.features[_f].type === 'AQ') {
              sF[_f] = interestedZone.features[_f];
            } else if (interestedZone.features[_f].type === 'VIRTUAL') {
              fF[_f] = interestedZone.features[_f];
            } else {
              fF[_f] = interestedZone.features[_f];
            }
          } else {
            fF[_f] = interestedZone.features[_f];
          }
        }
        log(newFeats, 'newFeats');
        extractionPoints.forEach(function (p) {
          if (newFeats.length == 0) {
            rmObjs.push(p);
          } else {
            if (newFeats.indexOf(p) === -1) {
              rmObjs.push(p);
            } else {
              chartObjs.push(p);
            }
          }
        });
        log(rmObjs, 'rmObjs :');
      }
      setFilteredFeatures([fF, rmObjs, chartObjs, sF]);
    }
  }, [extractionPoints, interestedZone, modifierHasChanged, variableHasChanged]);
  var addColorObject = useCallback(function (pnt) {
    log(pointColors, 'pointColors');
    var cid = Object.keys(datasetColors).length;
    if (!(pnt in datasetColors)) {
      if (cid > NCOLORS) datasetColors[pnt] = dynamicColors$1();else {
        if (Array.isArray(pointColors)) {
          datasetColors[pnt] = pointColors[cid];
        } else {
          datasetColors[pnt] = FixedColors$1[cid];
        }
      }
    }
    return datasetColors[pnt];
  }, [pointColors]);
  var getObservationsData = useCallback(function () {
    var measureDataset = {
      label: 'Mesure',
      fill: false,
      borderColor: 'rgb(255, 19, 0)',
      backgroundColor: 'rgb(255, 19, 0)',
      pointBackgroundColor: [],
      pointBorderWidth: 1,
      pointHoverRadius: 8,
      pointHoverBackgroundColor: 'rgba(255, 19, 0, 1.0)',
      pointHoverBorderColor: 'rgb(220,220,220)',
      pointHoverBorderWidth: 2,
      pointRadius: [],
      pointHitRadius: 10,
      data: []
    };
    var obsChartData = {
      labels: [],
      datasets: []
    };
    if (observations && observations.data) {
      log(observations, 'OBS DATA CHART');
      log(Object.keys(observations.units), 'OBS CHART POLS');
      POLS = Object.keys(observations.units).filter(function (pol) {
        return keepPOLS.includes(pol);
      });
      pUnits = observations.units;
      var timeframeLabels = [];
      if (observations.timeframes && observations.timeframes.length > 0) {
        var timeLabels = observations.timeframes.map(function (time) {
          return new Date(time);
        });
        obsChartData.labels = timeLabels;
        obsChartData.timeframes = observations.timeframes;
      }
      if (isVariableReadFromAPI) {
        log(isVariableReadFromAPI, 'isVariableReadFromAPI');
        POLS = [];
        observations.data.forEach(function (obs) {
          Object.keys(obs).forEach(function (pol) {
            log(pol, "POL");
            if (POLS.indexOf(pol) === -1) {
              POLS.push(pol);
            }
          });
        });
        pUnits = observations.units;
      }
      POLS.forEach(function (pol, cnt) {
        if (!(pol in datasetColors)) {
          addColorObject(pol);
        }
        var clrs = datasetColors[pol];
        if (!clrs) return;
        obsChartData.datasets.push(Object.assign({}, measureDataset));
        var vals = [];
        observations.data.map(function (d, index) {
          vals.push(d[pol]);
          timeframeLabels.push(new Date(d['timeframe']));
        });
        obsChartData.datasets[cnt].data = vals;
        obsChartData.datasets[cnt].backgroundColor = clrs.primary || clrs;
        obsChartData.datasets[cnt].borderColor = clrs.primary || clrs;
        obsChartData.datasets[cnt].pointBackgroundColor = clrs.primary || clrs;
        obsChartData.datasets[cnt].label = pol + "-" + pUnits[pol];
      });
    }
    return obsChartData;
  }, [observations, datetimeFormat, addColorObject, isVariableReadFromAPI, useValidatedValues]);
  var getObservationsDataMultipleSensors = useCallback(function () {
    var measureDataset = {
      label: 'Mesure',
      fill: false,
      borderColor: 'rgb(255, 19, 0)',
      backgroundColor: 'rgb(255, 19, 0)',
      pointBackgroundColor: [],
      pointBorderWidth: 1,
      pointHoverRadius: 8,
      pointHoverBackgroundColor: 'rgba(255, 19, 0, 1.0)',
      pointHoverBorderColor: 'rgb(220,220,220)',
      pointHoverBorderWidth: 2,
      pointRadius: [],
      pointHitRadius: 10,
      data: []
    };
    var obsChartData = {
      labels: [],
      datasets: []
    };
    if (observationsMultipleSensors) {
      log(observationsMultipleSensors, 'OBS DATA CHART');
      var datasets = [];
      observationsMultipleSensors.map(function (observationCurrentSensor) {
        var observations = observationCurrentSensor.measures;
        if (observations.data.length > 0) {
          var timeLabels = [];
          var values = [];
          observations.data.map(function (obsValues, index) {
            if (obsValues[selectedPollutant] != null || index == 0 || index == observations.data.length - 1) {
              timeLabels.push(new Date(obsValues.timeframe).setSeconds(0, 0));
              values.push(obsValues[selectedPollutant]);
            }
          });
          datasets.push({
            'labels': timeLabels,
            'values': values,
            'name': observationCurrentSensor.labelAirQualityStation
          });
        }
      });
      log(datasets, 'datasets');
      var combinedLabels = Array.from(new Set(datasets.flatMap(function (dataset) {
        return dataset.labels;
      }))).sort();
      log(combinedLabels, 'combinedLabels');
      obsChartData.labels = combinedLabels;
      obsChartData.timeframes = combinedLabels.map(function (label) {
        return new Date(label).toISOString();
      });
      var combinedValues = datasets.map(function (dataset) {
        return combinedLabels.map(function (label) {
          var index = dataset.labels.indexOf(label);
          return index !== -1 ? dataset.values[index] : null;
        });
      });
      log(combinedValues, 'combinedValues');
      combinedValues.forEach(function (values, index) {
        var nameSensor = datasets[index].name;
        if (!(nameSensor in datasetColors)) {
          addColorObject(nameSensor);
        }
        var clrs = datasetColors[nameSensor];
        if (!clrs) return;
        obsChartData.datasets.push(Object.assign({}, measureDataset));
        obsChartData.datasets[index].data = values;
        obsChartData.datasets[index].backgroundColor = clrs.primary || clrs;
        obsChartData.datasets[index].borderColor = clrs.primary || clrs;
        obsChartData.datasets[index].pointBackgroundColor = clrs.primary || clrs;
        obsChartData.datasets[index].label = nameSensor;
      });
    }
    log(obsChartData, ' obsChartData');
    return obsChartData;
  }, [observationsMultipleSensors, datetimeFormat, addColorObject, selectedPollutant, useValidatedValues]);
  var getChartData = React.useCallback(function () {
    return computeChartData(date, datetimeFormat, selectedDataFile, tsdata, datasetColors, pointColors);
  }, [date, datetimeFormat, selectedDataFile, tsdata, pointColors]);
  var getChartSeasonData = useCallback(function () {
    var chartData = {
      labels: SEASON_CYCLE_LABELS,
      datasets: []
    };
    if (Object.keys(datasetColors).length == 0) return chartData;
    if (dataFiles.length > 0 && Object.keys(tsdata).length > 0 && tsdata) {
      var csData = getSeasonCycleData(tsdata, dataFiles);
      if (bpmode === 'multipoint') {
        if (!isEmpty(period)) {
          for (var p in csData) {
            var clrs = void 0;
            if (p in datasetColors) {
              clrs = datasetColors[p];
            } else {
              clrs = addColorObject(p);
            }
            if (!clrs) return;
            var ds = Object.assign({}, DEFAULT_DATASET$3);
            if (period === 'Historique') {
              ds.data = csData[p].hist;
              ds.label = p + "_historique";
            } else if (period === '2050') {
              ds.data = csData[p].p2050;
              ds.label = p + "_2050";
            } else if (period === '2100') {
              ds.data = csData[p].p2100;
              ds.label = p + "_2100";
            }
            ds.backgroundColor = clrs.primary || clrs[0];
            ds.borderColor = clrs.primary || clrs[0];
            ds.pointBackgroundColor = clrs.primary || clrs[0];
            chartData.datasets.push(ds);
          }
        }
      } else if (bpmode === 'period') {
        if (!isEmpty(extractionPoint)) {
          var dsHist = Object.assign({}, DEFAULT_DATASET$3);
          dsHist.data = csData[extractionPoint].hist;
          dsHist.label = extractionPoint + "_historique";
          var clrHist = dynamicColors$1()[0];
          dsHist.backgroundColor = clrHist;
          dsHist.borderColor = clrHist;
          dsHist.pointBackgroundColor = clrHist;
          chartData.datasets.push(dsHist);
          var ds2050 = Object.assign({}, DEFAULT_DATASET$3);
          ds2050.data = csData[extractionPoint].p2050;
          ds2050.label = extractionPoint + "_2050";
          var clr2050 = dynamicColors$1()[0];
          ds2050.backgroundColor = clr2050;
          ds2050.borderColor = clr2050;
          ds2050.pointBackgroundColor = clr2050;
          chartData.datasets.push(ds2050);
          var ds2100 = Object.assign({}, DEFAULT_DATASET$3);
          ds2100.data = csData[extractionPoint].p2100;
          ds2100.label = extractionPoint + "_2100";
          var clr2100 = dynamicColors$1()[0];
          ds2100.backgroundColor = clr2100;
          ds2100.borderColor = clr2100;
          ds2100.pointBackgroundColor = clr2100;
          chartData.datasets.push(ds2100);
        }
      }
    }
    return chartData;
  }, [dataFiles, tsdata, bpmode, period, addColorObject, extractionPoint]);
  var onSelectMarkerHandler = React.useCallback(function (v) {
    setSelectedMarker(v);
  }, []);
  var onSelectExtractionPointHandler = React.useCallback(function (v) {
    setExtractionPoint(v);
  }, []);
  var onSelectPeriodHandler = React.useCallback(function (v) {
    setPeriod(v);
  }, []);
  var onChangeBoxplotModeHandler = React.useCallback(function (v) {
    setBpmode(v);
  }, []);
  var onSelectPollutantHandler = React.useCallback(function (p) {
    setPollutant(p);
  }, []);
  var handleCloseSnackbar = React.useCallback(function (v) {
    setSnackbarMessage('');
  }, []);
  var onSaveImageClickHandler = function onSaveImageClickHandler(chart_type) {
    if (chart_type == 'pollution_rose') {
      write2ImagePollutionRose('chart_widget');
    } else {
      write2Image$1('chart_widget');
    }
  };
  var refreshTimeseriesFetching = React.useCallback(function (e) {
    console.log('REFRESH .....');
  }, []);
  var onSaveCSVClickHandler = React.useCallback(function (e) {
    var grpData;
    var label;
    if (chartType === 'line') {
      grpData = getChartData();
      log(grpData, 'grpData');
    } else if (chartType === 'line_simulation') {
      grpData = lineSimulationData;
      log(grpData, 'grpData in simulation');
    } else if (chartType === 'observations') {
      if (selectedPollutant) {
        grpData = getObservationsDataMultipleSensors();
        label = selectedPollutant;
      } else {
        grpData = getObservationsData();
        label = observationStationLabel;
      }
      log(grpData, 'grpData');
      log(extractionPoints, 'extractionPoints');
      writeObsToCSVLine(label, interestedZone.layers, grpData);
      return;
    } else if (chartType === 'meteo' && meteoData) {
      grpData = meteoData;
      log(grpData, 'grpData');
      writeWeatherToCSVLine(interestedZone.layers, grpData);
      return;
    }
    if (grpData && !isEmpty(variable.name)) {
      writeToCSVLine$1(variable.name, extractionPoints, interestedZone.layers, chartType, grpData, variable.title, receptorLabel);
    }
  }, [variable.name, interestedZone.layers, extractionPoints, getChartData, getChartSeasonData, getObservationsData, getObservationsDataMultipleSensors, writeWeatherToCSVLine, chartType, meteoData, observationStationLabel, receptorLabel, lineSimulationData]);
  var saveMeteoDataHandler = React.useCallback(function (metdat) {
    log(metdat, 'saveMeteoDataHandler');
    if (metdat) {
      setMeteoData(metdat);
    }
  }, []);
  React.useEffect(function () {
    if (typeof onRunningExtraction === 'function') {
      onRunningExtraction(loading);
    }
  }, [loading, onRunningExtraction]);
  React.useEffect(function () {
    if (typeof onMounted === 'function') {
      onMounted(true);
    }
  }, [onMounted]);
  React.useEffect(function () {
    if (!interestedZone) return;
    if (!variable) return;
    if (!(date instanceof Date)) return;
    if (!timeseries) return;
    if (!(timeseries.datedeb.value instanceof Date)) return;
    if (!(timeseries.datefin.value instanceof Date)) return;
    if (interestedZone.infoType !== 'timeseries' && interestedZone.infoType !== 'contribution' && interestedZone.infoType !== 'pollution_rose') return;
    if (chartType == 'line_simulation') return;
    if (interestedZone.features && !isEmpty(variable.name) && !isEmpty(dataset)) {
      if (typeof onStartingService === 'function') {
        onStartingService();
      }
      log(filteredFeatures, 'filteredFeatures');
      if (Object.keys(filteredFeatures[0]).length > 0) {
        setObservations(undefined);
      } else if (Object.keys(filteredFeatures[3]).length > 0) {
        setError(false);
        setLoading(true);
        var tokenToUse = useValidatedValues ? 'dbbb2e806a14be81905a60a530bbe52bf789abef2e2c9811d6de5a5656d2546c:52d8dcd0febc46df8cf06f8f6d068a65' : client.token;
        var aqSensorIds = Object.keys(filteredFeatures[3]);
        if (aqSensorIds.length > 0 && client && client.token) {
          var startDate = timeseries.datedeb.value;
          var endDate = timeseries.datefin.value;
          var _fetchList = [];
          for (var _iterator = _createForOfIteratorHelperLoose(aqSensorIds), _step; !(_step = _iterator()).done;) {
            var aqSensorId = _step.value;
            setObservationStationLabel(filteredFeatures[3][aqSensorIds[0]].name);
            var staname = filteredFeatures[3][aqSensorIds[0]].code;
            var staid = filteredFeatures[3][aqSensorId].id;
            setObservationStationName(staname);
            var pp = [staid];
            var qp = {
              obs_type: 'aq',
              start_date: parseTime(startDate, '{y}-{m}-{d}T{h}:{i}:{s}'),
              end_date: parseTime(endDate, '{y}-{m}-{d}T{h}:{i}:{s}'),
              timezone: tz
            };
            qp['qa_qc'] = 'False';
            if (selectedTumblingAverage.timestampValue) {
              qp['tav'] = selectedTumblingAverage.timestampValue;
            }
            log(measure_points, 'measure_points');
            var _url = getUrlService({
              version: process.env.REACT_APP_OBS_API_VERSION || '',
              name: process.env.REACT_APP_OBS_API + '/stations'
            }, pp, qp, true);
            log(_url, 'URL Get AQ measure points');
            _fetchList.push(fetch(_url, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'X-ARIA-CLIENT-TOKEN': tokenToUse
              }
            }));
          }
          var requestId = ++lastRequestIdRef.current;
          Promise.all(_fetchList).then(function (res) {
            return Promise.all(res.map(function (r) {
              return r.json();
            }));
          }).then(function (dataJSON) {
            if (requestId === lastRequestIdRef.current) {
              setLoading(false);
              var datasetsValues = [];
              var pollutantsSet = new Set();
              dataJSON.map(function (json) {
                if (json.data) {
                  var resultParsed = addStartEndDates(json.data, startDate, endDate);
                  var measures = resultParsed.measures;
                  if (measures && measures.data && measures.units) datasetsValues.push(resultParsed);
                  Object.keys(measures.units).forEach(function (pol) {
                    return pollutantsSet.add(pol);
                  });
                  setObservations(measures);
                }
              });
              setCombinedPollutants(Array.from(pollutantsSet));
              setObservationsMultipleSensors(datasetsValues);
              log(datasetsValues, ' AQ datasetsValues');
            }
          });
        }
      }
    }
  }, [dataset, date, timeseries, domain, epsg, modifierValue, modifier_stats, variable, timeavgValue, data_type, onStartingService, onResult, filteredFeatures, onNoFeature, tz, client, derived_variable, selectedTumblingAverage, useValidatedValues]);
  useEffect(function () {
    if (combinedPollutants.includes(variable.group)) {
      setSelectedPollutant(variable.group);
    }
  }, [variable.group]);
  useEffect(function () {
    if (!isEmpty(modifierValue)) {
      if (modifierValue !== 'avg') {
        dispatch({
          type: 'SET_CHART_TYPE',
          value: 'line'
        });
      }
    }
  }, [modifierValue]);
  var handleValidatedValuesButton = function handleValidatedValuesButton(e) {
    if (!loading) {
      setUseValidatedValues(e.target.checked);
    }
  };
  var handleChangeTumblingAverage = function handleChangeTumblingAverage(e) {
    console.log({
      id: e.target.value,
      timestampValue: tumblingAverageAvailable[e.target.value].timestampValue,
      label: tumblingAverageAvailable[e.target.value].label
    });
    setSelectedTumblingAverage({
      id: e.target.value,
      timestampValue: tumblingAverageAvailable[e.target.value].timestampValue,
      label: tumblingAverageAvailable[e.target.value].label
    });
  };
  React.useEffect(function () {
    var autoValue = "";
    var autoLabel = "";
    var timeGap = Date.parse(timeseries.datefin.value) - Date.parse(timeseries.datedeb.value);
    var autoStep = timeGap / 10000;
    var _tumblingAverageAvailable = _extends({}, tumblingAverageAvailable);
    Object.keys(_tumblingAverageAvailable).map(function (idStep) {
      var step = _tumblingAverageAvailable[idStep];
      if (idStep == 'auto') return;
      if (autoStep > step.timestampValue && parseInt(step.timestampValue) > autoValue) {
        autoValue = step.timestampValue;
        autoLabel = step.label;
      }
    });
    _tumblingAverageAvailable['auto'] = {
      label: 'Auto - ' + autoLabel,
      timestampValue: autoValue
    };
    setTumblingAverageAvailable(_tumblingAverageAvailable);
    if (selectedTumblingAverage.id == 'auto') {
      setSelectedTumblingAverage({
        id: 'auto',
        label: 'Auto - ' + autoLabel,
        timestampValue: autoValue
      });
    }
  }, [timeseries]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Snackbar, {
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    open: snackbarMessage.length !== 0,
    autoHideDuration: 30000,
    onClose: handleCloseSnackbar
  }, /*#__PURE__*/React.createElement(Alert$1, {
    onClose: handleCloseSnackbar,
    severity: "warning"
  }, snackbarMessage)), /*#__PURE__*/React.createElement(Paper, {
    elevation: 0,
    className: classes.parameters
  }, chartType !== 'sources_contribution' && !modifierValue && !modifier_stats && /*#__PURE__*/React.createElement(MuiPickersUtilsProvider, {
    utils: MomentUtils
  }, /*#__PURE__*/React.createElement(AriaDatetimeWindowSelect, {
    autoOK: true,
    useAriaStore: true
  })), chartType === 'season_cycle' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AriaRadioInput, {
    buttons: [{
      label: 'Mode multipoint',
      value: 'multipoint'
    }, {
      label: 'Mode période',
      value: 'period'
    }],
    selected: "multipoint",
    selectHandler: onChangeBoxplotModeHandler
  }), bpmode === 'period' && Array.isArray(extractionPoints) && /*#__PURE__*/React.createElement(AriaSelect, {
    options: extractionPoints,
    selected: extractionPoint,
    onSelectHandler: onSelectExtractionPointHandler
  }), bpmode === 'multipoint' && /*#__PURE__*/React.createElement(AriaSelect, {
    options: PERIODS,
    selected: period,
    onSelectHandler: onSelectPeriodHandler
  })), chartType === 'observations' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    fullWidth: true,
    size: "small"
  }, /*#__PURE__*/React.createElement(InputLabel, {
    id: "selected_pollutant"
  }, t('Chart.Selected_pollutant')), /*#__PURE__*/React.createElement(Select$1, {
    key: selectedPollutant,
    variant: "outlined",
    labelId: "selected_pollutant",
    value: selectedPollutant,
    label: t('Chart.Selected_pollutant'),
    onChange: function onChange(e) {
      return setSelectedPollutant(e.target.value);
    }
  }, Object.keys(filteredFeatures[3]).length == 1 && /*#__PURE__*/React.createElement(MenuItem$1, {
    value: ""
  }, /*#__PURE__*/React.createElement("em", null, "All")), combinedPollutants.map(function (pol) {
    return /*#__PURE__*/React.createElement(MenuItem$1, {
      value: pol
    }, pol);
  })))), chartType === 'pollution_rose' && /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    fullWidth: true,
    size: "small"
  }, /*#__PURE__*/React.createElement(InputLabel, {
    id: "selected_pollutant_rose"
  }, t('Chart.Selected_pollutant')), /*#__PURE__*/React.createElement(Select$1, {
    key: selectedPollutantRose,
    variant: "outlined",
    labelId: "selected_pollutant_rose",
    value: selectedPollutantRose,
    label: t('Chart.Selected_pollutant'),
    onChange: function onChange(e) {
      return setSelectedPollutantRose(e.target.value);
    }
  }, keepPOLS.map(function (pol) {
    return /*#__PURE__*/React.createElement(MenuItem$1, {
      value: pol
    }, pol);
  }))), (chartType === 'observations' || chartType === 'pollution_rose') && /*#__PURE__*/React.createElement("div", {
    className: classes.selectStep
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    fullWidth: true,
    size: "small"
  }, /*#__PURE__*/React.createElement(InputLabel, {
    id: "selected_average"
  }, t('Chart.Step')), /*#__PURE__*/React.createElement(Select$1, {
    key: selectedTumblingAverage.id,
    variant: "outlined",
    labelId: "selected_average",
    value: selectedTumblingAverage.id,
    label: t('Chart.Step'),
    onChange: handleChangeTumblingAverage
  }, Object.keys(tumblingAverageAvailable).map(function (idStep) {
    return /*#__PURE__*/React.createElement(MenuItem$1, {
      value: idStep
    }, tumblingAverageAvailable[idStep].label);
  }))), /*#__PURE__*/React.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React.createElement(Switch, {
      color: "primary",
      size: "small",
      checked: useValidatedValues,
      onChange: handleValidatedValuesButton
    }),
    label: /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: "0.7rem",
        display: 'block'
      },
      variant: "body2"
    }, t('Chart.Remove_Outliers')),
    style: {
      marginLeft: '5px'
    }
  })), /*#__PURE__*/React.createElement(Tooltip, {
    title: t('Chart.Image_export')
  }, /*#__PURE__*/React.createElement(IconButton, {
    color: "inherit",
    "aria-label": "save",
    onClick: function onClick() {
      return onSaveImageClickHandler(chartType);
    }
  }, /*#__PURE__*/React.createElement(ImageIcon, null))), chartType != 'sources_contribution' && chartType != 'pollution_rose' && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Tooltip, {
    title: t('Chart.CSV_export')
  }, /*#__PURE__*/React.createElement(IconButton, {
    color: "inherit",
    "aria-label": "save",
    onClick: onSaveCSVClickHandler
  }, /*#__PURE__*/React.createElement(DescriptionIcon, null))))), chartType === 'meteo' ? /*#__PURE__*/React.createElement(AriaMeteoChart, {
    saveDataCB: saveMeteoDataHandler,
    timeOptions: timeOptions
  }) : chartType === 'observations_new' ? /*#__PURE__*/React.createElement(AriaObservationChart, {
    saveDataCB: function saveDataCB(data) {
      return console.log('Save obs has done !');
    }
  }) : chartType === 'pollution_rose' ? /*#__PURE__*/React.createElement(AriaPollutionRose, {
    selectedPollutantRose: selectedPollutantRose,
    selectedTumblingAverage: selectedTumblingAverage,
    useValidatedValues: useValidatedValues
  }) : /*#__PURE__*/React.createElement(Paper, {
    elevation: 1,
    className: classes.chart
  }, loading ? /*#__PURE__*/React.createElement(CircularProgress, {
    className: classes.linearProgress
  }) : error ? /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, t('Chart.Error_loading_message')) : chartType === 'boxplot' ? /*#__PURE__*/React.createElement(BoxPlot, {
    id: 'chart_widget',
    data: getBoxplotData(),
    options: {
      zoom: {
        enabled: true,
        mode: 'x'
      },
      pan: {
        enabled: true,
        mode: 'x'
      },
      maintainAspectRatio: false,
      animation: false,
      responsive: true,
      legend: {
        position: 'right'
      },
      title: {
        display: false,
        text: t('Chart.Boxplot_graphic')
      },
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: variable.title + ' (' + variable.unit + ')'
          }
        }]
      },
      tooltips: {
        callbacks: {
          boxplotLabel: function boxplotLabel(item, data, stats, hoveredOutlierIndex) {
            return "min:" + Number(stats.min).toFixed(3) + "; max:" + Number(stats.max).toFixed(3) + "; m\xE9diane:" + Number(stats.median).toFixed(3) + "; q1:" + Number(stats.q1).toFixed(3) + "; q3:" + Number(stats.q3).toFixed(3);
          }
        }
      }
    },
    redraw: true,
    height: 300
  }) : chartType === 'season_cycle' ? /*#__PURE__*/React.createElement(Line, {
    id: 'chart_widget',
    data: getChartSeasonData(),
    options: options,
    redraw: true,
    height: 300
  }) : chartType === 'sources_contribution' ? /*#__PURE__*/React.createElement(AriaContributionSources, {
    userinfo: userinfo,
    variable: variable,
    filteredFeatures: filteredFeatures,
    selectedMarker: selectedMarker,
    pollutant: pollutant,
    time: time,
    epsg: epsg
  }) : chartType === 'observations' ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Line, {
    id: 'chart_widget',
    ref: chartObsRef,
    data: selectedPollutant ? getObservationsDataMultipleSensors() : getObservationsData(),
    plugins: [{
      beforeDraw: addBackgroundColors
    }],
    options: {
      backgroundRules: backgroundRules,
      zoom: {
        mode: 'x',
        enabled: true
      },
      pan: {
        mode: 'x',
        enabled: true
      },
      legend: {
        labels: {
          generateLabels: function generateLabels(chart) {
            var original = Chart.defaults.global.legend.labels.generateLabels;
            Chart.defaults.global.legend.labels.generateLabels = function (chart) {
              var labels = original.call(this, chart);
              labels.forEach(function (label) {
                if (label.datasetIndex !== undefined) {
                  label.text = label.text.substring(0, 10) + "..";
                }
              });
              return labels;
            };
            var labels = Chart.defaults.global.legend.labels.generateLabels.call(this, chart);
            Chart.defaults.global.legend.labels.generateLabels = original;
            return labels;
          }
        },
        position: 'right'
      },
      maintainAspectRatio: false,
      responsive: true,
      animation: false,
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: selectedPollutant ? "" + t('Chart.Measures') + '-' + selectedPollutant : "" + t('Chart.Measures')
          },
          ticks: {
            beginAtZero: true,
            min: 0
          }
        }],
        xAxes: [{
          alignToPixels: true,
          type: 'time',
          time: timeOptions,
          ticks: {
            autoSkip: true,
            autoSkipPadding: 20,
            maxRotation: 0,
            minRotation: 0
          },
          scaleLabel: {
            display: true,
            labelString: t('Chart.Time')
          }
        }],
        y: {
          suggestedMin: 0
        }
      }
    },
    redraw: true
  })) : chartType === 'line_simulation' ? /*#__PURE__*/React.createElement(AriaTimeseriesReceptors, {
    chartRef: chartRef,
    lineSimulationData: lineSimulationData,
    setLineSimulationData: setLineSimulationData,
    date: date,
    variable: variable,
    lastRequestIdRef: lastRequestIdRef,
    filteredFeatures: filteredFeatures,
    domain: domain,
    epsg: epsg,
    addBackgroundColors: addBackgroundColors,
    backgroundRules: backgroundRules,
    timeOptions: timeOptions,
    dataset: dataset
  }) : /*#__PURE__*/React.createElement(Line, {
    id: 'chart_widget',
    ref: chartRef,
    data: getChartData(),
    options: {
      zoom: {
        enabled: true,
        mode: 'x'
      },
      pan: {
        enabled: true,
        mode: 'x'
      },
      maintainAspectRatio: false,
      responsive: true,
      title: {
        display: storeTitle,
        text: createChartTitle(time, datetimeFormat, receptorLabel)
      },
      legend: {
        position: 'top'
      },
      tooltips: {
        mode: 'index',
        callbacks: {
          label: function label(tooltipItem, data) {
            var val = tooltipItem.yLabel.toFixed(3);
            var dsID = tooltipItem.datasetIndex;
            if (modifierValue && modifier_stats) {
              if (dsID % 3 == 1) {
                return "q10:" + val;
              } else if (dsID % 3 == 2) {
                return "q90:" + val;
              } else if (dsID % 3 == 0) {
                return "avg:" + val;
              }
            }
            return "" + val;
          }
        }
      },
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: variable.title.split("-")[0] + ' (' + variable.unit + ')'
          },
          ticks: {
            beginAtZero: true,
            min: 0
          }
        }],
        xAxes: [{
          type: 'time',
          time: timeOptions,
          ticks: {
            autoSkip: true,
            autoSkipPadding: 20,
            maxRotation: 0,
            minRotation: 0
          },
          scaleLabel: {
            display: true,
            labelString: t('Chart.Time')
          }
        }]
      }
    },
    redraw: true
  })));
});
function addStartEndDates(datas, startDate, endDate) {
  if (!datas) return datas;
  var parsedEndDate = parseTime(endDate, '{y}-{m}-{d}T{h}:{i}:{s}.000Z', true);
  var parsedStartDate = parseTime(startDate, '{y}-{m}-{d}T{h}:{i}:{s}.000Z', true);
  if (datas.measures && datas.measures.data && datas.measures.timeframes) {
    if (datas.measures.timeframes[datas.measures.timeframes.length - 1] != parsedEndDate) {
      datas.measures.data.push({
        timeframe: parsedEndDate
      });
      datas.measures.timeframes.push(parsedEndDate);
    }
    if (datas.measures.timeframes[0] != parsedStartDate) {
      datas.measures.data.unshift({
        timeframe: parsedStartDate
      });
      datas.measures.timeframes.unshift(parsedStartDate);
    }
  }
  return datas;
}

var useStyles$i = makeStyles(function (theme) {
  return {
    panelOpen: {
      width: '100%',
      padding: theme.spacing(0.5)
    },
    panelClose: {
      width: '100%'
    },
    heading: {
      paddingLeft: '5px',
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular
    },
    header: {
      borderBottom: '1px solid lightgray',
      height: '40px',
      minHeight: '20px',
      '&.Mui-expanded': {
        height: '40px',
        minHeight: '20px'
      }
    },
    list: {
      padding: '0',
      margin: '0'
    },
    linearProgress: {
      margin: theme.spacing(2)
    },
    chip: {
      marginLeft: '1%',
      maxWidth: '15%',
      backgroundColor: 'white'
    },
    iconButton: {
      padding: '0',
      marginLeft: theme.spacing(1),
      color: 'rgba(59, 164, 179, 0.7)',
      '&:hover': {
        color: 'rgba(59, 164, 179, 1)'
      }
    },
    chips: {
      width: '80vw',
      overflow: 'auto',
      display: 'flex'
    },
    expanded: {},
    content: {
      '&$expanded': {
        width: 0
      }
    }
  };
});
var AriaInfoPanel = function AriaInfoPanel(_ref) {
  var _clsx;
  var stats = _ref.stats,
    modifier = _ref.modifier,
    timeavg = _ref.timeavg,
    datetimeFormat = _ref.datetimeFormat,
    onRunningExtraction = _ref.onRunningExtraction,
    withSourcesContribution = _ref.withSourcesContribution,
    isVariableReadFromAPI = _ref.isVariableReadFromAPI,
    userinfo = _ref.userinfo;
  var classes = useStyles$i();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0],
    dispatch = _useAriaAppStore[1];
  var dataset = store['dataset'];
  var variable = store['variable'];
  var date = store['date'];
  var time = store['timeframe'] ? store['timeframe'].value : undefined;
  var timeObj = store['timeframe'] ? store['timeframe'].obj : undefined;
  var is_atomic = store['is_atomic'] ? 1 : 0;
  var interestedZone = store['extraction_zones'];
  var measure_points = store['measure_points'];
  var chart_types = store['chart_types'];
  var timeseries = store['timeseries'];
  var _React$useState = React.useState(false),
    infoPanelIsExpanded = _React$useState[0],
    setInfoPanelIsExpanded = _React$useState[1];
  var chart_open = store['chart_open'];
  var emissionSensors = store['emission_sensors'];
  var _React$useState2 = React.useState(false),
    loading = _React$useState2[0],
    setLoading = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    error = _React$useState3[0],
    setError = _React$useState3[1];
  var _React$useState4 = React.useState(undefined),
    value = _React$useState4[0],
    setValue = _React$useState4[1];
  var openTimeseriesChart = store['chart_open'] == "TIMESERIES";
  log(interestedZone, 'Interested zone: ', 'info');
  var handleDeleteChip = function handleDeleteChip(id) {
    var interestedZoneCopy = _extends({}, interestedZone);
    if (interestedZoneCopy.features[id]) {
      delete interestedZoneCopy.features[id];
    }
    if (interestedZoneCopy.layers[id]) {
      delete interestedZoneCopy.layers[id];
    }
    dispatch({
      type: 'SET_EXTRACTION_ZONES',
      value: interestedZoneCopy
    });
  };
  var _React$useState5 = React.useState(null),
    anchorEl = _React$useState5[0],
    setAnchorEl = _React$useState5[1];
  var _React$useState6 = React.useState(false),
    open = _React$useState6[0],
    setOpen = _React$useState6[1];
  var handleClick = function handleClick(event) {
    console.log(event.currentTarget, ' clik event ');
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };
  var handleClose = function handleClose() {
    setAnchorEl(null);
    setOpen(false);
  };
  var getChipOfPoints = React.useCallback(function () {
    var valinfo = t('InfoPanel.Data_extraction');
    if (!interestedZone) return valinfo;
    if (!interestedZone.infoType) return valinfo;
    if (interestedZone.infoType === 'value') {
      if (typeof value !== 'undefined') {
        valinfo = t('InfoPanel.Average_extraction_value') + ": " + value + " (" + variable.unit + ")";
      }
    } else {
      if (interestedZone.features) {
        var points = Object.keys(interestedZone.features);
        if (points.length > 0) {
          return /*#__PURE__*/React.createElement(React.Fragment, null, points.map(function (point) {
            var label = interestedZone.features[point].name ? interestedZone.features[point].name : point;
            return /*#__PURE__*/React.createElement(Chip, {
              className: classes.chip,
              variant: "outlined",
              onDelete: function onDelete() {
                return handleDeleteChip(point);
              },
              label: label,
              color: "primary"
            });
          }), interestedZone.features[points[0]].type == 'AQ' && interestedZone.infoType == 'timeseries' &&
          /*#__PURE__*/
          React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton$1, {
            className: classes.iconButton,
            "aria-label": "more",
            id: "long-button",
            "aria-controls": open ? 'long-menu' : undefined,
            "aria-expanded": open ? 'true' : undefined,
            "aria-haspopup": "true",
            onClick: handleClick
          }, /*#__PURE__*/React.createElement(AddCircleRounded, null))));
        } else {
          dispatch({
            type: 'SET_EXTRACTION_ZONES',
            value: {
              infoType: undefined
            }
          });
          dispatch({
            type: 'SET_OPEN_CHART',
            value: 'TIMEFRAME'
          });
          return /*#__PURE__*/React.createElement("div", null);
        }
      }
    }
    return valinfo;
  }, [interestedZone, value, variable.unit, timeseries]);
  var expandedChangeHandler = function expandedChangeHandler() {
    setInfoPanelIsExpanded(!infoPanelIsExpanded);
  };
  var onTimeseriesStartingHandler = React.useCallback(function () {
    log(chart_open, 'chart open');
    if (chart_open == 'TIMESERIES') {
      setInfoPanelIsExpanded(true);
    }
  }, [chart_open]);
  var onNoFeatureHandler = React.useCallback(function () {
    setInfoPanelIsExpanded(false);
  }, []);
  React.useEffect(function () {
    if (!interestedZone) return;
    if (!variable) return;
    if (!dataset) return;
    if (interestedZone.infoType !== 'value') return;
    if (interestedZone.features && !isEmpty(variable.name) && !isEmpty(dataset.name)) {
      setLoading(true);
      setError(false);
      var qp = {};
      var pp;
      if (process.env.REACT_APP_API_VERSION === 'v1' || !process.env.REACT_APP_API_VERSION) {
        qp = {
          dataset: dataset,
          domain: dataset.domain,
          epsg: dataset.epsg,
          date: date,
          time: time
        };
        pp = ['value', variable.name];
      } else {
        qp = {
          variables: variable.name,
          domain: dataset.domain,
          epsg: dataset.epsg,
          date: parseTime(date, '{y}{m}{d}', true),
          time: parseTime(time, '{y}-{m}-{d}T{h}:{i}:{s}', true),
          stats: stats,
          modifier: modifier.toLowerCase(),
          timeavg: timeavg.toLowerCase()
        };
        pp = ['value', dataset.name];
      }
      var _url = getUrlService('points', pp, qp, true);
      log(_url, 'Get service timeseries', 'info');
      fetch(_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        },
        body: JSON.stringify(interestedZone.features)
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        setLoading(false);
        log(json, 'Response: ', 'info');
        if (json.error) {
          setError(json.status);
        } else {
          if (json.data && Object.keys(json.data).length > 0) {
            var vals = [];
            for (var v in json.data) {
              vals.push(v + ":" + json.data[v].value.toFixed(1));
            }
            setValue(vals.join(' - '));
          }
        }
      })["catch"](function (err) {
        setLoading(false);
        setError(err.toString());
      });
    }
  }, [dataset, date, interestedZone, modifier, stats, time, timeavg, variable]);
  var handleAddNewSensor = function handleAddNewSensor(sensorID) {
    var _newLayer;
    setOpen(false);
    setAnchorEl(null);
    var sta = emissionSensors[sensorID];
    console.log(sta);
    var newCoord = {
      lat: sta.y,
      lon: sta.x,
      type: 'AQ',
      code: sta.code,
      name: sta.name,
      id: sta.id
    };
    var newFeat = {};
    newFeat[sta.id] = newCoord;
    var newLayer = (_newLayer = {}, _newLayer[sta.id] = sta, _newLayer);
    if (interestedZone.features) {
      if (interestedZone.features[Object.keys(interestedZone.features)[0]].type == 'AQ' && interestedZone.infoType == 'timeseries') {
        newLayer = _extends({}, newLayer, interestedZone.layers);
        newFeat = _extends({}, newFeat, interestedZone.features);
      }
    }
    dispatch({
      type: 'SET_EXTRACTION_ZONES',
      value: {
        infoType: 'timeseries',
        type: 'circlemarker',
        layers: newLayer,
        features: newFeat
      }
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: clsx((_clsx = {}, _clsx[classes.panelOpen] = openTimeseriesChart, _clsx[classes.panelClose] = !openTimeseriesChart, _clsx))
  }, openTimeseriesChart && /*#__PURE__*/React.createElement(Accordion, {
    style: {
      width: '100%'
    },
    expanded: infoPanelIsExpanded,
    elevation: 2
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    style: {
      backgroundColor: 'aliceblue',
      overflowY: 'hidden',
      overflowX: 'auto',
      width: '100%'
    },
    expandIcon: /*#__PURE__*/React.createElement(ExpandLessIcon, {
      onClick: expandedChangeHandler
    }),
    "aria-controls": "panel1a-content",
    id: "panel1a-header",
    className: classes.header,
    classes: {
      content: classes.content,
      expanded: classes.expanded
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.chips
  }, interestedZone ? /*#__PURE__*/React.createElement(React.Fragment, null, interestedZone.infoType === 'timeseries' && /*#__PURE__*/React.createElement(TimelineIcon, null), interestedZone.infoType === 'contribution' && /*#__PURE__*/React.createElement(PieChartIcon, null), interestedZone.infoType === 'value' && /*#__PURE__*/React.createElement(LocationOnIcon, null), interestedZone.infoType === 'pollution_rose' && /*#__PURE__*/React.createElement(TrackChanges, null)) : /*#__PURE__*/React.createElement(NotListedLocationIcon, null), getChipOfPoints())), /*#__PURE__*/React.createElement(AccordionDetails, {
    style: {
      display: 'inherit',
      padding: '0'
    }
  }, interestedZone ? /*#__PURE__*/React.createElement(React.Fragment, null, (interestedZone.infoType === 'timeseries' || interestedZone.infoType === 'contribution' || interestedZone.infoType === 'pollution_rose') && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AriaTimeseries, {
    userinfo: userinfo,
    variable: variable,
    dataset: dataset ? dataset.name : '',
    epsg: dataset ? dataset.epsg : 4326,
    interestedZone: interestedZone,
    measure_points: measure_points,
    date: date,
    time: timeObj || time,
    stats: stats,
    modifier: modifier,
    timeavg: timeavg,
    datetimeFormat: datetimeFormat,
    is_atomic: is_atomic,
    data_type: store['data_type'],
    chart_types: chart_types,
    onStartingService: onTimeseriesStartingHandler,
    onMounted: setInfoPanelIsExpanded,
    onNoFeature: onNoFeatureHandler,
    onRunningExtraction: onRunningExtraction,
    withSourcesContribution: withSourcesContribution,
    isVariableReadFromAPI: isVariableReadFromAPI
  })), interestedZone.infoType === 'value' && /*#__PURE__*/React.createElement(React.Fragment, null, loading ? /*#__PURE__*/React.createElement(LinearProgress, {
    className: classes.linearProgress
  }) : error ? /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, "Cannot load data from server") : interestedZone.features && /*#__PURE__*/React.createElement(List, {
    className: classes.list
  }, Object.keys(interestedZone.features).forEach(function (key) {
    var lbl = key;
    var elm = /*#__PURE__*/React.createElement(ListItem, {
      alignItems: "flex-start"
    }, /*#__PURE__*/React.createElement(Typography$1, null, "`$", lbl, " | Location: $", interestedZone.features[lbl].lat.toFixed(6), ",$", interestedZone.features[lbl].lon.toFixed(6), "`"));
    return elm;
  })))) : /*#__PURE__*/React.createElement(Typography$1, null, "No data"))), /*#__PURE__*/React.createElement(Menu, {
    style: {
      zIndex: '80000'
    },
    id: "long-menu",
    MenuListProps: {
      'aria-labelledby': 'long-button'
    },
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    PaperProps: {
      style: {
        maxHeight: '200px'
      }
    }
  }, Object.keys(emissionSensors).map(function (sensor) {
    return /*#__PURE__*/React.createElement(MenuItem$1, {
      key: sensor,
      onClick: function onClick() {
        return handleAddNewSensor(sensor);
      }
    }, emissionSensors[sensor].name);
  })));
};

var drawerWidth = '30%';
var tempWidth = '30%';
var useStyles$j = function useStyles(store) {
  return makeStyles(function (theme) {
    var _drawerOpen;
    return {
      root: {
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      },
      toolbar: theme.mixins.toolbar,
      appBar: {
        zIndex: theme.zIndex.drawer + 1
      },
      drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap'
      },
      drawerOpen: (_drawerOpen = {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen
        })
      }, _drawerOpen[theme.breakpoints.down('xs')] = {
        width: store['leftPanel'] ? fullWidth : tempWidth
      }, _drawerOpen[theme.breakpoints.between('sm', 'md')] = {
        width: store['leftPanel'] ? halfWidth : tempWidth
      }, _drawerOpen[theme.breakpoints.up('md')] = {
        width: store['leftPanel'] ? mdWidth : tempWidth
      }, _drawerOpen),
      drawerClose: {
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen
        }),
        overflowX: 'hidden',
        width: theme.spacing(5)
      },
      content: {
        height: '0%',
        flexGrow: 1,
        padding: theme.spacing(0.2),
        background: '#666',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#b4e3ea',
        transition: theme.transitions.create('margin', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen
        }),
        marginLeft: theme.spacing(5),
        backgroundSize: 'cover'
      },
      contentShift: {
        transition: theme.transitions.create('margin', {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen
        }),
        marginLeft: drawerWidth
      },
      footer: {
        backgroundColor: theme.palette.background.paper,
        transition: theme.transitions.create('margin', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen
        }),
        marginLeft: theme.spacing(5),
        overflowY: 'auto'
      },
      footerShift: {
        transition: theme.transitions.create('margin', {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen
        }),
        marginLeft: drawerWidth,
        overflowY: 'auto'
      },
      madeWith: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      },
      marginLink: {
        marginLeft: theme.spacing(0.5),
        marginRight: theme.spacing(0.5)
      },
      logo: {
        marginLeft: theme.spacing(0.5),
        marginRight: theme.spacing(0.5)
      }
    };
  });
};
var AriaLayout = function AriaLayout(_ref) {
  var _clsx, _clsx2, _clsx3, _clsx4;
  var withDrawer = _ref.withDrawer,
    appbar = _ref.appbar,
    controlPanelProps = _ref.controlPanelProps,
    controls = _ref.controls,
    infoPanelProps = _ref.infoPanelProps,
    setWindowType = _ref.setWindowType,
    onChangeOpenDrawer = _ref.onChangeOpenDrawer,
    children = _ref.children,
    userinfo = _ref.userinfo;
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0];
  var classes = useStyles$j(store)();
  var matches = useMediaQuery(function (theme) {
    return theme.breakpoints.up('md');
  });
  var _useTranslation = useTranslation();
  var window_type = store['window_type'];
  var _React$useState = React.useState(store['leftPanel'] ? true : false),
    open = _React$useState[0],
    setOpen = _React$useState[1];
  var onClickHideControlPanel = React.useCallback(function (open) {
    setOpen(open);
  }, []);
  React.useEffect(function () {
    setWindowType(window_type);
  }, [window_type]);
  useEffect(function () {
    if (typeof onChangeOpenDrawer === 'function') {
      onChangeOpenDrawer(open);
    }
  }, [open]);
  return /*#__PURE__*/React.createElement(MuiPickersUtilsProvider, {
    utils: MomentUtils
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(CssBaseline, null), appbar, withDrawer && /*#__PURE__*/React.createElement(Drawer, {
    variant: "permanent",
    className: clsx(classes.drawer, (_clsx = {}, _clsx[classes.drawerOpen] = open, _clsx[classes.drawerClose] = !open, _clsx)),
    classes: {
      paper: clsx((_clsx2 = {}, _clsx2[classes.drawerOpen] = open, _clsx2[classes.drawerClose] = !open, _clsx2))
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.toolbar
  }), /*#__PURE__*/React.createElement(AriaControlPanel, _extends({
    onClickHideControlPanel: onClickHideControlPanel,
    drawerIsOpen: open,
    setWindowType: setWindowType
  }, controlPanelProps), controls)), /*#__PURE__*/React.createElement("main", {
    className: clsx(classes.content, (_clsx3 = {}, _clsx3[classes.contentShift] = withDrawer && open, _clsx3))
  }, children), /*#__PURE__*/React.createElement("footer", {
    className: clsx(classes.footer, (_clsx4 = {}, _clsx4[classes.footerShift] = withDrawer && open, _clsx4))
  }, infoPanelProps && /*#__PURE__*/React.createElement(AriaInfoPanel, _extends({}, infoPanelProps, {
    userinfo: userinfo
  })))));
};
AriaLayout.propTypes = {};

var useStyles$k = makeStyles(function (theme) {
  return {
    buttonCollapse: {}
  };
});
var AriaMenuLanguage = function AriaMenuLanguage(_ref) {
  var langs = _ref.langs;
  var classes = useStyles$k();
  var _useTranslation = useTranslation(),
    i18n = _useTranslation.i18n;
  var currLanguage = langs[0].code;
  if (i18n.language) {
    currLanguage = i18n.language.split('-')[0];
  } else {
    console.error('react-common.AriaMenuLanguage: ', 'Cannot get the browser detected language: ', i18n.language, '. The first language of the list will be used.');
  }
  var _React$useState = React.useState(currLanguage),
    langue = _React$useState[0],
    setLangue = _React$useState[1];
  var _React$useState2 = React.useState(null),
    anchorEl = _React$useState2[0],
    setAnchorEl = _React$useState2[1];
  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };
  var handleClose = function handleClose() {
    setAnchorEl(null);
  };
  var changeLanguageIn = function changeLanguageIn(lang) {
    setLangue(lang);
    i18n.changeLanguage(lang);
    handleClose();
    window.location.reload();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.buttonCollapse
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleClick
  }, /*#__PURE__*/React.createElement(LanguageIcon, null)), /*#__PURE__*/React.createElement("span", null, langue), /*#__PURE__*/React.createElement(Menu, {
    id: "menu-appbar",
    anchorEl: anchorEl,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    open: Boolean(anchorEl),
    onClose: handleClose
  }, Array.isArray(langs) && langs.map(function (lang, id) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: id,
      onClick: function onClick() {
        return changeLanguageIn(lang.code);
      }
    }, lang.label);
  })));
};

var useStyles$l = makeStyles(function (theme) {
  var _title, _organisation, _image;
  return {
    root: {
      zIndex: theme.zIndex.drawer + 1,
      backgroundColor: '#ffffff',
      height: theme.spacing(7.5)
    },
    bar: {
      display: 'flex',
      justifyContent: 'space-between',
      zIndex: '500',
      width: '100%',
      gap: theme.spacing(1),
      height: theme.spacing(10)
    },
    title: (_title = {}, _title[theme.breakpoints.down('xs')] = {
      fontSize: '0.8rem'
    }, _title),
    titleimage: {
      width: '100%',
      alignSelf: 'center',
      maxHeight: theme.spacing(6),
      marginTop: '11px'
    },
    menuButton: {
      marginLeft: -12,
      marginRight: 20
    },
    logoButton: {
      marginRight: theme.spacing(10)
    },
    organisation: (_organisation = {}, _organisation[theme.breakpoints.down('xs')] = {
      display: 'none'
    }, _organisation.margin = theme.spacing(1), _organisation),
    margin1: {
      marginLeft: 'auto',
      marginRight: theme.spacing(1)
    },
    logos: {
      alignSelf: 'center',
      whiteSpace: 'nowrap',
      display: 'flex'
    },
    loginLogout: {
      alignSelf: 'center',
      whiteSpace: 'nowrap',
      display: 'flex',
      alignItems: 'center'
    },
    image2: (_image = {
      maxHeight: theme.spacing(4)
    }, _image[theme.breakpoints.down('md')] = {
      display: 'none'
    }, _image),
    image: {
      maxWidth: theme.spacing(14),
      maxHeight: theme.spacing(6)
    },
    hidden: {
      display: 'None'
    },
    onethird: {
      whiteSpace: 'nowrap'
    }
  };
});
var AriaAppBar = function AriaAppBar(_ref) {
  var withDrawer = _ref.withDrawer,
    withoutLogout = _ref.withoutLogout,
    drawerIsOpen = _ref.drawerIsOpen,
    toggleDrawer = _ref.toggleDrawer,
    onClick = _ref.onClick,
    onClickOnExit = _ref.onClickOnExit,
    userinfo = _ref.userinfo,
    logos = _ref.logos,
    organisation = _ref.organisation,
    title = _ref.title,
    titleimage = _ref.titleimage,
    langs = _ref.langs,
    hidden = _ref.hidden;
  var classes = useStyles$l();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var onClickExitHandler = React.useCallback(function () {
    removeUser();
    removeToken();
    if (typeof onClickOnExit === 'function') {
      onClickOnExit();
    }
  }, [onClickOnExit]);
  var onClickAideHandler = React.useCallback(function () {
    alert('En cours de construction');
  }, []);
  return /*#__PURE__*/React.createElement(AppBar, {
    position: "static",
    className: hidden ? classes.hidden : classes.root
  }, /*#__PURE__*/React.createElement(Toolbar, null, /*#__PURE__*/React.createElement("div", {
    className: classes.bar
  }, withDrawer && /*#__PURE__*/React.createElement(IconButton, {
    color: "inherit",
    "aria-label": "Menu",
    onClick: toggleDrawer
  }, drawerIsOpen ? /*#__PURE__*/React.createElement(ChevronLeftIcon, null) : /*#__PURE__*/React.createElement(MenuIcon, null)), /*#__PURE__*/React.createElement("div", {
    className: classes.logos
  }, logos && logos.map(function (logo) {
    return logos.indexOf(logo) > 1 ? /*#__PURE__*/React.createElement("img", {
      alt: "SUEZ",
      src: logo,
      className: classes.image2
    }) : /*#__PURE__*/React.createElement("img", {
      alt: "SUEZ",
      src: logo,
      className: classes.image
    });
  }), organisation && /*#__PURE__*/React.createElement(Typography$1, {
    variant: "subtitle1",
    className: classes.organisation
  }, organisation)), /*#__PURE__*/React.createElement("div", null, titleimage ? /*#__PURE__*/React.createElement("img", {
    alt: "SUEZ",
    src: title,
    className: classes.titleimage
  }) : /*#__PURE__*/React.createElement(Typography$1, {
    variant: "h6",
    className: classes.title,
    align: "center"
  }, title)), !withoutLogout && /*#__PURE__*/React.createElement("div", {
    className: classes.loginLogout
  }, /*#__PURE__*/React.createElement(Chip$1, {
    icon: /*#__PURE__*/React.createElement(FaceIcon, null),
    label: userinfo ? userinfo : '',
    onClick: onClick,
    className: classes.margin1
  }), /*#__PURE__*/React.createElement(Tooltip, {
    title: t('ApplicationBar.Logout')
  }, /*#__PURE__*/React.createElement(IconButton, {
    color: "inherit",
    "aria-label": "Exit",
    onClick: onClickExitHandler,
    className: classes.margin1
  }, /*#__PURE__*/React.createElement(ExitToAppIcon, null))), Array.isArray(langs) && /*#__PURE__*/React.createElement(AriaMenuLanguage, {
    langs: langs
  })))));
};
AriaAppBar.propTypes = {};

var ShapeMarker = /*#__PURE__*/function (_Path) {
  _inheritsLoose(ShapeMarker, _Path);
  function ShapeMarker() {
    return _Path.apply(this, arguments) || this;
  }
  var _proto = ShapeMarker.prototype;
  _proto.createLeafletElement = function createLeafletElement(props) {
    var el = L$1.shapeMarker(props.center, this.getOptions(props));
    this.contextValue = _extends({}, props.leaflet, {
      popupContainer: el
    });
    return el;
  };
  _proto.updateLeafletElement = function updateLeafletElement(fromProps, toProps) {
    if (toProps.center !== fromProps.center) {
      this.leafletElement.setLatLng(toProps.center);
    }
    if (toProps.radius !== fromProps.radius) {
      this.leafletElement.setRadius(toProps.radius);
    }
    if (toProps.style !== fromProps.style) {
      this.leafletElement.setStyle(toProps.style);
    }
  };
  return ShapeMarker;
}(Path);
var ShapeMarker$1 = withLeaflet(ShapeMarker);

var panelHeightRelative = '25vh';
var panelHeightFixed = '250px';
var useStyles$m = makeStyles(function (theme) {
  return {
    root: {
      zIndex: '500',
      minHeight: panelHeightFixed,
      height: panelHeightRelative,
      width: 'auto'
    },
    summary: {
      backgroundColor: '#E9F4F8'
    },
    container: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#fff',
      padding: theme.spacing(1)
    },
    colorcontainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    },
    floatBothRow: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    colorlevel: {
      display: 'block',
      width: '100%'
    },
    colorlabel: {
      fontWeight: 600,
      color: '#333',
      marginLeft: theme.spacing(1)
    },
    progress: {
      margin: theme.spacing(2)
    },
    icons: {
      "float": 'right'
    },
    input: {
      maxWidth: '70px'
    }
  };
});
var checkIsValid$1 = function checkIsValid(palettes) {
  if (Array.isArray(palettes)) {
    log(palettes, 'Palette in checking');
    var isValid = true;
    palettes.forEach(function (obj, id) {
      var lvl = Number(obj.level);
      isValid &= !isNaN(lvl);
      var thr = Number(obj.threshold);
      isValid &= !isNaN(thr);
      obj.level = lvl;
      obj.threshold = thr;
      if (id < palettes.length - 1) {
        isValid &= obj.level < obj.threshold;
      } else {
        obj.threshold = obj.level * 2.0;
      }
    });
    return isValid;
  }
};
var AriaColorScaleControl = function AriaColorScaleControl(_ref) {
  var variableUnit = _ref.variableUnit,
    onLoadingPalette = _ref.onLoadingPalette,
    onChangedPalette = _ref.onChangedPalette,
    colormap = _ref.colormap,
    edittable = _ref.edittable;
  var classes = useStyles$m();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAriaAppStore = useAriaAppStore(),
    dispatch = _useAriaAppStore[1];
  var _useState = useState(undefined),
    error = _useState[0],
    setError = _useState[1];
  var _useState2 = useState(false),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useState3 = useState(false),
    editing = _useState3[0],
    setEditing = _useState3[1];
  var _React$useState = React.useState([]),
    paletteValues = _React$useState[0],
    setPaletteValues = _React$useState[1];
  var _React$useState2 = React.useState([]),
    paletteDatabaseValues = _React$useState2[0],
    setPaletteDatabaseValues = _React$useState2[1];
  log(colormap, 'Colormap in AriaColorScale: ');
  var onValueChangedHandler = function onValueChangedHandler(id) {
    return function (e) {
      e.persist();
      var newVal = e.target.value;
      setPaletteValues(function (x) {
        return x.map(function (v, i) {
          if (i == id - 1) {
            return _extends({}, v, {
              threshold: newVal
            });
          } else if (i == id) {
            return _extends({}, v, {
              label: ">" + newVal,
              level: newVal
            });
          } else return v;
        });
      });
    };
  };
  var onEditingChangedHandler = React.useCallback(function (e) {
    var editIsDone = editing;
    if (editIsDone) {
      if (!checkIsValid$1(paletteValues)) {
        setPaletteValues(paletteDatabaseValues);
        setTimeout(function () {
          alert("Valeurs ne sont pas dans l'interval. Réinitialiser !");
        }, 500);
      } else {
        log(paletteValues, 'New palettes');
        if (edittable) {
          if (typeof onChangedPalette === 'function') {
            onChangedPalette(paletteValues);
          }
        }
      }
    }
    setEditing(function (x) {
      return !x;
    });
  }, [editing, onChangedPalette, paletteDatabaseValues, paletteValues, edittable]);
  React.useEffect(function () {
    if (!isEmpty(colormap)) {
      setIsLoading(true);
      setError(false);
      var pp = [colormap];
      var _url = getUrlService('palettes', pp);
      log(_url, 'URL palettes services', 'info');
      fetch(_url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        }
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        setIsLoading(false);
        log(json);
        if (json.data) {
          if (Array.isArray(json.data.colormap)) {
            if (typeof onLoadingPalette === 'function') {
              onLoadingPalette(json.data.colormap);
            }
            if (dispatch) {
              dispatch({
                type: 'SET_PALETTE',
                value: json.data.colormap
              });
            }
            var itemVals = json.data.colormap.map(function (x) {
              var obj = {};
              if (isEmpty(x.label)) {
                obj['label'] = ">" + x.level;
              } else {
                obj['label'] = x.label;
              }
              obj['value'] = x.value;
              obj['level'] = x.level;
              obj['threshold'] = x.threshold;
              return obj;
            });
            setPaletteValues(itemVals);
            setPaletteDatabaseValues(itemVals);
            if (edittable) {
              if (typeof onChangedPalette === 'function') {
                onChangedPalette(itemVals);
              }
            }
          }
        }
      })["catch"](function (error) {
        setError(error.toString());
        setIsLoading(false);
      });
    }
  }, [onLoadingPalette, colormap, onChangedPalette, edittable]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, error ? /*#__PURE__*/React.createElement(Alert$2, {
    severity: "error",
    className: classes.alert
  }, t('ColorScale.Error_loading_message')) : isLoading ? /*#__PURE__*/React.createElement(CircularProgress$1, {
    className: classes.progress
  }) : /*#__PURE__*/React.createElement(Accordion, {
    elevation: 0,
    defaultExpanded: true
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null),
    "aria-controls": "panel1a-content",
    id: "panel1a-header"
  }, /*#__PURE__*/React.createElement(Typography$1, {
    color: "primary"
  }, t('Map.Legend'))), /*#__PURE__*/React.createElement(AccordionDetails, null, /*#__PURE__*/React.createElement(Box, {
    sx: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, variableUnit && /*#__PURE__*/React.createElement("div", {
    className: classes.floatBothRow
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.colorlabel
  }, variableUnit), edittable && /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "edit",
    className: classes.icons,
    size: "small",
    onClick: onEditingChangedHandler
  }, editing ? /*#__PURE__*/React.createElement(DoneIcon, {
    fontSize: "inherit"
  }) : /*#__PURE__*/React.createElement(EditIcon, {
    fontSize: "inherit"
  }))), paletteValues && paletteValues.map(function (x, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: classes.colorcontainer,
      style: {
        height: 100.0 / paletteValues.length + "%"
      }
    }, /*#__PURE__*/React.createElement("div", {
      key: i,
      style: {
        backgroundColor: x.value,
        width: '20px',
        height: '100%',
        display: 'inline-block',
        cursor: 'pointer'
      }
    }), editing ? /*#__PURE__*/React.createElement("input", {
      className: classes.input,
      type: "text",
      value: paletteValues[i].level,
      onChange: onValueChangedHandler(i),
      onDoubleClick: function onDoubleClick(e) {
        return false;
      },
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    }) : /*#__PURE__*/React.createElement("span", {
      className: classes.colorlabel
    }, isEmpty(x.label) ? ">=" + x.level : x.label));
  }))))));
};

var BaseLayers = {
  osm: {
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution: 'donn&eacute;es &copy; <a href="//osm.org/copyright">OpenStreetMap</a>/ODbL - rendu <a href="//openstreetmap.fr">OSM France</a>'
  },
  osmfr: {
    url: "//{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png",
    attribution: "&amp;copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
  },
  IGN: {
    url: 'https://wxs.ign.fr/decouverte/geoportail/wmts?&REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0&TILEMATRIXSET=PM' + '&LAYER=GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2&STYLE=normal&FORMAT=image/png&TILECOL={x}&TILEROW={y}&TILEMATRIX={z}',
    attribution: '<a href="https://geoservices.ign.fr/cgu-licences" target="_blank">IGN</a>'
  },
  maptiler_sat: {
    url: "https://api.maptiler.com/tiles/satellite/{z}/{x}/{y}.jpg?key=" + process.env.REACT_APP_ARIA_MAPTILER_APIKEY,
    attribution: '<a href="https://www.maptiler.com/copyright/" target="_blank">© MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">© OpenStreetMap contributors</a>'
  },
  googleHybrid: {
    url: 'https://mt1.google.com/vt/lyrs=y,h&x={x}&y={y}&z={z}',
    attribution: "&amp;copy; <a href=&quot;https://map.google.com/copyright&quot;>GOOGLE Map</a>"
  },
  googleSat: {
    url: 'https://mt.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',
    attribution: "&amp;copy; <a href=&quot;https://map.google.com/copyright&quot;>GOOGLE Map</a>"
  },
  googleTerrain: {
    url: 'https://mt.google.com/vt/lyrs=p,h&x={x}&y={y}&z={z}',
    attribution: "&amp;copy; <a href=&quot;https://map.google.com/copyright&quot;>GOOGLE Map</a>"
  },
  googleStreets: {
    url: 'https://mt1.google.com/vt/lyrs=m,h&x={x}&y={y}&z={z}',
    attribution: "&amp;copy; <a href=&quot;https://map.google.com/copyright&quot;>GOOGLE Map</a>"
  },
  mapBox: {
    url: 'https://api.mapbox.com/styles/v1/mapbox/outdoors-v9/tiles/256/{z}/{x}/{y}?access_token=' + process.env.REACT_APP_MAPBOX_TOKEN,
    attribution: '© <a href="https://www.mapbox.com/about/maps/"">Mapbox</a> © <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
  }
};
function getBaseLayers() {
  return BaseLayers;
}

var AriaDataTileLayer = (function (_ref) {
  var dataset = _ref.dataset,
    site = _ref.site,
    epsg = _ref.epsg,
    variable = _ref.variable,
    currdate = _ref.currdate,
    currTime = _ref.currTime,
    modifier = _ref.modifier,
    timeavg = _ref.timeavg,
    stat = _ref.stat,
    palette = _ref.palette,
    is_atomic = _ref.is_atomic,
    opacity = _ref.opacity,
    k_level = _ref.k_level,
    coeffsDerivedVariables = _ref.coeffsDerivedVariables,
    globalTransformB = _ref.globalTransformB;
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0];
  var ucomp = store['windcomps'].ucomp;
  var vcomp = store['windcomps'].vcomp;
  var derived_variable = store['derived_variable'];
  var getTileURL = React.useCallback(function () {
    var _tURL = '';
    if (dataset && variable && currTime) {
      var qp = {};
      var pp = ['{z}', '{x}', '{y}'];
      var time = currTime == 'mean' ? 'mean' : parseTime(currTime, '{y}-{m}-{d}T{h}:{i}:{s}', true);
      if (!process.env.REACT_APP_API_VERSION || process.env.REACT_APP_API_VERSION === 'v1') {
        if (variable === 'wind') {
          qp = {
            format: 'png',
            dataset: dataset,
            site: site,
            date: currdate,
            time: time,
            variable: variable,
            ucomp: ucomp,
            vcomp: vcomp,
            k_level: k_level
          };
        } else {
          qp = {
            format: 'png',
            dataset: dataset,
            site: site,
            date: currdate,
            time: time,
            variable: variable,
            epsg: epsg,
            k_level: k_level,
            is_atomic: is_atomic ? 1 : 0,
            derived_variable: coeffsDerivedVariables ? derived_variable.name : undefined,
            coeffs: coeffsDerivedVariables ? coeffsDerivedVariables : undefined
          };
        }
        pp.unshift('v2');
      } else if (process.env.REACT_APP_API_VERSION !== 'v1') {
        if (variable === 'wind') {
          qp = {
            format: 'png',
            dataset: dataset,
            date: currdate,
            time: currTime,
            variable: variable,
            ucomp: ucomp,
            vcomp: vcomp,
            k_level: k_level
          };
        } else {
          qp = {
            format: 'png',
            dataset: dataset,
            date: currdate,
            time: time,
            variable: variable,
            epsg: epsg,
            is_atomic: is_atomic ? 1 : 0,
            modifier: modifier ? modifier.toLowerCase() : undefined,
            timeavg: timeavg ? timeavg.toLowerCase() : undefined,
            stat: stat ? stat.toLowerCase() : undefined,
            k_level: k_level,
            globalTransformB: globalTransformB,
            derived_variable: coeffsDerivedVariables ? derived_variable.name : undefined,
            coeffs: coeffsDerivedVariables
          };
          log(palette, 'Palette values in TileLayer: ');
          if (Array.isArray(palette) && palette.length > 0) {
            var pal = palette.map(function (l) {
              return l.value.replace('#', '') + ":" + l.level + ":" + l.threshold + ":" + l.label;
            });
            qp['palette'] = pal.join('@');
          }
        }
      }
      _tURL = getUrlService('maps', pp, qp, true);
    }
    log(_tURL, 'URL: ');
    return _tURL;
  }, [currTime, currdate, dataset, epsg, modifier, palette, site, stat, timeavg, is_atomic, variable, k_level, coeffsDerivedVariables, globalTransformB]);
  return /*#__PURE__*/React.createElement(TileLayer, {
    url: getTileURL(),
    opacity: opacity,
    attribution: "&copy; <a href='https://api.aria.fr/py/docs' target='blank_'>ARIA Technologies</a> API",
    zIndex: 1100
  });
});

proj4.defs("EPSG:32631", "+proj=utm +zone=31 +south +datum=WGS84 +units=m +no_defs");
proj4.defs("EPSG:32722", "+proj=utm +zone=22 +south +datum=WGS84 +units=m +no_defs");
proj4.defs("EPSG:2154", "+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
function AriaWindy(params) {
  var INTENSITY_SCALE_STEP = 30;
  var MAX_WIND_INTENSITY = params.maxValue || 3;
  var MAX_PARTICLE_AGE = 100;
  var PARTICLE_LINE_WIDTH = 2.0;
  var PARTICLE_MULTIPLIER = 1 / 600;
  var PARTICLE_REDUCTION = 0.75;
  var FRAME_RATE = 20;
  var NULL_WIND_VECTOR = [NaN, NaN, null];
  var viewType = params.viewType || 0;
  var EPSG = params.epsg || 4326;
  var bilinearInterpolateVector = function bilinearInterpolateVector(x, y, g00, g10, g01, g11) {
    var rx = 1 - x;
    var ry = 1 - y;
    var a = rx * ry,
      b = x * ry,
      c = rx * y,
      d = x * y;
    var u = g00[0] * a + g10[0] * b + g01[0] * c + g11[0] * d;
    var v = g00[1] * a + g10[1] * b + g01[1] * c + g11[1] * d;
    return [u, v, Math.sqrt(u * u + v * v)];
  };
  var createWindBuilder = function createWindBuilder(uComp, vComp) {
    var uData = uComp.data,
      vData = vComp.data;
    return {
      header: uComp.header,
      data: function data(i) {
        return [uData[i], vData[i]];
      },
      interpolate: bilinearInterpolateVector
    };
  };
  var createBuilder = function createBuilder(data) {
    var uComp = null,
      vComp = null;
    data.forEach(function (record) {
      switch (record.header.parameterCategory + "," + record.header.parameterNumber) {
        case "2,2":
          uComp = record;
          break;
        case "2,3":
          vComp = record;
          break;
      }
    });
    return createWindBuilder(uComp, vComp);
  };
  var buildGrid = function buildGrid(data, callback) {
    var builder = createBuilder(data);
    var header = builder.header;
    var λ0 = header.lo1,
      φ0 = header.la1;
    var Δλ = header.dx,
      Δφ = header.dy;
    var ni = header.nx,
      nj = header.ny;
    var date = new Date(header.refTime);
    var λ1 = λ0 + ni * Δλ,
      φ1 = φ0 + nj * Δφ;
    date.setHours(date.getHours() + header.forecastTime);
    var grid = [],
      p = 0;
    var isContinuous = Math.floor(ni * Δλ) >= 360;
    for (var j = 0; j < nj; j++) {
      var row = [];
      for (var i = 0; i < ni; i++, p++) {
        row[i] = builder.data(p);
      }
      if (isContinuous) {
        row.push(row[0]);
      }
      grid[j] = row;
    }
    data = null;
    function isOutOfDomain(λ, φ) {
      return !((λ - (λ0 - Δλ)) / Δλ >= 0 && (λ1 + Δλ - λ) / Δλ >= 0 && (φ - (φ0 - Δφ)) / Δφ >= 0 && (φ1 + Δφ - φ) / Δφ >= 0);
    }
    function interpolate(λ, φ) {
      var i = floorMod(λ - λ0, 360) / Δλ;
      var j = (φ - φ0) / Δφ;
      var px = λ,
        py = φ;
      if (EPSG !== 4326) {
        var _proj = proj4('EPSG:' + EPSG, [λ, φ]);
        px = _proj[0];
        py = _proj[1];
        i = (px - λ0) / Δλ;
        j = (py - φ0) / Δφ;
      }
      if (isOutOfDomain(px, py)) {
        return null;
      }
      if (params.tiledData) {
        if ((λ - λ0) / Δλ < 0) {
          i = 0;
        }
        if ((φ - φ0) / Δφ < 0) {
          j = 0;
        }
        if ((λ1 - λ) / Δλ < 0) {
          i = ni - 1;
        }
        if ((φ1 - φ) / Δφ < 0) {
          j = nj - 1;
        }
      }
      var fi = Math.floor(i),
        ci = fi + 1;
      var fj = Math.floor(j),
        cj = fj + 1;
      var row;
      if (row = grid[fj]) {
        var g00 = row[fi];
        var g10 = row[ci];
        if (isValue(g00) && isValue(g10) && (row = grid[cj])) {
          var g01 = row[fi];
          var g11 = row[ci];
          if (isValue(g01) && isValue(g11)) {
            return builder.interpolate(i - fi, j - fj, g00, g10, g01, g11);
          }
        } else if (params.tiledData) {
          if (isValue(g00)) {
            return builder.interpolate(i - fi, j - fj, g00, g00, g00, g00);
          }
        }
      }
      return null;
    }
    callback({
      date: date,
      interpolate: interpolate
    });
  };
  var isValue = function isValue(x) {
    return x !== null && x !== undefined;
  };
  var floorMod = function floorMod(a, n) {
    return a - n * Math.floor(a / n);
  };
  var isMobile = function isMobile() {
    return /android|blackberry|iemobile|ipad|iphone|ipod|opera mini|webos/i.test(navigator.userAgent);
  };
  var distort = function distort(projection, λ, φ, x, y, scale, wind, windy) {
    var u = wind[0] * scale;
    var v = wind[1] * scale;
    var d = distortion(projection, λ, φ, x, y, windy);
    wind[0] = d[0] * u + d[2] * v;
    wind[1] = d[1] * u + d[3] * v;
    return wind;
  };
  var distortion = function distortion(projection, λ, φ, x, y, windy) {
    var τ = 2 * Math.PI;
    var H = Math.pow(10, -5.2);
    var hλ = λ < 0 ? H : -H;
    var hφ = φ < 0 ? H : -H;
    var pλ = project(φ, λ + hλ, windy);
    var pφ = project(φ + hφ, λ, windy);
    var k = Math.cos(φ / 360 * τ);
    return [(pλ[0] - x) / hλ / k, (pλ[1] - y) / hλ / k, (pφ[0] - x) / hφ, (pφ[1] - y) / hφ];
  };
  var createField = function createField(columns, bounds, callback) {
    function field(x, y) {
      var column = columns[Math.round(x)];
      return column && column[Math.round(y)] || NULL_WIND_VECTOR;
    }
    field.release = function () {
      columns = [];
    };
    field.randomize = function (o) {
      var x, y;
      x = Math.round(Math.floor(Math.random() * bounds.width) + bounds.x);
      y = Math.round(Math.floor(Math.random() * bounds.height) + bounds.y);
      o.x = x;
      o.y = y;
      return o;
    };
    callback(bounds, field);
  };
  var buildBounds = function buildBounds(bounds, width, height) {
    var upperLeft = bounds[0];
    var lowerRight = bounds[1];
    var x = Math.round(upperLeft[0]);
    var y = Math.max(Math.floor(upperLeft[1], 0), 0);
    var xMax = Math.min(Math.ceil(lowerRight[0], width), width - 1);
    var yMax = Math.min(Math.ceil(lowerRight[1], height), height - 1);
    return {
      x: x,
      y: y,
      xMax: xMax,
      yMax: yMax,
      width: width,
      height: height
    };
  };
  var deg2rad = function deg2rad(deg) {
    return deg / 180 * Math.PI;
  };
  var rad2deg = function rad2deg(ang) {
    return ang / (Math.PI / 180.0);
  };
  var invert = function invert(x, y, windy) {
    var mapLonDelta = windy.east - windy.west;
    var worldMapRadius = windy.width / rad2deg(mapLonDelta) * 360 / (2 * Math.PI);
    var mapOffsetY = worldMapRadius / 2 * Math.log((1 + Math.sin(windy.south)) / (1 - Math.sin(windy.south)));
    var equatorY = windy.height + mapOffsetY;
    var a = (equatorY - y) / worldMapRadius;
    var lat = 180 / Math.PI * (2 * Math.atan(Math.exp(a)) - Math.PI / 2);
    var lon = rad2deg(windy.west) + x / windy.width * rad2deg(mapLonDelta);
    return [lon, lat];
  };
  var mercY = function mercY(lat) {
    return Math.log(Math.tan(lat / 2 + Math.PI / 4));
  };
  var project = function project(lat, lon, windy) {
    var ymin = mercY(windy.south);
    var ymax = mercY(windy.north);
    var xFactor = windy.width / (windy.east - windy.west);
    var yFactor = windy.height / (ymax - ymin);
    var y = mercY(deg2rad(lat));
    var x = (deg2rad(lon) - windy.west) * xFactor;
    y = (ymax - y) * yFactor;
    return [x, y];
  };
  var interpolateField = function interpolateField(grid, bounds, extent, zoom, callback) {
    var projection = {};
    var velocityScale = 0.5 / Math.pow(2, zoom);
    var columns = [];
    var x = bounds.x;
    function interpolateColumn(x) {
      var column = [];
      for (var y = bounds.y; y <= bounds.yMax; y += 2) {
        var coord = invert(x, y, extent);
        if (coord) {
          var λ = coord[0],
            φ = coord[1];
          if (isFinite(λ)) {
            var wind = grid.interpolate(λ, φ);
            if (wind) {
              wind = distort(projection, λ, φ, x, y, velocityScale, wind, extent);
              column[y + 1] = column[y] = wind;
            }
          }
        }
      }
      columns[x + 1] = columns[x] = column;
    }
    (function batchInterpolate() {
      var start = Date.now();
      while (x <= bounds.width) {
        interpolateColumn(x);
        x += 2;
        if (Date.now() - start > 1000) {
          setTimeout(batchInterpolate, 25);
          return;
        }
      }
      createField(columns, bounds, callback);
      grid = [];
    })();
  };
  var animate = function animate(bounds, field, canvas) {
    function hexToR(h) {
      return parseInt(cutHex(h).substring(0, 2), 16);
    }
    function hexToG(h) {
      return parseInt(cutHex(h).substring(2, 4), 16);
    }
    function hexToB(h) {
      return parseInt(cutHex(h).substring(4, 6), 16);
    }
    function cutHex(h) {
      return h.charAt(0) == "#" ? h.substring(1, 7) : h;
    }
    function windIntensityColorScale(step, maxWind) {
      var result = ["rgba(" + hexToR('#00ffff') + ", " + hexToG('#00ffff') + ", " + hexToB('#00ffff') + ", " + 0.5 + ")", "rgba(" + hexToR('#64f0ff') + ", " + hexToG('#64f0ff') + ", " + hexToB('#64f0ff') + ", " + 0.5 + ")", "rgba(" + hexToR('#87e1ff') + ", " + hexToG('#87e1ff') + ", " + hexToB('#87e1ff') + ", " + 0.5 + ")", "rgba(" + hexToR('#a0d0ff') + ", " + hexToG('#a0d0ff') + ", " + hexToB('#a0d0ff') + ", " + 0.5 + ")", "rgba(" + hexToR('#b5c0ff') + ", " + hexToG('#b5c0ff') + ", " + hexToB('#b5c0ff') + ", " + 0.5 + ")", "rgba(" + hexToR('#c6adff') + ", " + hexToG('#c6adff') + ", " + hexToB('#c6adff') + ", " + 0.5 + ")", "rgba(" + hexToR('#d49bff') + ", " + hexToG('#d49bff') + ", " + hexToB('#d49bff') + ", " + 0.5 + ")", "rgba(" + hexToR('#e185ff') + ", " + hexToG('#e185ff') + ", " + hexToB('#e185ff') + ", " + 0.5 + ")", "rgba(" + hexToR('#ec6dff') + ", " + hexToG('#ec6dff') + ", " + hexToB('#ec6dff') + ", " + 0.5 + ")", "rgba(" + hexToR('#ff1edb') + ", " + hexToG('#ff1edb') + ", " + hexToB('#ff1edb') + ", " + 0.5 + ")"];
      result.indexFor = function (m) {
        return Math.floor(Math.min(m, maxWind) / maxWind * (result.length - 1));
      };
      return result;
    }
    var colorStyles = windIntensityColorScale(INTENSITY_SCALE_STEP, MAX_WIND_INTENSITY);
    var buckets = colorStyles.map(function () {
      return [];
    });
    var particleCount = Math.round(bounds.width * bounds.height * PARTICLE_MULTIPLIER);
    if (isMobile()) {
      particleCount *= PARTICLE_REDUCTION;
    }
    var fadeFillStyle = "rgba(0, 0, 0, 0.8)";
    var particles = [];
    for (var i = 0; i < particleCount; i++) {
      var newParticle = field.randomize({
        age: Math.floor(Math.random() * MAX_PARTICLE_AGE) + 0
      });
      if (field(newParticle.x, newParticle.y)[2] === null) {
        continue;
      }
      particles.push(newParticle);
    }
    function evolve() {
      buckets.forEach(function (bucket) {
        bucket.length = 0;
      });
      particles.forEach(function (particle) {
        if (particle.age > MAX_PARTICLE_AGE) {
          field.randomize(particle).age = 0;
        }
        var x = particle.x;
        var y = particle.y;
        var v = field(x, y);
        var m = v[2];
        if (m === null) {
          particle.age = MAX_PARTICLE_AGE;
        } else {
          var xt = x + v[0];
          var yt = y + v[1];
          if (field(xt, yt)[2] !== null) {
            particle.xt = xt;
            particle.yt = yt;
            buckets[colorStyles.indexFor(m)].push(particle);
          } else {
            particle.x = xt;
            particle.y = yt;
          }
        }
        particle.age += 1;
      });
    }
    if (canvas) {
      params.canvas = canvas;
    }
    var g = params.canvas.getContext("2d");
    g.clearRect(bounds.x, bounds.y, bounds.width, bounds.height);
    g.lineWidth = PARTICLE_LINE_WIDTH;
    g.fillStyle = fadeFillStyle;
    function draw() {
      var prev = g.globalCompositeOperation;
      g.globalCompositeOperation = "destination-in";
      g.fillStyle = fadeFillStyle;
      g.fillRect(bounds.x, bounds.y, bounds.width, bounds.height);
      g.globalCompositeOperation = prev;
      buckets.forEach(function (bucket, i) {
        if (bucket.length > 0) {
          g.beginPath();
          g.strokeStyle = 'rgba(64,64,64,0.5)';
          bucket.forEach(function (particle) {
            g.moveTo(particle.x, particle.y);
            g.lineTo(particle.xt, particle.yt);
            particle.x = particle.xt;
            particle.y = particle.yt;
          });
          g.stroke();
        }
      });
    }
    function drawField() {
      for (var y = bounds.y; y <= bounds.yMax; y += 2) {
        for (var x = bounds.x; x <= bounds.xMax; x += 2) {
          var v = field(x, y);
          var m = v[2];
          if (m !== null) {
            g.fillStyle = colorStyles[colorStyles.indexFor(m)];
            g.fillRect(x, y, 2, 2);
          }
        }
      }
    }
    (function frame() {
      try {
        if (viewType == 0) {
          windy.timers.push(setTimeout(function () {
            requestAnimationFrame(frame);
            evolve();
            draw();
          }, 1000 / FRAME_RATE));
        } else if (viewType == 1) {
          drawField();
        }
      } catch (e) {
        console.error(e);
      }
    })();
  };
  var start = function start(bounds, width, height, extent, zoom, canvas, data) {
    var mapBounds = {
      south: deg2rad(extent[0][1]),
      north: deg2rad(extent[1][1]),
      east: deg2rad(extent[1][0]),
      west: deg2rad(extent[0][0]),
      width: width,
      height: height
    };
    buildGrid(data || params.data, function (grid) {
      interpolateField(grid, buildBounds(bounds, width, height), mapBounds, zoom, function (bounds, field) {
        windy.fields.push(field);
        animate(bounds, field, canvas);
      });
    });
  };
  var eraseDrawing = function eraseDrawing(bounds, canvas) {
    var fadeFillStyle = "rgba(0, 0, 0, 0.8)";
    var g = canvas.getContext("2d");
    g.clearRect(bounds.x, bounds.y, bounds.width, bounds.height);
    g.lineWidth = PARTICLE_LINE_WIDTH;
    g.fillStyle = fadeFillStyle;
    var prev = g.globalCompositeOperation;
    g.globalCompositeOperation = "destination-in";
    g.fillStyle = fadeFillStyle;
    g.fillRect(bounds.x, bounds.y, bounds.width, bounds.height);
    g.globalCompositeOperation = prev;
  };
  var stop = function stop() {
    var popped;
    while (popped = windy.fields.pop()) {
      popped.release();
    }
    while (popped = windy.timers.pop()) {
      clearTimeout(popped);
    }
  };
  var windy = {
    fields: [],
    timers: [],
    params: params,
    start: start,
    stop: stop,
    reset: eraseDrawing
  };
  return windy;
}
window.requestAnimationFrame = function () {
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
    window.setTimeout(callback, 1000 / 20);
  };
}();

var PALETTES = {
  unit: 'm/s',
  data: [{
    color: '#ff1edb'
  }, {
    color: '#ec6dff'
  }, {
    color: '#e185ff'
  }, {
    color: '#d49bff'
  }, {
    color: '#b5c0ff'
  }, {
    color: '#87e1ff'
  }, {
    color: '#00ffff'
  }],
  levelFunction: function levelFunction(index) {
    var lvls = [{
      value: 10.0,
      label: '>10.0'
    }, {
      value: 7.0,
      label: '7.0-10.0'
    }, {
      value: 4.0,
      label: '4.0-7.0'
    }, {
      value: 4.0,
      label: '2.0-4.0'
    }, {
      value: 2.0,
      label: '1.0-2.0'
    }, {
      value: 1.0,
      label: '0.0-1.0'
    }, {
      value: 0.0,
      label: '<0.0'
    }];
    if (typeof index === "undefined") {
      return lvls.length;
    }
    return lvls[index] || null;
  }
};
var AriaWindLayer = (function (_ref) {
  var data = _ref.data,
    enableAnimation = _ref.enableAnimation,
    pauseAnimation = _ref.pauseAnimation;
  var _useAriaAppStore = useAriaAppStore(),
    dispatch = _useAriaAppStore[1];
  var windy = useSelector(function (state) {
    return state.app.results.windy;
  });
  var homepage = useSelector(function (state) {
    return state.app.homepage;
  });
  React.useEffect(function () {
    var _windy = null;
    if (!homepage) {
      _windy = new AriaWindy({
        maxValue: PALETTES.levelFunction(0).value,
        epsg: 2154,
        tiledData: false
      });
      console.log("***** New windy ...");
      dispatch({
        type: 'SET_WIND_RESULT',
        value: _windy
      });
    }
    return function () {
      if (_windy) {
        _windy.stop();
        _windy = null;
      }
    };
  }, [homepage]);
  var drawMethod = React.useCallback(function (params) {
    var size = params.size;
    if (size.x > 0 && size.y > 0) {
      if (windy) {
        if (params.data) {
          windy.stop();
          if (!enableAnimation) {
            if (params.canvas) {
              windy.reset({
                x: 0,
                y: 0,
                width: size.x,
                height: size.y
              }, params.canvas);
            }
          } else {
            if (!pauseAnimation) {
              windy.start([[0, 0], [size.x, size.y]], size.x, size.y, [[params.bounds._southWest.lng, params.bounds._southWest.lat], [params.bounds._northEast.lng, params.bounds._northEast.lat]], params.zoom, params.canvas, params.data);
            }
          }
        } else {
          windy.stop();
        }
      }
    }
  }, [windy, enableAnimation, pauseAnimation]);
  return /*#__PURE__*/React.createElement(CanvasLayer, {
    data: data,
    drawMethod: drawMethod,
    zIndex: 1500
  });
});

var _excluded$2 = ["apiservice", "onLoadingCallback", "onErrorCallback"];
var index$1 = (function (_ref) {
  var apiservice = _ref.apiservice,
    onLoadingCallback = _ref.onLoadingCallback,
    onErrorCallback = _ref.onErrorCallback,
    others = _objectWithoutPropertiesLoose(_ref, _excluded$2);
  var geoLayerRef = React.useRef(null);
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0];
  var project = store['project'];
  var variable = store['variable'];
  var palette = store['palette'];
  var _React$useState = React.useState(),
    layerData = _React$useState[0],
    setLayerData = _React$useState[1];
  var _React$useState2 = React.useState(false),
    isLoading = _React$useState2[0],
    setIsLoading = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    hasError = _React$useState3[0],
    setError = _React$useState3[1];
  var onMarkerClickedHandler = React.useCallback(function () {
    console.log('Get timeseries !!!');
  }, []);
  var onEachFeatureHandler = React.useCallback(function (feat, layer) {
    if (isEmpty(variable.name)) {
      return;
    }
    var popValue;
    if (variable.name in feat.properties) {
      popValue = feat.properties[variable.name];
      layer.bindTooltip(popValue.toString());
    }
    var popDetails = document.createElement('table');
    popDetails.style.border = 0;
    var tBody = document.createElement('tbody');
    var ir = 0;
    for (var v in feat.properties) {
      var col1 = document.createElement('td');
      col1.innerHTML = v;
      col1.style.color = '#3ba4b3';
      col1.style.padding = '4px';
      var col2 = document.createElement('td');
      col2.innerHTML = feat.properties[v];
      col2.style.padding = '4px';
      var row = document.createElement('tr');
      row.appendChild(col1);
      row.appendChild(col2);
      if (ir % 2 == 0) {
        row.style.backgroundColor = '#ebf1ff';
      } else {
        row.style.backgroundColor = '##D1E0FF';
      }
      tBody.appendChild(row);
      ir++;
    }
    popDetails.appendChild(tBody);
    var button = document.createElement('a');
    button.innerHTML = 'Get the timeserie';
    button.style.textDecoration = 'none';
    button.style.textAlign = 'center';
    button.style.cursor = 'pointer';
    button.onclick = onMarkerClickedHandler;
    popDetails.appendChild(button);
    layer.bindPopup(popDetails, {
      closeButton: false,
      className: 'popupTable'
    });
    var clr = 'gray';
    if (popValue && Array.isArray(palette)) {
      for (var i = 0; i < palette.length; i++) {
        if (palette[i].level <= popValue && palette[i].threshold > popValue) {
          clr = palette[i].value;
          break;
        }
      }
    }
    var sty = {
      weight: 1,
      color: clr,
      fillColor: clr,
      radius: 5,
      shape: "square",
      fillOpacity: 0.7
    };
    if (layer.setStyle) {
      layer.setStyle(sty);
    }
    layer.on({
      click: function click(e) {
        layer.openPopup();
      },
      mouseover: function mouseover(e) {
        layer.openTooltip();
      },
      mouseout: function mouseout(e) {
        layer.closeTooltip();
      }
    });
  }, [palette, variable.name]);
  React.useEffect(function () {
    if (!isEmpty(project)) {
      setIsLoading(true);
      setError(false);
      var _url = getUrlService({
        base: apiservice.base,
        name: apiservice.name,
        version: apiservice.version
      }, apiservice.paths, apiservice.query);
      log(_url, 'URL Get data layer services', 'info');
      fetch(_url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        }
      }).then(function (response) {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 403) {
          var jr = response.json();
          setError(jr.message);
          setIsLoading(false);
          return Promise.reject(new Error(jr.message));
        } else if (response.status === 401) {
          var errmsg = response.statusText || 'No handled error';
          setError(errmsg);
          setIsLoading(false);
          return Promise.reject(new Error(errmsg));
        } else if (response.status === 404) {
          var _errmsg = 'The service is not found!';
          setError(_errmsg);
          setIsLoading(false);
          return Promise.reject(new Error(_errmsg));
        }
        return response.json();
      }).then(function (json) {
        setIsLoading(false);
        log(json, 'Fetch data layer', 'info');
        if (json.error) {
          setError(json.error.message);
          setIsLoading(false);
          setLayerData(undefined);
        } else if (json.features) {
          setLayerData(json);
        }
        setLayerData(undefined);
      })["catch"](function (error) {
        console.error(error.toString());
        setError(error.toString());
        setIsLoading(false);
        setLayerData(undefined);
      });
    }
  }, [project]);
  React.useEffect(function () {
    if (typeof onLoadingCallback === 'function') {
      onLoadingCallback(isLoading);
    }
  }, [isLoading]);
  React.useEffect(function () {
    if (typeof onErrorCallback === 'function') {
      onErrorCallback(hasError);
    }
  }, [hasError]);
  React.useEffect(function () {
    if (!geoLayerRef.current) return;
    var layer = geoLayerRef.current.leafletElement;
    if (layer) {
      layer.clearLayers();
      if (layerData) {
        layer.addData(layerData);
        log(layer, 'Layer in AriaGeoJSONLayer');
        if (others.pathOptions) {
          layer.setStyle(others.pathOptions);
        } else if (others.style) {
          layer.setStyle(others.style);
        }
      }
    }
  }, [geoLayerRef, layerData, others.pathOptions, others.style]);
  if (!layerData) return null;
  return /*#__PURE__*/React.createElement(GeoJSON, _extends({}, others, {
    ref: geoLayerRef,
    data: layerData,
    onEachFeature: onEachFeatureHandler,
    pointToLayer: function pointToLayer(geoJsonPoint, latlng) {
      return L.shapeMarker(latlng);
    }
  }));
});

var useStyles$n = makeStyles(function (theme) {
  return {
    root: {
      height: '100%'
    },
    cardContent: {
      padding: 0,
      "&:last-child": {
        paddingBottom: 0
      }
    }
  };
});
var index$2 = (function (_ref) {
  var apiservice = _ref.apiservice,
    datatype = _ref.datatype,
    onLoadingCallback = _ref.onLoadingCallback,
    onErrorCallback = _ref.onErrorCallback,
    onSelectPointCallback = _ref.onSelectPointCallback,
    map = _ref.map,
    attribution = _ref.attribution;
  var classes = useStyles$n();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0];
  var project = store['project'];
  var _React$useState = React.useState(),
    layerData = _React$useState[0],
    setLayerData = _React$useState[1];
  var _React$useState2 = React.useState(false),
    isLoading = _React$useState2[0],
    setIsLoading = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    hasError = _React$useState3[0],
    setError = _React$useState3[1];
  var _React$useState4 = React.useState(null),
    selectedPointMarker = _React$useState4[0],
    setSelectedPointMarker = _React$useState4[1];
  var _React$useState5 = React.useState({}),
    setSensorMarkers = _React$useState5[1];
  React.useEffect(function () {
    if (!isEmpty(project)) {
      setIsLoading(true);
      setError(false);
      var _url = getUrlService({
        base: apiservice.base,
        name: apiservice.name,
        version: apiservice.version
      }, apiservice.paths, apiservice.query);
      log(_url, 'URL Get data layer services', 'error');
      fetch(_url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        }
      }).then(function (response) {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 403) {
          var jr = response.json();
          setError(jr.message);
          setIsLoading(false);
          return Promise.reject(new Error(jr.message));
        } else if (response.status === 401) {
          var errmsg = response.statusText || 'No handled error';
          setError(errmsg);
          setIsLoading(false);
          return Promise.reject(new Error(errmsg));
        } else if (response.status === 404) {
          var _errmsg = 'The service is not found!';
          setError(_errmsg);
          setIsLoading(false);
          return Promise.reject(new Error(_errmsg));
        }
        return response.json();
      }).then(function (json) {
        setIsLoading(false);
        log(json, 'Fetch data layer', 'info');
        if (json.error) {
          setError(json.error.message);
          setIsLoading(false);
          setLayerData(undefined);
        } else if (json.data && json.data.features) {
          setLayerData(json.data.features);
        } else if (json.features) {
          setLayerData(json.features);
        } else {
          console.error('Features data not found in response: ' + _url);
          setLayerData(undefined);
        }
      })["catch"](function (error) {
        console.error(error.toString());
        setError(error.toString());
        setIsLoading(false);
        setLayerData(undefined);
      });
    }
  }, [project]);
  React.useEffect(function () {
    if (typeof onLoadingCallback === 'function') {
      onLoadingCallback(isLoading);
    }
  }, [isLoading]);
  React.useEffect(function () {
    if (typeof onErrorCallback === 'function') {
      onErrorCallback(hasError);
    }
  }, [hasError]);
  var popupActionClickHandler = React.useCallback(function (dtype, pointParam) {
    return function (e) {
      if (selectedPointMarker) {
        if (typeof onSelectPointCallback === 'function') {
          onSelectPointCallback(dtype, selectedPointMarker, pointParam);
        }
      }
      if (map) {
        map.current.leafletElement.closePopup();
      }
      e.stopPropagation();
    };
  }, [map, selectedPointMarker]);
  return /*#__PURE__*/React.createElement(FeatureGroup, {
    name: "points-layer",
    attribution: attribution
  }, Array.isArray(layerData) && layerData.map(function (feat, index) {
    if (!feat.geometry) return null;
    if (!feat.properties) return null;
    if (feat.geometry.type !== 'Point') return null;
    var props = feat.properties;
    var coords = feat.geometry.coordinates;
    return /*#__PURE__*/React.createElement(ShapeMarker$1, {
      key: "measurement_" + index,
      shape: 'square',
      center: [coords[1], coords[0]],
      radius: 5,
      color: props.color || 'green',
      fillColor: props.color || "green",
      fillOpacity: 0.8,
      onClick: function onClick(e) {
        return setSelectedPointMarker(e.target);
      },
      onAdd: function onAdd(e) {
        setSensorMarkers(function (olds) {
          olds[index] = feat;
          return olds;
        });
      }
    }, /*#__PURE__*/React.createElement(Popup, null, /*#__PURE__*/React.createElement(Card, {
      elevation: 0
    }, /*#__PURE__*/React.createElement(CardContent, {
      className: classes.cardContent
    }, /*#__PURE__*/React.createElement(Typography, {
      gutterBottom: true,
      variant: "h6",
      component: "h4"
    }, /*#__PURE__*/React.createElement("span", null, props.NAME && "Station name: " + props.NAME), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", null, "Station id: " + (props.ID || props.ID_1)))), /*#__PURE__*/React.createElement(CardActions, {
      className: classes.cardActions
    }, /*#__PURE__*/React.createElement(Button$1, {
      size: "small",
      color: "primary",
      onClick: popupActionClickHandler(datatype, feat)
    }, t('Map.Show_timeseries'))))));
  }));
});

Control.AriaButton = Control.extend({
  options: {
    title: 'Button title',
    position: 'topleft',
    onClick: undefined
  },
  setOptions: function setOptions(option, value) {
    if (option === 'onClick') {
      if (this.but && this.options.onClick) {
        DomEvent.removeListener(this.but, 'click', this.options.onClick, this);
        DomEvent.addListener(this.but, 'click', value, this);
      }
    }
    this.options[option] = value;
  },
  onAdd: function onAdd() {
    this.mapContainer = this._map.getContainer();
    var container = DomUtil.create('div', 'leaflet-control-button-container leaflet-bar leaflet-control');
    this._addCss();
    this.but = DomUtil.create('button', 'leaflet-control-button', container);
    this.but.type = 'button';
    this.but.title = this.options.title;
    this.but.innerHTML = '<svg id="Capa_1" enable-background="new 0 0 512 512" height="16" width="16" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><g><path d="m62.804 226.755c0 4.142 3.358 7.5 7.5 7.5h309.554c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-309.554c-4.142 0-7.5 3.358-7.5 7.5z"/><path d="m115.629 173.952c0 4.142 3.358 7.5 7.5 7.5h256.729c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-256.729c-4.142 0-7.5 3.358-7.5 7.5z"/><path d="m270.671 71.489c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-91.181c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5z"/><path d="m387.358 279.185c0-4.142-3.358-7.5-7.5-7.5h-309.554c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h309.554c4.142 0 7.5-3.358 7.5-7.5z"/><path d="m70.304 339.116h129.601c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-129.601c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5z"/><path d="m300.808 384.043c0-4.142-3.358-7.5-7.5-7.5h-223.004c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h223.003c4.143 0 7.501-3.358 7.501-7.5z"/><path d="m70.304 443.08c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h48.153c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5z"/><path d="m475.338 382.83 29.198-29.207c4.231-4.231 6.562-9.858 6.562-15.843s-2.33-11.612-6.562-15.843l-19.3-19.301c-8.736-8.735-22.951-8.734-31.687 0l-4.297 4.297v-177.583c0-1.989-.79-3.897-2.197-5.303l-121.849-121.85c-1.406-1.407-3.314-2.197-5.303-2.197h-210.52c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5h203.023v70.349c0 28.399 23.105 51.504 51.504 51.504h70.343v185.081l-9.909 9.909-29.198-29.206c-8.731-8.731-22.947-8.733-31.698.001l-19.284 19.294c-4.239 4.232-6.574 9.86-6.574 15.848 0 5.987 2.334 11.616 6.568 15.842l29.2 29.208-8.501 8.508c-2.928 2.93-2.926 7.679.004 10.606 2.929 2.927 7.678 2.927 10.606-.004l13.8-13.81c2.927-2.929 2.926-7.675-.001-10.604l-34.505-34.516c-1.4-1.397-2.171-3.255-2.171-5.231 0-1.977.771-3.834 2.177-5.238l19.284-19.294c2.895-2.891 7.6-2.892 10.487-.005l34.5 34.51c1.407 1.407 3.314 2.197 5.304 2.197 1.989 0 3.897-.79 5.303-2.197l34.51-34.51c2.888-2.888 7.586-2.888 10.474 0l19.3 19.3c1.398 1.398 2.168 3.258 2.168 5.237s-.77 3.838-2.169 5.237l-34.5 34.51c-2.928 2.929-2.928 7.677 0 10.605l34.5 34.51c2.888 2.888 2.888 7.586 0 10.474l-19.3 19.3c-2.888 2.889-7.586 2.887-10.474 0l-34.51-34.51c-1.407-1.407-3.314-2.197-5.304-2.197s-3.897.791-5.304 2.197l-34.499 34.51c-2.888 2.887-7.592 2.886-10.482.001l-19.296-19.307c-2.811-2.806-2.92-7.289-.249-10.206 2.798-3.054 2.59-7.798-.464-10.596s-7.798-2.59-10.596.464c-8.115 8.858-7.802 22.455.706 30.948l19.296 19.307c8.745 8.729 22.961 8.726 31.693-.005l29.197-29.206 9.909 9.909v16.764c0 20.131-16.374 36.51-36.5 36.51h-345.338c-20.132 0-36.51-16.378-36.51-36.51v-408.978c0-20.131 16.378-36.51 36.51-36.51h26.97c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-26.97c-28.403 0-51.51 23.107-51.51 51.51v408.98c0 28.403 23.107 51.51 51.51 51.51h345.34c28.397 0 51.5-23.107 51.5-51.51v-1.764l4.297 4.297c4.368 4.369 10.104 6.552 15.843 6.552 5.737 0 11.476-2.185 15.844-6.552l19.3-19.3c8.736-8.736 8.736-22.95.001-31.686zm-147.932-297.481v-59.74l96.244 96.244h-59.74c-20.129 0-36.504-16.375-36.504-36.504z"/></g></svg>';
    DomEvent.addListener(this.but, 'click', this.options.onClick, this);
    DomEvent.disableClickPropagation(container);
    return container;
  },
  _addCss: function _addCss() {
    var css = document.createElement('style');
    css.innerHTML = "\n    .leaflet-control-button {\n      border-radius: 4px;\n      background: white;\n      min-width: 30px;\n      min-height: 30px;\n      border: solid 0 black;\n      cursor: pointer;\n    }\n    \n    .leaflet-touch .leaflet-control-button {\n      min-width: 30px;\n      min-height: 30px;\n    }\n    \n    .leaflet-control-button svg {\n      position: absolute;\n      top: 7px;\n      left: 7px;\n    }\n    ";
    document.body.appendChild(css);
  }
});
var LAriaControlButton = Control.AriaButton;

var AriaControlButton = withLeaflet( /*#__PURE__*/function (_MapControl) {
  _inheritsLoose(AriaControlButton, _MapControl);
  function AriaControlButton() {
    return _MapControl.apply(this, arguments) || this;
  }
  var _proto = AriaControlButton.prototype;
  _proto.createLeafletElement = function createLeafletElement(props) {
    var m_props = _extends({}, props);
    return new LAriaControlButton(props);
  };
  _proto.updateLeafletElement = function updateLeafletElement(fromProps, toProps) {
    if (toProps.onClick !== fromProps.onClick) {
      this.leafletElement.setOptions('onClick', toProps.onClick);
    }
  };
  _proto.componentDidMount = function componentDidMount() {
    _MapControl.prototype.componentDidMount.call(this);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    _MapControl.prototype.componentWillUnmount.call(this);
  };
  return AriaControlButton;
}(MapControl));

var withLeafletComponent = withLeaflet( /*#__PURE__*/function (_MapControl) {
  _inheritsLoose(AriaGeocoderControl, _MapControl);
  function AriaGeocoderControl() {
    return _MapControl.apply(this, arguments) || this;
  }
  var _proto = AriaGeocoderControl.prototype;
  _proto.createLeafletElement = function createLeafletElement(props) {
    var _extends2;
    var m_props = _extends({}, props, (_extends2 = {
      provider: new OpenStreetMapProvider(),
      style: 'bar',
      updateMap: false,
      marker: {
        icon: new L$1.Icon.Default(),
        draggable: false
      },
      showMarker: false,
      maxMarkers: 1000,
      keepResult: true,
      searchLabel: props.t('Draw.Enter_an_address')
    }, _extends2["style"] = 'button', _extends2));
    return new GeoSearchControl(m_props);
  };
  _proto.componentDidMount = function componentDidMount() {
    _MapControl.prototype.componentDidMount.call(this);
    var onResult = this.props.onResult;
    var map = this.props.leaflet.map;
    if (map != null) {
      map.on('geosearch/showlocation', function (e) {
        if (typeof onResult === 'function') {
          onResult(e);
        }
      });
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    var map = this.props.leaflet.map;
    if (map != null) {
      map.off('geosearch/showlocation');
      map.removeLayer(this.leafletElement);
    }
    _MapControl.prototype.componentWillUnmount.call(this);
  };
  return AriaGeocoderControl;
}(MapControl));
var AriaGeocoderControl = withTranslation()(withLeafletComponent);

var configDrawLocal = function configDrawLocal(t, L) {
  L.drawLocal = {
    draw: {
      toolbar: {
        actions: {
          title: t('Draw.Cancel'),
          text: t('Draw.Cancel')
        },
        finish: {
          title: t('Draw.Finish'),
          text: t('Draw.Finish')
        },
        undo: {
          title: t('Draw.Delete_the_last_point'),
          text: t('Draw.Delete_the_last_point')
        },
        buttons: {
          polyline: t('Draw.Draw_a_polyline'),
          polygon: t('Draw.Draw_a_zone'),
          rectangle: t('Draw.Draw_a_rectangle'),
          circle: t('Draw.Draw_a_circle'),
          marker: t('Draw.Marker'),
          circlemarker: t('Draw.Extraction_point')
        }
      },
      handlers: {
        circle: {
          tooltip: {
            start: t('Draw.Click_and_drag_to_draw_a_circle')
          },
          radius: t('Draw.Radius')
        },
        circlemarker: {
          tooltip: {
            start: t('Draw.Click_on_the_map_to_place_a_point_of_extraction')
          }
        },
        marker: {
          tooltip: {
            start: t('Draw.Click_on_the_map_to_place_a_marker')
          }
        },
        polygon: {
          tooltip: {
            start: t('Draw.Click_to_begin_to_draw'),
            cont: t('Draw.Click_to_continue'),
            end: t('Draw.Click_on_the_first_point_to_finish')
          }
        },
        polyline: {
          error: "<strong>" + t('Draw.Error') + ":</strong> " + t('Draw.shape_edges_cannot_cross'),
          tooltip: {
            start: t('Draw.Click_to_start_drawing'),
            cont: t('Draw.Click_to_continue'),
            end: t('Draw.Click_on_the_last_point_to_finish')
          }
        },
        rectangle: {
          tooltip: {
            start: t('Draw.Click_and_drag_to_draw_a_rectangle')
          }
        },
        simpleshape: {
          tooltip: {
            end: t('Draw.Release_mouse_to_finish_drawing')
          }
        }
      }
    },
    edit: {
      toolbar: {
        actions: {
          save: {
            title: t('Draw.Save_changes'),
            text: t('Draw.Save')
          },
          cancel: {
            title: t('Draw.Cancel_editing_discard_all_changes'),
            text: t('Draw.Cancel')
          },
          clearAll: {
            title: t('Draw.Clear_all_layers'),
            text: t('Draw.Clear_all')
          }
        },
        buttons: {
          edit: t('Draw.Edit_layers'),
          editDisabled: t('Draw.No_layer_to_edit'),
          remove: t('Draw.Delete_all'),
          removeDisabled: t('Draw.No_object_to_be_deleted')
        }
      },
      handlers: {
        edit: {
          tooltip: {
            text: t('Draw.Drag_handles_or_markers_to_edit_features'),
            subtext: t('Draw.Click_cancel_to_undo_changes')
          }
        },
        remove: {
          tooltip: {
            text: t('Draw.Click_on_an_object_to_delete')
          }
        }
      }
    }
  };
};

var useStyles$o = makeStyles(function (theme) {
  return {
    formControl: {
      margin: theme.spacing(1),
      marginBottom: theme.spacing(2),
      minWidth: '50%'
    },
    select: {
      marginTop: theme.spacing(1)
    }
  };
});
var SaveReceptorDialog = (function (_ref) {
  var openDialog = _ref.openDialog,
    setOpenDialog = _ref.setOpenDialog,
    point = _ref.point;
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0],
    dispatch = _useAriaAppStore[1];
  var markers_colors = store['markers_colors'];
  var classes = useStyles$o();
  var _useState = useState('');
  var _React$useState = React.useState(false);
  var _React$useState2 = React.useState(undefined),
    lat = _React$useState2[0],
    setLat = _React$useState2[1];
  var _React$useState3 = React.useState(undefined),
    lon = _React$useState3[0],
    setLon = _React$useState3[1];
  var _React$useState4 = React.useState(undefined),
    name = _React$useState4[0],
    setName = _React$useState4[1];
  React.useEffect(function () {
    if (!point) return;
    setLat(point.lat);
    setLon(point.lon);
    setName(point.r_name);
    console.log(openDialog, 'opendialog', point, 'point');
  }, [point]);
  var handleNewReceptor = function handleNewReceptor() {
    var pointToSave = _extends({}, point, {
      r_name: name,
      lat: lat,
      lon: lon
    });
    console.log(pointToSave, ' tttttttttt');
    var markers_colors_copy = _extends({}, markers_colors);
    markers_colors_copy[pointToSave.id] = pointToSave;
    dispatch({
      type: 'SET_MARKERS_COLORS',
      value: markers_colors_copy
    });
    setOpenDialog(false);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, openDialog && point && /*#__PURE__*/React.createElement(Dialog$1, {
    open: openDialog
  }, /*#__PURE__*/React.createElement(DialogTitle$1, null, "Enregistrer un nouveau point recepteur "), /*#__PURE__*/React.createElement(DialogContent$1, null, /*#__PURE__*/React.createElement(TextField, {
    variant: "outlined",
    margin: "normal",
    required: true,
    fullWidth: true,
    label: "Name",
    name: "username",
    autoFocus: true,
    value: name,
    onChange: function onChange(e) {
      return setName(e.target.value);
    }
  }), /*#__PURE__*/React.createElement(TextField, {
    margin: "normal",
    required: true,
    fullWidth: true,
    label: "Lat",
    name: "username",
    autoFocus: true,
    value: lat,
    onChange: function onChange(e) {
      return setLat(e.target.value);
    }
  }), /*#__PURE__*/React.createElement(TextField, {
    margin: "normal",
    required: true,
    fullWidth: true,
    label: "Lon",
    name: "username",
    autoFocus: true,
    value: lon,
    onChange: function onChange(e) {
      return setLon(e.target.value);
    }
  })), /*#__PURE__*/React.createElement(DialogActions$1, null, /*#__PURE__*/React.createElement(Button$1, {
    color: "primary",
    onClick: function onClick() {
      return setOpenDialog(false);
    }
  }, "Retour"), /*#__PURE__*/React.createElement(Button$1, {
    color: "primary",
    onClick: handleNewReceptor
  }, "Enregistrer"))));
});

var COLORS = ['#9BB7D4', '#B55A30', '#0072B5', '#00A170', '#926AA6', '#D2386C'];
var greenIcon = new L$1.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});
var violetIcon = new L$1.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-violet.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});
var orangeIcon = new L$1.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-orange.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});
var redIcon = new L$1.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});
var blueIcon = new L$1.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});
var IconsColors = {
  'violet': violetIcon,
  'orange': orangeIcon,
  'red': redIcon,
  'green': greenIcon,
  'blue': blueIcon
};
var _round = function _round(num, len) {
  return Math.round(num * Math.pow(10, len)) / Math.pow(10, len);
};
var strLatLng = function strLatLng(latlng) {
  return '(' + _round(latlng.lat, 6) + ', ' + _round(latlng.lng, 6) + ')';
};
var getPopupContent = function getPopupContent(layer, objLabel) {
  if (layer instanceof L$1.Marker || layer instanceof L$1.CircleMarker) {
    var content = '';
    if (objLabel) {
      content = "" + objLabel + '<br />' + strLatLng(layer.getLatLng());
    } else {
      content = "Point_" + layer._leaflet_id + '<br />' + strLatLng(layer.getLatLng());
    }
    content += "<br /><br /> <button id=\"button\" style=\" letter-spacing:0.02857em;font-size: 1rem;cursor:pointer;border: none; color: #3ba4b3;background-color:white;font-family:" + "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif" + "> SHOW TIMESERIES </button>";
    return content;
  } else if (layer instanceof L$1.Circle) {
    var center = layer.getLatLng(),
      radius = layer.getRadius();
    return 'Center: ' + strLatLng(center) + '<br />' + 'Radius: ' + _round(radius, 2) + ' m';
  } else if (layer instanceof L$1.Polygon) {
    var latlngs = layer._defaultShape ? layer._defaultShape() : layer.getLatLngs(),
      area = L$1.GeometryUtil.geodesicArea(latlngs);
    var title;
    if (objLabel) {
      title = "" + objLabel + '<br />';
    } else {
      title = "Polygone_" + layer._leaflet_id + '<br />';
    }
    return title + 'Area: ' + L$1.GeometryUtil.readableArea(area, true);
  } else if (layer instanceof L$1.Polyline) {
    var latlngs = layer._defaultShape ? layer._defaultShape() : layer.getLatLngs(),
      distance = 0;
    if (latlngs.length < 2) {
      return 'Distance: N/A';
    } else {
      for (var i = 0; i < latlngs.length - 1; i++) {
        distance += latlngs[i].distanceTo(latlngs[i + 1]);
      }
      return 'Distance: ' + _round(distance, 2) + ' m';
    }
  }
  return null;
};
var AriaDrawToolbar = (function (_ref) {
  var position = _ref.position,
    preLoadedLayers = _ref.preLoadedLayers,
    limitingZone = _ref.limitingZone,
    drawOptions = _ref.drawOptions;
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0],
    dispatch = _useAriaAppStore[1];
  var markers_colors = store['markers_colors'];
  var _React$useState = React.useState(false),
    openDialog = _React$useState[0],
    setOpenDialog = _React$useState[1];
  var _React$useState2 = React.useState(undefined),
    currentPoint = _React$useState2[0],
    setCurrentPoint = _React$useState2[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var findFirstAvailableColor = function findFirstAvailableColor() {
    if (Object.keys(markers_colors).length == 0) {
      return 'violet';
    }
    var _loop = function _loop(colorToUse) {
      var verif = true;
      Object.keys(markers_colors).forEach(function (mk) {
        if (colorToUse == markers_colors[mk].color) verif = false;
      });
      if (verif == true) {
        return {
          v: colorToUse
        };
      }
    };
    for (var colorToUse in IconsColors) {
      var _ret = _loop(colorToUse);
      if (typeof _ret === "object") return _ret.v;
    }
    return 'blue';
  };
  configDrawLocal(t, L$1);
  var drawingOptions = {
    polyline: false,
    rectangle: false,
    polygon: false,
    circle: false,
    marker: true,
    circlemarker: false
  };
  if (typeof drawOptions === 'object') {
    objectMerge(drawingOptions, drawOptions);
  }
  log(drawingOptions, 'drawingOptions');
  var _useState = useState({}),
    interestedZone = _useState[0],
    setInterestedZone = _useState[1];
  var _React$useState3 = React.useState(5),
    extractionObjectsLimit = _React$useState3[0];
  var _React$useState4 = React.useState({
      clrid: -1
    }),
    drawEvent = _React$useState4[0],
    setDrawEvent = _React$useState4[1];
  var _React$useState5 = React.useState({
      radius: 7,
      color: '#000000',
      fillColor: '#808080',
      fillOpacity: 0.7,
      weight: 2
    }),
    cmarkerOptions = _React$useState5[0];
  var editRef = React.useRef(null);
  var featsRef = React.useRef(null);
  var handleDeleted = useCallback(function (e) {
    log(e, 'Event');
    var layerGroup = e.layers;
    var map = e.target;
    var deletedIds = [];
    layerGroup.eachLayer(function (layer) {
      log(layer, 'Layer to be deleted');
      var layLabel = "Point_" + layer._leaflet_id;
      delete markers_colors[layLabel];
      deletedIds.push(layLabel);
    });
    setInterestedZone(function (x) {
      var newObj = Object.assign({}, x);
      if (x.layers) {
        Object.keys(x.layers).forEach(function (k) {
          if (deletedIds.indexOf(k) !== -1) {
            if (!(newObj.layers[k].options.type && newObj.layers[k].options.type === 'gouvernorat')) {
              map.removeLayer(newObj.layers[k]);
            }
            delete newObj.layers[k];
          }
        });
      }
      if (x.features) {
        var newFeats = Object.assign({}, x.features);
        Object.keys(newFeats).forEach(function (k) {
          if (deletedIds.indexOf(k) !== -1) {
            delete newFeats[k];
          }
        });
        newObj.features = newFeats;
      }
      return newObj;
    });
    setDrawEvent(function (ev) {
      return _extends({}, ev, {
        layer: undefined,
        clrid: Math.max(-1, ev.clrid - deletedIds.length)
      });
    });
  }, [setInterestedZone]);
  var handleEdited = useCallback(function (e) {
  }, []);
  var onGeocoderResultHandler = useCallback(function (res) {
    if (!featsRef) return;
    if (!featsRef.current) return;
    if (!featsRef.current.leafletElement) return;
    var featureGroup = featsRef.current.leafletElement;
    var map = featsRef.current.leafletElement._map;
    var locCoords = {
      lng: res.location.x,
      lat: res.location.y
    };
    var locLabels = res.location.label.split(',');
    var locLabel = locLabels[0].replace(/\s+/g, '_');
    if (res.marker && res.target) {
      map.removeLayer(res.marker);
    }
    var locMarker = new L$1.Marker(locCoords).addTo(featureGroup);
    return {
      layerType: 'marker',
      layer: locMarker,
      label: locLabel,
      target: map
    };
  }, [cmarkerOptions]);
  var handleOnValue = useCallback(function (e) {
    var type = e.layerType;
    var layer = e.layer;
    var label = e.label;
    var colorIndex = e.clrid;
    if (colorIndex < 0) return;
    if (['circlemarker', 'marker', 'polygon'].indexOf(type) < 0) {
      log(undefined, 'Not supported for this geometry', 'warning');
      window.alert('This geometry type is not supported yet!');
      return false;
    }
    var layers = {};
    var feats = {};
    var infoType;
    if (type === 'marker') {
      infoType = 'timeseries';
      var latlng = layer.getLatLng();
      feats["Point_" + layer._leaflet_id] = {
        lat: latlng.lat,
        lon: latlng.lng,
        type: 'VIRTUAL'
      };
      var content = getPopupContent(layer);
      if (content !== null) {
        layer.bindPopup(content);
      }
      layer.on('click', function (e) {
        this.openPopup();
      });
      layer.on("popupopen", function (a) {
        var popUp = a.target.getPopup();
        popUp.getElement().addEventListener("click", function (e) {
          if (e.target.id === 'button') {
            dispatch({
              type: 'SET_CHART_TYPE',
              value: 'line'
            });
            dispatch({
              type: 'SET_OPEN_CHART',
              value: 'TIMESERIES'
            });
            setInterestedZone(function (x) {
              return {
                type: type,
                layers: _extends({}, x.layers, layers),
                features: _extends({}, x.features, feats),
                infoType: infoType
              };
            });
          }
        });
      });
      layers["Point_" + layer._leaflet_id] = layer;
    } else if (type === 'circlemarker') {
      infoType = 'timeseries';
      var markerLabel = "Point_" + layer._leaflet_id;
      if (label) {
        markerLabel = "Point_" + label;
      }
      var _latlng = layer.getLatLng();
      feats[markerLabel] = {
        lat: _latlng.lat,
        lon: _latlng.lng,
        type: 'VIRTUAL'
      };
      var _content = getPopupContent(layer, markerLabel);
      if (_content !== null) {
        layer.bindPopup(_content);
      }
      layer.on('mouseover', function (e) {
        this.openPopup();
      });
      layer.on('mouseout', function (e) {
        this.closePopup();
      });
      layers[markerLabel] = layer;
      log(layer, 'layer=>');
    } else if (type === 'polygon') {
      infoType = 'timeseries';
      var latlngs = layer.getLatLngs()[0];
      var pogJSON = {
        type: 'FeatureCollection',
        features: [{
          type: 'Feature',
          properties: {
            name: "Pog_" + layer._leaflet_id
          },
          geometry: {
            type: 'Polygon',
            coordinates: []
          }
        }]
      };
      var coords = [];
      latlngs.forEach(function (latlng) {
        coords.push([latlng.lng, latlng.lat]);
      });
      coords.push([latlngs[0].lng, latlngs[0].lat]);
      pogJSON.features[0].geometry.coordinates.push(coords);
      var pogname = "Pog_" + layer._leaflet_id;
      if (label) {
        pogname = "Pog_" + label;
      }
      if (pogname == null) {
        pogname = undefined;
        window.alert('Default polygon will be generated!');
      } else {
        if (pogname.indexOf(' ') !== -1) {
          pogname = undefined;
        }
      }
      feats[pogname] = pogJSON;
      var _content2 = getPopupContent(layer, pogname);
      if (_content2 !== null) {
        layer.bindPopup(_content2);
      }
      layer.on('mouseover', function (e) {
        this.openPopup();
      });
      layer.on('mouseout', function (e) {
        this.closePopup();
      });
      layers[pogname] = layer;
      layer.setStyle({
        color: COLORS[colorIndex],
        fillColor: COLORS[colorIndex],
        label: pogname,
        userId: colorIndex
      });
    }
    setInterestedZone(function (x) {
      return {
        type: type,
        layers: _extends({}, x.layers, layers),
        features: _extends({}, x.features, feats),
        infoType: infoType
      };
    });
  }, [setInterestedZone]);
  var checkInsideZone = useCallback(function (e) {
    if (!e) return;
    if (!e.layer) return;
    if (!e.layerType) return;
    if (!e.target) return;
    var layer = e.layer;
    var type = e.layerType;
    var map = e.target;
    if (type === 'circlemarker') {
      var latlng = layer.getLatLng();
      if (limitingZone) {
        var isInside = inside.feature(limitingZone, [latlng.lng, latlng.lat]);
        if (isInside === -1) {
          if (map) {
            map.removeLayer(layer);
          }
          alert("Le point n'est pas dans le domaine de calcul !");
          return false;
        }
      }
    } else if (type === 'polygon') {
      var latlngs = layer.getLatLngs()[0];
      if (limitingZone) {
        var isOK = true;
        latlngs.forEach(function (latlng) {
          var isInside = inside.feature(limitingZone, [latlng.lng, latlng.lat]);
          isOK = isOK && isInside !== -1;
        });
        if (!isOK) {
          if (map) {
            map.removeLayer(layer);
          }
          alert("Le polygone n'est pas dans le domaine de calculs !");
          return false;
        }
      }
    }
    return true;
  }, [limitingZone]);
  var onCreatedHandler = useCallback(function (e) {
    var ok = checkInsideZone(e);
    if (!ok) return false;
    var layer = e.layer;
    var map = e.target;
    map.removeLayer(layer);
    var color = findFirstAvailableColor();
    var point = {};
    point['id'] = layer._leaflet_id;
    point['r_name'] = layer._leaflet_id;
    point['lat'] = layer._latlng.lat;
    point['lon'] = layer._latlng.lng;
    point['icon'] = IconsColors[color];
    point['color'] = color;
    setOpenDialog(true);
    setCurrentPoint(point);
  }, [checkInsideZone, markers_colors]);
  var onGeolocationResultHandler = useCallback(function (e) {
    var newEvt = onGeocoderResultHandler(e);
    onCreatedHandler(newEvt);
  }, [checkInsideZone, onGeocoderResultHandler]);
  React.useEffect(function () {
    if (preLoadedLayers) {
      log(preLoadedLayers, 'preLoadedLayers');
      if (preLoadedLayers.layer && featsRef.current.leafletElement) {
        preLoadedLayers.layer.addTo(featsRef.current.leafletElement);
        setDrawEvent(function (ev) {
          return _extends({}, ev, {
            layerType: 'polygon',
            layer: preLoadedLayers.layer,
            label: preLoadedLayers.name,
            clrid: ev.clrid + 1
          });
        });
      }
    }
  }, [preLoadedLayers]);
  React.useEffect(function () {
    if (drawEvent.clrid && drawEvent.clrid > extractionObjectsLimit - 1) {
      alert('LIMIT POINTS');
      return;
    }
    if (drawEvent.layer) {
      handleOnValue(drawEvent);
    }
  }, [extractionObjectsLimit, drawEvent, handleOnValue]);
  React.useEffect(function () {
    if (drawEvent.clrid < 0) {
      setInterestedZone(function (x) {
        return _extends({}, x, {
          infoType: undefined
        });
      });
    }
  }, [drawEvent, setInterestedZone]);
  React.useEffect(function () {
    var hasData = Object.keys(interestedZone).length > 0;
    if (hasData) {
      dispatch({
        type: 'SET_EXTRACTION_ZONES',
        value: {
          infoType: interestedZone.infoType,
          type: interestedZone.type,
          layers: interestedZone.layers,
          features: interestedZone.features
        }
      });
    }
  }, [interestedZone]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FeatureGroup, {
    ref: featsRef
  }, /*#__PURE__*/React.createElement(EditControl, {
    ref: editRef,
    position: position || 'topleft',
    onCreated: onCreatedHandler,
    onEdited: function onEdited(e) {
      return handleEdited(e);
    },
    onDeleted: function onDeleted(e) {
      return handleDeleted(e);
    },
    draw: drawingOptions,
    edit: {
      edit: false,
      remove: false
    }
  }), /*#__PURE__*/React.createElement(AriaGeocoderControl, {
    position: "topleft",
    onResult: onGeolocationResultHandler
  })), openDialog && currentPoint && /*#__PURE__*/React.createElement(SaveReceptorDialog, {
    openDialog: openDialog,
    setOpenDialog: setOpenDialog,
    point: currentPoint
  }));
});

var bigSize = new L$1.Point(45, 81);
var normalSize = new L$1.Point(25, 41);
var orangeIcon$1 = new L$1.Icon({
  iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-orange.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});
var blueIcon$1 = new L$1.Icon({
  iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});
var ComplaintObjects = {};
var _round$1 = function _round(num, len) {
  return Math.round(num * Math.pow(10, len)) / Math.pow(10, len);
};
var strLatLng$1 = function strLatLng(latlng) {
  return '(' + _round$1(latlng.lat, 6) + ', ' + _round$1(latlng.lng, 6) + ')';
};
var getPopupContent$1 = function getPopupContent(layer, objLabel) {
  if (layer instanceof L$1.Marker || layer instanceof L$1.CircleMarker) {
    if (objLabel) {
      return "" + objLabel + '<br />' + strLatLng$1(layer.getLatLng());
    } else {
      return "Point_" + layer._leaflet_id + '<br />' + strLatLng$1(layer.getLatLng());
    }
  } else if (layer instanceof L$1.Circle) {
    var center = layer.getLatLng(),
      radius = layer.getRadius();
    return 'Center: ' + strLatLng$1(center) + '<br />' + 'Radius: ' + _round$1(radius, 2) + ' m';
  } else if (layer instanceof L$1.Polygon) {
    var latlngs = layer._defaultShape ? layer._defaultShape() : layer.getLatLngs(),
      area = L$1.GeometryUtil.geodesicArea(latlngs);
    var title;
    if (objLabel) {
      title = "" + objLabel + '<br />';
    } else {
      title = "Polygone_" + layer._leaflet_id + '<br />';
    }
    return title + 'Area: ' + L$1.GeometryUtil.readableArea(area, true);
  } else if (layer instanceof L$1.Polyline) {
    var latlngs = layer._defaultShape ? layer._defaultShape() : layer.getLatLngs(),
      distance = 0;
    if (latlngs.length < 2) {
      return 'Distance: N/A';
    } else {
      for (var i = 0; i < latlngs.length - 1; i++) {
        distance += latlngs[i].distanceTo(latlngs[i + 1]);
      }
      return 'Distance: ' + _round$1(distance, 2) + ' m';
    }
  }
  return null;
};
var useStyles$p = makeStyles(function (theme) {
  return {
    root: {
      height: '100%'
    },
    popup: {
      padding: 0
    },
    cardContent: {
      padding: 0,
      "&:last-child": {
        paddingBottom: 0
      }
    }
  };
});
var AriaComplainToolbar = (function (_ref) {
  var position = _ref.position;
  var classes = useStyles$p();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  L$1.drawLocal = {
    draw: {
      toolbar: {
        actions: {
          title: t('Map.Cancel'),
          text: t('Map.Cancel')
        },
        finish: {
          title: 'Terminer',
          text: t('Map.Finish')
        },
        undo: {
          title: 'Supprimer le dernier point',
          text: 'Supprimer le dernier point'
        },
        buttons: {
          polyline: 'Draw a polyline',
          polygon: 'Dessiner une zone',
          rectangle: 'Draw a rectangle',
          circle: 'Draw a circle',
          marker: t('Map.Complaint'),
          circlemarker: "Point d'extraction"
        }
      },
      handlers: {
        circle: {
          tooltip: {
            start: 'Click and drag to draw circle.'
          },
          radius: 'Radius'
        },
        circlemarker: {
          tooltip: {
            start: "Cliquez sur la carte pour placer un point d'extraction."
          }
        },
        marker: {
          tooltip: {
            start: t('Map.ComplaintMarkerTooltip')
          }
        },
        polygon: {
          tooltip: {
            start: 'Cliquez pour commencer à dessiner.',
            cont: 'Cliquez pour continuer.',
            end: 'Cliquez sur le premier point pour fermer la zone.'
          }
        },
        polyline: {
          error: '<strong>Error:</strong> shape edges cannot cross!',
          tooltip: {
            start: 'Click to start drawing line.',
            cont: 'Click to continue drawing line.',
            end: 'Click last point to finish line.'
          }
        },
        rectangle: {
          tooltip: {
            start: 'Click and drag to draw rectangle.'
          }
        },
        simpleshape: {
          tooltip: {
            end: 'Release mouse to finish drawing.'
          }
        }
      }
    },
    edit: {
      toolbar: {
        actions: {
          save: {
            title: 'Save changes',
            text: t('Map.Save')
          },
          cancel: {
            title: 'Cancel editing, discards all changes',
            text: t('Map.Cancel')
          },
          clearAll: {
            title: 'Clear all complaints for this timeframe',
            text: t('Map.Clear_all')
          }
        },
        buttons: {
          edit: 'Edit layers',
          editDisabled: 'No layers to edit',
          remove: t('Map.Remove_all_statements'),
          removeDisabled: t('Map.No_statement_to_be_removed')
        }
      },
      handlers: {
        edit: {
          tooltip: {
            text: 'Drag handles or markers to edit features.',
            subtext: 'Click cancel to undo changes.'
          }
        },
        remove: {
          tooltip: {
            text: t('Map.Click_on_a_statement_for_removing')
          }
        }
      }
    }
  };
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0],
    dispatch = _useAriaAppStore[1];
  var complains = store['complains'];
  var selectedComplain = store['selectedComplaint'];
  var _useState = useState({});
  var _React$useState = React.useState({
      clrid: -1
    }),
    drawEvent = _React$useState[0],
    setDrawEvent = _React$useState[1];
  var _React$useState2 = React.useState({
      radius: 7,
      color: '#000000',
      fillColor: '#808080',
      fillOpacity: 0.7,
      weight: 2
    });
  var editRef = React.useRef(null);
  var featsRef = React.useRef(null);
  var handleOnValue = useCallback(function (e) {
    var type = e.layerType;
    var layer = e.layer;
    var colorIndex = e.clrid;
    var map = e.target;
    if (colorIndex < 0) return;
    if (['marker'].indexOf(type) < 0) {
      log(undefined, 'Not supported for this geometry', 'warning');
      window.alert('This geometry type is not supported yet!');
      return false;
    }
    if (type === 'marker') {
      var latlng = layer.getLatLng();
      var content = getPopupContent$1(layer);
      if (content !== null) {
        layer.bindPopup(content);
      }
      layer.on('mouseover', function (e) {
        this.openPopup();
      });
      layer.on('mouseout', function (e) {
        this.closePopup();
      });
      map.removeLayer(layer);
      dispatch({
        type: 'SET_COMPLAIN',
        value: {
          isFormOpened: true,
          lon: latlng.lng.toFixed(6),
          lat: latlng.lat.toFixed(6),
          content: undefined
        }
      });
    }
  }, []);
  React.useEffect(function () {
    if (drawEvent.layer) {
      handleOnValue(drawEvent);
    }
  }, [drawEvent, handleOnValue]);
  var onEditedHandler = useCallback(function (e) {
  }, []);
  var onCreatedHandler = useCallback(function (e) {
    var mLabel = e.layer._leaflet_id;
    setDrawEvent(function (ev) {
      return _extends({}, ev, e, {
        label: mLabel,
        clrid: ev.clrid + 1
      });
    });
  }, []);
  var onDeletedHandler = useCallback(function (e) {
    var cpIds = [];
    e.layers.eachLayer(function (l) {
      var l_id = e.layers.getLayerId(l);
      if (typeof ComplaintObjects[l_id] == 'object') {
        var cpId = ComplaintObjects[l_id].cpid;
        log(cpId, 'cpId');
        cpIds.push(cpId);
      }
      log(cpIds, 'cpIds');
    });
    var qp = {
      ids: cpIds.join('_')
    };
    var pp;
    var _url = getUrlService('ariaview/complains', pp, qp);
    log(_url, "Delete a Complain service");
    fetch(_url, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8'
      }
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      log(json);
      dispatch({
        type: 'SET_COMPLAIN',
        value: {
          isFormOpened: false,
          created: new Date().getTime()
        }
      });
      if (cpIds.indexOf(selectedComplain.id) !== -1) {
        dispatch({
          type: 'SET_SELECTED_COMPLAINT',
          value: undefined
        });
      }
    })["catch"](function (error) {
      console.error(error.toString());
    });
  }, [ComplaintObjects, selectedComplain]);
  var getComplaintIcon = useCallback(function (cp) {
    var cIcon = blueIcon$1;
    if (cp) {
      if (cp.type == 'complain') {
        cIcon = orangeIcon$1;
      }
    }
    return cIcon;
  }, []);
  React.useEffect(function () {
    for (var ic in ComplaintObjects) {
      var currentIcon = ComplaintObjects[ic].marker.options.icon;
      if (selectedComplain) {
        if (ComplaintObjects[ic].cpid == selectedComplain.id) {
          currentIcon.options.iconSize = bigSize;
          ComplaintObjects[ic].marker.setIcon(currentIcon);
          continue;
        }
      }
      currentIcon.options.iconSize = normalSize;
      ComplaintObjects[ic].marker.setIcon(currentIcon);
    }
  }, [selectedComplain, ComplaintObjects]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FeatureGroup, {
    ref: featsRef
  }, /*#__PURE__*/React.createElement(EditControl, {
    ref: editRef,
    position: position || 'topleft',
    onCreated: onCreatedHandler,
    onEdited: onEditedHandler,
    onDeleted: onDeletedHandler,
    draw: {
      polyline: false,
      rectangle: false,
      polygon: false,
      circle: false,
      marker: true,
      circlemarker: false
    },
    edit: {
      edit: false,
      remove: true
    }
  }), Array.isArray(complains) && complains.length > 0 && complains.map(function (cp, index) {
    return /*#__PURE__*/React.createElement(Marker, {
      key: index,
      position: [cp.lat, cp.lon],
      icon: getComplaintIcon(cp),
      onAdd: function onAdd(e) {
        return ComplaintObjects[e.target._leaflet_id] = {
          cpid: cp.id,
          marker: e.target
        };
      }
    }, /*#__PURE__*/React.createElement(Popup, {
      className: classes.popup
    }, /*#__PURE__*/React.createElement(Card, {
      elevation: 0
    }, /*#__PURE__*/React.createElement(CardContent, {
      className: classes.cardContent
    }, /*#__PURE__*/React.createElement(Typography, {
      color: "primary",
      gutterBottom: true,
      variant: "h5",
      component: "h3"
    }, cp.observer_name), /*#__PURE__*/React.createElement(Typography, {
      gutterBottom: true,
      variant: "subtitle1",
      color: "textSecondary",
      component: "h6"
    }, "" + parseTime(cp.start_date, '{y}-{m}-{d} {h}:{i}:{s}')), /*#__PURE__*/React.createElement(Typography, {
      gutterBottom: true,
      variant: "subtitle2",
      color: "textSecondary",
      component: "h6"
    }, t('Complain.Location') + ": " + cp.lat + ", " + cp.lon), /*#__PURE__*/React.createElement(Typography, {
      variant: "body1",
      component: "p"
    }, "" + cp.comment)))));
  })));
});

var _excluded$3 = ["time", "timeObj", "className", "hasSelected", "isInner", "type", "value"];
var useStyles$q = makeStyles(function (theme) {
  return {
    root: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around'
    },
    imageIcon: {
      height: '100%',
      marginBottom: '5px'
    },
    iconRoot: {
      textAlign: 'center'
    },
    button: {
      textTransform: 'none',
      '&:hover': {
        backgroundColor: 'transparent',
        cursor: 'default'
      }
    },
    progress: {
      width: '100%',
      marginBottom: theme.spacing(1)
    },
    groupIcons: {
      marginTop: theme.spacing(1)
    }
  };
});
function ThermometerIcon(props) {
  var classes = useStyles$q();
  return /*#__PURE__*/React.createElement(Icon, {
    classes: {
      root: classes.iconRoot
    }
  }, /*#__PURE__*/React.createElement("img", {
    className: classes.imageIcon,
    src: "./thermometer.jpg"
  }));
}
var WindIcon = function WindIcon(_ref) {
  var wind_direction = _ref.wind_direction,
    color = _ref.color;
  var classes = useStyles$q();
  var getAngleStyle = function getAngleStyle(angle) {
    var metAngle = Number(angle) + 90 % 360;
    log(metAngle, 'METANGLE');
    log(angle, 'ANGLE');
    return {
      transform: "rotateZ(" + metAngle + "deg)"
    };
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.groupIcons
  }, /*#__PURE__*/React.createElement(Brightness1Icon, {
    color: color,
    style: {
      position: 'absolute',
      left: '4px'
    }
  }), /*#__PURE__*/React.createElement(ArrowRightAltIcon, {
    style: getAngleStyle(wind_direction || 0)
  }));
};
var RainIcon = function RainIcon(_ref2) {
  var color = _ref2.color;
  var classes = useStyles$q();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.groupIcons
  }, /*#__PURE__*/React.createElement(FilterDramaIcon, null), /*#__PURE__*/React.createElement(ScatterPlotIcon, {
    color: color,
    style: {
      position: 'absolute',
      left: '4px',
      bottom: '11px'
    }
  }));
};
var WindCompass = function WindCompass(_ref3) {
  var time = _ref3.time,
    timeObj = _ref3.timeObj,
    type = _ref3.type,
    other = _objectWithoutPropertiesLoose(_ref3, _excluded$3);
  var classes = useStyles$q();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _React$useState = React.useState(undefined),
    error = _React$useState[0],
    setError = _React$useState[1];
  var _React$useState2 = React.useState(false),
    isLoading = _React$useState2[0],
    setIsLoading = _React$useState2[1];
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0];
  var metsta = store['weather_monitoring_sensor'];
  var config = store['wind_compass_config'];
  var client = store['client'];
  var _React$useState3 = React.useState(undefined),
    currentMeteoData = _React$useState3[0],
    setCurrentMeteoData = _React$useState3[1];
  var _React$useState4 = React.useState(false),
    setToAnimateTransform = _React$useState4[1];
  var _React$useState5 = React.useState(undefined),
    previousType = _React$useState5[0],
    setPreviousType = _React$useState5[1];
  React.useEffect(function () {
    if (!metsta || !metsta.id) return;
    if (!client || !client.token) return;
    if (timeObj instanceof Date) {
      setIsLoading(true);
      setError(false);
      var timeForRequest;
      var tavForRequest;
      if (time == 'mean') {
        var timePlusOneDay = timeObj.setDate(timeObj.getDate() + 1);
        timeForRequest = parseTime(timePlusOneDay, '{y}-{m}-{d}T{h}:{i}:{s}', true);
        tavForRequest = '86400';
      } else {
        timeForRequest = parseTime(timeObj, '{y}-{m}-{d}T{h}:{i}:{s}', true);
        tavForRequest = '3600';
      }
      var pp = [metsta.id];
      var qp = {
        obs_type: 'met',
        start_date: timeForRequest,
        end_date: timeForRequest,
        tav: tavForRequest,
        qa_qc: 'False'
      };
      var _url = getUrlService({
        version: process.env.REACT_APP_OBS_API_VERSION || '',
        name: process.env.REACT_APP_OBS_API + '/stations'
      }, pp, qp);
      log(_url, 'URL meteo services', 'info');
      fetch(_url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          'X-ARIA-CLIENT-TOKEN': client.token
        }
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        setIsLoading(false);
        if (json.data) {
          log(json.data, '*** Meteo response in WindCompass: ');
          var measures = json.data.measures;
          if (measures && measures.data) {
            var ndata = measures.data.length;
            if (ndata > 0) {
              var fixedMeasures = measures.data[0];
              for (var k in fixedMeasures) {
                fixedMeasures[k] = parseFloat(fixedMeasures[k]).toFixed(1);
              }
              setCurrentMeteoData(fixedMeasures);
            } else {
              setCurrentMeteoData(undefined);
            }
          }
        }
      })["catch"](function (error) {
        setError(error.toString());
        setIsLoading(false);
      });
    }
  }, [timeObj, metsta, client, time]);
  React.useEffect(function () {
    if (type !== previousType) {
      setPreviousType(type);
      setToAnimateTransform(true);
    } else {
      setPreviousType(type);
      setToAnimateTransform(false);
    }
    log(currentMeteoData, 'currentMeteoData');
  }, [type, previousType]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, error ? /*#__PURE__*/React.createElement(Alert$2, {
    severity: "error",
    className: classes.alert
  }, t('InfoPanel.Error_loading_message')) : isLoading ? /*#__PURE__*/React.createElement(LinearProgress, {
    className: classes.progress
  }) : currentMeteoData && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tooltip$1, {
    arrow: true,
    placement: "left",
    title: config.meteo_station_info
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Tooltip$1, {
    arrow: true,
    title: config.wind_info_tooltip
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    className: classes.button,
    startIcon: /*#__PURE__*/React.createElement(WindIcon, {
      color: 'primary',
      wind_direction: currentMeteoData[config.wind_direction]
    })
  }, currentMeteoData[config.wind_average] + " " + config.wind_average_unit)), /*#__PURE__*/React.createElement(Tooltip$1, {
    arrow: true,
    light: true,
    title: config.temperature_info_tooltip
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    className: classes.button,
    startIcon: /*#__PURE__*/React.createElement(ThermometerIcon, {
      color: "primary"
    })
  }, currentMeteoData[config.temperature], " ", config.temperature_unit)), /*#__PURE__*/React.createElement(Tooltip$1, {
    arrow: true,
    title: config.rain_info_tooltip
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    className: classes.button,
    startIcon: /*#__PURE__*/React.createElement(RainIcon, {
      color: "primary"
    })
  }, currentMeteoData[config.total_rain], " ", config.total_rain_unit))))));
};

var panelHeightFixed$1 = '300px';
var useStyles$r = makeStyles(function (theme) {
  return {
    root: {
      position: 'absolute',
      right: '0',
      bottom: '10px',
      zIndex: '500',
      maxHeight: panelHeightFixed$1,
      backgroundColor: 'rgb(246 249 242)',
      width: '332px'
    },
    container: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'row'
    },
    progress: {
      margin: theme.spacing(2)
    }
  };
});
var cInitDataset = {
  labels: [],
  datasets: [{
    data: [],
    label: "No name",
    borderColor: "#3e95cd",
    fill: false
  }]
};
var AriaWeatherInfo = function AriaWeatherInfo(_ref) {
  var time = _ref.time,
    timeObj = _ref.timeObj,
    onChangedPalette = _ref.onChangedPalette;
  var classes = useStyles$r();
  var _React$useState = React.useState(cInitDataset);
  var _React$useState2 = React.useState(false),
    setOpenChart = _React$useState2[1];
  var _useState = useState(undefined);
  var _useState2 = useState(false);
  var _useState3 = useState(false),
    editing = _useState3[0],
    setEditing = _useState3[1];
  var _React$useState3 = React.useState([]),
    paletteValues = _React$useState3[0],
    setPaletteValues = _React$useState3[1];
  var _React$useState4 = React.useState([]),
    paletteDatabaseValues = _React$useState4[0];
  var onEditingChangedHandler = React.useCallback(function (e) {
    var editIsDone = editing;
    if (editIsDone) {
      if (!checkIsValid(paletteValues)) {
        setPaletteValues(paletteDatabaseValues);
        setTimeout(function () {
          alert("Valeurs ne sont pas dans l'interval. Réinitialiser !");
        }, 500);
      } else {
        log(paletteValues, 'New palettes');
        if (typeof onChangedPalette === 'function') {
          onChangedPalette(paletteValues);
        }
      }
    }
    setEditing(function (x) {
      return !x;
    });
  }, [editing, onChangedPalette, paletteDatabaseValues, paletteValues]);
  var showChart = React.useCallback(function (showed) {
    setOpenChart(showed);
    setSelectedQuantity('temperature');
  });
  var onSelectQuantityHandler = React.useCallback(function (v) {
    setSelectedQuantity(v);
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(WindCompass, {
    time: time,
    timeObj: timeObj
  }));
};

var useGetValues = function useGetValues(feats, store, callback) {
  var savedCallback = useRef();
  var _useState = useState(undefined),
    error = _useState[0],
    setError = _useState[1];
  var _useState2 = useState(false),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var derived_variable = store['derived_variable'];
  var _useState3 = useState(undefined),
    values = _useState3[0],
    setValues = _useState3[1];
  var timeframe = store['timeframe'];
  if (typeof store == 'object' && typeof feats == 'object') {
    useEffect(function () {
      savedCallback.current = callback;
    }, [callback]);
    useEffect(function () {
      if (store.dataset && timeframe && store.variable) {
        setIsLoading(true);
        var qp = {};
        var pp;
        var variable_is_total = [];
        var variables_initial = store.dataset.variables;
        var group = store.variable.group;
        variables_initial.map(function (dv) {
          if (dv.group == group && dv.isTotal == 1) variable_is_total.push(dv.name);
        });
        log(store.variable.name, 'VAR');
        if (process.env.REACT_APP_API_VERSION !== 'v1') {
          qp = {
            variables: variable_is_total,
            epsg: store.dataset.epsg,
            time: parseTime(timeframe.obj, '{y}-{m}-{d}T{h}:{i}:{s}', true),
            is_atomic: 1,
            tsmin: -1000,
            derived_variable: derived_variable === undefined ? undefined : derived_variable.name
          };
          pp = ['value', store.dataset.name];
        }
        if (timeframe.value == 'mean') {
          qp['date'] = parseTime(timeframe.obj, '{y}{m}{d}', true);
          qp['time'] = 'mean';
        }
        var _feats = {};
        if (Array.isArray(feats)) {
          feats.forEach(function (r) {
            _feats[r.id] = r;
          });
        } else {
          _feats = feats;
        }
        log(_feats, 'Feats');
        var _url = getUrlService('points', pp, qp, true);
        log(_url, '*** URL Get values ***');
        fetch(_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json; charset=UTF-8'
          },
          body: JSON.stringify(_feats)
        }).then(function (response) {
          return response.json();
        }).then(function (json) {
          log(json, '--- Get values response ---');
          setIsLoading(false);
          if (json.data) {
            if (savedCallback && typeof savedCallback.current === 'function') {
              savedCallback.current(json.data);
            }
            setValues(json.data);
          }
          if (json.error) {
            setError(true);
          } else {
            setError(false);
          }
        })["catch"](function (err) {
          setIsLoading(false);
          setError(true);
        });
      }
    }, [feats, store.timeframe, store.variable, store.derived_variable]);
  }
  return [isLoading, error, values];
};

var useStyles$s = makeStyles(function (theme) {
  return {
    formControl: {
      margin: theme.spacing(1),
      marginLeft: theme.spacing(0),
      marginBottom: theme.spacing(2),
      width: '95%',
      minWidth: '50%'
    },
    linearProgress: {
      marginTop: theme.spacing(1)
    },
    themeToggleButton: {
      width: 'auto',
      '&$selected': {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.main
      }
    },
    formLabel: {
      marginBottom: theme.spacing(2)
    },
    details: {
      maxHeight: "250px",
      overflowY: "scroll"
    },
    hidden: {
      display: 'None'
    },
    buttonText: {
      display: 'block',
      whiteSpace: 'pre-wrap'
    }
  };
});
var REMOVEDED_VARLIST = ['u', 'v', 'winz', 'winm'];
var marks = [{
  value: 0,
  label: '0%'
}, {
  value: 10,
  label: '20%'
}, {
  value: 25,
  label: '50%'
}, {
  value: 40,
  label: '80%'
}, {
  value: 50,
  label: '100%'
}, {
  value: 60,
  label: '120%'
}, {
  value: 75,
  label: '150%'
}, {
  value: 100,
  label: '200%'
}];
var AriaSourcesEditor = (function (_ref) {
  var title = _ref.title,
    project = _ref.project,
    site = _ref.site,
    dataType = _ref.dataType,
    selectedVarlist = _ref.selectedVarlist,
    onLoadingDatasets = _ref.onLoadingDatasets,
    onChangeDatasetHandler = _ref.onChangeDatasetHandler,
    onToggleButtonChangeHandler = _ref.onToggleButtonChangeHandler,
    onChangeVariableHandler = _ref.onChangeVariableHandler,
    withTypeSelect = _ref.withTypeSelect,
    currentVariable = _ref.currentVariable,
    hidden = _ref.hidden,
    selectedDataset = _ref.selectedDataset,
    dv_name = _ref.dv_name,
    disabled = _ref.disabled,
    toggleButtons = _ref.toggleButtons,
    group = _ref.group,
    externalSourcesButton = _ref.externalSourcesButton,
    backgroundPollutionButton = _ref.backgroundPollutionButton,
    in_toolbar = _ref.in_toolbar;
  var classes = useStyles$s();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _React$useState = React.useState(false),
    error = _React$useState[0],
    setError = _React$useState[1];
  var _React$useState2 = React.useState(false),
    isLoading = _React$useState2[0],
    setIsLoading = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    actionToDo = _React$useState3[0],
    setActionToDo = _React$useState3[1];
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0],
    dispatch = _useAriaAppStore[1];
  var datasets = store['datasets'];
  var dataset = store['dataset'];
  var modeltype = site || store['case'];
  var _React$useState4 = React.useState(dataType || store['data_type']),
    type = _React$useState4[0],
    setType = _React$useState4[1];
  var _React$useState5 = React.useState([]),
    variables = _React$useState5[0],
    setVariables = _React$useState5[1];
  var _React$useState6 = React.useState(currentVariable || ''),
    setVariable = _React$useState6[1];
  var _React$useState7 = React.useState(),
    derivedVariables = _React$useState7[0],
    setDerivedVariables = _React$useState7[1];
  var _React$useState8 = React.useState(false),
    setTrigger = _React$useState8[1];
  var _React$useState9 = React.useState({}),
    slidval = _React$useState9[0],
    setslidval = _React$useState9[1];
  var takeBackgroundPollution = backgroundPollutionButton ? store.background_pollution.used : false;
  var takeExternalSources = store['external_sources'];
  React.useEffect(function () {
    var gotDataset = selectedDataset;
    if (typeof selectedDataset === 'string' && Array.isArray(datasets)) {
      gotDataset = datasets.find(function (ds) {
        return ds.name === selectedDataset;
      });
    }
    if (gotDataset) {
      dispatch({
        type: 'SET_DATASET',
        value: gotDataset
      });
      var filteredVars = gotDataset.variables.filter(function (varobj) {
        return REMOVEDED_VARLIST.indexOf(varobj.name.toLowerCase()) == -1;
      }).filter(function (v) {
        return v.group === group;
      });
      if (Array.isArray(selectedVarlist)) {
        filteredVars = filteredVars.filter(function (varobj) {
          return selectedVarlist.indexOf(varobj.name.toUpperCase()) > -1;
        });
      }
      log(filteredVars, 'filteredVars: ');
      setTrigger(true);
      setVariables(filteredVars);
      setDerivedVariables(filteredVars.filter(function (variable) {
        return variable.isTotal === 0;
      }));
      if (typeof onChangeDatasetHandler === 'function') {
        onChangeDatasetHandler(gotDataset);
      }
    }
  }, [onChangeDatasetHandler, selectedVarlist, group, dataset, datasets]);
  var handleButtonChange = function handleButtonChange(newVal, buttons) {
    setType(newVal);
    var selectedBut = buttons.find(function (but) {
      return but.value === newVal;
    });
    if (typeof onToggleButtonChangeHandler === 'function') {
      onToggleButtonChangeHandler(selectedBut.value);
    }
  };
  React.useEffect(function () {
    handleSave();
  }, [variables]);
  var onCoeffAChange = function onCoeffAChange(newVal, variable) {
    var _extends2;
    setTrigger(false);
    setslidval(_extends({}, slidval, (_extends2 = {}, _extends2[variable.name] = newVal, _extends2)));
    log(slidval, "slidVal");
    var newVariables = variables.filter(function (variable) {
      return variable.isTotal === 0;
    }).filter(function (v) {
      return v.group === group;
    }).map(function (v, index) {
      if (v.name === variable.name) {
        return _extends({}, v, {
          transformA: v.transformA * (newVal * 2) / 100
        });
      }
      return derivedVariables[index];
    });
    setDerivedVariables(newVariables);
  };
  var handleSave = function handleSave() {
    var derivedVariablesCopy = [].concat(derivedVariables);
    log(derivedVariables, ' derivedVariables');
    log(takeExternalSources, ' takeexternalsources');
    if (!takeExternalSources) {
      derivedVariablesCopy = derivedVariablesCopy.map(function (v, index) {
        if (v.transform == 0) {
          return _extends({}, v, {
            transform: 1,
            transformA: 0
          });
        }
        return derivedVariables[index];
      });
    }
    var datasetName = store['dataset']['name'];
    var qp = {};
    var pp = [datasetName, 'derived_variables'];
    var _url = getUrlService('datasets', pp, qp);
    if (actionToDo === 'post') {
      fetch(_url, {
        method: 'POST',
        body: JSON.stringify({
          name: dvname,
          variables: derivedVariablesCopy,
          dataset: store['dataset']['id'],
          user: store['dataset']['user'],
          group: store['dataset']['group']
        }),
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        }
      }).then(function (response) {
        setActionToDo('put');
        return response.json();
      }).then(function (json) {
        dispatch({
          type: 'SET_DERIVED_VARIABLE',
          value: json
        });
      });
    } else if (actionToDo === 'put') {
      pp = [datasetName, 'derived_variables', dv_name];
      var _url2 = getUrlService('datasets', pp, qp);
      fetch(_url2, {
        method: 'PUT',
        body: JSON.stringify({
          name: dv_name,
          variables: derivedVariablesCopy,
          dataset: store['dataset']['id'],
          user: store['dataset']['user'],
          group: store['dataset']['group']
        }),
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        }
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        dispatch({
          type: 'SET_DERIVED_VARIABLE',
          value: json
        });
      });
    }
  };
  var handleButton = function handleButton() {
    handleSave();
  };
  React.useEffect(function () {
    handleSave();
  }, [takeExternalSources]);
  var changeSwitchValue = function changeSwitchValue(value) {
    dispatch({
      type: 'SET_EXTERNAL_SOURCES',
      value: value
    });
  };
  var handleBackgroundPolClick = function handleBackgroundPolClick(value) {
    dispatch({
      type: 'SET_BACKGROUND_POLLUTION_USED',
      value: value
    });
  };
  var variableChangeHandler = useCallback(function (selectedVariable, variables) {
    var gotVar = selectedVariable;
    if (typeof selectedVariable === 'string' && Array.isArray(variables)) {
      gotVar = variables.find(function (v) {
        return v.name === selectedVariable;
      });
    }
    setVariable(selectedVariable);
    if (gotVar) {
      dispatch({
        type: 'SET_VARIABLE',
        value: gotVar
      });
      if (typeof onChangeVariableHandler === 'function') {
        onChangeVariableHandler(gotVar);
      }
    }
  }, [onChangeVariableHandler]);
  var handleReset = function handleReset() {
    derivedVariables.filter(function (variable) {
      return variable.isTotal === 0 && variable.transform === 1;
    }).map(function (variable) {
      return variable['transformA'] = 1, slidval[variable.name] = 50;
    });
    handleSave();
  };
  React.useEffect(function () {
    if (!isEmpty(selectedDataset)) {
      setIsLoading(true);
      setError(false);
      var qp = {};
      var pp = [selectedDataset];
      var _url = getUrlService('datasets', pp, qp);
      log(_url, 'URL datasets services ARIASOURCESEDITOR', 'info');
      fetch(_url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        }
      }).then(function (response) {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 403) {
          var jr = response.json();
          setError(jr.message);
          setIsLoading(false);
          return response.json();
        } else if (response.status === 401) {
          var errmsg = response.statusText || 'No handled error';
          setError(errmsg);
          setIsLoading(false);
          return Promise.reject(new Error(errmsg));
        }
        return response.json();
      }).then(function (json) {
        setIsLoading(false);
        log(json, 'Fetch dataset', 'info');
        if (json.error) {
          setError(json.message);
          setIsLoading(false);
          dispatch({
            type: 'SET_DATASET',
            value: undefined
          });
        } else if (json.data) {
          if (typeof onLoadingDatasets === 'function') {
            onLoadingDatasets(json.data);
          }
          dispatch({
            type: 'SET_DATASETS',
            value: [json.data]
          });
        }
      })["catch"](function (error) {
        console.error(error);
        setError(error.toString());
        setIsLoading(false);
      });
    }
  }, [selectedDataset]);
  React.useEffect(function () {
    console.log(error, ' error  !!!');
  }, [error]);
  React.useEffect(function () {
    var datasetName = store['dataset']['name'];
    var qp = {};
    var pp = [datasetName, 'derived_variables'];
    var _url = getUrlService('datasets', pp, qp);
    fetch(_url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8'
      }
    }).then(function (response) {
      if (response.status === 200) {
        setActionToDo('put');
        return response.json();
      } else if (response.status === 403) {
        var jr = response.json();
        return response.json();
      } else if (response.status === 401) {
        var errmsg = response.statusText || 'No handled error';
        return Promise.reject(new Error(errmsg));
      } else if (response.status === 404) {
        setActionToDo('post');
      }
      return response.json();
    })["catch"](function (error) {
      console.error(error);
    });
  }, [group]);
  React.useEffect(function () {
    if (selectedDataset !== undefined) return null;
    if (!isEmpty(project) && !isEmpty(modeltype) && !isEmpty(type)) {
      setIsLoading(true);
      setError(false);
      var qp = {
        project: project,
        "case": modeltype.toUpperCase(),
        type: type
      };
      var pp = [];
      var _url = getUrlService('datasets', pp, qp);
      log(_url, 'URL datasets services', 'info');
      fetch(_url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        }
      }).then(function (response) {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 403) {
          var jr = response.json();
          setError(jr.message);
          setIsLoading(false);
          return response.json();
        } else if (response.status === 401) {
          var errmsg = response.statusText || 'No handled error';
          setError(errmsg);
          setIsLoading(false);
          return Promise.reject(new Error(errmsg));
        }
        return response.json();
      }).then(function (json) {
        setIsLoading(false);
        log(json, 'Fetch datasets', 'info');
        if (json.error) {
          setError(json.message || json.status);
          setIsLoading(false);
          dispatch({
            type: 'SET_DATASETS',
            value: undefined
          });
        } else if (Array.isArray(json.data)) {
          if (typeof onLoadingDatasets === 'function') {
            onLoadingDatasets(json.data);
          }
          dispatch({
            type: 'SET_DATASETS',
            value: json.data
          });
        } else {
          if (typeof onLoadingDatasets === 'function') {
            onLoadingDatasets([json.data]);
          }
          dispatch({
            type: 'SET_DATASETS',
            value: [json.data]
          });
        }
      })["catch"](function (error) {
        console.error(error);
        setError(error.toString());
        setIsLoading(false);
      });
    }
  }, [onLoadingDatasets, project, modeltype, type]);
  React.useEffect(function () {
    if (Array.isArray(variables)) {
      if (variables.length > 0) {
        var curvar = variables[0].name;
        if (currentVariable && !isEmpty(currentVariable)) {
          curvar = currentVariable;
        } else if (variables.length > 1) {
          var variableTotal = variables.filter(function (varr) {
            return varr.isTotal == 1;
          })[0];
          if (variableTotal) curvar = variableTotal.name;
        }
        setVariable(curvar);
        variableChangeHandler(curvar, variables);
      }
    }
  }, [variableChangeHandler, variables, currentVariable]);
  React.useEffect(function () {
    if (!isEmpty(dataType)) {
      setType(dataType);
    }
  }, [dataType]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, error && /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, t('ControlPanel.Error_loading_message')), withTypeSelect && !error && /*#__PURE__*/React.createElement(FormControl$1, {
    className: classes.formControl
  }, /*#__PURE__*/React.createElement(FormLabel, {
    className: classes.formLabel
  }, t('ControlPanel.Select_data_type')), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    direction: "column",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    size: "small",
    value: type,
    exclusive: true,
    onChange: function onChange(e, newval) {
      return handleButtonChange(newval, toggleButtons);
    }
  }, toggleButtons && toggleButtons.map(function (but, id) {
    return but.visible && /*#__PURE__*/React.createElement(ToggleButton, {
      disabled: disabled,
      key: id,
      value: but.value,
      className: classes.themeToggleButton
    }, /*#__PURE__*/React.createElement(Typography$1, {
      variant: "button",
      style: {
        textTransform: 'capitalize'
      }
    }, but.label));
  }))))), !error && in_toolbar && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormControl$1, {
    className: hidden ? classes.hidden : classes.formControl
  }, /*#__PURE__*/React.createElement(FormLabel, {
    htmlFor: "dataset"
  }, title), isLoading ? /*#__PURE__*/React.createElement(LinearProgress, {
    className: classes.linearProgress
  }) : error ? /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, t('ControlPanel.Error_loading_message')) : dataset && /*#__PURE__*/React.createElement(Select, {
    disabled: disabled,
    value: dataset,
    onChange: function onChange(e) {
      return console.log(e, 'e ');
    },
    inputProps: {
      name: 'dataset',
      id: 'dataset'
    }
  }, datasets && datasets.map(function (dataset, index) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: index,
      value: dataset
    }, dataset.title);
  }))), /*#__PURE__*/React.createElement(Accordion, null, /*#__PURE__*/React.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React.createElement(ExpandMore, null),
    "aria-controls": "panel1a-content",
    id: "panel1a-header"
  }, isLoading ? /*#__PURE__*/React.createElement(LinearProgress, {
    className: classes.linearProgress
  }) : error ? /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, t('ControlPanel.Error_loading_message')) : /*#__PURE__*/React.createElement(Typography$1, {
    color: "primary"
  }, t('ControlPanel.Source_Editors'))), /*#__PURE__*/React.createElement(AccordionDetails, null, /*#__PURE__*/React.createElement(FormControl$1, {
    className: classes.formControl,
    key: group
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      mt: 2,
      width: '95%'
    }
  }, derivedVariables && derivedVariables.filter(function (variable) {
    return variable.isTotal === 0 && variable.transform === 1;
  }).length != 0 ? derivedVariables.filter(function (variable) {
    return variable.isTotal === 0 && variable.transform === 1;
  }).map(function (variable, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, /*#__PURE__*/React.createElement(Typography$1, null, variable.title), /*#__PURE__*/React.createElement(Slider, {
      key: index,
      "aria-label": "Restricted values",
      defaultValue: 50,
      value: slidval[variable.name] || slidval[variable.name] === 0 ? slidval[variable.name] : 50,
      step: null,
      marks: marks,
      onChange: function onChange(event, newVal) {
        return onCoeffAChange(newVal, variable);
      }
    }));
  }) : /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, "Aucune variable pour ce groupe \xE0 ce site")), /*#__PURE__*/React.createElement(Box, {
    sx: {
      width: '90%'
    },
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleReset
  }, /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    fontWeight: "bold"
  }, t('ControlPanel.Reset_Derived_Variable'), " "))), /*#__PURE__*/React.createElement(Box, {
    sx: {
      mt: 2,
      width: '95%'
    },
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleButton,
    color: "primary",
    variant: "outlined"
  }, t('ControlPanel.Apply_Derived_Variable')))))), /*#__PURE__*/React.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React.createElement(ExpandMore, null),
    "aria-controls": "panel1a-content",
    id: "panel1a-header"
  }, /*#__PURE__*/React.createElement(Typography$1, {
    color: "primary"
  }, t('ControlPanel.Global_parameters'))), /*#__PURE__*/React.createElement(AccordionDetails, null, /*#__PURE__*/React.createElement(FormControl$1, null, externalSourcesButton && /*#__PURE__*/React.createElement(FormGroup, {
    className: classes.buttonText
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    label: t('ControlPanel.Add_external_sources'),
    control: /*#__PURE__*/React.createElement(Switch$1, {
      checked: takeExternalSources,
      color: "primary",
      onChange: function onChange(e) {
        return changeSwitchValue(e.target.checked);
      }
    })
  })), backgroundPollutionButton && /*#__PURE__*/React.createElement(FormGroup, {
    className: classes.buttonText
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    label: t('ControlPanel.Background_Pollution'),
    control: /*#__PURE__*/React.createElement(Switch$1, {
      checked: takeBackgroundPollution,
      color: "primary",
      onChange: function onChange(e) {
        return handleBackgroundPolClick(e.target.checked);
      }
    })
  })))))));
});

var useStyles$t = makeStyles(function (theme) {
  return {
    button: {
      marginLeft: '2px',
      border: '1px solid',
      display: 'inline-block',
      backgroundColor: 'rgb(255 255 255 / 80%)'
    },
    buttonActive: {
      marginLeft: '2px',
      border: '1px solid',
      display: 'inline-block'
    },
    linearProgress: {
      marginTop: theme.spacing(1)
    },
    formLabel: {
      marginBottom: theme.spacing(2)
    },
    hidden: {
      display: 'None'
    },
    buttons: {
      display: 'inline-block',
      marginLeft: theme.spacing(0)
    },
    block: {
      marginTop: '10px'
    }
  };
});
var AriaSources = (function (_ref) {
  var title = _ref.title,
    project = _ref.project,
    selectedDataset = _ref.selectedDataset,
    backgroundPollutionButton = _ref.backgroundPollutionButton,
    externalSourcesButton = _ref.externalSourcesButton,
    dv_name = _ref.dv_name,
    in_toolbar = _ref.in_toolbar;
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0],
    dispatch = _useAriaAppStore[1];
  var classes = useStyles$t();
  var _React$useState = React.useState(undefined),
    error = _React$useState[0];
  var _React$useState2 = React.useState(false),
    isLoading = _React$useState2[0];
  var _React$useState3 = React.useState(Date.now());
  var _useTranslation = useTranslation();
  var sourcesContributionGroups = store['sources_contribution_groups'];
  var _React$useState4 = React.useState(''),
    group = _React$useState4[0],
    setGroup = _React$useState4[1];
  var pol_group = store['pol_group'];
  var groupChangeHandler = useCallback(function (selectedGroup, sources) {
    var gotGroup = selectedGroup;
    if (typeof selectedGroup === 'string' && Array.isArray(sourcesContributionGroups)) {
      gotGroup = sourcesContributionGroups.find(function (v) {
        return v === selectedGroup;
      });
    }
    setGroup(selectedGroup);
    dispatch({
      type: 'SET_POL_GROUP',
      value: selectedGroup
    });
    console.log('################', pol_group);
  }, [pol_group]);
  React.useEffect(function () {
    if (Array.isArray(sourcesContributionGroups)) {
      if (sourcesContributionGroups.length > 0) {
        var curGroup = sourcesContributionGroups[0];
        setGroup(curGroup);
      }
    }
  }, [sourcesContributionGroups]);
  React.useEffect(function () {
    groupChangeHandler(pol_group);
  }, [pol_group]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormControl$1, {
    className: classes.formControl
  }, /*#__PURE__*/React.createElement(FormLabel, {
    htmlFor: "group"
  }), isLoading ? /*#__PURE__*/React.createElement(LinearProgress, null) : error ? /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, "Impossible de charger les variables.") : !in_toolbar && /*#__PURE__*/React.createElement("div", {
    className: classes.buttons
  }, " ", sourcesContributionGroups.map(function (gp, index) {
    return /*#__PURE__*/React.createElement(Button$1, {
      color: "primary",
      size: "small",
      className: group == gp ? classes.buttonActive : classes.button,
      value: gp,
      variant: group == gp ? 'contained' : 'outlined',
      onClick: function onClick(e) {
        return groupChangeHandler(e.target.innerText, sourcesContributionGroups);
      },
      key: index
    }, gp);
  })))), /*#__PURE__*/React.createElement(AriaSourcesEditor, {
    title: title,
    project: project,
    selectedDataset: selectedDataset,
    hidden: true,
    group: group,
    externalSourcesButton: externalSourcesButton,
    backgroundPollutionButton: backgroundPollutionButton,
    dv_name: dv_name,
    in_toolbar: in_toolbar
  }));
});

var useStyles$u = makeStyles(function (theme) {
  return {
    play: {
      paddingRight: ' 10px',
      padding: '5px 5px ',
      marginTop: 'auto',
      marginBottom: 'auto',
      marginLeft: 'auto',
      marginRight: 'auto',
      display: 'inline-flex'
    },
    circularButton: {
      width: '25px',
      height: '25px'
    },
    circularButtonDisabled: {
      width: '25px',
      height: '25px',
      color: '#b1b7ba'
    }
  };
});
var AriaAnimationDay = (function (_ref) {
  var hidden = _ref.hidden,
    timeframes = _ref.timeframes,
    timeframe = _ref.timeframe,
    dailyAverage = _ref.dailyAverage,
    setTimeframeCB = _ref.setTimeframeCB,
    animation = _ref.animation,
    setAnimation = _ref.setAnimation;
  var classes = useStyles$u();
  var _useTranslation = useTranslation();
  var _React$useState = React.useState(0),
    animationProgress = _React$useState[0],
    setAnimationProgress = _React$useState[1];
  var AnimationStep = 10000;
  React.useEffect(function () {
    if (animation) {
      var timer = setInterval(function () {
        setAnimationProgress(function (oldProgress) {
          if (oldProgress === 100) {
            return 0;
          }
          var diff = 10;
          return Math.min(oldProgress + diff, 100);
        });
      }, parseInt(0.9 * AnimationStep / 10));
      return function () {
        clearInterval(timer);
      };
    } else {
      setAnimationProgress(0);
    }
  }, [animation]);
  var handlePlayStopButtonOnClick = React.useCallback(function (e) {
    e.stopPropagation();
    setTimeout(function () {
      setAnimation(function (val) {
        return !val;
      });
    }, 200);
  }, []);
  var handleButtonOnClick = function handleButtonOnClick(timeframe) {
    return function (typeButton) {
      return function () {
        var curId = timeframe.id;
        var nTfs = timeframes.length;
        setAnimation(false);
        if (curId < 0 || nTfs === 0) return;
        switch (typeButton) {
          case 'NEXT':
            curId++;
            curId = Math.min(nTfs - 1, curId);
            setTimeframeCB(curId, timeframes);
            break;
          case "FORWARD":
            curId = nTfs;
            setTimeframeCB(curId, timeframes);
          case 'PREVIOUS':
            curId--;
            curId = Math.max(0, curId);
            setTimeframeCB(curId, timeframes);
            break;
          case "REWIND":
            curId = 0;
            setTimeframeCB(curId, timeframes);
          default:
            console.warn("Button type [" + typeButton + "] has not handled yet.");
        }
      };
    };
  };
  React.useEffect(function () {
    if (animation && timeframe) {
      var ID = undefined;
      if (timeframe.id + 1 === timeframes.length) {
        ID = 0;
      } else {
        ID = timeframe.id + 1;
      }
      var timer = setTimeout(function () {
        return setTimeframeCB(ID, timeframes);
      }, AnimationStep);
      return function () {
        clearTimeout(timer);
      };
    }
  }, [animation, timeframe, timeframes, AnimationStep]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.play
  }, timeframe && !hidden && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      width: 25,
      height: 25
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    disabled: dailyAverage || timeframe.id === 0,
    "aria-label": "Rewind",
    onClick: handleButtonOnClick(timeframe)('REWIND')
  }, /*#__PURE__*/React.createElement(FastRewindIcon, {
    fontSize: "small"
  }))), /*#__PURE__*/React.createElement(IconButton, {
    disabled: dailyAverage || timeframe.id === 0,
    "aria-label": "Previous",
    onClick: handleButtonOnClick(timeframe)('PREVIOUS')
  }, /*#__PURE__*/React.createElement(SkipPreviousIcon, {
    fontSize: "small"
  })), /*#__PURE__*/React.createElement(IconButton, {
    disabled: dailyAverage,
    size: "small",
    "aria-label": "Play",
    onClick: handlePlayStopButtonOnClick
  }, animation ? /*#__PURE__*/React.createElement("div", {
    className: dailyAverage ? classes.circularButtonDisabled : classes.circularButton
  }, /*#__PURE__*/React.createElement(CircularProgressbarWithChildren, {
    value: animationProgress,
    styles: buildStyles({
      pathColor: "red"
    })
  }, /*#__PURE__*/React.createElement(StopIcon, {
    color: "error",
    style: {
      width: 18,
      height: 18
    }
  }))) : /*#__PURE__*/React.createElement("div", {
    className: dailyAverage ? classes.circularButtonDisabled : classes.circularButton
  }, /*#__PURE__*/React.createElement(CircularProgressbarWithChildren, {
    value: 100,
    styles: buildStyles({
      pathColor: "#84b61e"
    })
  }, dailyAverage ? /*#__PURE__*/React.createElement(PlayArrowIcon, {
    style: {
      width: 18,
      height: 18
    }
  }) : /*#__PURE__*/React.createElement(PlayArrowIcon, {
    color: "secondary",
    style: {
      width: 18,
      height: 18
    }
  })))), /*#__PURE__*/React.createElement("div", {
    style: {
      width: 25,
      height: 25
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    disabled: dailyAverage || timeframe.id === timeframes.length - 1,
    "aria-label": "Next",
    onClick: handleButtonOnClick(timeframe)('NEXT')
  }, /*#__PURE__*/React.createElement(SkipNextIcon, {
    fontSize: "small"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      width: 25,
      height: 25
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    disabled: dailyAverage || timeframe.id === timeframes.length - 1,
    "aria-label": "Forward",
    onClick: handleButtonOnClick(timeframe)('FORWARD')
  }, /*#__PURE__*/React.createElement(FastForwardIcon, {
    fontSize: "small"
  })))));
});

var loadTimeframes = function loadTimeframes(cdate, dataset, isAtomic, isUTC, dtformat, setTimeframes, setDailyAverage, setIsLoading, setError) {
  var dateIn = cdate;
  if (!(dateIn instanceof Date)) return;
  if (dateIn instanceof Date) {
    dateIn = parseTime(cdate, '{y}-{m}-{d}', isUTC);
  }
  if (dataset && !isEmpty(dataset.name) && !isEmpty(dateIn)) {
    setIsLoading(true);
    setError(false);
    var qp = {
      info: 'timeframes',
      date: dateIn,
      is_atomic: isAtomic ? 1 : 0,
      modifier: undefined,
      timeavg: undefined,
      with_prevision: undefined,
      stat: 'True'
    };
    var additionalDay = cdate.getTimezoneOffset() > 0 ? 1 : -1;
    var date2 = new Date().setDate(cdate.getDate() + additionalDay);
    var qp2 = _extends({}, qp, {
      date: parseTime(date2, '{y}-{m}-{d}', true)
    });
    var pp = [dataset.name];
    var _url = getUrlService('datasets', pp, qp);
    var _url2 = getUrlService('datasets', pp, qp2);
    fetch(_url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8'
      }
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      fetch(_url2, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        }
      }).then(function (response2) {
        return response2.json();
      }).then(function (json2) {
        var tfsdata2;
        var tfsdata;
        if (json.data) {
          if (Array.isArray(json.data)) {
            tfsdata = json.data;
          } else if (json.data.timeframes) {
            tfsdata = json.data.timeframes;
          }
        }
        if (json2.data) {
          if (Array.isArray(json2.data)) {
            tfsdata2 = json2.data;
          } else if (json2.data.timeframes) {
            tfsdata2 = json2.data.timeframes;
          }
        }
        setDailyAverage(tfsdata.includes("mean"));
        var tfs = additionalDay == 1 ? tfsdata.concat(tfsdata2) : tfsdata2.concat(tfsdata);
        log(tfs, '*** Timeframes before ');
        tfs = tfs.filter(function (tf) {
          return parseTime(tf, dtformat, isUTC).split(' ')[0] == dateIn;
        });
        if (tfs.length == 0 && !tfsdata.includes("mean")) alert('Pas de simulation pour le jour sélectionné');
        log(tfs, '*** Timeframes ');
        setTimeframes(tfs);
        setIsLoading(false);
      })["catch"](function (error) {
        setError(error.toString());
        setIsLoading(false);
      });
    })["catch"](function (error) {
      setError(error.toString());
      setIsLoading(false);
    });
  }
  return null;
};

var useStyles$v = makeStyles(function (theme) {
  return {
    formControl: {
      alignItems: 'center',
      zIndex: '500',
      maxHeight: '600px',
      width: 'auto',
      height: 'min-content',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      backgroundColor: 'rgb(255 255 255 / 80%)',
      borderRadius: '10px'
    },
    selectEmpty: {
      marginTop: theme.spacing(2)
    },
    hidden: {
      display: 'None'
    },
    linearProgress: {
      marginTop: theme.spacing(1)
    },
    regroup: {
      padding: '5px 5px ',
      width: '150px',
      marginRight: '0px',
      marginTop: 'auto',
      marginBottom: 'auto',
      display: 'inline-flex',
      columnGap: theme.spacing(1)
    },
    avg: {
      padding: '5px 5px ',
      width: '100px',
      marginRight: '0px',
      marginTop: 'auto',
      marginBottom: 'auto',
      display: 'inline-flex',
      columnGap: theme.spacing(1)
    }
  };
});
var AriaDatePickerAdvanced = (function (_ref) {
  var title = _ref.title,
    hidden = _ref.hidden,
    showAnimation = _ref.showAnimation,
    showDailyAverageButton = _ref.showDailyAverageButton,
    disabled = _ref.disabled,
    withoutInitTimeseries = _ref.withoutInitTimeseries,
    isUTC = _ref.isUTC;
  var classes = useStyles$v();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(undefined),
    error = _useState[0],
    setError = _useState[1];
  var _useState2 = useState(false),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _React$useState = React.useState(false),
    animation = _React$useState[0],
    setAnimation = _React$useState[1];
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0],
    dispatch = _useAriaAppStore[1];
  var dataset = store['dataset'];
  var modeltype = store['case'];
  var isAtomic = store['is_atomic'];
  var variable = store['variable'];
  var _useState3 = useState({}),
    timeframe = _useState3[0],
    setTimeframe = _useState3[1];
  var _useState4 = useState({}),
    timeframes = _useState4[0],
    setTimeframes = _useState4[1];
  var _useState5 = useState(undefined),
    cdate = _useState5[0],
    setCDate = _useState5[1];
  var _useState6 = useState(undefined),
    minDate = _useState6[0],
    setMinDate = _useState6[1];
  var _useState7 = useState(undefined),
    maxDate = _useState7[0],
    setMaxDate = _useState7[1];
  var _useState8 = useState([]),
    dates = _useState8[0],
    setDates = _useState8[1];
  var _useState9 = useState(false),
    dailyAverage = _useState9[0],
    setDailyAverage = _useState9[1];
  var _useState10 = useState(false),
    showDailyAverage = _useState10[0],
    setShowDailyAverage = _useState10[1];
  var dtformat = '{y}-{m}-{d} {h}:{i}';
  var _React$useState2 = React.useState(false),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  var handleChange = function handleChange(event) {
    setAnimation(false);
    var currentFrame = event.target.value;
    var selId = -1;
    timeframes.find(function (tf, sid) {
      if (currentFrame == tf) {
        selId = sid;
        return true;
      }
    });
    setTimeframe({
      id: selId,
      value: currentFrame
    });
    dispatch({
      type: 'SET_TIMEFRAME',
      value: {
        id: selId,
        value: currentFrame,
        obj: new Date(currentFrame)
      }
    });
    onChangeTimeframeHandler(timeframe.value);
  };
  var handleClose = function handleClose() {
    setOpen(false);
  };
  var handleOpen = function handleOpen() {
    setOpen(true);
  };
  React.useEffect(function () {
    if (dataset && !isEmpty(dataset.name)) {
      setAnimation(false);
      setIsLoading(true);
      setError(false);
      var pp;
      var qp = {
        info: 'dates'
      };
      pp = [dataset.name];
      var _url = getUrlService('datasets', pp, qp);
      fetch(_url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        }
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        setIsLoading(false);
        log(json, 'SIM DATES');
        if (Array.isArray(json.data)) {
          var dateObjs = json.data.map(function (d) {
            var dObj = new Date(d + 'T12:00:00.00Z');
            return dObj;
          });
          setDates(dateObjs);
        }
      })["catch"](function (error) {
        setError(error.toString());
        setIsLoading(false);
      });
    }
  }, [dataset]);
  React.useEffect(function () {
    loadTimeframes(cdate, dataset, isAtomic, isUTC, dtformat, setTimeframes, setDailyAverage, setIsLoading, setError);
  }, [dataset, cdate]);
  useEffect(function () {
    if (showDailyAverage) {
      var dateMidnight = new Date(cdate);
      dateMidnight.setHours(0, 0, 0, 0);
      setTimeframe({
        id: -1,
        value: 'mean'
      });
      dispatch({
        type: 'SET_TIMEFRAME',
        value: {
          id: -1,
          value: 'mean',
          obj: dateMidnight
        }
      });
      return;
    }
    if (Array.isArray(timeframes)) {
      if (timeframes.length > 0) {
        var curUTCHour = new Date(Date.now()).getUTCHours();
        var curUTCDate = new Date(Date.now()).getUTCDate();
        var selId = -1;
        var selTf = timeframes.find(function (tf, sid) {
          var currDateObj = new Date(tf);
          if (currDateObj.getUTCHours() === curUTCHour && currDateObj.getUTCDate() === curUTCDate) {
            selId = sid;
            return true;
          }
        });
        var id = timeframes.length == 1 ? 0 : Math.floor(timeframes.length / 2);
        var selObj = {
          id: id,
          value: timeframes[id]
        };
        if (selTf || selId >= 0) {
          selObj.id = selId;
          selObj.value = selTf;
        }
        selObj.obj = new Date(selObj.value);
        setTimeframe(selObj);
        dispatch({
          type: 'SET_TIMEFRAME',
          value: selObj
        });
        if (typeof onChangeTimeframeHandler === 'function') {
          onChangeTimeframeHandler(selObj.value);
        }
      } else {
        dispatch({
          type: 'SET_TIMEFRAME',
          value: {
            id: 0,
            value: ''
          }
        });
      }
    }
  }, [onChangeTimeframeHandler, timeframes, showDailyAverage]);
  var onChangeTimeframeHandler = useCallback(function (v) {
    setCDate(v);
  }, []);
  var dateChangeHandler = useCallback(function (selectedDate) {
    log(selectedDate, 'Selected data: ');
    setAnimation(false);
    setCDate(selectedDate.toDate());
  }, []);
  var setTimeframeCB = useCallback(function (curId, timeframes) {
    setTimeframe({
      id: curId,
      value: timeframes[curId]
    });
    dispatch({
      type: 'SET_TIMEFRAME',
      value: {
        id: curId,
        value: timeframes[curId],
        obj: new Date(timeframes[curId])
      }
    });
    if (typeof onChangeTimeframeHandler === 'function') {
      onChangeTimeframeHandler(timeframes[curId]);
    }
  }, [onChangeTimeframeHandler]);
  var handleDailyAverageButton = useCallback(function (e) {
    setAnimation(false);
    setShowDailyAverage(e.target.checked);
  }, []);
  useEffect(function () {
    if (dates.length > 0) {
      log(dates, 'Dates', 'error');
      var miDate = dates[0];
      var maDate = dates[0];
      dates.forEach(function (d) {
        miDate = Math.min(miDate, d);
        maDate = Math.max(maDate, d);
      });
      setMinDate(miDate);
      setMaxDate(maDate);
      var _currdate = dates[dates.length - 1];
      var currentDateTime = new Date();
      if (_currdate < currentDateTime) {
        setCDate(_currdate);
      } else {
        setCDate(currentDateTime);
      }
      log(_currdate, 'Max Date', 'error');
    }
  }, [dates]);
  useEffect(function () {
    setAnimation(false);
  }, [variable]);
  useEffect(function () {
    if (!dailyAverage) {
      setShowDailyAverage(false);
    }
  }, [dailyAverage]);
  useEffect(function () {
    if (cdate instanceof Date) {
      log(cdate, 'DATE HAS CHANGED', 'error');
      dispatch({
        type: 'SET_DATE',
        value: cdate
      });
      var startDate = new Date();
      startDate.setTime(cdate.getTime());
      startDate.setHours(0);
      startDate.setMinutes(0);
      startDate.setSeconds(0);
      var endDate = new Date();
      endDate.setTime(cdate.getTime());
      endDate.setHours(23);
      endDate.setMinutes(0);
      endDate.setSeconds(0);
      if (!withoutInitTimeseries) {
        dispatch({
          type: 'SET_TIMESERIES',
          value: {
            datedeb: {
              value: startDate,
              max: endDate
            },
            datefin: {
              value: endDate,
              min: startDate,
              max: endDate
            }
          }
        });
      }
    }
  }, [cdate, withoutInitTimeseries]);
  return /*#__PURE__*/React.createElement(FormControl$1, {
    className: hidden || modeltype.toLowerCase().startsWith('rcp') ? classes.hidden : classes.formControl,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(FormLabel, {
    htmlFor: "date-picker"
  }, title), isLoading ? /*#__PURE__*/React.createElement(LinearProgress, {
    className: classes.linearProgress
  }) : error ? /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, t('ControlPanel.Cannot_load_variables_from_server')) : cdate && minDate && maxDate && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.regroup
  }, /*#__PURE__*/React.createElement(Box$1, {
    alignSelf: "center"
  }, /*#__PURE__*/React.createElement(CalendarToday, null)), /*#__PURE__*/React.createElement(DatePicker, {
    disableToolbar: true,
    autoOk: true,
    inputVariant: "outlined",
    ampm: false,
    value: cdate,
    onChange: dateChangeHandler,
    minDate: minDate,
    format: "DD/MM/yyyy",
    size: "small",
    inputProps: {
      name: 'date-picker',
      id: 'date-picker',
      style: _extends({}, {
        textAlign: 'center',
        padding: '10px 10px'
      })
    }
  })), showDailyAverageButton && /*#__PURE__*/React.createElement("div", {
    className: classes.avg
  }, /*#__PURE__*/React.createElement(FormGroup$1, null, /*#__PURE__*/React.createElement(FormControlLabel$1, {
    disabled: !dailyAverage,
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: showDailyAverage,
      color: "primary",
      onChange: handleDailyAverageButton
    }),
    label: /*#__PURE__*/React.createElement(Typography$1, {
      variant: "body1",
      style: {
        lineHeight: '1',
        fontSize: 'small'
      }
    }, t('Map.Daily_average'))
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.regroup
  }, /*#__PURE__*/React.createElement(Box$1, {
    alignSelf: "center"
  }, /*#__PURE__*/React.createElement(ScheduleIcon, {
    style: {
      color: showDailyAverage ? '#b1b7ba' : 'black'
    }
  })), /*#__PURE__*/React.createElement(FormControl$1, {
    fullWidth: true
  }, /*#__PURE__*/React.createElement(FormLabel, null, title), isLoading && /*#__PURE__*/React.createElement(LinearProgress, {
    className: classes.linearProgress
  }), error ? /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, "Cannot load variables from server") : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(FormControl$1, {
    variant: "outlined",
    size: "small"
  }, /*#__PURE__*/React.createElement(Select, {
    disabled: showDailyAverage,
    open: open,
    onClose: handleClose,
    onOpen: handleOpen,
    value: timeframe.value,
    onChange: handleChange
  }, timeframes && timeframes.length > 0 && timeframes.map(function (tf, index) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: index,
      value: tf
    }, parseTime(tf, dtformat, isUTC).split(' ')[1]);
  })))))), !isLoading && timeframes.length > 0 && showAnimation && /*#__PURE__*/React.createElement(AriaAnimationDay, {
    animation: animation,
    setAnimation: setAnimation,
    timeframe: timeframe,
    timeframes: timeframes,
    dailyAverage: showDailyAverage,
    setTimeframeCB: setTimeframeCB
  })));
});

delete L$1.Icon.Default.prototype._getIconUrl;
L$1.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png'
});
var useStyles$w = makeStyles(function (theme) {
  return {
    root: {
      height: '100%'
    },
    iconSmall: {
      margin: theme.spacing(1),
      fontSize: 12
    },
    cardContent: {
      padding: 0,
      '&:last-child': {
        paddingBottom: 0
      },
      width: '500px'
    },
    card: {},
    divMap: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    upperBar: {
      display: 'flex',
      justifyContent: 'space-between',
      position: 'absolute',
      zIndex: '500',
      width: '100%',
      padding: theme.spacing(1),
      gap: theme.spacing(1),
      height: theme.spacing(10)
    },
    legend: {
      backgroundColor: 'rgb(2555,255,255,0.9)',
      right: 10,
      bottom: '100px',
      position: 'absolute',
      zIndex: '500',
      padding: '8px',
      borderRadius: '10px'
    },
    linearProgress: {},
    scaleColor: {
      width: '14px',
      height: '14px',
      alignSelf: 'center',
      marginRight: '4%'
    }
  };
});
var AriaMap = (function (_ref) {
  var mapObj = _ref.mapObj,
    modifier = _ref.modifier,
    timeavg = _ref.timeavg,
    stat = _ref.stat,
    userDataLayer = _ref.userDataLayer,
    onFeatureClickedHandler = _ref.onFeatureClickedHandler,
    withClearButton = _ref.withClearButton,
    onClearGouvernoratButtonHandler = _ref.onClearGouvernoratButtonHandler,
    withTimeseries = _ref.withTimeseries,
    withComplains = _ref.withComplains,
    ModelWeatherCheck = _ref.ModelWeatherCheck,
    colorscaleEditable = _ref.colorscaleEditable,
    children = _ref.children,
    selectedDataset = _ref.selectedDataset,
    dv_name = _ref.dv_name,
    domainVars = _ref.domainVars;
  var classes = useStyles$w();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _React$useState = React.useState(false),
    isMapLoading = _React$useState[0],
    setIsMapLoading = _React$useState[1];
  var _React$useState2 = React.useState(false),
    setMapError = _React$useState2[1];
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0],
    dispatch = _useAriaAppStore[1];
  log(store, 'STORE: ');
  var dataset = store['dataset'];
  var variable = store['variable'];
  var currentDate = store['date'];
  var time = store['timeframe'] ? store['timeframe'].value : undefined;
  var timeObj = store['timeframe'] ? store['timeframe'].obj : undefined;
  var is_atomic = store['is_atomic'];
  var regulations = store['regulations'];
  var opacity = store['map'].opacity;
  var sourcesContributionGroups = store['sources_contribution_groups'];
  var met_sensors = store['weather_sensors'];
  var emis_sensors = store['emission_sensors'];
  var emis_sensor_thresholds = store['emission_sensor_thresholds'];
  var receptors = store['receptors'];
  var leftPanel = store['leftPanel'];
  var client = store['client'];
  var k_level = store['klevel'];
  var pol_group = store['pol_group'];
  var chart_open = store['chart_open'];
  var derived_variable = store['derived_variable'];
  var windAnimation = store['windAnimation'];
  var markers_colors = store['markers_colors'];
  var _React$useState3 = React.useState(false),
    openDialog = _React$useState3[0],
    setOpenDialog = _React$useState3[1];
  var udlcolor = "#4D666D";
  if (store['udlcolor'] != undefined) {
    udlcolor = store['udlcolor'];
  }
  var userDataLayerStyle = {
    "default": {
      type: 'gouvernorat',
      weight: 2,
      color: udlcolor,
      fillColor: udlcolor,
      fillOpacity: 0.5
    },
    click: {
      type: 'gouvernorat',
      weight: 5,
      fillColor: '#F30400',
      color: '#F30400',
      fillOpacity: 0.7
    }
  };
  var data_type_modifier = store['data_type_modifier'];
  var modifierValue = modifier;
  var timeavgValue = timeavg;
  var stats = stat;
  if (data_type_modifier && typeof data_type_modifier === 'object') {
    modifierValue = data_type_modifier['modifier'];
    timeavgValue = data_type_modifier['timeavgValue'];
    stats = data_type_modifier['stats'];
  }
  var takeReceptors = false;
  var extraction_zones = store['extraction_zones'];
  var _React$useState4 = React.useState(undefined),
    coeffsDerivedVariables = _React$useState4[0],
    setCoeffsDerivedVariables = _React$useState4[1];
  var _React$useState5 = React.useState([]),
    paletteValues = _React$useState5[0],
    setPaletteValues = _React$useState5[1];
  var _React$useState6 = React.useState(null),
    setSelectedRegion = _React$useState6[1];
  var _React$useState7 = React.useState(null),
    selectedWeatherSensor = _React$useState7[0],
    setSelectedWeatherSensor = _React$useState7[1];
  var _React$useState8 = React.useState(null),
    selectedEmissionSensor = _React$useState8[0],
    setSelectedEmissionSensor = _React$useState8[1];
  var _React$useState9 = React.useState(null),
    selectedReceptorSensor = _React$useState9[0],
    setSelectedReceptorSensor = _React$useState9[1];
  var _React$useState10 = React.useState({}),
    receptorObjects = _React$useState10[0];
  var _React$useState11 = React.useState({}),
    setEmisSensorsObjects2 = _React$useState11[1];
  var _React$useState12 = React.useState({}),
    markersColorsObjects = _React$useState12[0],
    setMarkersColorsObjects = _React$useState12[1];
  var _React$useState13 = React.useState(undefined),
    setCurrentRegulation = _React$useState13[1];
  var _React$useState14 = React.useState(null),
    healthData = _React$useState14[0],
    setHealthData = _React$useState14[1];
  var _React$useState15 = React.useState(false),
    setEditMarkerName = _React$useState15[1];
  var _React$useState16 = React.useState(null),
    setNewEditName = _React$useState16[1];
  var _useGetValues = useGetValues(receptors, store),
    isLoading = _useGetValues[0],
    rvalues = _useGetValues[2];
  var _useGetValues2 = useGetValues(markers_colors, store),
    mcvalues = _useGetValues2[2];
  var _React$useState17 = React.useState(undefined),
    rowValues = _React$useState17[0],
    setRowValues = _React$useState17[1];
  var _React$useState18 = React.useState(undefined),
    receptorToChanged = _React$useState18[0];
  var backgroundPollutionValue = store['background_pollution'] && store['background_pollution'].used ? store['background_pollution'].value : 0;
  React.useEffect(function () {
    if (!emis_sensors) return;
    var feats = _extends({}, emis_sensors);
    if (typeof feats === 'object' && time && variable && client && client.token) {
      var pp = [];
      var qp;
      if (time == 'mean') {
        var currentDatePlusOne = new Date(parseTime(currentDate, '{y}-{m}-{d}T00:00:00', true));
        currentDatePlusOne.setDate(currentDatePlusOne.getDate() + 1);
        currentDatePlusOne = parseTime(currentDatePlusOne, '{y}-{m}-{d}T00:00:00', false);
        qp = {
          obs_type: 'aq',
          time: currentDatePlusOne,
          timezone: store.timezone,
          average_period: '1440'
        };
      } else {
        qp = {
          obs_type: 'aq',
          time: parseTime(time, '{y}-{m}-{d}T{h}:{i}:{s}', true)
        };
      }
      var _feats = {};
      if (Array.isArray(feats)) {
        feats.forEach(function (r) {
          _feats[r.code] = r;
        });
      } else {
        _feats = feats;
      }
      var _url = getUrlService({
        version: process.env.REACT_APP_OBS_API_VERSION || '',
        name: process.env.REACT_APP_OBS_API + '/stations'
      }, pp, qp, true);
      log(_url, '*** URL Get AQ sensors values ***');
      fetch(_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          'X-ARIA-CLIENT-TOKEN': client.token
        },
        body: JSON.stringify(_feats)
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        log(json, '--- Get AQ sensors values response ---');
        var rowValuesCurrent;
        if (json.data) {
          rowValuesCurrent = json.data;
        } else {
          rowValuesCurrent = undefined;
        }
        setRowValues(rowValuesCurrent);
      })["catch"](function (err) {
        _readOnlyError("error");
      });
    } else {
      setRowValues(undefined);
    }
  }, [store.timeframe, store.client, store.timezone, store.variable]);
  React.useEffect(function () {}, [pol_group]);
  React.useEffect(function () {
    setCurrentRegulation(searchRegulationByPollutant(regulations, pol_group));
  }, [pol_group, regulations]);
  var baseLayers = getBaseLayers();
  var mZoom = 12;
  React.useEffect(function () {
    var dateIn = currentDate;
    if (time && time != 'mean') {
      dateIn = time.split('T')[0].replace(/-/g, '');
    } else {
      if (dateIn instanceof Date) {
        dateIn = parseTime(currentDate, '{y}{m}{d}');
      }
    }
    if (!dataset || !variable) return undefined;
    if (isEmpty(dataset.name) || isEmpty(dateIn) || isEmpty(variable.name)) {
      return undefined;
    }
    var parameters = {
      baseURL: process.env.REACT_APP_BASE_API,
      token: process.env.REACT_APP_ARIOTE_APIKEY,
      dataset: dataset.name,
      site: dataset["case"],
      epsg: dataset.epsg || epsg,
      variable: variable.name,
      currdate: dateIn,
      currTime: time,
      modifier: modifierValue,
      timeavg: timeavgValue,
      stat: stats,
      coeffsDerivedVariables: coeffsDerivedVariables,
      is_atomic: is_atomic,
      opacity: opacity,
      k_level: k_level,
      pol_group: pol_group
    };
    log(parameters, 'Parameters for request: ');
    if (store.background_pollution && store.background_pollution.used) {
      var sensorsOfBackgroundPollution = Object.values(emis_sensors).filter(function (sensor) {
        return sensor.samplingMethod == 'BG';
      });
      var fetchList = [];
      for (var _iterator = _createForOfIteratorHelperLoose(sensorsOfBackgroundPollution), _step; !(_step = _iterator()).done;) {
        var sensorBG = _step.value;
        var endDate = new Date(currentDate.getTime());
        var startDate = new Date(currentDate.getTime());
        endDate.setHours(0, 0, 0, 0);
        startDate.setDate(endDate.getDate() - 1);
        startDate.setHours(0, 0, 0, 0);
        var pp = [sensorBG.id];
        var qp = {
          obs_type: 'aq',
          start_date: parseTime(startDate, '{y}-{m}-{d}T{h}:{i}:{s}'),
          end_date: parseTime(endDate, '{y}-{m}-{d}T{h}:{i}:{s}'),
          timezone: store['timezone'],
          tav: '86400'
        };
        var _url = getUrlService({
          version: process.env.REACT_APP_OBS_API_VERSION || '',
          name: process.env.REACT_APP_OBS_API + '/stations'
        }, pp, qp, true);
        fetchList.push(fetch(_url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            'X-ARIA-CLIENT-TOKEN': client.token
          }
        }));
      }
      Promise.all(fetchList).then(function (res) {
        return Promise.all(res.map(function (r) {
          return r.json();
        }));
      }).then(function (dataJSON) {
        var sensorsMeanValues = [];
        dataJSON.map(function (json) {
          if (json.data && json.data.measures.data && json.data.measures.data[0] && json.data.measures.data[0][pol_group]) {
            sensorsMeanValues.push(json.data.measures.data[0][pol_group]);
          }
        });
        var minOfMean = sensorsMeanValues.length != 0 ? Math.min.apply(Math, sensorsMeanValues) : 0;
        dispatch({
          type: 'SET_BACKGROUND_POLLUTION_VALUE',
          value: minOfMean
        });
        setDataLayer(_extends({}, parameters, {
          globalTransformB: minOfMean
        }));
      });
    } else {
      setDataLayer(parameters);
    }
    log(dataLayer, 'dataLayer for request: ');
  }, [currentDate, dataset.name, dataset["case"], modifierValue, opacity, stats, time, timeavgValue, variable, is_atomic, k_level, coeffsDerivedVariables, store.background_pollution.used]);
  React.useEffect(function () {
    setCoeffsDerivedVariables(undefined);
    if (!derived_variable || !derived_variable.variables) return;
    var different = false;
    var _coeffs = [];
    derived_variable.variables.map(function (dv) {
      _coeffs.push(dv.transformA);
      if (dv.transformA != 1) different = true;
    });
    if (different) {
      setCoeffsDerivedVariables(_coeffs);
    }
  }, [derived_variable]);
  var getVariableUnit = React.useCallback(function () {
    return '';
  }, [variable]);
  var getVariableColormap = React.useCallback(function () {
    if (variable.palette) {
      if (typeof variable.palette === 'string') {
        return variable.palette;
      }
      if (modifierValue && timeavgValue) {
        var key = modifierValue + "_year";
        if (timeavgValue.toLowerCase() !== 'year') {
          key = modifierValue + "_month";
        }
        log(key, 'Colormap in AriaMap: ');
        if (key in variable.palette) {
          if (typeof variable.palette[key] === 'string') {
            log(variable.palette[key], 'Colormap in AriaMap key: ');
            return variable.palette[key];
          }
        }
      }
      if (variable.palette["default"]) {
        if (typeof variable.palette["default"] === 'string') {
          return variable.palette["default"];
        }
      }
    }
    return '';
  }, [modifierValue, timeavgValue, variable.palette]);
  var onChangedPaletteHandler = React.useCallback(function (clrmap) {
    setPaletteValues(clrmap);
  }, []);
  var onLoadingPaletteHandler = React.useCallback(function (clrmap) {
    setPaletteValues(clrmap);
  }, []);
  var onClickedOnFeature = React.useCallback(function (feat, layer, userDataLayerStyle) {
    var pogJSON = {
      type: 'FeatureCollection',
      features: [feat]
    };
    if (typeof onFeatureClickedHandler == 'function') {
      onFeatureClickedHandler(pogJSON, layer, userDataLayerStyle);
    }
  }, [onFeatureClickedHandler]);
  var onEachFeatureHandler = React.useCallback(function (feat, layer) {
    var popDetails = document.createElement('table');
    popDetails.style.border = 0;
    var tBody = document.createElement('tbody');
    var ir = 0;
    for (var v in feat.properties) {
      var col1 = document.createElement('td');
      col1.innerHTML = v;
      col1.style.color = '#3ba4b3';
      col1.style.padding = '4px';
      var col2 = document.createElement('td');
      col2.innerHTML = feat.properties[v];
      col2.style.padding = '4px';
      var row = document.createElement('tr');
      row.appendChild(col1);
      row.appendChild(col2);
      if (ir % 2 == 0) {
        row.style.backgroundColor = '#ebf1ff';
      } else {
        row.style.backgroundColor = '##D1E0FF';
      }
      tBody.appendChild(row);
      ir++;
    }
    popDetails.appendChild(tBody);
    layer.bindPopup(popDetails, {
      closeButton: false,
      className: 'popupTable'
    });
    layer.setStyle(userDataLayerStyle["default"]);
    var _click = 2;
    layer.on({
      click: function click(e) {
        if (e.target) {
          e.target.setStyle(userDataLayerStyle.click), layer.openPopup();
        }
        setSelectedRegion(function (l) {
          if (l) {
            if (l !== e.target) {
              _click = 2;
              l.setStyle(userDataLayerStyle["default"]);
            } else {
              _click += 1;
              if (_click % 2 !== 0) {
                l.setStyle(userDataLayerStyle["default"]);
                layer.closePopup();
              } else {
                l.setStyle(userDataLayerStyle.click);
                layer.openPopup();
              }
            }
          }
          return e.target;
        });
        onClickedOnFeature(feat, layer, userDataLayerStyle);
      },
      add: function add() {
        layer.bringToBack();
      }
    });
  }, [onClickedOnFeature]);
  var popupActionClickHandler = React.useCallback(function (dtype, sta) {
    return function (e) {
      log(sta, '***STATION on click***');
      dispatch({
        type: 'SET_OPEN_CHART',
        value: 'TIMESERIES'
      });
      if (dtype === 'pollution_rose' && selectedEmissionSensor) {
        var _newLayer;
        var newCoord = {
          lat: sta.y,
          lon: sta.x,
          type: 'AQ',
          code: sta.code,
          name: sta.name,
          id: sta.id
        };
        var newFeat = {};
        newFeat[sta.id] = newCoord;
        var newLayer = (_newLayer = {}, _newLayer[sta.id] = selectedEmissionSensor, _newLayer);
        dispatch({
          type: 'SET_EXTRACTION_ZONES',
          value: {
            infoType: 'pollution_rose',
            type: 'circlemarker',
            layers: newLayer,
            features: newFeat
          }
        });
        dispatch({
          type: 'SET_CHART_TYPE',
          value: 'pollution_rose'
        });
      }
      if (dtype === 'emission' && selectedEmissionSensor) {
        var _newLayer3;
        var _newCoord = {
          lat: sta.y,
          lon: sta.x,
          type: 'AQ',
          code: sta.code,
          name: sta.name,
          id: sta.id
        };
        var _newFeat = {};
        _newFeat[sta.id] = _newCoord;
        var _newLayer2 = (_newLayer3 = {}, _newLayer3[sta.id] = selectedEmissionSensor, _newLayer3);
        if (extraction_zones.features) {
          if (extraction_zones.features[Object.keys(extraction_zones.features)[0]].type == 'AQ' && extraction_zones.infoType == 'timeseries') {
            _newLayer2 = _extends({}, _newLayer2, extraction_zones.layers);
            _newFeat = _extends({}, _newFeat, extraction_zones.features);
          }
        }
        dispatch({
          type: 'SET_EXTRACTION_ZONES',
          value: {
            infoType: 'timeseries',
            type: 'circlemarker',
            layers: _newLayer2,
            features: _newFeat
          }
        });
        dispatch({
          type: 'SET_CHART_TYPE',
          value: 'observations'
        });
      } else if (dtype === 'receptors' && selectedReceptorSensor) {
        var _newLayer5;
        var _newCoord2 = {
          lat: sta.lat,
          lon: sta.lon,
          type: 'VIRTUAL',
          name: sta.r_name
        };
        var _newFeat2 = {};
        _newFeat2[sta.id] = _newCoord2;
        var _newLayer4 = (_newLayer5 = {}, _newLayer5[sta.id] = selectedReceptorSensor, _newLayer5);
        dispatch({
          type: 'SET_EXTRACTION_ZONES',
          value: {
            infoType: 'timeseries',
            type: 'circlemarker',
            layers: _newLayer4,
            features: _newFeat2
          }
        });
        if (store['allow_simulation']) {
          dispatch({
            type: 'SET_CHART_TYPE',
            value: 'line_simulation'
          });
        } else {
          dispatch({
            type: 'SET_CHART_TYPE',
            value: 'line'
          });
        }
      } else if (dtype === 'meteo' && selectedWeatherSensor) {
        var _newLayer7;
        var _newCoord3 = {
          lat: sta.latitude,
          lon: sta.longitude,
          type: 'WEATHER',
          id: sta.id
        };
        var _newFeat3 = {};
        _newFeat3[sta.id] = _newCoord3;
        var _newLayer6 = (_newLayer7 = {}, _newLayer7[sta.id] = selectedWeatherSensor, _newLayer7);
        dispatch({
          type: 'SET_EXTRACTION_ZONES',
          value: {
            infoType: 'timeseries',
            type: 'circlemarker',
            layers: _newLayer6,
            features: _newFeat3
          }
        });
        dispatch({
          type: 'SET_CHART_TYPE',
          value: 'meteo'
        });
        dispatch({
          type: 'SET_EXTRACTION_WEATHER_SENSOR',
          value: sta
        });
      } else if (dtype === 'contribution') {
        var _newLayer9;
        var _newCoord4 = {
          lat: sta.lat,
          lon: sta.lon,
          type: 'VIRTUAL',
          name: sta.r_name
        };
        var _newFeat4 = {};
        _newFeat4[sta.id] = _newCoord4;
        var _newLayer8 = (_newLayer9 = {}, _newLayer9[sta.id] = selectedReceptorSensor, _newLayer9);
        dispatch({
          type: 'SET_EXTRACTION_ZONES',
          value: {
            infoType: 'contribution',
            type: 'circlemarker',
            layers: _newLayer8,
            features: _newFeat4
          }
        });
        dispatch({
          type: 'SET_CHART_TYPE',
          value: 'sources_contribution'
        });
      }
      if (mapObj) {
        mapObj.current.leafletElement.closePopup();
      }
      e.stopPropagation();
    };
  }, [mapObj, selectedEmissionSensor, selectedWeatherSensor, selectedReceptorSensor, chart_open]);
  var sourceOnClickHandler = React.useCallback(function (srcdata, e) {
    return false;
  }, []);
  var stationOnClickHandler = React.useCallback(function (metstadata) {
    return false;
  }, []);
  var onEachGeojsonFeatureHandler = React.useCallback(function (feat, layer) {
    if (isEmpty(variable.name)) {
      return;
    }
    var popValue = feat.properties[variable.name] || 'None';
    var popDetails = document.createElement('table');
    popDetails.style.border = 0;
    var tBody = document.createElement('tbody');
    var ir = 0;
    for (var v in feat.properties) {
      var col1 = document.createElement('td');
      col1.innerHTML = v;
      col1.style.color = '#3ba4b3';
      col1.style.padding = '4px';
      var col2 = document.createElement('td');
      col2.innerHTML = feat.properties[v];
      col2.style.padding = '4px';
      var row = document.createElement('tr');
      row.appendChild(col1);
      row.appendChild(col2);
      if (ir % 2 == 0) {
        row.style.backgroundColor = '#ebf1ff';
      } else {
        row.style.backgroundColor = '##D1E0FF';
      }
      tBody.appendChild(row);
      ir++;
    }
    popDetails.appendChild(tBody);
    layer.bindPopup(popDetails, {
      closeButton: false,
      className: 'popupTable'
    });
    layer.bindTooltip(popValue.toString());
    var clr = undefined;
    if (popValue && Array.isArray(paletteValues)) {
      for (var i = 0; i < paletteValues.length; i++) {
        if (paletteValues[i].level <= popValue && paletteValues[i].threshold > popValue) {
          clr = paletteValues[i].value;
          break;
        }
      }
    }
    var sty = {
      weight: 1,
      color: clr,
      fillColor: clr,
      fillOpacity: 0.7
    };
    layer.setStyle(sty);
    layer.on({
      click: function click(e) {
        layer.openPopup();
      },
      mouseover: function mouseover(e) {
        layer.openTooltip();
      },
      mouseout: function mouseout(e) {
        layer.closeTooltip();
      }
    });
  }, [paletteValues, variable.name]);
  var deletePersonalMarker = React.useCallback(function (mk) {
    return function (e) {
      mapObj.current.leafletElement.closePopup();
      if (mk in markersColorsObjects) {
        if (extraction_zones.features && extraction_zones.features[mk]) {
          dispatch({
            type: 'SET_OPEN_CHART',
            value: 'TIMEFRAME'
          });
        }
        delete markersColorsObjects[mk];
        dispatch({
          type: 'SET_MARKERS_COLORS',
          value: markersColorsObjects
        });
      }
      e.stopPropagation();
    };
  }, [mapObj, extraction_zones, markers_colors]);
  React.useEffect(function () {
    log(dataset, 'Effect on map', 'error');
    if (dataset && !isEmpty(dataset.name) && currentDate instanceof Date) {
      log(dataset.format, 'Effect on map dataset format', 'info');
      if (dataset.format !== 'shp') {
        setHealthData(undefined);
        return undefined;
      }
      setIsMapLoading(true);
      setMapError(false);
      var qp = {};
      var pp;
      if (process.env.REACT_APP_API_VERSION === 'v2') {
        qp = {
          dataset: dataset.name,
          date: parseTime(currentDate, '{y}{m}{d}', true)
        };
        pp = [dataset.project];
      }
      var _url = getUrlService('health/map', pp, qp);
      log(_url, 'URL Health services', 'info');
      fetch(_url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        }
      }).then(function (response) {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 403) {
          var jr = response.json();
          setMapError(jr.message);
          setIsMapLoading(false);
          return Promise.reject(new Error(errmsg));
        } else if (response.status === 401) {
          var _errmsg = response.statusText || 'No handled error';
          setMapError(_errmsg);
          setIsMapLoading(false);
          return Promise.reject(new Error(_errmsg));
        }
        return response.json();
      }).then(function (json) {
        setIsMapLoading(false);
        log(json, 'Fetch getHealth data', 'info');
        if (json.error) {
          setMapError(json.message);
          setIsMapLoading(false);
          setHealthData(undefined);
        } else if (json.data) {
          setHealthData(json.data);
        }
      })["catch"](function (error) {
        console.error(error);
        setMapError(error.toString());
        setIsMapLoading(false);
        setHealthData(undefined);
      });
    }
  }, [dataset, currentDate]);
  log(healthData, 'HEALTH DATA', 'error');
  React.useEffect(function () {
    if (!client || !client.name) return;
    var _url = getUrlService('points', ['receptors'], {
      client: client.name
    }, true);
    log(_url, '*** URL Get Receptors ***');
    fetch(_url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8'
      }
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      log(json, 'Get Receptors', 'info');
      var receptors = {};
      json.forEach(function (rcp) {
        if (!(rcp.id.toString() in receptors)) {
          receptors[rcp.id] = {};
        }
        receptors[rcp.id] = rcp;
      });
      dispatch({
        type: 'SET_RECEPTORS',
        value: receptors
      });
    })["catch"](function (error) {
      log(error, 'Error from Observation service', 'error');
    });
  }, [client]);
  React.useEffect(function () {
    log(rvalues, '*** rvalues ***', 'error');
    if (Object.keys(receptorObjects).length == 0) return;
    for (var recepetor in receptorObjects) {
      receptorObjects[recepetor].value = undefined;
      receptorObjects[recepetor].color = '#828481';
    }
    if (rvalues) {
      for (var v in rvalues) {
        var limit = 999.0;
        var _v = v.split('S');
        if (_v.length > 1) {
          limit = store['receptor_thresh'][_v[1]];
        }
        log(receptorObjects, 'receptorObjects');
        for (var rid in rvalues[v].values) {
          receptorObjects[rid].value = rvalues[v].values[rid];
          if (receptorObjects[rid].value > limit) {
            receptorObjects[rid].color = 'red';
          } else {
            receptorObjects[rid].color = '#306ec9';
          }
        }
        dispatch({
          type: 'SET_RECEPTORS',
          value: receptorObjects
        });
      }
    }
  }, [rvalues]);
  React.useEffect(function () {
    log(mcvalues, '*** mcvalues ***', 'error');
    for (var mc in markersColorsObjects) {
      markersColorsObjects[mc].value = undefined;
    }
    if (mcvalues) {
      for (var v in mcvalues) {
        var _v = v.split('S');
        for (var rid in mcvalues[v].values) {
          markersColorsObjects[rid].value = mcvalues[v].values[rid];
        }
        dispatch({
          type: 'SET_MARKERS_COLORS',
          value: markersColorsObjects
        });
      }
    }
  }, [mcvalues]);
  React.useEffect(function () {
    log(rowValues, '*** rowValues ***', 'error');
    var emisSensorsObjects = _extends({}, emis_sensors);
    if (!emisSensorsObjects) return;
    for (var sensor in emisSensorsObjects) {
      emisSensorsObjects[sensor].value = undefined;
      emisSensorsObjects[sensor].color = '#828481';
      emisSensorsObjects[sensor].values = {};
    }
    if (rowValues) {
      if (Object.keys(rowValues).length != 0) {
        for (var rid in rowValues.values) {
          if (!emisSensorsObjects[rid]) continue;
          emisSensorsObjects[rid]['values'] = rowValues.values[rid];
          var limit = emis_sensor_thresholds;
          var v = variable.group;
          emisSensorsObjects[rid].value = rowValues.values[rid][v];
          log(emisSensorsObjects, 'emisSensorsObjects');
          if (regulations) {
            emisSensorsObjects[rid].color = searchColorByRegulation(rowValues.values[rid][v], searchRegulationByPollutant(regulations, pol_group));
          } else {
            if (emisSensorsObjects[rid].value == undefined || limit[v] == undefined) {
              emisSensorsObjects[rid].color = '#828481';
            } else if (emisSensorsObjects[rid].value > limit[v]) {
              emisSensorsObjects[rid].color = 'red';
            } else {
              emisSensorsObjects[rid].color = 'green';
            }
          }
        }
      }
    }
    dispatch({
      type: 'SET_EMISSION_SENSORS',
      value: emisSensorsObjects
    });
  }, [rowValues]);
  var _React$useState19 = React.useState(undefined),
    dataLayer = _React$useState19[0],
    setDataLayer = _React$useState19[1];
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, domainVars.domain && /*#__PURE__*/React.createElement(Map, {
    center: domainVars.mCenter,
    zoom: mZoom,
    bounds: domainVars.domain.bounds || null,
    minZoom: 5,
    maxZoom: 19,
    keepInView: true,
    continuousWorld: true,
    ref: mapObj,
    zoomControl: false
  }, !leftPanel && /*#__PURE__*/React.createElement("div", {
    className: classes.upperBar
  }, /*#__PURE__*/React.createElement(AriaSources, {
    title: t('ControlPanel.Select_dataset'),
    project: 'ARIAVIEW',
    pol_group: pol_group,
    selectedDataset: selectedDataset,
    externalSourcesButton: true,
    backgroundPollutionButton: true,
    dv_name: dv_name,
    in_toolbar: false
  }), /*#__PURE__*/React.createElement(AriaDatePickerAdvanced, {
    showDailyAverageButton: true,
    showAnimation: true,
    isUTC: false
  }), /*#__PURE__*/React.createElement(AriaColorScaleControl, {
    variableUnit: getVariableUnit(),
    colormap: getVariableColormap(),
    onChangedPalette: onChangedPaletteHandler,
    onLoadingPalette: onLoadingPaletteHandler,
    edittable: colorscaleEditable
  })), /*#__PURE__*/React.createElement(LayersControl, {
    position: "bottomleft"
  }, /*#__PURE__*/React.createElement(LayersControl.BaseLayer, {
    name: "OpenStreetMap FR"
  }, /*#__PURE__*/React.createElement(TileLayer, {
    attribution: baseLayers.osmfr.attribution,
    url: baseLayers.osmfr.url
  })), /*#__PURE__*/React.createElement(LayersControl.BaseLayer, {
    name: "Mapbox"
  }, /*#__PURE__*/React.createElement(TileLayer, {
    attribution: baseLayers.mapBox.attribution,
    url: baseLayers.mapBox.url
  })), /*#__PURE__*/React.createElement(LayersControl.BaseLayer, {
    name: "GOOGLE Satellite"
  }, /*#__PURE__*/React.createElement(TileLayer, {
    attribution: baseLayers.googleSat.attribution,
    url: baseLayers.googleSat.url
  })), /*#__PURE__*/React.createElement(LayersControl.BaseLayer, {
    name: "IGN",
    checked: true
  }, /*#__PURE__*/React.createElement(TileLayer, {
    attribution: baseLayers.IGN.attribution,
    url: baseLayers.IGN.url
  })), dataLayer && /*#__PURE__*/React.createElement(LayersControl.Overlay, {
    name: '<p style="font-size:125% ; display:inline">' + '<img src="https://gitlab.com/T-Huard/images/-/raw/main/panache.png"  width="14" height="14"> ' + t('Map.Data') + '</p>',
    checked: true
  }, /*#__PURE__*/React.createElement(AriaDataTileLayer, _extends({}, dataLayer, {
    palette: colorscaleEditable ? paletteValues : undefined
  }))), windAnimation && /*#__PURE__*/React.createElement(AriaWindLayer, {
    data: swift,
    enableAnimation: wind_animation,
    pauseAnimation: false
  }), healthData && /*#__PURE__*/React.createElement(LayersControl.Overlay, {
    name: t('Map.Health_data'),
    checked: true
  }, /*#__PURE__*/React.createElement(GeoJSON, {
    key: Date.now(),
    data: healthData,
    onEachFeature: onEachGeojsonFeatureHandler
  })), modifierValue === 'ano' && /*#__PURE__*/React.createElement(LayersControl.Overlay, {
    name: t('Map.Confidence_indice')
  }, dataLayer ? /*#__PURE__*/React.createElement(AriaDataTileLayer, _extends({}, dataLayer, {
    stat: "score"
  })) : null), domainVars.domain.polygon && /*#__PURE__*/React.createElement(LayersControl.Overlay, {
    name: '<p style="font-size:125% ; display:inline">' + '<img src="https://gitlab.com/T-Huard/images/-/raw/main/domain.png"  width="14" height="14"> ' + t('Map.Domain') + '</p>',
    checked: true
  }, /*#__PURE__*/React.createElement(Polygon, {
    positions: domainVars.domain.polygon,
    color: 'black',
    fill: false
  })), domainVars.domainNesting && /*#__PURE__*/React.createElement(LayersControl.Overlay, {
    name: t('Map.Domain_nesting'),
    checked: true
  }, /*#__PURE__*/React.createElement(Polygon, {
    positions: domainVars.domainNesting,
    color: 'gray',
    fill: false
  })), Array.isArray(met_sensors) && met_sensors.length > 0 && met_sensors.filter(function (station) {
    return station.nameAirQualityNetwork === 'NA' || station.nameAirQualityNetwork === 'OBS';
  }).length != 0 && /*#__PURE__*/React.createElement(LayersControl.Overlay, {
    name: '<p style="font-size:125% ; display:inline">' + '<img src="https://gitlab.com/T-Huard/images/-/raw/main/triangle_meteo.png"  width="14" height="14"> ' + t('Map.Weather_stations') + '</p>',
    checked: true
  }, /*#__PURE__*/React.createElement(FeatureGroup, {
    name: "metsta",
    attribution: "Meteo station"
  }, met_sensors.filter(function (station) {
    return station.nameAirQualityNetwork === 'NA' || station.nameAirQualityNetwork === 'OBS';
  }).map(function (sta, index) {
    if (!sta.latitude || !sta.longitude) return null;
    return /*#__PURE__*/React.createElement(ShapeMarker$1, {
      key: index,
      center: [sta.latitude, sta.longitude],
      shape: "triangle",
      radius: 5,
      color: 'black',
      fillColor: "blue",
      fillOpacity: 0.8,
      onClick: function onClick(e) {
        return setSelectedWeatherSensor(e.target);
      }
    }, /*#__PURE__*/React.createElement(Popup, {
      onOpen: function onOpen() {
        return stationOnClickHandler(sta);
      }
    }, /*#__PURE__*/React.createElement(Card, {
      elevation: 0
    }, /*#__PURE__*/React.createElement(CardContent, {
      className: classes.cardContent
    }, /*#__PURE__*/React.createElement(Typography, {
      gutterBottom: true,
      variant: "h6",
      component: "h2"
    }, /*#__PURE__*/React.createElement("span", null, sta.name)), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      color: "textSecondary",
      component: "p"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("strong", null)))), /*#__PURE__*/React.createElement(CardActions, null, /*#__PURE__*/React.createElement(Button$1, {
      size: "small",
      color: "primary",
      onClick: popupActionClickHandler('meteo', sta)
    }, /*#__PURE__*/React.createElement(TimelineIcon, {
      style: {
        marginRight: '10'
      }
    }), t('Map.Show_timeseries'))))));
  }))), Array.isArray(met_sensors) && met_sensors.filter(function (station) {
    return station.nameAirQualityNetwork === 'MODEL';
  }).length > 0 && /*#__PURE__*/React.createElement(LayersControl.Overlay, {
    name: '<p style="font-size:125% ; display:inline">' + '<img src="https://gitlab.com/T-Huard/images/-/raw/main/profil_arome.png"  width="14" height="14"> ' + t('Map.Model_Weather_stations') + '</p>',
    checked: ModelWeatherCheck
  }, /*#__PURE__*/React.createElement(FeatureGroup, {
    name: "metsta",
    attribution: "Meteo station"
  }, met_sensors.filter(function (station) {
    return station.nameAirQualityNetwork === 'MODEL';
  }).map(function (sta, index) {
    if (!sta.latitude || !sta.longitude) return null;
    return /*#__PURE__*/React.createElement(ShapeMarker$1, {
      key: index,
      center: [sta.latitude, sta.longitude],
      shape: "diamond",
      radius: 5,
      color: 'black',
      fillColor: "purple",
      fillOpacity: 0.8,
      onClick: function onClick(e) {
        return setSelectedWeatherSensor(e.target);
      }
    }, /*#__PURE__*/React.createElement(Popup, {
      onOpen: function onOpen() {
        return stationOnClickHandler(sta);
      }
    }, /*#__PURE__*/React.createElement(Card, {
      elevation: 0
    }, /*#__PURE__*/React.createElement(CardContent, {
      className: classes.cardContent
    }, /*#__PURE__*/React.createElement(Typography, {
      gutterBottom: true,
      variant: "h6",
      component: "h2"
    }, /*#__PURE__*/React.createElement("span", null, sta.name)), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      color: "textSecondary",
      component: "p"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("strong", null)))), /*#__PURE__*/React.createElement(CardActions, null, /*#__PURE__*/React.createElement(Button$1, {
      size: "small",
      color: "primary",
      onClick: popupActionClickHandler('meteo', sta)
    }, /*#__PURE__*/React.createElement(TimelineIcon, {
      style: {
        marginRight: '10'
      }
    }), t('Map.Show_timeseries'))))));
  }))), Object.keys(emis_sensors).length > 0 && /*#__PURE__*/React.createElement(LayersControl.Overlay, {
    name: '<div style="display:inline-flex"> <div style="border:black solid;width: 14px ;height:14px; align-self:center;margin-right:6px; border-radius:50%"></div> ' + '<text style="font-size:125%">' + t('Map.Air_quality_sensors') + '</text></div>',
    checked: true
  }, /*#__PURE__*/React.createElement(FeatureGroup, {
    name: "sensors",
    attribution: ""
  }, Object.keys(emis_sensors).map(function (src_key, index) {
    if (!emis_sensors[src_key].latitude || !emis_sensors[src_key].longitude) return null;
    return /*#__PURE__*/React.createElement(CircleMarker, {
      weight: 2,
      key: index,
      center: [emis_sensors[src_key].latitude, emis_sensors[src_key].longitude],
      radius: 7,
      color: 'black',
      fillColor: emis_sensors[src_key].color || '#a3a3a3',
      fillOpacity: 1,
      onClick: function onClick(e) {
        return setSelectedEmissionSensor(e.target);
      },
      onAdd: function onAdd(e) {
        setEmisSensorsObjects2(function (olds) {
          olds[emis_sensors[src_key].code] = emis_sensors[src_key];
          return olds;
        });
      }
    }, /*#__PURE__*/React.createElement(Popup, {
      minWidth: "1000px",
      onOpen: function onOpen(e) {
        return sourceOnClickHandler(emis_sensors[src_key]);
      }
    }, /*#__PURE__*/React.createElement(Card, {
      elevation: 0
    }, /*#__PURE__*/React.createElement(CardContent, {
      className: classes.cardContent
    }, /*#__PURE__*/React.createElement(Typography, {
      align: "center",
      gutterBottom: true,
      variant: "h6",
      component: "h4"
    }, /*#__PURE__*/React.createElement("span", null, emis_sensors[src_key].name)),
    /*#__PURE__*/
    React.createElement(TableContainer, {
      component: Paper$2,
      style: {
        textAlign: 'left'
      }
    }, /*#__PURE__*/React.createElement(Table, {
      size: "small",
      "aria-label": "a dense table"
    }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, sourcesContributionGroups.map(function (source) {
      return /*#__PURE__*/React.createElement(TableCell, {
        align: "center",
        style: {
          fontWeight: source == variable.group ? 'bold' : 'unset'
        }
      }, " ", source);
    }))), /*#__PURE__*/React.createElement(TableBody, null, /*#__PURE__*/React.createElement(TableRow, null, emis_sensors[src_key].code !== undefined && emis_sensors[src_key].values !== undefined && sourcesContributionGroups.map(function (source) {
      return emis_sensors[src_key].values[source] && emis_sensors[src_key].values[source] > 0 ? /*#__PURE__*/React.createElement(TableCell, {
        align: "center",
        style: source == variable.group ? {
          fontWeight: 'bold',
          padding: '6px'
        } : {
          padding: '6px'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.scaleColor,
        style: {
          background: searchColorByRegulation(emis_sensors[src_key].values[source], searchRegulationByPollutant(regulations, source))
        }
      }), emis_sensors[src_key].values[source].toFixed(2), /*#__PURE__*/React.createElement("small", {
        style: {
          placeSelf: 'end'
        }
      }, " \xB5g/m\xB3"))) : /*#__PURE__*/React.createElement(TableCell, {
        align: "center",
        style: source == variable.group ? {
          fontWeight: 'bold',
          padding: '6px'
        } : {
          padding: '6px'
        }
      }, '∅');
    })))))), /*#__PURE__*/React.createElement(CardActions, {
      style: {
        justifyContent: 'center'
      }
    }, /*#__PURE__*/React.createElement(Button$1, {
      size: "small",
      color: "primary",
      onClick: popupActionClickHandler('emission', emis_sensors[src_key])
    }, /*#__PURE__*/React.createElement(TimelineIcon, {
      style: {
        marginRight: '10'
      }
    }), t('Map.Show_timeseries')), /*#__PURE__*/React.createElement(Button$1, {
      size: "small",
      color: "primary",
      onClick: popupActionClickHandler('pollution_rose', emis_sensors[src_key])
    }, /*#__PURE__*/React.createElement(TrackChanges, {
      style: {
        marginRight: '10'
      }
    }), t('Map.Pollution_rose'))))));
  }))), takeReceptors  , Object.keys(markers_colors).length > 0 && /*#__PURE__*/React.createElement(LayersControl.Overlay, {
    name: '<p style="font-size:125% ; display:inline">' + '<img src="https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png"  width="14" height="14"> ' + t('Map.Personal_markers') + '</p>',
    checked: true
  }, /*#__PURE__*/React.createElement(FeatureGroup, {
    name: "markers",
    attribution: "markers"
  }, Object.keys(markers_colors).map(function (mk, index) {
    return /*#__PURE__*/React.createElement(Marker, {
      key: markers_colors[mk].id,
      position: [markers_colors[mk].lat, markers_colors[mk].lon],
      icon: markers_colors[mk].icon,
      onClick: function onClick(e) {
        setSelectedReceptorSensor(e.target);
        setEditMarkerName(false);
        setNewEditName(null);
      },
      onAdd: function onAdd(e) {
        setMarkersColorsObjects(function (olds) {
          olds[markers_colors[mk].id] = markers_colors[mk];
          return olds;
        });
      }
    }, /*#__PURE__*/React.createElement(Popup, {
      minWidth: "1000px"
    }, /*#__PURE__*/React.createElement(Card, {
      elevation: 0,
      className: classes.card
    }, /*#__PURE__*/React.createElement(CardContent, {
      className: classes.cardContent
    }, /*#__PURE__*/React.createElement(Typography, {
      align: "center",
      gutterBottom: true,
      variant: "h6",
      component: "h4"
    }, /*#__PURE__*/React.createElement("span", null, " ", markers_colors[mk].r_name, " "), /*#__PURE__*/React.createElement(Button$1, {
      style: {
        "float": 'right'
      },
      color: "primary",
      onClick: deletePersonalMarker(mk)
    }, /*#__PURE__*/React.createElement(DeleteForeverIcon, null))), markers_colors[mk].value !== undefined && /*#__PURE__*/React.createElement(TableContainer, {
      component: Paper$2,
      style: {
        textAlign: 'left'
      }
    }, /*#__PURE__*/React.createElement(Table, {
      size: "small",
      "aria-label": "a dense table"
    }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
      align: "center",
      style: {
        fontWeight: 'bold'
      }
    }, " ", variable.group))), /*#__PURE__*/React.createElement(TableBody, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
      align: "center",
      style: {
        fontWeight: 'bold',
        padding: '6px'
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'center'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.scaleColor,
      style: {
        background: searchColorByRegulation(markers_colors[mk].value + backgroundPollutionValue, searchRegulationByPollutant(regulations, variable.group))
      }
    }), (markers_colors[mk].value + backgroundPollutionValue).toFixed(2), /*#__PURE__*/React.createElement("small", {
      style: {
        placeSelf: 'end'
      }
    }, " \xB5g/m\xB3")))))))), /*#__PURE__*/React.createElement(CardActions, {
      style: {
        justifyContent: 'space-around'
      }
    }, /*#__PURE__*/React.createElement(Button$1, {
      style: {
        columnGap: '10%'
      },
      size: "small",
      color: "primary",
      onClick: popupActionClickHandler('receptors', markers_colors[mk])
    }, /*#__PURE__*/React.createElement(TimelineIcon, {
      style: {
        marginRight: '10'
      }
    }), t('Map.Show_timeseries')), /*#__PURE__*/React.createElement(Button$1, {
      size: "small",
      color: "primary",
      onClick: popupActionClickHandler('contribution', markers_colors[mk])
    }, /*#__PURE__*/React.createElement(PieChartIcon, {
      style: {
        marginRight: '10'
      }
    }), t('Map.Sources_contribution'))))));
  }))), openDialog && receptorToChanged && /*#__PURE__*/React.createElement(SaveReceptorDialog, {
    openDialog: openDialog,
    setOpenDialog: setOpenDialog,
    point: receptorToChanged
  }), withComplains && /*#__PURE__*/React.createElement(LayersControl.Overlay, {
    name: t('Map.Complain_locations'),
    checked: true
  }, /*#__PURE__*/React.createElement(AriaComplainToolbar, null)), userDataLayer && /*#__PURE__*/React.createElement(LayersControl.Overlay, {
    name: '<p style="font-size:125% ; display:inline">' + '<img src="https://gitlab.com/T-Huard/images/-/raw/main/building_grey.png"  width="14" height="14"> ' + userDataLayer.name + '</p>',
    checked: userDataLayer.checked
  }, userDataLayer.polygon && /*#__PURE__*/React.createElement(GeoJSON, {
    data: userDataLayer.polygon,
    onEachFeature: onEachFeatureHandler
  }))), /*#__PURE__*/React.createElement(AriaWeatherInfo, {
    timeObj: timeObj,
    time: time
  }), withClearButton && /*#__PURE__*/React.createElement(AriaControlButton, {
    title: withClearButton.title,
    onClick: onClearGouvernoratButtonHandler
  }), /*#__PURE__*/React.createElement(Control$1, {
    position: "topleft"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: '150px'
    }
  })), withTimeseries && /*#__PURE__*/React.createElement(AriaDrawToolbar, {
    drawOptions: withTimeseries.drawOptions,
    setInterestedZone: setSelectedRegion,
    pointColors: withTimeseries.pointColors
  }), children), (isMapLoading || isLoading) && /*#__PURE__*/React.createElement(LinearProgress$1, {
    className: classes.linearProgress
  }));
});

var _excluded$4 = ["controlPanelProps", "mapProps", "controls", "logo", "children", "layers"];
var useStyles$x = makeStyles(function (theme) {
  return {
    root: {}
  };
});
var AriaMapLayout = function AriaMapLayout(_ref) {
  var controlPanelProps = _ref.controlPanelProps,
    mapProps = _ref.mapProps,
    controls = _ref.controls,
    logo = _ref.logo,
    children = _ref.children,
    others = _objectWithoutPropertiesLoose(_ref, _excluded$4);
  var classes = useStyles$x();
  var _useTranslation = useTranslation();
  var mapObj = React.useRef(null);
  var onChangeOpenDrawerHandler = React.useCallback(function (open) {
    setTimeout(function () {
      if (mapObj && mapObj.current) {
        mapObj.current.leafletElement.invalidateSize({
          pan: true
        });
      }
    }, 300);
  });
  console.log("========== LOG FROM AriaMapLayout");
  return /*#__PURE__*/React.createElement(AriaLayout, _extends({
    withDrawer: true,
    appbar: /*#__PURE__*/React.createElement(AriaAppBar, {
      logo: logo,
      title: process.env.REACT_APP_SITE
    }),
    controlPanelProps: _extends({
      withToolbar: true
    }, controlPanelProps),
    onChangeOpenDrawer: onChangeOpenDrawerHandler,
    controls: controls
  }, others), /*#__PURE__*/React.createElement(AriaMap, _extends({
    mapObj: mapObj
  }, mapProps), children));
};
AriaMapLayout.propTypes = {};

var useStyles$y = makeStyles(function (theme) {
  return {
    root: {
      height: '100%'
    },
    map: {
      borderRadius: '10px'
    },
    button: {
      position: 'absolute',
      zIndex: '4000',
      right: '1%',
      bottom: '5%',
      backgroundColor: 'white',
      border: '2px solid rgba(0,0,0,0.2)',
      '&:hover': {
        backgroundColor: '#cccccc'
      }
    },
    analytics: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      width: '25%',
      maxWidth: '300px'
    },
    select: {
      fontSize: theme.typography.body1.fontSize,
      padding: 0,
      backgroundColor: '#3ba4b3'
    },
    dateInfo: {
      display: 'flex',
      height: 'min-content',
      backgroundColor: '#e1f4ff',
      textAlign: 'center',
      padding: '2px',
      borderRadius: '5px'
    },
    toolbar: {
      position: 'absolute',
      display: 'flex',
      zIndex: '500',
      justifyContent: 'space-between',
      width: 'calc(100% - 50px)',
      marginLeft: '50px',
      marginTop: theme.spacing(1)
    },
    warning: {
      color: 'red',
      display: 'flex'
    },
    circle: {
      borderRadius: "50%",
      width: "15px",
      height: "15px",
      border: "2px solid black",
      alignSelf: 'center'
    },
    square: {
      width: "15px",
      height: "15px",
      border: "2px solid black",
      alignSelf: 'center'
    },
    line: {
      marginTop: '2vh',
      border: '1px black solid',
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      paddingLeft: '1%',
      paddingRight: '1%',
      flexWrap: 'wrap'
    },
    cardContent: {
      padding: 0,
      '&:last-child': {
        paddingBottom: 0
      },
      width: '20vw'
    }
  };
});
var DashboardMap = (function (_ref) {
  var domainVars = _ref.domainVars,
    globalGroupSelected = _ref.globalGroupSelected;
  var classes = useStyles$y();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0],
    dispatch = _useAriaAppStore[1];
  console.log(store, 'STORE: ');
  var baseLayers = getBaseLayers();
  var dataset = store['dataset'];
  var emis_sensors = store['emission_sensors'];
  var receptors = store['receptors'];
  var client = store['client'];
  var sourcesContributionGroups = store['sources_contribution_groups'];
  var regulations = store['regulations'];
  var _React$useState = React.useState(undefined),
    variable = _React$useState[0],
    setVariable = _React$useState[1];
  var _React$useState2 = React.useState(undefined),
    sensorsValues = _React$useState2[0],
    setSensorsValues = _React$useState2[1];
  var _React$useState3 = React.useState({}),
    setReceptorsValues = _React$useState3[1];
  var _React$useState4 = React.useState(undefined),
    tileLayer = _React$useState4[0],
    setTileLayer = _React$useState4[1];
  var _React$useState5 = React.useState(globalGroupSelected || sourcesContributionGroups[0]),
    groupMap = _React$useState5[0],
    setGroupMap = _React$useState5[1];
  var _React$useState6 = React.useState(false),
    noSimulationData = _React$useState6[0],
    setNoSimulationData = _React$useState6[1];
  var is_atomic = 1;
  var opacity = 0.7;
  var k_level = 0;
  var _React$useState7 = React.useState(new Date()),
    currentDate = _React$useState7[0];
  React.useEffect(function () {
    if (groupMap == 'AQI') {
      setVariable(undefined);
    } else if (dataset.variables) {
      var variables = dataset.variables.filter(function (v) {
        return v.group == groupMap && v.isTotal == 1;
      });
      setVariable(variables[0]);
    }
  }, [dataset, groupMap]);
  React.useEffect(function () {
    setGroupMap(globalGroupSelected);
  }, [globalGroupSelected]);
  React.useEffect(function () {
    console.log(sensorsValues, ' sensorsValues');
  }, [sensorsValues]);
  React.useEffect(function () {
    if (!emis_sensors) return;
    var feats = _extends({}, emis_sensors);
    if (typeof feats === 'object' && currentDate && client && client.token) {
      var pp = [];
      var qp = {
        obs_type: 'aq',
        time: parseTime(currentDate, '{y}-{m}-{d}T{h}:00:00', true)
      };
      var _feats = {};
      if (Array.isArray(feats)) {
        feats.forEach(function (r) {
          _feats[r.code] = r;
        });
      } else {
        _feats = feats;
      }
      var _url = getUrlService({
        version: process.env.REACT_APP_OBS_API_VERSION || '',
        name: process.env.REACT_APP_OBS_API + '/stations'
      }, pp, qp, true);
      fetch(_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          'X-ARIA-CLIENT-TOKEN': client.token
        },
        body: JSON.stringify(_feats)
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        log(json, '--- Get AQ sensors values response ---');
        if (json.data) {
          if (json.data.length != 0 && json.data.values) setSensorsValues(json.data.values);
        }
      });
    }
  }, [currentDate, emis_sensors]);
  React.useEffect(function () {
    if (!receptors) return;
    setNoSimulationData(false);
    var feats = _extends({}, receptors);
    if (typeof feats === 'object' && currentDate && client && client.token && variable) {
      var qp = {
        variables: variable.name,
        epsg: dataset.epsg,
        time: parseTime(currentDate, '{y}-{m}-{d}T{h}:00:00', true),
        is_atomic: 1,
        tsmin: -1000
      };
      var pp = ['value', dataset.name];
      var _feats = {};
      if (Array.isArray(feats)) {
        feats.forEach(function (r) {
          _feats[r.id] = r;
        });
      } else {
        _feats = feats;
      }
      log(_feats, 'Feats');
      var _url = getUrlService('points', pp, qp, true);
      log(_url, '*** URL Get values ***');
      fetch(_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        },
        body: JSON.stringify(_feats)
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        log(json, '--- Get values response ---');
        if (json.data) {
          setReceptorsValues(json.data[variable.name].values);
        }
      })["catch"](function (err) {
        setNoSimulationData(true);
      });
    }
  }, [currentDate, variable, receptors]);
  React.useEffect(function () {
    var dateIn = currentDate;
    var time;
    if (dateIn instanceof Date) {
      dateIn = parseTime(currentDate, '{y}{m}{d}');
      time = parseTime(currentDate, '{y}-{m}-{d}T{h}:00:00');
    }
    if (!dataset || !variable) {
      setTileLayer(undefined);
      return undefined;
    }
    if (isEmpty(dataset.name) || isEmpty(dateIn) || isEmpty(variable.name) || isEmpty(time)) {
      setTileLayer(undefined);
    }
    setTileLayer({
      baseURL: process.env.REACT_APP_BASE_API,
      token: process.env.REACT_APP_ARIOTE_APIKEY,
      dataset: dataset.name,
      site: dataset["case"],
      epsg: dataset.epsg || epsg,
      variable: variable.name,
      currdate: dateIn,
      currTime: time,
      modifier: undefined,
      timeavg: undefined,
      stat: undefined,
      is_atomic: is_atomic,
      opacity: opacity,
      k_level: k_level,
      groupMap: groupMap
    });
  }, [groupMap, variable]);
  var expandMap = function expandMap() {
    dispatch({
      type: 'SET_WINDOW_TYPE',
      value: 'monitoring'
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Map, {
    zoom: 15,
    bounds: domainVars.domain.bounds,
    className: classes.map
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.toolbar
  }, /*#__PURE__*/React.createElement(FormControl, {
    size: "small"
  }, /*#__PURE__*/React.createElement(Select$1, {
    autoWidth: true,
    value: groupMap,
    onChange: function onChange(e) {
      setGroupMap(e.target.value);
    },
    className: classes.select,
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(MenuItem$1, {
    disableRipple: true,
    className: classes.choice,
    key: globalGroupSelected,
    value: globalGroupSelected
  }, globalGroupSelected), sourcesContributionGroups.map(function (gp) {
    return /*#__PURE__*/React.createElement(MenuItem$1, {
      disableRipple: true,
      className: classes.choice,
      key: gp,
      value: gp
    }, gp);
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.dateInfo
  }, /*#__PURE__*/React.createElement(AccessTime, null), /*#__PURE__*/React.createElement(Typography$1, null, parseTime(currentDate, ' {d}/{m}/{y} {h}:00')), noSimulationData && /*#__PURE__*/React.createElement("div", {
    className: classes.warning
  }, "\xA0", /*#__PURE__*/React.createElement(Warning, null), /*#__PURE__*/React.createElement(Typography$1, null, " ", t('Dashboard.No_simulation'), " "))), /*#__PURE__*/React.createElement("div", null)), /*#__PURE__*/React.createElement(LayersControl, {
    position: "bottomleft"
  }, /*#__PURE__*/React.createElement(LayersControl.BaseLayer, {
    name: "OpenStreetMap FR"
  }, /*#__PURE__*/React.createElement(TileLayer, {
    attribution: baseLayers.osmfr.attribution,
    url: baseLayers.osmfr.url
  })), /*#__PURE__*/React.createElement(LayersControl.BaseLayer, {
    name: "Mapbox"
  }, /*#__PURE__*/React.createElement(TileLayer, {
    attribution: baseLayers.mapBox.attribution,
    url: baseLayers.mapBox.url
  })), /*#__PURE__*/React.createElement(LayersControl.BaseLayer, {
    name: "GOOGLE Satellite"
  }, /*#__PURE__*/React.createElement(TileLayer, {
    attribution: baseLayers.googleSat.attribution,
    url: baseLayers.googleSat.url
  })), /*#__PURE__*/React.createElement(LayersControl.BaseLayer, {
    name: "IGN",
    checked: true
  }, /*#__PURE__*/React.createElement(TileLayer, {
    attribution: baseLayers.IGN.attribution,
    url: baseLayers.IGN.url
  })), tileLayer && /*#__PURE__*/React.createElement(LayersControl.Overlay, {
    name: '<p style="font-size:125% ; display:inline">' + '<img src="https://gitlab.com/T-Huard/images/-/raw/main/panache.png"  width="14" height="14"> ' + t('Map.Data') + '</p>',
    checked: true
  }, /*#__PURE__*/React.createElement(AriaDataTileLayer, tileLayer)), domainVars.domain.polygon && /*#__PURE__*/React.createElement(LayersControl.Overlay, {
    name: '<p style="font-size:125% ; display:inline">' + '<img src="https://gitlab.com/T-Huard/images/-/raw/main/domain.png"  width="14" height="14"> ' + t('Map.Domain') + '</p>',
    checked: true
  }, /*#__PURE__*/React.createElement(Polygon, {
    positions: domainVars.domain.polygon,
    color: 'black',
    fill: false
  })), Object.keys(emis_sensors).length > 0 && /*#__PURE__*/React.createElement(LayersControl.Overlay, {
    name: '<div style="display:inline-flex"> <div style="border:black solid;width: 14px ;height:14px; align-self:center;margin-right:6px; border-radius:50%"></div> ' + '<text style="font-size:125%">' + t('Map.Air_quality_sensors') + '</text></div>',
    checked: true
  }, /*#__PURE__*/React.createElement(FeatureGroup, {
    name: "sensors",
    attribution: ""
  }, Object.keys(emis_sensors).map(function (src_key, index) {
    if (!emis_sensors[src_key].latitude || !emis_sensors[src_key].longitude) return null;
    return /*#__PURE__*/React.createElement(ShapeMarker$1, {
      key: index,
      center: [emis_sensors[src_key].latitude, emis_sensors[src_key].longitude],
      shape: "circle",
      radius: 7,
      weight: 1.5,
      color: 'black',
      fillColor: sensorsValues && groupMap != 'AQI' ? searchColorByRegulation(sensorsValues[src_key][groupMap], searchRegulationByPollutant(regulations, groupMap)) : 'grey',
      fillOpacity: 1
    }, /*#__PURE__*/React.createElement(Popup, {
      minWidth: "1000px"
    }, /*#__PURE__*/React.createElement(Card, {
      elevation: 0
    }, /*#__PURE__*/React.createElement(CardContent, {
      className: classes.cardContent
    }, /*#__PURE__*/React.createElement(Typography$1, {
      style: {
        textAlign: 'center'
      },
      gutterBottom: true,
      variant: "h6",
      component: "h2"
    }, /*#__PURE__*/React.createElement("span", null, emis_sensors[src_key].name))))));
  })))), /*#__PURE__*/React.createElement(Tooltip$1, {
    title: t('Dashboard.Expand_map')
  }, /*#__PURE__*/React.createElement(Button$1, {
    className: classes.button,
    size: "large",
    onClick: expandMap
  }, /*#__PURE__*/React.createElement(SettingsOverscanTwoTone, null)))));
});

var useStyles$z = makeStyles(function (theme) {
  return {
    root: {
      width: '99%',
      height: '100%',
      marginLeft: '1%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      overflow: 'hidden'
    },
    histogram: {
      height: '100%',
      width: '100%'
    }
  };
});
function dynamicColors$2() {
  var r = Math.floor(Math.random() * 255);
  var g = Math.floor(Math.random() * 255);
  var b = Math.floor(Math.random() * 255);
  return "rgb(" + r + "," + g + "," + b + ")";
}
var HistogramChart = (function (_ref) {
  var globalGroupSelected = _ref.globalGroupSelected,
    sensorsSelected = _ref.sensorsSelected,
    date = _ref.date,
    details = _ref.details,
    currentRegulation = _ref.currentRegulation;
  var classes = useStyles$z();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0];
  var client = store['client'];
  var _React$useState = React.useState(undefined),
    rowValues = _React$useState[0],
    setRowValues = _React$useState[1];
  var _React$useState2 = React.useState(undefined),
    labels = _React$useState2[0],
    setLabels = _React$useState2[1];
  var _React$useState3 = React.useState([]),
    datasets = _React$useState3[0],
    setDatasets = _React$useState3[1];
  var _React$useState4 = React.useState(false),
    loading = _React$useState4[0],
    setLoading = _React$useState4[1];
  var _React$useState5 = React.useState(undefined),
    unit = _React$useState5[0],
    setUnit = _React$useState5[1];
  var _React$useState6 = React.useState(0),
    firstVisibleLabel = _React$useState6[0],
    setFirstVisibleLabel = _React$useState6[1];
  var _React$useState7 = React.useState(undefined),
    options = _React$useState7[0],
    setOptions = _React$useState7[1];
  var chartRef = React.useRef(null);
  var _React$useState8 = React.useState(false),
    redrawTime = _React$useState8[0],
    setRedrawTime = _React$useState8[1];
  React.useEffect(function () {
    if (!rowValues) return;
    setFirstVisibleLabel(0);
    var _labels = Object.keys(rowValues);
    _labels.reverse();
    var sensors = [].concat(sensorsSelected);
    var moyenneDatasetName = {
      id: 'average',
      name: t('TimeseriesScale.Average')
    };
    sensors.push(moyenneDatasetName);
    sensors.reverse();
    var _datasets = [];
    for (var _iterator = _createForOfIteratorHelperLoose(sensors), _step; !(_step = _iterator()).done;) {
      var sensor = _step.value;
      var _dataset = {};
      var id_sensor = sensor.id;
      var name_sensor = sensor.name;
      _dataset['data'] = [];
      _dataset['label'] = name_sensor;
      if (id_sensor === 'average' && currentRegulation) {
        _dataset['backgroundColor'] = [];
        for (var _iterator2 = _createForOfIteratorHelperLoose(_labels), _step2; !(_step2 = _iterator2()).done;) {
          var _label = _step2.value;
          var meanValue = meanOfArray(Object.values(rowValues[_label]));
          _dataset['data'].push(meanValue);
          _dataset['backgroundColor'].push(searchColorByRegulation(meanValue, currentRegulation));
        }
      } else {
        _dataset['backgroundColor'] = dynamicColors$2();
        for (var _iterator3 = _createForOfIteratorHelperLoose(_labels), _step3; !(_step3 = _iterator3()).done;) {
          var _label2 = _step3.value;
          _dataset['data'].push(rowValues[_label2][id_sensor]);
        }
      }
      _datasets.push(_dataset);
    }
    var _labelsTraducted = _labels.map(function (label) {
      return t('TimeseriesScale.' + label);
    });
    setLabels(_labelsTraducted);
    setDatasets(_datasets);
  }, [rowValues]);
  var lastRequestIdRef = React.useRef(0);
  React.useEffect(function () {
    if (globalGroupSelected && sensorsSelected && date) {
      setLoading(true);
      var sensorsSelectedIds = sensorsSelected.map(function (sens) {
        return sens.id;
      });
      var pp = [];
      var qp;
      if (globalGroupSelected === 'AQI') {
        qp = {
          date: date,
          analytic: 1,
          level: 3
        };
      } else {
        qp = {
          date: date,
          "var": globalGroupSelected
        };
      }
      var _url = getUrlService({
        version: process.env.REACT_APP_OBS_API_VERSION || '',
        name: process.env.REACT_APP_OBS_API + '/kpi/analytics'
      }, pp, qp, true);
      var requestId = ++lastRequestIdRef.current;
      fetch(_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          'X-ARIA-CLIENT-TOKEN': client.token
        },
        body: JSON.stringify(sensorsSelectedIds)
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        if (requestId === lastRequestIdRef.current) {
          setLoading(false);
          if (json && json.data) {
            setRowValues(json.data);
          }
        }
      });
    }
  }, [globalGroupSelected, sensorsSelected, date]);
  React.useEffect(function () {
    if (globalGroupSelected == 'AQI') {
      setUnit('');
    } else {
      setUnit('µg/m³');
    }
  }, [globalGroupSelected]);
  var ChangeLegend = function ChangeLegend(pos) {
    if (pos == 'right') {
      setFirstVisibleLabel(firstVisibleLabel + 5);
    }
    if (pos == 'left') {
      if (firstVisibleLabel - 5 < 0) {
        setFirstVisibleLabel(0);
      } else {
        setFirstVisibleLabel(firstVisibleLabel - 5);
      }
    }
  };
  React.useEffect(function () {
    setRedrawTime(true);
    setTimeout(function () {
      setRedrawTime(false);
    }, "100");
  }, [details]);
  React.useEffect(function () {
    var _options = {
      backgroundRules: backgroundRules,
      legend: {
        labels: {
          generateLabels: function generateLabels(chart) {
            var original = Chart$1.defaults.global.legend.labels.generateLabels;
            Chart$1.defaults.global.legend.labels.generateLabels = function (chart) {
              var labels = original.call(this, chart);
              labels.forEach(function (label) {
                if (label.datasetIndex !== undefined) {
                  label.text = label.text.substring(0, 6) + "..";
                }
              });
              return labels;
            };
            var labels = Chart$1.defaults.global.legend.labels.generateLabels.call(this, chart);
            Chart$1.defaults.global.legend.labels.generateLabels = original;
            var labels_sliced = [];
            for (var i = firstVisibleLabel; i < firstVisibleLabel + 5; i++) {
              if (labels[i]) labels_sliced.push(labels[i]);
            }
            return labels_sliced;
          }
        },
        display: true
      },
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        x: {
          stacked: true
        },
        y: {
          stacked: true
        },
        yAxes: [{
          ticks: {
            beginAtZero: true
          },
          scaleLabel: {
            display: true,
            labelString: globalGroupSelected.split("-")[0] + parseUnit(unit)
          }
        }]
      },
      tooltips: {
        callbacks: {
          label: function label(tooltipItem, data) {
            var dataset = data.datasets[tooltipItem.datasetIndex];
            var currentValue = dataset.data[tooltipItem.index];
            var currentLabel = dataset.label;
            return currentLabel + " : " + currentValue.toFixed(2) + unit;
          }
        }
      }
    };
    setOptions(_options);
  }, [firstVisibleLabel, backgroundRules, details, globalGroupSelected]);
  var optionsAVG = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        stacked: true
      },
      y: {
        stacked: true
      },
      yAxes: [{
        ticks: {
          beginAtZero: true
        },
        scaleLabel: {
          display: true,
          labelString: globalGroupSelected.split("-")[0] + parseUnit(unit)
        }
      }]
    },
    legend: {
      display: false
    },
    tooltips: {
      callbacks: {
        label: function label(tooltipItem, data) {
          var dataset = data.datasets[tooltipItem.datasetIndex];
          var currentValue = dataset.data[tooltipItem.index];
          var currentLabel = dataset.label;
          return currentLabel + " : " + currentValue.toFixed(2) + " " + unit;
        }
      }
    }
  };
  var _React$useState9 = React.useState(undefined),
    backgroundRules = _React$useState9[0],
    setBackgroundRules = _React$useState9[1];
  function addBackgroundColors(chart) {
    var rules = chart.chart.options.backgroundRules;
    if (!rules) return;
    var ctx = chart.chart.ctx;
    var yAxis = chart.chart.scales["y-axis-0"];
    var xaxis = chart.chart.scales["x-axis-0"];
    for (var i = 0; i < rules.length; ++i) {
      var yAxisSegement = rules[i].yAxisSegement > yAxis.ticksAsNumbers[0] ? yAxis.ticksAsNumbers[0] : rules[i].yAxisSegement;
      var yAxisPosStart = yAxis.height - yAxisSegement * yAxis.height / yAxis.ticksAsNumbers[0] + chart.chart.controller.chartArea.top;
      var yAxisPosEnd = i === 0 ? yAxis.height : yAxis.height - rules[i - 1].yAxisSegement * yAxis.height / yAxis.ticksAsNumbers[0];
      ctx.fillStyle = rules[i].backgroundColor;
      if (yAxisPosEnd - yAxisPosStart + chart.chart.controller.chartArea.top < 0) {
        ctx.fillRect(xaxis.left, yAxisPosStart, xaxis.width, 0);
      } else {
        ctx.fillRect(xaxis.left, yAxisPosStart, xaxis.width, yAxisPosEnd - yAxisPosStart + chart.chart.controller.chartArea.top);
      }
    }
  }
  React.useEffect(function () {
    if (!currentRegulation) {
      setBackgroundRules(undefined);
    } else {
      var backgroundRulesOfPullutant = [];
      var thresholds = currentRegulation['Thresholds'];
      thresholds.forEach(function (thresh, index) {
        var level = 0;
        if (thresholds[index + 1]) {
          level = thresholds[index + 1].Level;
        } else {
          level = Infinity;
        }
        if (thresh.Color) {
          backgroundRulesOfPullutant.push({
            backgroundColor: addAlpha(thresh.Color, 0.2),
            yAxisSegement: level
          });
        }
      });
      setBackgroundRules(backgroundRulesOfPullutant);
    }
  }, [currentRegulation]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, loading ? /*#__PURE__*/React.createElement(CircularProgress, {
    size: 60,
    style: {
      margin: '15%'
    }
  }) : labels && datasets[0] && (details ? /*#__PURE__*/React.createElement("div", {
    className: classes.histogram,
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement(Bar, {
    ref: chartRef,
    options: options,
    data: {
      labels: labels,
      datasets: datasets
    },
    plugins: [{
      beforeDraw: addBackgroundColors
    }],
    redraw: redrawTime
  }), datasets.length > 5 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      top: '3%',
      left: '1%'
    }
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return ChangeLegend('left');
    }
  }, '<', " ")), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      top: '3%',
      right: '1%'
    }
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return ChangeLegend('right');
    }
  }, '>', " ")))) : /*#__PURE__*/React.createElement("div", {
    className: classes.histogram
  }, /*#__PURE__*/React.createElement(Bar, {
    options: optionsAVG,
    data: {
      labels: labels,
      datasets: [datasets[0]]
    },
    redraw: redrawTime
  }))));
});
function parseUnit(unit) {
  if (!unit) return '';
  return ' (' + unit + ')';
}

var useStyles$A = makeStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      width: '100%',
      overflow: 'auto'
    },
    date: {
      width: '40%'
    },
    buttonNonSelected: {},
    buttonSelected: {
      backgroundColor: '#d9e7fc'
    },
    selectAllText: {
      fontWeight: '500'
    },
    title: {
      display: 'flex',
      justifyContent: 'center',
      border: 'solid 0.5px #92c6cf',
      background: '#ddf5fa',
      borderRadius: '10px'
    }
  };
});
var ITEM_HEIGHT = 48;
var ITEM_PADDING_TOP = 8;
var DashboardHistogram = (function (_ref) {
  var title = _ref.title,
    globalGroupSelected = _ref.globalGroupSelected,
    currentRegulation = _ref.currentRegulation,
    sensorsListFiltered = _ref.sensorsListFiltered;
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0];
  log(store, 'STORE in DashboardHistogram: ');
  var classes = useStyles$A();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _React$useState = React.useState(undefined),
    date = _React$useState[0],
    setDate = _React$useState[1];
  var _React$useState2 = React.useState(undefined),
    dateUTC = _React$useState2[0],
    setDateUTC = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    details = _React$useState3[0],
    setDetails = _React$useState3[1];
  var _React$useState4 = React.useState([]),
    selectedSensorsTemp = _React$useState4[0],
    setSelectedSensorsTemp = _React$useState4[1];
  var _React$useState5 = React.useState([]),
    selectedSensors = _React$useState5[0],
    setSelectedSensors = _React$useState5[1];
  var anchorRef = React.useRef(null);
  var isAllSelected = sensorsListFiltered.length > 0 && selectedSensorsTemp.length === sensorsListFiltered.length;
  React.useEffect(function () {
    if (sensorsListFiltered.length > 0) {
      setSelectedSensorsTemp(sensorsListFiltered);
      setSelectedSensors(sensorsListFiltered);
    }
  }, [sensorsListFiltered]);
  var MenuProps = {
    variant: "menu",
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    getContentAnchorEl: null,
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250
      }
    }
  };
  var handleChange = function handleChange(event) {
    var value = event.target.value;
    var value1 = event.target.value;
    if (value1[value1.length - 1] === "all") {
      setSelectedSensorsTemp(selectedSensorsTemp.length === sensorsListFiltered.length ? [] : sensorsListFiltered);
    } else {
      setSelectedSensorsTemp(typeof value === 'string' ? value.split(',') : value);
    }
  };
  var handleClose = function handleClose() {
    if (!verifyListSensorsIdentical(selectedSensorsTemp, selectedSensors)) {
      setSelectedSensors(selectedSensorsTemp);
    }
  };
  var handleCloseDate = function handleCloseDate() {
    if (date) {
      var dateParsed = parseTime(date, '{y}-{m}-{d}T{h}:00:00', true);
      setDateUTC(dateParsed);
    }
  };
  React.useEffect(function () {
    setDetails(false);
  }, [selectedSensors, dateUTC, globalGroupSelected]);
  React.useEffect(function () {
    var today = new Date();
    today.setMinutes(0, 0, 0, 0);
    setDate(today);
    setDateUTC(parseTime(today, '{y}-{m}-{d}T{h}:00:00', true));
  }, [globalGroupSelected]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      padding: 8,
      display: 'flex',
      justifyContent: 'space-around'
    }
  }, /*#__PURE__*/React.createElement(FormControl, {
    size: "small",
    variant: "outlined",
    style: {
      width: '40%'
    }
  }, /*#__PURE__*/React.createElement(InputLabel, {
    id: "sensors"
  }, t('Dashboard.Sensors')), /*#__PURE__*/React.createElement(Select$1, {
    ref: anchorRef,
    labelId: "sensors",
    variant: "outlined",
    label: t('Dashboard.Sensors'),
    multiple: true,
    value: selectedSensorsTemp,
    onChange: handleChange,
    onClose: handleClose,
    input: /*#__PURE__*/React.createElement(OutlinedInput, {
      label: t('Dashboard.Sensors')
    }),
    renderValue: function renderValue(selected) {
      var names = selected.map(function (sensor) {
        return sensor.name;
      });
      if (names.length == sensorsListFiltered.length) {
        return t('Dashboard.All');
      }
      return names.join(', ');
    },
    MenuProps: MenuProps
  }, /*#__PURE__*/React.createElement(MenuItem$1, {
    key: 'all',
    value: 'all',
    autoFocus: true
  }, /*#__PURE__*/React.createElement(Checkbox$1, {
    color: "primary",
    checked: isAllSelected
  }), /*#__PURE__*/React.createElement(ListItemText, {
    primary: /*#__PURE__*/React.createElement(Typography, {
      style: {
        fontWeight: '600'
      }
    }, " ", t('Dashboard.Select_all'), " ")
  })), sensorsListFiltered && sensorsListFiltered.map(function (sensor) {
    var sensorName = sensor.name;
    return /*#__PURE__*/React.createElement(MenuItem$1, {
      key: sensorName,
      value: sensor
    }, /*#__PURE__*/React.createElement(Checkbox$1, {
      color: "primary",
      checked: selectedSensorsTemp.indexOf(sensor) > -1
    }), /*#__PURE__*/React.createElement(ListItemText, {
      primary: sensorName
    }));
  }))), /*#__PURE__*/React.createElement(DateTimePicker, {
    size: "small",
    className: classes.date,
    label: t('Dashboard.Date_hour'),
    disableToolbar: true,
    autoOk: true,
    minutesStep: 60,
    inputVariant: "outlined",
    variant: "inline",
    ampm: false,
    value: date,
    onClose: handleCloseDate,
    onChange: function onChange(dateval) {
      return setDate(dateval.toDate());
    },
    maxDate: date,
    format: "DD/MM/YY HH:mm",
    onKeyDown: function onKeyDown(e) {
      return e.preventDefault();
    },
    disabled: globalGroupSelected == 'AQI'
  }), /*#__PURE__*/React.createElement("button", {
    className: details ? classes.buttonSelected : classes.buttonNonSelected,
    onClick: function onClick() {
      return setDetails(!details);
    },
    disabled: globalGroupSelected == 'AQI'
  }, t('Dashboard.View_more'))), /*#__PURE__*/React.createElement(HistogramChart, {
    globalGroupSelected: globalGroupSelected,
    sensorsSelected: selectedSensors,
    date: dateUTC,
    details: details,
    currentRegulation: currentRegulation
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, /*#__PURE__*/React.createElement(Info, {
    color: "primary"
  }), /*#__PURE__*/React.createElement(Typography, {
    style: {
      paddingLeft: '1%'
    }
  }, title)));
});

var useStyles$B = makeStyles(function (theme) {
  return {
    root: {
      height: '100%',
      width: '100%',
      textAlign: 'center',
      overflow: 'hidden'
    },
    donut: {
      height: '95%',
      width: '100%'
    }
  };
});
var DoughnutChart = (function (_ref) {
  var currentRegulation = _ref.currentRegulation,
    valuesParsed = _ref.valuesParsed;
  var classes = useStyles$B();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0];
  var _React$useState = React.useState([]),
    datasets = _React$useState[0],
    setDatasets = _React$useState[1];
  var _React$useState2 = React.useState(undefined),
    labels = _React$useState2[0],
    setLabels = _React$useState2[1];
  console.log(store, 'STORE: ');
  React.useEffect(function () {
    log(valuesParsed, 'RowValues PieChart Dashboard');
    if (!valuesParsed || !currentRegulation) {
      setLabels(undefined);
      setDatasets([]);
    } else {
      var data = [];
      var colors = [];
      var _labels = [];
      var thresholds = currentRegulation['Thresholds'];
      thresholds.forEach(function (thresh, index) {
        _labels.push(t('AirQualityScale.' + thresh.Label));
        var cpt = 0;
        valuesParsed.map(function (station) {
          if (station.threshold == thresh.Label) cpt += 1;
        });
        colors.push(thresh.Color);
        data.push(cpt);
      });
      _labels.push(t('AirQualityScale.No_data'));
      colors.push('#d9d9d9');
      data.push(Object.keys(valuesParsed).length - 1 - data.reduce(function (a, b) {
        return a + b;
      }, 0));
      setLabels(_labels);
      setDatasets([{
        data: data,
        backgroundColor: colors,
        label: 'Values of stations last 24h ',
        borderWidth: 1
      }]);
    }
  }, [valuesParsed, currentRegulation]);
  var options = {
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
      mode: 'index',
      callbacks: {
        label: function label(tooltipItems, data) {
          var i = tooltipItems.index;
          return data.labels[i] + ": " + data.datasets[0].data[i] + ' ' + (data.datasets[0].data[i] == 1 ? t('Dashboard.Sensor') : t('Dashboard.Sensors'));
        }
      }
    },
    legend: {
      position: 'right',
      display: true,
      labels: {
        generateLabels: function generateLabels(chart) {
          var data = chart.data;
          if (data.labels.length && data.datasets.length) {
            return data.labels.map(function (label, i) {
              var meta = chart.getDatasetMeta(0);
              var ds = data.datasets[0];
              var arc = meta.data[i];
              var custom = arc && arc.custom || {};
              var getValueAtIndexOrDefault = Chart.helpers.getValueAtIndexOrDefault;
              var arcOpts = chart.options.elements.arc;
              var fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
              var stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
              var bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);
              var truncatedLabel = label.length > 10 ? label.slice(0, 10) + "..." : label;
              return {
                text: truncatedLabel,
                fillStyle: fill,
                strokeStyle: stroke,
                lineWidth: bw,
                hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
                index: i
              };
            });
          }
          return [];
        }
      }
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, labels && datasets[0] && /*#__PURE__*/React.createElement("div", {
    className: classes.donut
  }, /*#__PURE__*/React.createElement(Doughnut, {
    options: options,
    data: {
      labels: labels,
      datasets: datasets
    }
  })));
});

var useStyles$C = makeStyles(function (theme) {
  return {
    root: {
      height: '100%',
      width: '100%',
      textAlign: 'center',
      overflow: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888888 rgba(0, 0, 0, 0)'
    },
    details: {}
  };
});
var DoughnutDetails = (function (_ref) {
  var currentRegulation = _ref.currentRegulation,
    valuesParsed = _ref.valuesParsed;
  var classes = useStyles$C();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0];
  var sensors = store['emission_sensors'];
  var _React$useState = React.useState(undefined),
    stationsDetails = _React$useState[0],
    setsStationDetails = _React$useState[1];
  console.log(store, 'STORE: ');
  React.useEffect(function () {
    log(valuesParsed, 'valuesParsed PieChart Dashboard');
    if (!valuesParsed || !currentRegulation) {
      setsStationDetails(undefined);
    } else {
      var valuesParsedCopy = [].concat(valuesParsed);
      var stationsWithName = valuesParsedCopy.map(function (sta) {
        Object.values(sensors).map(function (sensorInfos) {
          if (sensorInfos.id == sta.id) {
            sta['name'] = sensorInfos.name;
          }
        });
        return sta;
      });
      var stationsSorted = [].concat(stationsWithName).sort(function (a, b) {
        return b.level - a.level;
      });
      setsStationDetails(stationsSorted);
    }
  }, [valuesParsed, currentRegulation]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.details
  }, /*#__PURE__*/React.createElement(List$1, null, stationsDetails && stationsDetails.map(function (station) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, station.name && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ListItem$1, {
      button: true,
      divider: true,
      disablePadding: true
    }, /*#__PURE__*/React.createElement(Tooltip$1, {
      title: t('AirQualityScale.' + station.threshold)
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        backgroundColor: station.color,
        width: '16px',
        height: '16px',
        marginRight: '1%'
      }
    }, " ")), /*#__PURE__*/React.createElement(ListItemText, {
      primary: station.name
    })), /*#__PURE__*/React.createElement(Divider$1, null)));
  }))));
});

var useStyles$D = makeStyles(function (theme) {
  var _date;
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      width: '100%'
    },
    buttonNonSelected: {},
    buttonSelected: {
      backgroundColor: '#d9e7fc'
    },
    card: {
      height: '100%',
      width: "100%"
    },
    progressBar: {
      height: '100%',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    title: {
      display: 'flex',
      justifyContent: 'center',
      border: 'solid 0.5px #92c6cf',
      background: '#ddf5fa',
      borderRadius: '10px'
    },
    date: (_date = {
      maxHeight: '40px',
      border: '1px solid #b5bebf',
      padding: '4px',
      whiteSpace: 'nowrap',
      borderRadius: '5px'
    }, _date["padding"] = '1%', _date.textAlign = 'center', _date.width = '40%', _date)
  };
});
var ITEM_HEIGHT$1 = 48;
var ITEM_PADDING_TOP$1 = 8;
var DashboardKPI = (function (_ref) {
  var title = _ref.title,
    globalGroupSelected = _ref.globalGroupSelected,
    currentRegulation = _ref.currentRegulation,
    sensorsListFiltered = _ref.sensorsListFiltered;
  var classes = useStyles$D();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0];
  var client = store['client'];
  var _React$useState = React.useState(false),
    details = _React$useState[0],
    setDetails = _React$useState[1];
  var _React$useState2 = React.useState(false),
    loading = _React$useState2[0],
    setLoading = _React$useState2[1];
  var _React$useState3 = React.useState(undefined),
    rowValues = _React$useState3[0],
    setRowValues = _React$useState3[1];
  var _React$useState4 = React.useState(undefined),
    valuesParsed = _React$useState4[0],
    setValuesParsed = _React$useState4[1];
  var lastRequestIdRef = React.useRef(0);
  var _React$useState5 = React.useState([]),
    selectedSensorsTemp = _React$useState5[0],
    setSelectedSensorsTemp = _React$useState5[1];
  var _React$useState6 = React.useState([]),
    selectedSensors = _React$useState6[0],
    setSelectedSensors = _React$useState6[1];
  var anchorRef = React.useRef(null);
  var isAllSelected = sensorsListFiltered.length > 0 && selectedSensorsTemp.length === sensorsListFiltered.length;
  React.useEffect(function () {
    if (sensorsListFiltered.length > 0) {
      setSelectedSensorsTemp(sensorsListFiltered);
      setSelectedSensors(sensorsListFiltered);
    }
  }, [sensorsListFiltered]);
  var MenuProps = {
    variant: "menu",
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    getContentAnchorEl: null,
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT$1 * 4.5 + ITEM_PADDING_TOP$1,
        width: 250
      }
    }
  };
  var handleChange = function handleChange(event) {
    var value = event.target.value;
    var value1 = event.target.value;
    if (value1[value1.length - 1] === "all") {
      setSelectedSensorsTemp(selectedSensorsTemp.length === sensorsListFiltered.length ? [] : sensorsListFiltered);
    } else {
      setSelectedSensorsTemp(typeof value === 'string' ? value.split(',') : value);
    }
  };
  var handleClose = function handleClose() {
    if (!verifyListSensorsIdentical(selectedSensorsTemp, selectedSensors)) {
      setSelectedSensors(selectedSensorsTemp);
    }
  };
  React.useEffect(function () {
    if (globalGroupSelected && selectedSensors && currentRegulation) {
      setLoading(true);
      var endDate = new Date();
      var startDate = new Date();
      startDate.setDate(startDate.getDate() - 1);
      var pp = [];
      var qp = {
        start_date: parseTime(startDate, '{y}-{m}-{d}T{h}:00:00', true),
        end_date: parseTime(endDate, '{y}-{m}-{d}T{h}:00:00', true),
        id: currentRegulation['Thresholds'][0]['object_id'],
        level: currentRegulation['Thresholds'][0]['content_type'].substr(currentRegulation['Thresholds'][0]['content_type'].length - 1),
        r_id: currentRegulation.id
      };
      var _url = getUrlService({
        version: process.env.REACT_APP_OBS_API_VERSION || '',
        name: process.env.REACT_APP_OBS_API + '/kpi'
      }, pp, qp, true);
      var requestId = ++lastRequestIdRef.current;
      fetch(_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          'X-ARIA-CLIENT-TOKEN': client.token
        },
        body: JSON.stringify(selectedSensors.map(function (sens) {
          return sens.id;
        }))
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        log(json, 'GET RESPONSE KPI');
        if (requestId === lastRequestIdRef.current) {
          setLoading(false);
          if (json && json.data) {
            setRowValues(json.data);
          }
        }
      });
    } else {
      setRowValues(undefined);
    }
  }, [selectedSensors, currentRegulation]);
  React.useEffect(function () {
    log(rowValues, 'RowValues PieChart Dashboard');
    if (!rowValues || !currentRegulation) {
      setValuesParsed(undefined);
    } else {
      var values = [];
      var thresholds = currentRegulation['Thresholds'];
      var _loop = function _loop() {
        var _Object$entries$_i = _Object$entries[_i],
          stationId = _Object$entries$_i[0],
          threshValues = _Object$entries$_i[1];
        var name = "No_data";
        var color = "#d9d9d9";
        var level = -1;
        thresholds.forEach(function (thresh, index) {
          var key = 'thresh_' + (index + 1).toString();
          if (threshValues[key]) {
            name = thresh.Label;
            color = thresh.Color;
            level = thresh.Level;
          }
        });
        values.push({
          id: stationId,
          threshold: name,
          color: color,
          level: level
        });
      };
      for (var _i = 0, _Object$entries = Object.entries(rowValues); _i < _Object$entries.length; _i++) {
        _loop();
      }
      setValuesParsed(values);
    }
  }, [rowValues, currentRegulation]);
  React.useEffect(function () {
    setDetails(false);
  }, [rowValues]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      padding: 8,
      display: 'flex',
      justifyContent: 'space-around'
    }
  }, /*#__PURE__*/React.createElement(FormControl, {
    size: "small",
    variant: "outlined",
    style: {
      width: '40%'
    }
  }, /*#__PURE__*/React.createElement(InputLabel, {
    id: "sensors"
  }, t('Dashboard.Sensors')), /*#__PURE__*/React.createElement(Select$1, {
    ref: anchorRef,
    labelId: "sensors",
    variant: "outlined",
    label: t('Dashboard.Sensors'),
    multiple: true,
    value: selectedSensorsTemp,
    onChange: handleChange,
    onClose: handleClose,
    input: /*#__PURE__*/React.createElement(OutlinedInput, {
      label: t('Dashboard.Sensors')
    }),
    renderValue: function renderValue(selected) {
      var names = selected.map(function (sensor) {
        return sensor.name;
      });
      if (names.length == sensorsListFiltered.length) {
        return t('Dashboard.All');
      }
      return names.join(', ');
    },
    MenuProps: MenuProps
  }, /*#__PURE__*/React.createElement(MenuItem$1, {
    key: 'all',
    value: 'all',
    autoFocus: true
  }, /*#__PURE__*/React.createElement(Checkbox$1, {
    color: "primary",
    checked: isAllSelected
  }), /*#__PURE__*/React.createElement(ListItemText, {
    primary: /*#__PURE__*/React.createElement(Typography, {
      style: {
        fontWeight: '600'
      }
    }, " ", t('Dashboard.Select_all'), " ")
  })), sensorsListFiltered.length > 0 && sensorsListFiltered.map(function (sensor) {
    var sensorName = sensor.name;
    return /*#__PURE__*/React.createElement(MenuItem$1, {
      key: sensorName,
      value: sensor
    }, /*#__PURE__*/React.createElement(Checkbox$1, {
      color: "primary",
      checked: selectedSensorsTemp.indexOf(sensor) > -1
    }), /*#__PURE__*/React.createElement(ListItemText, {
      primary: sensorName
    }));
  }))), /*#__PURE__*/React.createElement(Typography, {
    className: classes.date
  }, t('Dashboard.Last_24h')), /*#__PURE__*/React.createElement("button", {
    className: details ? classes.buttonSelected : classes.buttonNonSelected,
    onClick: function onClick() {
      return setDetails(!details);
    }
  }, t('Dashboard.View_more'))), loading ? /*#__PURE__*/React.createElement("div", {
    className: classes.progressBar
  }, /*#__PURE__*/React.createElement(CircularProgress, {
    size: 60
  })) : details ? /*#__PURE__*/React.createElement(DoughnutDetails, {
    currentRegulation: currentRegulation,
    valuesParsed: valuesParsed
  }) : /*#__PURE__*/React.createElement(DoughnutChart, {
    currentRegulation: currentRegulation,
    valuesParsed: valuesParsed
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, /*#__PURE__*/React.createElement(Info, {
    color: "primary"
  }), /*#__PURE__*/React.createElement(Typography, {
    style: {
      paddingLeft: '1%'
    }
  }, title)));
});

var useStyles$E = makeStyles(function (theme) {
  return {
    root: {
      height: '100%',
      textAlign: 'center',
      overflowY: 'auto',
      overflowX: 'hidden'
    },
    legend: {},
    line: {
      display: 'flex',
      padding: '2px',
      flexWrap: 'wrap'
    },
    fontStyle: {
      display: 'flex',
      flexDirection: 'column',
      color: '#00000091',
      fontSize: 'min(1vw, 1.5vh)'
    },
    img: {
      marginRight: '1%',
      width: '10%',
      height: '20px',
      border: 'solid 1px white'
    },
    title: {
      backgroundColor: '#0076ff30',
      borderRadius: '5px',
      fontWeight: 'bold'
    }
  };
});

var useStyles$F = makeStyles(function (theme) {
  var _legendSmall;
  return {
    root: {
      height: '100%'
    },
    map: {
      alignSelf: 'center',
      height: '42%',
      border: 'solid black 1px',
      borderRadius: '10px',
      margin: theme.spacing(1),
      minWidth: '400px'
    },
    histo: {
      width: '50%',
      border: 'solid black 1px',
      borderRadius: '10px',
      backgroundColor: 'rgb(235, 247, 249)',
      margin: theme.spacing(1)
    },
    headers: {
      display: 'flex',
      justifyContent: 'space-evenly',
      alignItems: 'center'
    },
    buttons: {
      textAlign: 'center',
      width: '40%',
      minWidth: '480px',
      maxHeight: '50px'
    },
    button: {
      marginLeft: '2px',
      border: '1px solid',
      display: 'inline-block',
      backgroundColor: 'rgb(255 255 255 / 80%)'
    },
    buttonActive: {
      marginLeft: '2px',
      border: '1px solid',
      display: 'inline-block'
    },
    kpis: {
      display: 'flex',
      width: '100%',
      height: '55%'
    },
    legend: {
      border: 'solid black 1px',
      borderRadius: '10px',
      backgroundColor: 'rgb(235, 247, 249)',
      margin: theme.spacing(1)
    },
    dashboardPaper: {
      height: 'calc(100% - 38px)',
      width: '100%'
    },
    legendSmall: (_legendSmall = {}, _legendSmall[theme.breakpoints.between('xs', 'sm')] = {
      visibility: 'hidden'
    }, _legendSmall.backgroundColor = 'white', _legendSmall.display = 'flex', _legendSmall.border = 'solid #aecbff', _legendSmall.alignItems = 'center', _legendSmall.borderRadius = '10px', _legendSmall.maxHeight = '50px', _legendSmall.width = '60%', _legendSmall.overflow = 'auto', _legendSmall.justifyContent = 'space-between', _legendSmall.maxWidth = '830px', _legendSmall),
    coloredRectangle: {
      marginRight: '1%',
      width: '20px',
      height: '15px',
      border: 'solid 1px white'
    },
    legendValue: {
      display: 'flex',
      alignItems: 'center',
      whiteSpace: 'nowrap'
    }
  };
});
var AriaDashboard = (function (_ref) {
  var domainVars = _ref.domainVars;
  var classes = useStyles$F();
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var sourcesContributionGroups = store['sources_contribution_groups'];
  var _React$useState = React.useState('AQI'),
    groupSelected = _React$useState[0],
    setGroupSelected = _React$useState[1];
  var regulations = store['regulations'];
  var _React$useState2 = React.useState(undefined),
    currentRegulation = _React$useState2[0],
    setCurrentRegulation = _React$useState2[1];
  var _React$useState3 = React.useState(''),
    currentUnit = _React$useState3[0],
    setCurrentUnit = _React$useState3[1];
  var sensors = store['emission_sensors'];
  var _React$useState4 = React.useState([]),
    sensorsListFiltered = _React$useState4[0],
    setSensorsListFiltered = _React$useState4[1];
  var startName = 'ATMO_';
  React.useEffect(function () {
    if (!regulations) return;
    for (var _iterator = _createForOfIteratorHelperLoose(regulations), _step; !(_step = _iterator()).done;) {
      var regulation = _step.value;
      if (regulation.Name == startName + groupSelected) {
        setCurrentRegulation(regulation);
        return;
      }
    }
    setCurrentRegulation(undefined);
  }, [regulations, groupSelected]);
  React.useEffect(function () {
    if (groupSelected != 'AQI') {
      setCurrentUnit("µg/m³");
    } else {
      setCurrentUnit("");
    }
  }, [currentRegulation]);
  var handleInfoButton = function handleInfoButton() {
    window.open("https://www.atmo-france.org/article/lindice-atmo#item-4738", "_blank", "noreferrer");
  };
  React.useEffect(function () {
    if (sensors) {
      setSensorsListFiltered(Object.values(sensors).filter(function (sensor) {
        return sensor.samplingMethod != 'BG';
      }));
    }
  }, [sensors]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.headers
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.buttons
  }, /*#__PURE__*/React.createElement(Button$1, {
    style: {
      textTransform: "none"
    },
    color: "primary",
    className: groupSelected == 'AQI' ? classes.buttonActive : classes.button,
    value: 'AQI',
    variant: groupSelected == 'AQI' ? 'contained' : 'outlined',
    onClick: function onClick(e) {
      return setGroupSelected('AQI');
    },
    key: 'AQI'
  }, t('Dashboard.Air_quality_index') + ' (AQI)'), sourcesContributionGroups && sourcesContributionGroups.map(function (gp) {
    if (gp != 'COVNM') return /*#__PURE__*/React.createElement(Button$1, {
      color: "primary",
      className: groupSelected == gp ? classes.buttonActive : classes.button,
      value: gp,
      variant: groupSelected == gp ? 'contained' : 'outlined',
      onClick: function onClick(e) {
        return setGroupSelected(e.target.innerText);
      },
      key: gp
    }, gp);
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.legendSmall
  }, /*#__PURE__*/React.createElement(IconButton$1, {
    size: "small",
    color: "primary",
    onClick: handleInfoButton
  }, /*#__PURE__*/React.createElement(Info, {
    size: "small",
    color: "primary"
  })), /*#__PURE__*/React.createElement(Typography, {
    style: {
      whiteSpace: 'nowrap'
    }
  }, t('Dashboard.Air_quality') + ' : '), currentRegulation && currentRegulation.Thresholds.map(function (thresh) {
    return /*#__PURE__*/React.createElement(Tooltip$1, {
      title: thresh.Operator + ' ' + thresh.Level + currentUnit
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.legendValue
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.coloredRectangle,
      style: {
        backgroundColor: thresh.Color
      }
    }), /*#__PURE__*/React.createElement("div", null, t('AirQualityScale.' + thresh.Label))));
  }), /*#__PURE__*/React.createElement(Tooltip$1, {
    title: t('AirQualityScale.No_data')
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.legendValue
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.coloredRectangle,
    style: {
      backgroundColor: '#d9d9d9'
    }
  }), /*#__PURE__*/React.createElement("div", null, t('AirQualityScale.No_data')))), /*#__PURE__*/React.createElement("div", null))), /*#__PURE__*/React.createElement("div", {
    className: classes.dashboardPaper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.kpis
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.histo,
    style: {
      width: '40%'
    }
  }, /*#__PURE__*/React.createElement(DashboardKPI, {
    title: groupSelected + " : " + t('Dashboard.Kpi_title'),
    globalGroupSelected: groupSelected,
    currentRegulation: currentRegulation,
    sensorsListFiltered: sensorsListFiltered
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.histo,
    style: {
      width: '60%'
    }
  }, /*#__PURE__*/React.createElement(DashboardHistogram, {
    title: groupSelected + " : " + t('Dashboard.Timeline_title'),
    globalGroupSelected: groupSelected,
    currentRegulation: currentRegulation,
    sensorsListFiltered: sensorsListFiltered
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.map
  }, domainVars && /*#__PURE__*/React.createElement(Fade, null, /*#__PURE__*/React.createElement(DashboardMap, {
    domainVars: domainVars,
    globalGroupSelected: groupSelected
  })))));
});

var CRSs = {
  'EPSG:32601': new L$1.Proj.CRS('EPSG:32601', '+proj=utm +zone=01 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32602': new L$1.Proj.CRS('EPSG:32602', '+proj=utm +zone=02 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32603': new L$1.Proj.CRS('EPSG:32603', '+proj=utm +zone=03 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32604': new L$1.Proj.CRS('EPSG:32604', '+proj=utm +zone=04 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32605': new L$1.Proj.CRS('EPSG:32605', '+proj=utm +zone=05 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32606': new L$1.Proj.CRS('EPSG:32606', '+proj=utm +zone=06 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32607': new L$1.Proj.CRS('EPSG:32607', '+proj=utm +zone=07 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32608': new L$1.Proj.CRS('EPSG:32608', '+proj=utm +zone=08 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32609': new L$1.Proj.CRS('EPSG:32609', '+proj=utm +zone=09 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32610': new L$1.Proj.CRS('EPSG:32610', '+proj=utm +zone=10 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32611': new L$1.Proj.CRS('EPSG:32611', '+proj=utm +zone=11 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32612': new L$1.Proj.CRS('EPSG:32612', '+proj=utm +zone=12 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32613': new L$1.Proj.CRS('EPSG:32613', '+proj=utm +zone=13 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32614': new L$1.Proj.CRS('EPSG:32614', '+proj=utm +zone=14 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32615': new L$1.Proj.CRS('EPSG:32615', '+proj=utm +zone=15 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32616': new L$1.Proj.CRS('EPSG:32616', '+proj=utm +zone=16 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32617': new L$1.Proj.CRS('EPSG:32617', '+proj=utm +zone=17 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32618': new L$1.Proj.CRS('EPSG:32618', '+proj=utm +zone=18 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32619': new L$1.Proj.CRS('EPSG:32619', '+proj=utm +zone=19 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32620': new L$1.Proj.CRS('EPSG:32620', '+proj=utm +zone=20 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32621': new L$1.Proj.CRS('EPSG:32621', '+proj=utm +zone=21 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32622': new L$1.Proj.CRS('EPSG:32622', '+proj=utm +zone=22 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32623': new L$1.Proj.CRS('EPSG:32623', '+proj=utm +zone=23 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32624': new L$1.Proj.CRS('EPSG:32624', '+proj=utm +zone=24 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32625': new L$1.Proj.CRS('EPSG:32625', '+proj=utm +zone=25 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32626': new L$1.Proj.CRS('EPSG:32626', '+proj=utm +zone=26 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32627': new L$1.Proj.CRS('EPSG:32627', '+proj=utm +zone=27 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32628': new L$1.Proj.CRS('EPSG:32628', '+proj=utm +zone=28 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32629': new L$1.Proj.CRS('EPSG:32629', '+proj=utm +zone=29 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32630': new L$1.Proj.CRS('EPSG:32630', '+proj=utm +zone=30 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32631': new L$1.Proj.CRS('EPSG:32631', '+proj=utm +zone=31 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32632': new L$1.Proj.CRS('EPSG:32632', '+proj=utm +zone=32 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32633': new L$1.Proj.CRS('EPSG:32633', '+proj=utm +zone=33 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32634': new L$1.Proj.CRS('EPSG:32634', '+proj=utm +zone=34 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32635': new L$1.Proj.CRS('EPSG:32635', '+proj=utm +zone=35 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32636': new L$1.Proj.CRS('EPSG:32636', '+proj=utm +zone=36 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32637': new L$1.Proj.CRS('EPSG:32637', '+proj=utm +zone=37 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32638': new L$1.Proj.CRS('EPSG:32638', '+proj=utm +zone=38 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32639': new L$1.Proj.CRS('EPSG:32639', '+proj=utm +zone=39 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32640': new L$1.Proj.CRS('EPSG:32640', '+proj=utm +zone=40 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32641': new L$1.Proj.CRS('EPSG:32641', '+proj=utm +zone=41 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32642': new L$1.Proj.CRS('EPSG:32642', '+proj=utm +zone=42 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32643': new L$1.Proj.CRS('EPSG:32643', '+proj=utm +zone=43 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32644': new L$1.Proj.CRS('EPSG:32644', '+proj=utm +zone=44 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32645': new L$1.Proj.CRS('EPSG:32645', '+proj=utm +zone=45 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32646': new L$1.Proj.CRS('EPSG:32646', '+proj=utm +zone=46 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32647': new L$1.Proj.CRS('EPSG:32647', '+proj=utm +zone=47 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32648': new L$1.Proj.CRS('EPSG:32648', '+proj=utm +zone=48 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32649': new L$1.Proj.CRS('EPSG:32649', '+proj=utm +zone=49 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32650': new L$1.Proj.CRS('EPSG:32650', '+proj=utm +zone=50 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32651': new L$1.Proj.CRS('EPSG:32651', '+proj=utm +zone=51 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32652': new L$1.Proj.CRS('EPSG:32652', '+proj=utm +zone=52 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32653': new L$1.Proj.CRS('EPSG:32653', '+proj=utm +zone=53 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32654': new L$1.Proj.CRS('EPSG:32654', '+proj=utm +zone=54 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32655': new L$1.Proj.CRS('EPSG:32655', '+proj=utm +zone=55 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32656': new L$1.Proj.CRS('EPSG:32656', '+proj=utm +zone=56 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32657': new L$1.Proj.CRS('EPSG:32657', '+proj=utm +zone=57 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32658': new L$1.Proj.CRS('EPSG:32658', '+proj=utm +zone=58 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32659': new L$1.Proj.CRS('EPSG:32659', '+proj=utm +zone=59 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32660': new L$1.Proj.CRS('EPSG:32660', '+proj=utm +zone=60 +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32701': new L$1.Proj.CRS('EPSG:32701', '+proj=utm +zone=01 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32702': new L$1.Proj.CRS('EPSG:32702', '+proj=utm +zone=02 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32703': new L$1.Proj.CRS('EPSG:32703', '+proj=utm +zone=03 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32704': new L$1.Proj.CRS('EPSG:32704', '+proj=utm +zone=04 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32705': new L$1.Proj.CRS('EPSG:32705', '+proj=utm +zone=05 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32706': new L$1.Proj.CRS('EPSG:32706', '+proj=utm +zone=06 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32707': new L$1.Proj.CRS('EPSG:32707', '+proj=utm +zone=07 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32708': new L$1.Proj.CRS('EPSG:32708', '+proj=utm +zone=08 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32709': new L$1.Proj.CRS('EPSG:32709', '+proj=utm +zone=09 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32710': new L$1.Proj.CRS('EPSG:32710', '+proj=utm +zone=10 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32711': new L$1.Proj.CRS('EPSG:32711', '+proj=utm +zone=11 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32712': new L$1.Proj.CRS('EPSG:32712', '+proj=utm +zone=12 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32713': new L$1.Proj.CRS('EPSG:32713', '+proj=utm +zone=13 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32714': new L$1.Proj.CRS('EPSG:32714', '+proj=utm +zone=14 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32715': new L$1.Proj.CRS('EPSG:32715', '+proj=utm +zone=15 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32716': new L$1.Proj.CRS('EPSG:32716', '+proj=utm +zone=16 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32717': new L$1.Proj.CRS('EPSG:32717', '+proj=utm +zone=17 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32718': new L$1.Proj.CRS('EPSG:32718', '+proj=utm +zone=18 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32719': new L$1.Proj.CRS('EPSG:32719', '+proj=utm +zone=19 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32720': new L$1.Proj.CRS('EPSG:32720', '+proj=utm +zone=20 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32721': new L$1.Proj.CRS('EPSG:32721', '+proj=utm +zone=21 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32722': new L$1.Proj.CRS('EPSG:32722', '+proj=utm +zone=22 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32723': new L$1.Proj.CRS('EPSG:32723', '+proj=utm +zone=23 +south +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32724': new L$1.Proj.CRS('EPSG:32724', '+proj=utm +zone=24 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32725': new L$1.Proj.CRS('EPSG:32725', '+proj=utm +zone=25 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32726': new L$1.Proj.CRS('EPSG:32726', '+proj=utm +zone=26 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32727': new L$1.Proj.CRS('EPSG:32727', '+proj=utm +zone=27 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32728': new L$1.Proj.CRS('EPSG:32728', '+proj=utm +zone=28 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32729': new L$1.Proj.CRS('EPSG:32729', '+proj=utm +zone=29 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32730': new L$1.Proj.CRS('EPSG:32730', '+proj=utm +zone=30 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32731': new L$1.Proj.CRS('EPSG:32731', '+proj=utm +zone=31 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32732': new L$1.Proj.CRS('EPSG:32732', '+proj=utm +zone=32 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32733': new L$1.Proj.CRS('EPSG:32733', '+proj=utm +zone=33 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32734': new L$1.Proj.CRS('EPSG:32734', '+proj=utm +zone=34 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32735': new L$1.Proj.CRS('EPSG:32735', '+proj=utm +zone=35 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32736': new L$1.Proj.CRS('EPSG:32736', '+proj=utm +zone=36 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32737': new L$1.Proj.CRS('EPSG:32737', '+proj=utm +zone=37 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32738': new L$1.Proj.CRS('EPSG:32738', '+proj=utm +zone=38 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32739': new L$1.Proj.CRS('EPSG:32739', '+proj=utm +zone=39 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32740': new L$1.Proj.CRS('EPSG:32740', '+proj=utm +zone=40 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32741': new L$1.Proj.CRS('EPSG:32741', '+proj=utm +zone=41 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32742': new L$1.Proj.CRS('EPSG:32742', '+proj=utm +zone=42 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32743': new L$1.Proj.CRS('EPSG:32743', '+proj=utm +zone=43 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32744': new L$1.Proj.CRS('EPSG:32744', '+proj=utm +zone=44 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32745': new L$1.Proj.CRS('EPSG:32745', '+proj=utm +zone=45 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32746': new L$1.Proj.CRS('EPSG:32746', '+proj=utm +zone=46 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32747': new L$1.Proj.CRS('EPSG:32747', '+proj=utm +zone=47 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32748': new L$1.Proj.CRS('EPSG:32748', '+proj=utm +zone=48 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32749': new L$1.Proj.CRS('EPSG:32749', '+proj=utm +zone=49 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32750': new L$1.Proj.CRS('EPSG:32750', '+proj=utm +zone=50 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32751': new L$1.Proj.CRS('EPSG:32751', '+proj=utm +zone=51 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32752': new L$1.Proj.CRS('EPSG:32752', '+proj=utm +zone=52 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32753': new L$1.Proj.CRS('EPSG:32753', '+proj=utm +zone=53 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32754': new L$1.Proj.CRS('EPSG:32754', '+proj=utm +zone=54 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32755': new L$1.Proj.CRS('EPSG:32755', '+proj=utm +zone=55 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32756': new L$1.Proj.CRS('EPSG:32756', '+proj=utm +zone=56 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32757': new L$1.Proj.CRS('EPSG:32757', '+proj=utm +zone=57 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32758': new L$1.Proj.CRS('EPSG:32758', '+proj=utm +zone=58 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32759': new L$1.Proj.CRS('EPSG:32759', '+proj=utm +zone=59 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:32760': new L$1.Proj.CRS('EPSG:32760', '+proj=utm +zone=60 +south +datum=WGS84 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:3857': new L$1.Proj.CRS('EPSG:3857', '+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext  +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128],
    origin: [0, 0]
  }),
  'EPSG:2154': new L$1.Proj.CRS('EPSG:2154', '+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs', {
    resolutions: [8192, 4096, 2048, 1024, 512, 256, 128, 64, 32, 16, 8, 4, 2, 1, 0.5],
    origin: [6236000.0, 886000]
  })
};
function getCRS(epsg) {
  return CRSs[epsg];
}
function getDomain(dataset, client_domain_nesting) {
  var domain;
  var mCenter;
  var domain_nesting;
  if (dataset && dataset.domain) {
    log(dataset.domain, 'Dom in the dataset! ', 'info');
    var dom = dataset.domain;
    if (process.env.REACT_APP_API_VERSION !== 'v1') {
      domain = {};
      var pNO = [dom.yno, dom.xno];
      var pNE = [dom.yno, dom.xse];
      var pSE = [dom.yse, dom.xse];
      var pSO = [dom.yse, dom.xno];
      if (dom.epsg && dom.epsg !== 4326) {
        var clientCRS = getCRS("EPSG:" + dom.epsg);
        pSO = clientCRS.projection.unproject(L$1.point(dom.xno, dom.yse));
        pSO = [pSO.lat, pSO.lng];
        pNO = clientCRS.projection.unproject(L$1.point(dom.xno, dom.yno));
        pNO = [pNO.lat, pNO.lng];
        pNE = clientCRS.projection.unproject(L$1.point(dom.xse, dom.yno));
        pNE = [pNE.lat, pNE.lng];
        pSE = clientCRS.projection.unproject(L$1.point(dom.xse, dom.yse));
        pSE = [pSE.lat, pSE.lng];
      }
      mCenter = [0.5 * (pNO[0] + pSE[0]), 0.5 * (pNO[1] + pSE[1])];
      domain.center = mCenter;
      domain.bounds = [pNO, pSE];
      domain.polygon = [pNO, pNE, pSE, pSO];
      if (client_domain_nesting) {
        var npNO = [client_domain_nesting.yno, client_domain_nesting.xno];
        var npNE = [client_domain_nesting.yno, client_domain_nesting.xse];
        var npSE = [client_domain_nesting.yse, client_domain_nesting.xse];
        var npSO = [client_domain_nesting.yse, client_domain_nesting.xno];
        if (client_domain_nesting.epsg && client_domain_nesting.epsg !== 4326) {
          var _clientCRS = getCRS("EPSG:" + client_domain_nesting.epsg);
          npSO = _clientCRS.projection.unproject(L$1.point(client_domain_nesting.xno, client_domain_nesting.yse));
          npSO = [npSO.lat, npSO.lng];
          npNO = _clientCRS.projection.unproject(L$1.point(client_domain_nesting.xno, client_domain_nesting.yno));
          npNO = [npNO.lat, npNO.lng];
          npNE = _clientCRS.projection.unproject(L$1.point(client_domain_nesting.xse, client_domain_nesting.yno));
          npNE = [npNE.lat, npNE.lng];
          npSE = _clientCRS.projection.unproject(L$1.point(client_domain_nesting.xse, client_domain_nesting.yse));
          npSE = [npSE.lat, npSE.lng];
          domain_nesting = [npNO, npNE, npSE, npSO];
        }
      }
    } else if (process.env.REACT_APP_API_VERSION === 'v1' || !process.env.REACT_APP_API_VERSION) {
      domain = dom;
    }
  }
  if (domain) {
    log(domain, 'Found domain in the dataset! ', 'info');
    log(domain_nesting, 'Domain nesting');
  } else {
    log(domain, 'Not found domain in the dataset! ', 'error');
  }
  return {
    domain: domain,
    mCenter: mCenter,
    domain_nesting: domain_nesting
  };
}

var AriaInterface = (function (_ref) {
  var mapObj = _ref.mapObj,
    selectedDataset = _ref.selectedDataset,
    dv_name = _ref.dv_name,
    mapProps = _ref.mapProps;
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0],
    dispatch = _useAriaAppStore[1];
  console.log(store, 'STORE: ');
  var client = store['client'];
  var window_type = store['window_type'];
  var client_domain_nesting = store['client_domain_nesting'];
  var _React$useState = React.useState(undefined),
    domainVars = _React$useState[0],
    setDomainVars = _React$useState[1];
  var weather_monitoring_sensor = store['weather_monitoring_sensor'].idAirQualityStation;
  var sensors = store['emission_sensors'];
  React.useEffect(function () {
    if (!isEmpty(selectedDataset)) {
      var qp = {};
      var pp = [selectedDataset];
      var _url = getUrlService('datasets', pp, qp);
      log(_url, 'URL datasets services', 'info');
      fetch(_url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        }
      }).then(function (response) {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 403) {
          var jr = response.json();
          return response.json();
        } else if (response.status === 401) {
          var errmsg = response.statusText || 'No handled error';
          return Promise.reject(new Error(errmsg));
        }
        return response.json();
      }).then(function (json) {
        log(json, 'Fetch dataset', 'info');
        if (json.error) {
          dispatch({
            type: 'SET_DATASET',
            value: undefined
          });
        } else if (json.data) {
          dispatch({
            type: 'SET_DATASETS',
            value: [json.data]
          });
          dispatch({
            type: 'SET_DATASET',
            value: [json.data][0]
          });
          var _domainVars = getDomain([json.data][0], client_domain_nesting);
          setDomainVars(_domainVars);
        }
      })["catch"](function (error) {
        console.error(error);
      });
    }
  }, [selectedDataset]);
  React.useEffect(function () {
    if (!client || !client.token) return;
    var _url = getUrlService({
      version: process.env.REACT_APP_OBS_API_VERSION || '',
      name: process.env.REACT_APP_OBS_API + '/stations'
    }, [], {});
    log(_url, 'URL observation services called from AriaMap', 'info');
    fetch(_url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'X-ARIA-CLIENT-TOKEN': client.token
      }
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      log(json, 'Get Observation station', 'info');
      var respData;
      if (json.data && !json.error) {
        respData = json.data;
      } else if (Array.isArray(json)) {
        respData = json;
      }
      var emis_stations = {};
      var weather_staions = [];
      var monitoring_station = {};
      respData.forEach(function (sta) {
        if (sta.station_type === 'met') {
          sta.name = sta['nameAirQualityStation'];
          weather_staions.push(sta);
          if (sta['idAirQualityStation'] === weather_monitoring_sensor) {
            monitoring_station = sta;
          }
        } else if (sta.station_type === 'aq') {
          sta.code = sta['nameAirQualityStation'];
          sta.name = sta['labelAirQualityStation'];
          emis_stations[sta['nameAirQualityStation']] = sta;
        }
      });
      dispatch({
        type: 'SET_EMISSION_SENSORS',
        value: emis_stations
      });
      dispatch({
        type: 'SET_WEATHER_SENSORS',
        value: weather_staions
      });
      dispatch({
        type: 'SET_MONITORING_WEATHER_SENSOR',
        value: monitoring_station
      });
    })["catch"](function (error) {
      log(error, 'Error from Observation service', 'error');
    });
  }, [client]);
  React.useEffect(function () {
    if (!client || !client.name) return;
    var _url = getUrlService('points', ['receptors'], {
      client: client.name
    }, true);
    log(_url, '*** URL Get Receptors ***');
    fetch(_url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8'
      }
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      log(json, 'Get Receptors', 'info');
      var receptors = {};
      json.forEach(function (rcp) {
        if (!(rcp.id.toString() in receptors)) {
          receptors[rcp.id] = {};
        }
        receptors[rcp.id] = rcp;
      });
      dispatch({
        type: 'SET_RECEPTORS',
        value: receptors
      });
    })["catch"](function (error) {
      log(error, 'Error from Observation service', 'error');
    });
  }, [client]);
  React.useEffect(function () {
    if (!client || !client.token) return;
    var _url = getUrlService({
      version: process.env.REACT_APP_OBS_API_VERSION || '',
      name: process.env.REACT_APP_OBS_API + '/kpi/regulations'
    }, [], {});
    fetch(_url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'X-ARIA-CLIENT-TOKEN': client.token
      }
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      log(json, 'Get Regulations', 'info');
      if (json.data) {
        dispatch({
          type: 'SET_REGULATIONS',
          value: json.data
        });
      }
    })["catch"](function (error) {
      log(error, 'Error from Regulations service', 'error');
    });
  }, [client]);
  return (
    /*#__PURE__*/
    React.createElement(React.Fragment, null, domainVars && window_type === 'monitoring' && /*#__PURE__*/React.createElement(AriaMap, _extends({
      mapObj: mapObj,
      selectedDataset: selectedDataset,
      dv_name: dv_name,
      domainVars: domainVars
    }, mapProps)), domainVars && window_type === 'dashboard' && sensors && /*#__PURE__*/React.createElement(AriaDashboard, {
      dv_name: dv_name,
      domainVars: domainVars
    }))
  );
});

var _excluded$5 = ["store", "reducer", "controlPanelProps", "mapProps", "title", "titleimage", "logos", "selectedDataset", "children", "layers", "dv_name", "userinfo", "onClickOnExit", "setWindowType"];
var useStyles$G = makeStyles(function (theme) {
  return {
    root: {}
  };
});
var AriaControlLayout = function AriaControlLayout(_ref) {
  var store = _ref.store,
    reducer = _ref.reducer,
    controlPanelProps = _ref.controlPanelProps,
    mapProps = _ref.mapProps,
    title = _ref.title,
    titleimage = _ref.titleimage,
    logos = _ref.logos,
    selectedDataset = _ref.selectedDataset,
    children = _ref.children,
    dv_name = _ref.dv_name,
    userinfo = _ref.userinfo,
    onClickOnExit = _ref.onClickOnExit,
    setWindowType = _ref.setWindowType,
    others = _objectWithoutPropertiesLoose(_ref, _excluded$5);
  var classes = useStyles$G();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var mapObj = React.useRef(null);
  var onChangeOpenDrawerHandler = React.useCallback(function (open) {
    setTimeout(function () {
      if (mapObj && mapObj.current) {
        mapObj.current.leafletElement.invalidateSize({
          pan: true
        });
      }
    }, 500);
  });
  return /*#__PURE__*/React.createElement(AriaAppStoreProvider, {
    store: store,
    reducer: reducer
  }, /*#__PURE__*/React.createElement(AriaLayout, _extends({
    withDrawer: true,
    userinfo: userinfo,
    appbar: /*#__PURE__*/React.createElement(AriaAppBar, {
      logos: logos,
      title: title || t('ApplicationBar.Title'),
      titleimage: titleimage,
      langs: [{
        code: 'en',
        label: 'EN'
      }, {
        code: 'fr',
        label: 'FR'
      }, {
        code: 'it',
        label: 'IT'
      }, {
        code: 'es',
        label: 'ES'
      }],
      onClickOnExit: onClickOnExit,
      userinfo: userinfo
    }),
    controlPanelProps: _extends({
      withToolbar: true
    }, controlPanelProps),
    setWindowType: setWindowType,
    onChangeOpenDrawer: onChangeOpenDrawerHandler,
    controls: children
  }, others), /*#__PURE__*/React.createElement(AriaInterface, {
    mapObj: mapObj,
    selectedDataset: selectedDataset,
    dv_name: dv_name,
    mapProps: mapProps
  })));
};
AriaControlLayout.propTypes = {};

var useStyles$H = makeStyles(function (theme) {
  return {
    formControl: {
      margin: theme.spacing(1),
      marginBottom: theme.spacing(2),
      width: '95%'
    },
    linearProgress: {
      marginTop: theme.spacing(1)
    },
    hidden: {
      display: 'None'
    }
  };
});
var AriaSiteSelect = (function (_ref) {
  var title = _ref.title,
    sites = _ref.sites,
    onChangeHandler = _ref.onChangeHandler,
    isLoading = _ref.isLoading,
    isError = _ref.isError,
    hidden = _ref.hidden;
  var classes = useStyles$H();
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0],
    dispatch = _useAriaAppStore[1];
  var site = store['case'];
  React.useEffect(function () {
    if (Array.isArray(sites)) {
      if (sites.length > 0) {
        if (dispatch) {
          dispatch({
            type: 'SET_CASE',
            value: sites[0].name
          });
        }
        if (typeof onChangeHandler === 'function') {
          onChangeHandler(sites[0]);
        }
      }
    }
  }, [onChangeHandler, sites]);
  var siteChangeHandler = useCallback(function (event) {
    var selectedSite = event.target.value;
    if (sites.length > 0) {
      var f = sites.filter(function (s) {
        return s.name === selectedSite;
      });
      if (Array.isArray(f)) {
        if (dispatch) {
          dispatch({
            type: 'SET_CASE',
            value: f[0].name
          });
        }
        if (typeof onChangeHandler === 'function') {
          onChangeHandler(f[0]);
        }
      }
    }
  }, [onChangeHandler, sites]);
  return /*#__PURE__*/React.createElement(FormControl$1, {
    fullWidth: true,
    className: hidden ? classes.hidden : classes.formControl
  }, /*#__PURE__*/React.createElement(FormLabel, {
    htmlFor: "case"
  }, title), isLoading ? /*#__PURE__*/React.createElement(LinearProgress, {
    className: classes.linearProgress
  }) : isError ? /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, "Cannot load cases from server") : /*#__PURE__*/React.createElement(Select, {
    value: typeof site === 'string' ? site : site.name,
    onChange: siteChangeHandler,
    inputProps: {
      name: 'case',
      id: 'case'
    }
  }, sites && sites.map(function (s, index) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: index,
      value: s.name
    }, s.label);
  })));
});

var useStyles$I = makeStyles(function (theme) {
  return {
    formControl: {
      margin: theme.spacing(1),
      marginBottom: theme.spacing(2),
      width: '95%',
      minWidth: '50%'
    },
    selectEmpty: {
      marginTop: theme.spacing(2)
    },
    hidden: {
      display: 'None'
    }
  };
});
var AriaDateSelect = (function (_ref) {
  var title = _ref.title,
    isUTC = _ref.isUTC,
    dateformat = _ref.dateformat,
    hidden = _ref.hidden,
    disabled = _ref.disabled,
    onLoadingDates = _ref.onLoadingDates,
    onChangeDateHandler = _ref.onChangeDateHandler;
  var classes = useStyles$I();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(undefined),
    error = _useState[0],
    setError = _useState[1];
  var _useState2 = useState(false),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0],
    dispatch = _useAriaAppStore[1];
  var dataset = store['dataset'].name;
  var storeDate = store['date'];
  var _useState3 = useState(''),
    cdate = _useState3[0],
    setCDate = _useState3[1];
  var _useState4 = useState([]),
    dates = _useState4[0],
    setDates = _useState4[1];
  React.useEffect(function () {
    if (!isEmpty(dataset)) {
      setIsLoading(true);
      setError(false);
      var qp = {};
      var pp;
      if (!process.env.REACT_APP_API_VERSION || process.env.REACT_APP_API_VERSION === 'v1') {
        qp = {
          info: 'dates'
        };
        pp = [dataset];
      } else if (process.env.REACT_APP_API_VERSION !== 'v1') {
        qp = {
          info: 'dates'
        };
        pp = [dataset];
      }
      var _url = getUrlService('datasets', pp, qp);
      fetch(_url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        }
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        setIsLoading(false);
        log(json, 'SIM DATES');
        if (Array.isArray(json.data)) {
          var dateObjs = json.data.map(function (d) {
            var dObj = new Date(d);
            return {
              value: dObj,
              label: parseTime(dObj, dateformat || '{y}-{m}-{d}', isUTC)
            };
          });
          if (typeof onLoadingDates === 'function') {
            onLoadingDates(dateObjs);
          }
          setDates(dateObjs);
        }
      })["catch"](function (error) {
        setError(error.toString());
        setIsLoading(false);
      });
    }
  }, [dataset, onLoadingDates, isUTC, dateformat]);
  var dateChangeHandler = useCallback(function (event) {
    var selectedDate = event.target.value;
    dispatch({
      type: 'SET_DATE',
      value: selectedDate
    });
    if (typeof onChangeDateHandler === 'function') {
      onChangeDateHandler(selectedDate);
    }
  }, [onChangeDateHandler]);
  useEffect(function () {
    if (dates.length > 0) {
      var currentDateTime = new Date();
      console.log(currentDateTime, 'currentDateTime');
      dispatch({
        type: 'SET_DATE',
        value: currentDateTime
      });
      if (typeof onChangeDateHandler === 'function') {
        onChangeDateHandler(currentDateTime);
      }
    }
  }, [dates, onChangeDateHandler]);
  useEffect(function () {
    if (storeDate) {
      log(storeDate, 'STORE DATE', 'error');
      setCDate(storeDate);
    }
  }, [storeDate]);
  return /*#__PURE__*/React.createElement(FormControl$1, {
    fullWidth: true,
    className: hidden ? classes.hidden : classes.formControl,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(FormLabel, {
    htmlFor: "date-model"
  }, title), isLoading ? /*#__PURE__*/React.createElement(LinearProgress, {
    className: classes.linearProgress
  }) : error ? /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, t('ControlPanel.Cannot_load_variables_from_server')) : dates && /*#__PURE__*/React.createElement(Select, {
    value: cdate,
    onChange: dateChangeHandler,
    inputProps: {
      name: 'date-model',
      id: 'date-model'
    }
  }, dates.map(function (date, index) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: index,
      value: date.value
    }, date.label);
  })));
});

var useStyles$J = makeStyles(function (theme) {
  return {
    formControl: {
      margin: theme.spacing(1),
      marginBottom: theme.spacing(2),
      width: '95%',
      minWidth: '50%'
    },
    formLabel: {
      marginTop: theme.spacing(2)
    },
    linearProgress: {
      marginTop: theme.spacing(1)
    }
  };
});
var AnimationStep = 15000;
var TimelineControl = function TimelineControl(_ref) {
  var title = _ref.title,
    modifier = _ref.modifier,
    timeavg = _ref.timeavg,
    isUTC = _ref.isUTC,
    datetimeFormat = _ref.datetimeFormat,
    with_prevision = _ref.with_prevision,
    withAnimation = _ref.withAnimation,
    onLoadingTimeframes = _ref.onLoadingTimeframes,
    onChangeTimeframeHandler = _ref.onChangeTimeframeHandler;
  var classes = useStyles$J();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(undefined),
    error = _useState[0],
    setError = _useState[1];
  var _useState2 = useState(false),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0],
    dispatch = _useAriaAppStore[1];
  var dataset = store['dataset'];
  var date = store['date'];
  var isAtomic = store['is_atomic'];
  var tz = store['timezone'];
  var modeltype = store['case'];
  var _useState3 = useState(false),
    animation = _useState3[0],
    setAnimation = _useState3[1];
  var _useState4 = useState(0),
    progress = _useState4[0],
    setProgress = _useState4[1];
  var _useState5 = useState({}),
    timeframe = _useState5[0],
    setTimeframe = _useState5[1];
  var _useState6 = useState([]),
    timeframes = _useState6[0],
    setTimeframes = _useState6[1];
  var _useState7 = useState(datetimeFormat),
    dtformat = _useState7[0],
    setDtFormat = _useState7[1];
  React.useEffect(function () {
    if (!isEmpty(modeltype)) {
      if (modeltype.toLowerCase().startsWith('rcp')) {
        setDtFormat('{y}');
      } else {
        setDtFormat('{y}-{m}-{d} {h}:{i}');
      }
    }
  }, [modeltype]);
  React.useEffect(function () {
    var dateIn = date;
    if (!(dateIn instanceof Date)) return;
    if (dateIn instanceof Date) {
      dateIn = parseTime(date, '{y}-{m}-{d}', true);
    }
    if (dataset && !isEmpty(dataset.name) && !isEmpty(dateIn)) {
      setIsLoading(true);
      setError(false);
      var qp = {
        info: 'timeframes',
        date: dateIn,
        is_atomic: isAtomic ? 1 : 0,
        modifier: modifier ? modifier.toLowerCase() : undefined,
        timeavg: timeavg ? timeavg.toLowerCase() : undefined,
        with_prevision: with_prevision
      };
      var pp = [dataset.name];
      var _url = getUrlService('datasets', pp, qp);
      fetch(_url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        }
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        setIsLoading(false);
        log(json, '*** Timeframes response');
        if (json.data) {
          var tfsdata;
          if (Array.isArray(json.data)) {
            tfsdata = json.data;
          } else if (json.data.timeframes) {
            tfsdata = json.data.timeframes;
          }
          var tfs = tfsdata;
          if (typeof onLoadingTimeframes === 'function') {
            onLoadingTimeframes(tfs);
          }
          setTimeframes(tfs);
        }
      })["catch"](function (error) {
        setError(error.toString());
        setIsLoading(false);
      });
    }
  }, [dataset, date, modifier, onLoadingTimeframes, timeavg, tz, isAtomic, with_prevision]);
  useEffect(function () {
    if (Array.isArray(timeframes)) {
      if (timeframes.length > 0) {
        var curUTCHour = new Date(Date.now()).getUTCHours();
        var curUTCDate = new Date(Date.now()).getUTCDate();
        var selId = -1;
        var selTf = timeframes.find(function (tf, sid) {
          var currDateObj = new Date(tf);
          if (currDateObj.getUTCHours() === curUTCHour && currDateObj.getUTCDate() === curUTCDate) {
            selId = sid;
            return true;
          }
        });
        var selObj = {
          id: timeframes.length - 1,
          value: timeframes[timeframes.length - 1]
        };
        if (selTf || selId >= 0) {
          selObj.id = selId;
          selObj.value = selTf;
        }
        selObj.obj = new Date(selObj.value);
        setTimeframe(selObj);
        dispatch({
          type: 'SET_TIMEFRAME',
          value: selObj
        });
        if (typeof onChangeTimeframeHandler === 'function') {
          onChangeTimeframeHandler(selObj.value);
        }
      }
    }
  }, [onChangeTimeframeHandler, timeframes]);
  var setTimeframeCB = useCallback(function (curId, timeframes) {
    setTimeframe({
      id: curId,
      value: timeframes[curId]
    });
    dispatch({
      type: 'SET_TIMEFRAME',
      value: {
        id: curId,
        value: timeframes[curId],
        obj: new Date(timeframes[curId])
      }
    });
    dispatch({
      type: 'SET_OPEN_CHART',
      value: 'TIMEFRAME'
    });
    if (typeof onChangeTimeframeHandler === 'function') {
      onChangeTimeframeHandler(timeframes[curId]);
    }
  }, [onChangeTimeframeHandler]);
  useEffect(function () {
    if (animation && timeframes.length > 0 && timeframe) {
      var tId = timeframe.id;
      tId++;
      if (tId >= timeframes.length) {
        tId = 0;
      }
      setTimeout(function () {
        return setTimeframeCB(tId, timeframes);
      }, AnimationStep);
    }
  }, [animation, timeframe, timeframes, setTimeframeCB]);
  useEffect(function () {
    if (animation) {
      var timer = setInterval(function () {
        setProgress(function (oldProgress) {
          if (oldProgress === 100) {
            return 0;
          }
          var diff = 10;
          return Math.min(oldProgress + diff, 100);
        });
      }, parseInt(0.9 * AnimationStep / 10));
      return function () {
        clearInterval(timer);
      };
    } else {
      setProgress(0);
    }
  }, [animation]);
  var handleButtonOnClick = function handleButtonOnClick(timeframe, timeframes) {
    return function (typeButton) {
      return function () {
        var curId = timeframe.id;
        var nTfs = timeframes.length;
        if (curId < 0 || nTfs === 0) return;
        switch (typeButton) {
          case 'PLAY-STOP':
            if (animation) {
              setAnimation(false);
            } else {
              setAnimation(true);
              setTimeframeCB(curId, timeframes);
            }
            break;
          case 'NEXT':
            curId++;
            curId = Math.min(nTfs - 1, curId);
            setTimeframeCB(curId, timeframes);
            break;
          case 'PREVIOUS':
            curId--;
            curId = Math.max(0, curId);
            setTimeframeCB(curId, timeframes);
            break;
          case 'FORWARD':
            curId = nTfs - 1;
            curId = Math.min(nTfs - 1, curId);
            setTimeframeCB(curId, timeframes);
            break;
          case 'REWIND':
            curId = 0;
            curId = Math.max(0, curId);
            setTimeframeCB(curId, timeframes);
            break;
          default:
            console.warn("Button type [" + typeButton + "] has not handled yet.");
        }
      };
    };
  };
  return /*#__PURE__*/React.createElement(FormControl$1, {
    fullWidth: true,
    className: classes.formControl
  }, /*#__PURE__*/React.createElement(FormLabel, {
    className: classes.formLabel
  }, title), isLoading && /*#__PURE__*/React.createElement(LinearProgress, {
    className: classes.linearProgress
  }), error ? /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, "Cannot load variables from server") : /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justifyContent: "center",
    alignItems: "center",
    spacing: 1,
    direction: "row"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, withAnimation && /*#__PURE__*/React.createElement(Tooltip, {
    title: t('ControlPanel.Animation'),
    "aria-label": "play"
  }, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "Play",
    onClick: handleButtonOnClick(timeframe, timeframes)('PLAY-STOP')
  }, animation ? /*#__PURE__*/React.createElement(StopIcon, {
    color: "primary",
    fontSize: "small"
  }) : /*#__PURE__*/React.createElement(PlayArrowIcon, {
    color: "primary",
    fontSize: "small"
  })))), animation ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 7
  }, /*#__PURE__*/React.createElement(LinearProgress, {
    variant: "determinate",
    value: progress
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: true
  }, timeframe.value && /*#__PURE__*/React.createElement(Typography$1, null, parseTime(timeframe.value, dtformat, isUTC)))) : /*#__PURE__*/React.createElement(Fragment, null, timeframes.length > 2 && /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "Rewind",
    onClick: handleButtonOnClick(timeframe, timeframes)('REWIND')
  }, /*#__PURE__*/React.createElement(FastRewindIcon, {
    fontSize: "small"
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "Previous",
    onClick: handleButtonOnClick(timeframe, timeframes)('PREVIOUS')
  }, /*#__PURE__*/React.createElement(SkipPreviousIcon, {
    fontSize: "small"
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, timeframe.value && /*#__PURE__*/React.createElement(Typography$1, null, parseTime(timeframe.value, dtformat, isUTC))), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "Next",
    onClick: handleButtonOnClick(timeframe, timeframes)('NEXT')
  }, /*#__PURE__*/React.createElement(SkipNextIcon, {
    fontSize: "small"
  }))), timeframes.length > 2 && /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "Forward",
    onClick: handleButtonOnClick(timeframe, timeframes)('FORWARD')
  }, /*#__PURE__*/React.createElement(FastForwardIcon, {
    fontSize: "small"
  }))))));
};

var useStyles$K = makeStyles(function (theme) {
  return {
    formControl: {
      margin: theme.spacing(1),
      marginBottom: theme.spacing(2),
      width: '90%',
      marginLeft: '5%'
    },
    formLabel: {
      marginTop: theme.spacing(2)
    },
    linearProgress: {
      marginTop: theme.spacing(1)
    }
  };
});
var TimeSliderControl = function TimeSliderControl(_ref) {
  var title = _ref.title,
    modifier = _ref.modifier,
    timeavg = _ref.timeavg,
    isUTC = _ref.isUTC,
    disabled = _ref.disabled,
    datetimeFormat = _ref.datetimeFormat,
    onLoadingTimeframes = _ref.onLoadingTimeframes,
    onChangeTimeframeHandler = _ref.onChangeTimeframeHandler;
  var classes = useStyles$K();
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0],
    dispatch = _useAriaAppStore[1];
  var dataset = store['dataset'].name;
  var variable = store['variable'].name;
  var date = store['date'];
  var epsg = store['dataset'].epsg;
  var modeltype = store['case'];
  var data_type_modifier = store['data_type_modifier'];
  var modifierValue = modifier;
  var timeavgValue = timeavg;
  if (data_type_modifier && typeof data_type_modifier === 'object') {
    modifierValue = data_type_modifier['modifier'];
    timeavgValue = data_type_modifier['timeavgValue'];
  }
  var _useState = useState(undefined),
    error = _useState[0],
    setError = _useState[1];
  var _useState2 = useState(false),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useState3 = useState(false);
  var _useState4 = useState(0);
  var _useState5 = useState(0),
    sliderValue = _useState5[0],
    setSliderValue = _useState5[1];
  var _useState6 = useState({}),
    timeframe = _useState6[0],
    setTimeframe = _useState6[1];
  var _useState7 = useState([]),
    timeframes = _useState7[0],
    setTimeframes = _useState7[1];
  React.useEffect(function () {
    var dateIn = date;
    if (typeof date === 'object') {
      if (!process.env.REACT_APP_API_VERSION || process.env.REACT_APP_API_VERSION === 'v1') {
        dateIn = parseTime(date, '{y}{m}{d}');
      } else {
        dateIn = parseTime(date, '{y}-{m}-{d}');
      }
    }
    if (!isEmpty(dataset) && !isEmpty(dateIn)) {
      setIsLoading(true);
      setError(false);
      var pp, qp;
      if (!process.env.REACT_APP_API_VERSION || process.env.REACT_APP_API_VERSION === 'v1') {
        qp = {
          info: 'timeframes',
          epsg: epsg,
          with_prevision: modeltype.toLowerCase().startWith('rcp'),
          date: dateIn
        };
        if (isEmpty(variable)) return;
        pp = [dataset, 'variables', variable];
      } else if (process.env.REACT_APP_API_VERSION !== 'v1') {
        qp = {
          info: 'timeframes',
          date: dateIn,
          modifier: modifierValue ? modifierValue.toLowerCase() : undefined,
          timeavg: timeavgValue ? timeavgValue.toLowerCase() : undefined
        };
        pp = [dataset];
      }
      var _url = getUrlService('datasets', pp, qp);
      log(_url, 'URL Service getTimeframes', 'info');
      fetch(_url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        }
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        setIsLoading(false);
        log(json);
        if (json.data) {
          var tfsdata;
          if (Array.isArray(json.data)) {
            tfsdata = json.data;
          } else if (json.data.timeframes) {
            tfsdata = json.data.timeframes;
          }
          var tfs = tfsdata;
          if (typeof onLoadingTimeframes === 'function') {
            onLoadingTimeframes(tfs);
          }
          setTimeframes(tfs);
        }
      })["catch"](function (error) {
        setError(error.toString());
        setIsLoading(false);
      });
    }
  }, [dataset, date, epsg, modifierValue, onLoadingTimeframes, timeavgValue, variable]);
  useEffect(function () {
    if (Array.isArray(timeframes)) {
      if (timeframes.length > 0) {
        var curUTCHour = new Date(Date.now()).getUTCHours();
        var curUTCDate = new Date(Date.now()).getUTCDate();
        var selId = -1;
        var selTf = timeframes.find(function (tf, sid) {
          var currDateObj = new Date(tf);
          if (currDateObj.getUTCHours() === curUTCHour && currDateObj.getUTCDate() === curUTCDate) {
            selId = sid;
            return true;
          }
        });
        var selObj = {
          id: timeframes.length - 1,
          value: timeframes[timeframes.length - 1]
        };
        if (selTf || selId >= 0) {
          selObj.id = selId;
          selObj.value = selTf;
        }
        setTimeframe(selObj);
        setSliderValue(timeframes.length - 1);
        dispatch({
          type: 'SET_TIMEFRAME',
          value: selObj
        });
        if (typeof onChangeTimeframeHandler === 'function') {
          onChangeTimeframeHandler(selObj.value);
        }
      }
    }
  }, [onChangeTimeframeHandler, timeframes]);
  var setTimeframeCB = useCallback(function (curId, timeframes) {
    setTimeframe({
      id: curId,
      value: timeframes[curId]
    });
    if (typeof onChangeTimeframeHandler === 'function') {
      onChangeTimeframeHandler(timeframes[curId]);
    }
    if (dispatch) {
      dispatch({
        type: 'SET_TIMEFRAME',
        value: {
          id: curId,
          value: timeframes[curId],
          obj: new Date(timeframes[curId])
        }
      });
    }
  }, [onChangeTimeframeHandler]);
  var onChangeSlider = useCallback(function (_e, curId) {
    setSliderValue(curId);
    setTimeframeCB(curId, timeframes);
  }, [setTimeframeCB, timeframes]);
  var getMarks = useCallback(function () {
    if (Array.isArray(timeframes)) {
      var tfs = timeframes.map(function (tf, id) {
        return {
          id: id,
          value: tf
        };
      });
      var marks = tfs.filter(function (v, id) {
        return id == 0 || id == tfs.length - 1 || id == parseInt(tfs.length / 2);
      });
      return marks.map(function (tf) {
        return {
          value: tf.id,
          label: parseTime(tf.value, datetimeFormat, isUTC)
        };
      });
    }
    return [];
  }, [datetimeFormat, isUTC, timeframes]);
  return /*#__PURE__*/React.createElement(FormControl$1, {
    className: classes.formControl,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(FormLabel, {
    className: classes.formLabel
  }, title, ' ', timeframe && /*#__PURE__*/React.createElement("span", null, parseTime(timeframe.value, datetimeFormat, isUTC))), isLoading && /*#__PURE__*/React.createElement(LinearProgress, {
    className: classes.linearProgress
  }), error ? /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, "Cannot load variables from server") : Array.isArray(timeframes) && timeframes.length > 0 ? /*#__PURE__*/React.createElement(Slider, {
    value: sliderValue,
    "aria-labelledby": "time-slider",
    marks: getMarks(),
    step: 1,
    min: 0,
    max: timeframes.length - 1,
    disabled: disabled,
    onChange: onChangeSlider
  }) : /*#__PURE__*/React.createElement(React.Fragment, null));
};

var useStyles$L = makeStyles(function (theme) {
  return {
    formControl: {
      margin: theme.spacing(1),
      marginBottom: theme.spacing(2),
      width: '95%',
      minWidth: '50%'
    },
    linearProgress: {
      marginTop: theme.spacing(1)
    },
    themeToggleButton: {
      width: 'auto',
      '&$selected': {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.main
      }
    },
    formLabel: {
      marginBottom: theme.spacing(2)
    },
    hidden: {
      display: 'None'
    }
  };
});
var REMOVEDED_VARLIST$1 = ['u', 'v', 'winz', 'winm'];
var AriaDatasetSelect = (function (_ref) {
  var title = _ref.title,
    project = _ref.project,
    site = _ref.site,
    dataType = _ref.dataType,
    selectedVarlist = _ref.selectedVarlist,
    onLoadingDatasets = _ref.onLoadingDatasets,
    onChangeDatasetHandler = _ref.onChangeDatasetHandler,
    onToggleButtonChangeHandler = _ref.onToggleButtonChangeHandler,
    onChangeVariableHandler = _ref.onChangeVariableHandler,
    withTypeSelect = _ref.withTypeSelect,
    currentVariable = _ref.currentVariable,
    hidden = _ref.hidden,
    selectedDataset = _ref.selectedDataset,
    disabled = _ref.disabled,
    toggleButtons = _ref.toggleButtons;
  var classes = useStyles$L();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _React$useState = React.useState(undefined),
    error = _React$useState[0],
    setError = _React$useState[1];
  var _React$useState2 = React.useState(false),
    isLoading = _React$useState2[0],
    setIsLoading = _React$useState2[1];
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0],
    dispatch = _useAriaAppStore[1];
  var datasets = store['datasets'];
  var dataset = store['dataset'];
  var modeltype = site || store['case'];
  var _React$useState3 = React.useState(dataType || store['data_type']),
    type = _React$useState3[0],
    setType = _React$useState3[1];
  var _React$useState4 = React.useState([]),
    variables = _React$useState4[0],
    setVariables = _React$useState4[1];
  var _React$useState5 = React.useState(currentVariable || ''),
    variable = _React$useState5[0],
    setVariable = _React$useState5[1];
  var datasetChangeHandler = useCallback(function (selectedDataset, datasets) {
    var gotDataset = selectedDataset;
    if (typeof selectedDataset === 'string' && Array.isArray(datasets)) {
      gotDataset = datasets.find(function (ds) {
        return ds.name === selectedDataset;
      });
    }
    if (gotDataset) {
      dispatch({
        type: 'SET_DATASET',
        value: gotDataset
      });
      dispatch({
        type: 'SET_OPEN_CHART',
        value: 'TIMEFRAME'
      });
      var filteredVars = gotDataset.variables.filter(function (varobj) {
        return REMOVEDED_VARLIST$1.indexOf(varobj.name.toLowerCase()) == -1;
      });
      if (Array.isArray(selectedVarlist)) {
        filteredVars = filteredVars.filter(function (varobj) {
          return selectedVarlist.indexOf(varobj.name.toUpperCase()) > -1;
        });
      }
      log(filteredVars, 'filteredVars: ');
      setVariables(filteredVars);
      if (typeof onChangeDatasetHandler === 'function') {
        onChangeDatasetHandler(gotDataset);
      }
    }
  }, [onChangeDatasetHandler, selectedVarlist]);
  var handleButtonChange = function handleButtonChange(newVal, buttons) {
    setType(newVal);
    dispatch({
      type: 'SET_OPEN_CHART',
      value: 'TIMEFRAME'
    });
    dispatch({
      type: 'SET_DATATYPE',
      value: newVal
    });
    var selectedBut = buttons.find(function (but) {
      return but.value === newVal;
    });
    if (typeof onToggleButtonChangeHandler === 'function') {
      onToggleButtonChangeHandler(selectedBut.value);
    }
  };
  var variableChangeHandler = useCallback(function (selectedVariable, variables) {
    var gotVar = selectedVariable;
    if (typeof selectedVariable === 'string' && Array.isArray(variables)) {
      gotVar = variables.find(function (v) {
        return v.name === selectedVariable;
      });
    }
    setVariable(selectedVariable);
    if (gotVar) {
      dispatch({
        type: 'SET_VARIABLE',
        value: gotVar
      });
      if (typeof onChangeVariableHandler === 'function') {
        onChangeVariableHandler(gotVar);
      }
    }
    dispatch({
      type: 'SET_OPEN_CHART',
      value: 'TIMEFRAME'
    });
  }, [onChangeVariableHandler]);
  React.useEffect(function () {
    if (!isEmpty(selectedDataset)) {
      setIsLoading(true);
      setError(false);
      var qp = {};
      var pp = [selectedDataset];
      var _url = getUrlService('datasets', pp, qp);
      log(_url, 'URL datasets services', 'info');
      fetch(_url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        }
      }).then(function (response) {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 403) {
          var jr = response.json();
          setError(jr.message);
          setIsLoading(false);
          return response.json();
        } else if (response.status === 401) {
          var errmsg = response.statusText || 'No handled error';
          setError(errmsg);
          setIsLoading(false);
          return Promise.reject(new Error(errmsg));
        }
        return response.json();
      }).then(function (json) {
        setIsLoading(false);
        log(json, 'Fetch dataset', 'info');
        if (json.error) {
          setError(json.message);
          setIsLoading(false);
          dispatch({
            type: 'SET_DATASET',
            value: undefined
          });
        } else if (json.data) {
          if (typeof onLoadingDatasets === 'function') {
            onLoadingDatasets(json.data);
          }
          dispatch({
            type: 'SET_DATASETS',
            value: [json.data]
          });
          datasetChangeHandler(json.data);
        }
      })["catch"](function (error) {
        console.error(error);
        setError(error.toString());
        setIsLoading(false);
      });
    }
  }, [selectedDataset]);
  React.useEffect(function () {
    if (selectedDataset !== undefined) return null;
    if (!isEmpty(project) && !isEmpty(modeltype) && !isEmpty(type)) {
      setIsLoading(true);
      setError(false);
      var qp = {
        project: project,
        "case": modeltype.toUpperCase(),
        type: type
      };
      var pp = [];
      var _url = getUrlService('datasets', pp, qp);
      log(_url, 'URL datasets services', 'info');
      fetch(_url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        }
      }).then(function (response) {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 403) {
          var jr = response.json();
          setError(jr.message);
          setIsLoading(false);
          return response.json();
        } else if (response.status === 401) {
          var errmsg = response.statusText || 'No handled error';
          setError(errmsg);
          setIsLoading(false);
          return Promise.reject(new Error(errmsg));
        }
        return response.json();
      }).then(function (json) {
        setIsLoading(false);
        log(json, 'Fetch datasets', 'info');
        if (json.error) {
          setError(json.message || json.status);
          setIsLoading(false);
          dispatch({
            type: 'SET_DATASETS',
            value: undefined
          });
        } else if (Array.isArray(json.data)) {
          if (typeof onLoadingDatasets === 'function') {
            onLoadingDatasets(json.data);
          }
          dispatch({
            type: 'SET_DATASETS',
            value: json.data
          });
        } else {
          if (typeof onLoadingDatasets === 'function') {
            onLoadingDatasets([json.data]);
          }
          dispatch({
            type: 'SET_DATASETS',
            value: [json.data]
          });
        }
      })["catch"](function (error) {
        console.error(error);
        setError(error.toString());
        setIsLoading(false);
      });
    }
  }, [onLoadingDatasets, project, modeltype, type]);
  React.useEffect(function () {
    if (Array.isArray(datasets)) {
      if (datasets.length > 0) {
        datasetChangeHandler(datasets[0], datasets);
      }
    }
  }, [datasetChangeHandler, datasets]);
  React.useEffect(function () {
    console.log(currentVariable, 'currentVariable&&');
    if (Array.isArray(variables)) {
      if (variables.length > 0) {
        var curvar = variables[0].name;
        if (currentVariable && !isEmpty(currentVariable)) {
          curvar = currentVariable;
        } else if (variables.length > 1) {
          var variableTotal = variables.filter(function (varr) {
            return varr.isTotal == 1;
          })[0];
          if (variableTotal) curvar = variableTotal.name;
        }
        setVariable(curvar);
        variableChangeHandler(curvar, variables);
      }
    }
  }, [variableChangeHandler, variables, currentVariable]);
  React.useEffect(function () {
    if (!isEmpty(dataType)) {
      setType(dataType);
    }
  }, [dataType]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, error && /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, t('ControlPanel.Error_loading_message')), withTypeSelect && !error && /*#__PURE__*/React.createElement(FormControl$1, {
    fullWidth: true,
    className: classes.formControl
  }, /*#__PURE__*/React.createElement(FormLabel, {
    className: classes.formLabel
  }, t('ControlPanel.Select_data_type')), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    direction: "column",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    size: "small",
    value: type,
    exclusive: true,
    onChange: function onChange(e, newval) {
      return handleButtonChange(newval, toggleButtons);
    }
  }, toggleButtons && toggleButtons.map(function (but, id) {
    return but.visible && /*#__PURE__*/React.createElement(ToggleButton, {
      disabled: disabled,
      key: id,
      value: but.value,
      className: classes.themeToggleButton
    }, /*#__PURE__*/React.createElement(Typography$1, {
      variant: "button",
      style: {
        textTransform: 'capitalize'
      }
    }, but.label));
  }))))), !error && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormControl$1, {
    className: hidden ? classes.hidden : classes.formControl
  }, /*#__PURE__*/React.createElement(FormLabel, {
    htmlFor: "dataset"
  }, title), isLoading ? /*#__PURE__*/React.createElement(LinearProgress, {
    className: classes.linearProgress
  }) : error ? /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, "Impossible de charger les donn\xE9es.") : dataset && /*#__PURE__*/React.createElement(Select, {
    disabled: disabled,
    value: dataset,
    onChange: function onChange(e) {
      return datasetChangeHandler(e.target.value, datasets);
    },
    inputProps: {
      name: 'dataset',
      id: 'dataset'
    }
  }, datasets && datasets.map(function (dataset, index) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: index,
      value: dataset
    }, dataset.title);
  }))), /*#__PURE__*/React.createElement(FormControl$1, {
    className: classes.formControl
  }, /*#__PURE__*/React.createElement(FormLabel, {
    htmlFor: "variable"
  }, t('ControlPanel.List_of_variables')), isLoading ? /*#__PURE__*/React.createElement(LinearProgress, {
    className: classes.linearProgress
  }) : error ? /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, "Impossible de charger les variables.") : /*#__PURE__*/React.createElement(Select, {
    disabled: disabled,
    value: variable,
    onChange: function onChange(e) {
      return variableChangeHandler(e.target.value, variables);
    },
    inputProps: {
      name: 'variable',
      id: 'variable'
    }
  }, variables && variables.map(function (variable, index) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: index,
      value: variable.name
    }, variable.title);
  })))));
});

var useStyles$M = makeStyles(function (theme) {
  return {
    formControl: {
      margin: theme.spacing(1),
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(2),
      width: '90%',
      marginLeft: '5%'
    },
    slider: {
      padding: '10px 0px'
    }
  };
});
var AriaOpacitySlider = (function (_ref) {
  var title = _ref.title,
    onChangeOpacityHandler = _ref.onChangeOpacityHandler;
  var classes = useStyles$M();
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0],
    dispatch = _useAriaAppStore[1];
  var _useState = useState(100 * store['map'].opacity),
    opacity = _useState[0],
    setOpacity = _useState[1];
  var onChangeOpacity = useCallback(function (event, opaVal) {
    setOpacity(opaVal);
    if (typeof onChangeOpacityHandler === 'function') {
      onChangeOpacityHandler(0.01 * opaVal);
    }
    if (dispatch) {
      dispatch({
        type: 'SET_OPACITY',
        value: 0.01 * opaVal
      });
    }
  }, [onChangeOpacityHandler]);
  return /*#__PURE__*/React.createElement(FormControl$1, {
    className: classes.formControl
  }, /*#__PURE__*/React.createElement(FormLabel, {
    id: "opacity-slider"
  }, title), /*#__PURE__*/React.createElement(Slider, {
    value: opacity,
    "aria-labelledby": "opacity-slider",
    onChange: onChangeOpacity
  }));
});

var useStyles$N = makeStyles(function (theme) {
  return {
    formControl: {
      margin: theme.spacing(1),
      marginBottom: theme.spacing(2),
      width: '95%',
      minWidth: '50%',
      overflowY: 'auto',
      height: '100%'
    },
    radioGroup: {
      display: 'flex',
      justifyContent: 'space-around'
    },
    selectEmpty: {
      marginTop: theme.spacing(2)
    },
    hidden: {
      display: 'None'
    }
  };
});
var AriaComplainHistory = (function (_ref) {
  var title = _ref.title,
    hidden = _ref.hidden,
    disabled = _ref.disabled;
  var classes = useStyles$N();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(undefined),
    error = _useState[0],
    setError = _useState[1];
  var _useState2 = useState(false),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0],
    dispatch = _useAriaAppStore[1];
  var complainDate = store['timeframe'] ? store['timeframe'].obj : undefined;
  var newComplain = store['complain'].created;
  var _useState3 = useState([]),
    complains = _useState3[0],
    setComplains = _useState3[1];
  var _useState4 = useState(undefined),
    selectedComplain = _useState4[0],
    setSelectedComplain = _useState4[1];
  var _useState5 = useState('hour'),
    filter = _useState5[0],
    setFilter = _useState5[1];
  React.useEffect(function () {
    if (complainDate instanceof Date) {
      setIsLoading(true);
      setError(false);
      var start_date = new Date();
      start_date.setTime(complainDate.getTime() - (60 + 1) * 60 * 1000);
      var end_date = new Date(complainDate.getTime() - (60 + 1));
      if (filter === 'day') {
        start_date.setTime(complainDate.getTime());
        start_date.setHours(0);
        start_date.setMinutes(0);
        start_date.setSeconds(0);
        end_date.setTime(complainDate.getTime());
        end_date.setHours(23);
        end_date.setMinutes(59);
        end_date.setSeconds(59);
      }
      var qp = {};
      var pp;
      if (process.env.REACT_APP_API_VERSION !== 'v1') {
        pp = [];
        qp = {
          client: process.env.REACT_APP_CLIENT_NAME,
          start_date: parseTime(start_date, '{y}-{m}-{d}T{h}:{i}:{s}', true),
          end_date: parseTime(end_date, '{y}-{m}-{d}T{h}:{i}:{s}', true),
          type: 'all'
        };
      }
      var _url = getUrlService('ariaview/complains', pp, qp);
      log(_url, "Get Complains list");
      fetch(_url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        }
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        setIsLoading(false);
        log(json);
        if (Array.isArray(json.data)) {
          setComplains(json.data);
          dispatch({
            type: 'SET_COMPLAINS',
            value: json.data
          });
        }
      })["catch"](function (error) {
        setError(error.toString());
        setIsLoading(false);
      });
    }
  }, [complainDate, newComplain, filter]);
  var itemClickHandler = React.useCallback(function (cp) {
    setSelectedComplain(cp);
    if (cp.lat && cp.lon) {
      dispatch({
        type: 'SET_SELECTED_COMPLAINT',
        value: cp
      });
    }
  }, []);
  var handleFilterChange = function handleFilterChange(event) {
    setFilter(event.target.value);
  };
  var onCloseComplaintDetailsHandler = function onCloseComplaintDetailsHandler(e) {
    setSelectedComplain(undefined);
    dispatch({
      type: 'SET_SELECTED_COMPLAINT',
      value: undefined
    });
  };
  return /*#__PURE__*/React.createElement(FormControl$1, {
    fullWidth: true,
    className: hidden ? classes.hidden : classes.formControl,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(FormLabel, {
    htmlFor: "date-model"
  }, title), error ? /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, t('ControlPanel.Cannot_load_variables_from_server')) : complains && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RadioGroup, {
    row: true,
    className: classes.radioGroup,
    "aria-label": "filter",
    name: "filter",
    value: filter,
    onChange: handleFilterChange
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "day",
    control: /*#__PURE__*/React.createElement(Radio, null),
    label: t("Complain.Day"),
    labelPlacement: "start"
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "hour",
    control: /*#__PURE__*/React.createElement(Radio, null),
    label: t("Complain.Hour"),
    labelPlacement: "start"
  })), /*#__PURE__*/React.createElement(List, {
    className: classes.root
  }, complains.map(function (cp) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: "fragment-" + cp.id
    }, /*#__PURE__*/React.createElement(ListItem, {
      key: cp.id,
      role: undefined,
      dense: true,
      button: true,
      onClick: function onClick() {
        return itemClickHandler(cp);
      }
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement(RoomIcon, {
      style: cp.type == 'complain' ? {
        color: '#cb852b'
      } : {
        color: '#2981ca'
      }
    })), /*#__PURE__*/React.createElement(ListItemAvatar, {
      style: {
        width: "50%"
      }
    }, /*#__PURE__*/React.createElement(Typography$1, {
      color: "primary"
    }, cp.observer_name)), /*#__PURE__*/React.createElement(ListItemText$1, null, /*#__PURE__*/React.createElement(Typography$1, null, "" + parseTime(cp.start_date, '{h}:{i}')))), selectedComplain && selectedComplain.id == cp.id && /*#__PURE__*/React.createElement(ComplainDetails, {
      key: "Details-" + cp.id,
      complain: selectedComplain,
      onClose: onCloseComplaintDetailsHandler
    }));
  }))), isLoading && /*#__PURE__*/React.createElement(LinearProgress, {
    className: classes.linearProgress
  }));
});
var ComplainDetails = function ComplainDetails(_ref2) {
  var complain = _ref2.complain,
    onClose = _ref2.onClose;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  return /*#__PURE__*/React.createElement(List, null, /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(ListItemText$1, null, t('Complain.Location') + ": " + complain.lat + ", " + complain.lon)), /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement(CommentIcon, null)), /*#__PURE__*/React.createElement(ListItemText$1, null, "" + complain.comment), /*#__PURE__*/React.createElement(ListItemSecondaryAction, null, /*#__PURE__*/React.createElement(IconButton, {
    onClick: onClose
  }, /*#__PURE__*/React.createElement(CloseIcon, null)))));
};

var useStyles$O = makeStyles(function (theme) {
  return {
    formControl: {
      margin: theme.spacing(1),
      marginBottom: theme.spacing(2),
      width: '95%',
      minWidth: '50%'
    },
    selectEmpty: {
      marginTop: theme.spacing(2)
    },
    hidden: {
      display: 'None'
    }
  };
});
var AriaDatePicker = (function (_ref) {
  var title = _ref.title,
    hidden = _ref.hidden,
    disabled = _ref.disabled,
    withoutInitTimeseries = _ref.withoutInitTimeseries;
  var classes = useStyles$O();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(undefined),
    error = _useState[0],
    setError = _useState[1];
  var _useState2 = useState(false),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0],
    dispatch = _useAriaAppStore[1];
  var dataset = store['dataset'];
  var modeltype = store['case'];
  var _useState3 = useState(undefined),
    cdate = _useState3[0],
    setCDate = _useState3[1];
  var _useState4 = useState(undefined),
    minDate = _useState4[0],
    setMinDate = _useState4[1];
  var _useState5 = useState(undefined),
    maxDate = _useState5[0],
    setMaxDate = _useState5[1];
  var _useState6 = useState([]),
    dates = _useState6[0],
    setDates = _useState6[1];
  React.useEffect(function () {
    if (dataset && !isEmpty(dataset.name)) {
      setIsLoading(true);
      setError(false);
      var pp;
      var qp = {
        info: 'dates'
      };
      pp = [dataset.name];
      var _url = getUrlService('datasets', pp, qp);
      fetch(_url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        }
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        setIsLoading(false);
        log(json, 'SIM DATES');
        if (Array.isArray(json.data)) {
          var dateObjs = json.data.map(function (d) {
            var dObj = new Date(d + 'T12:00:00.00Z');
            return dObj;
          });
          setDates(dateObjs);
        }
      })["catch"](function (error) {
        setError(error.toString());
        setIsLoading(false);
      });
    }
  }, [dataset]);
  var dateChangeHandler = useCallback(function (selectedDate) {
    log(selectedDate, 'Selected data: ');
    setCDate(selectedDate.toDate());
  }, []);
  useEffect(function () {
    if (dates.length > 0) {
      log(dates, 'Dates', 'error');
      var miDate = dates[0];
      var maDate = dates[0];
      dates.forEach(function (d) {
        miDate = Math.min(miDate, d);
        maDate = Math.max(maDate, d);
      });
      setMinDate(miDate);
      setMaxDate(maDate);
      var _currdate = dates[dates.length - 1];
      setCDate(_currdate);
      log(_currdate, 'Max Date', 'error');
    }
  }, [dates]);
  useEffect(function () {
    if (cdate instanceof Date) {
      log(cdate, 'DATE HAS CHANGED', 'error');
      dispatch({
        type: 'SET_DATE',
        value: cdate
      });
      var startDate = new Date();
      startDate.setTime(cdate.getTime());
      startDate.setHours(0);
      startDate.setMinutes(0);
      startDate.setSeconds(0);
      var endDate = new Date();
      endDate.setTime(cdate.getTime());
      endDate.setHours(23);
      endDate.setMinutes(0);
      endDate.setSeconds(0);
      if (!withoutInitTimeseries) {
        dispatch({
          type: 'SET_TIMESERIES',
          value: {
            datedeb: {
              value: startDate,
              max: endDate
            },
            datefin: {
              value: endDate,
              min: startDate,
              max: endDate
            }
          }
        });
      }
    }
    dispatch({
      type: 'SET_OPEN_CHART',
      value: 'TIMEFRAME'
    });
  }, [cdate, withoutInitTimeseries]);
  return /*#__PURE__*/React.createElement(FormControl$1, {
    fullWidth: true,
    className: hidden || modeltype.toLowerCase().startsWith('rcp') ? classes.hidden : classes.formControl,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(FormLabel, {
    htmlFor: "date-picker"
  }, title), isLoading ? /*#__PURE__*/React.createElement(LinearProgress, {
    className: classes.linearProgress
  }) : error ? /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, t('ControlPanel.Cannot_load_variables_from_server')) : cdate && minDate && maxDate && /*#__PURE__*/React.createElement(DatePicker, {
    disableToolbar: true,
    autoOk: true,
    variant: "inline",
    ampm: false,
    value: cdate,
    onChange: dateChangeHandler,
    minDate: minDate,
    format: "yyyy-MM-DD",
    inputProps: {
      name: 'date-picker',
      id: 'date-picker'
    }
  }));
});

var drawerWidth$1 = '450px';
var mdWidth$1 = '500px';
var halfWidth$1 = '42%';
var fullWidth$1 = '100vw';
var logoHeight = '20px';
var MONTHLABELS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
var SEASONLABELS = ['DJF', 'MAM', 'JJA', 'SON'];
var tavgButtons = function tavgButtons(base) {
  if (base === 'CLIMATO') {
    return [{
      label: 'year',
      value: 'year'
    }, {
      label: 'month',
      value: 'month'
    }, {
      label: 'season',
      value: 'season'
    }];
  } else {
    return [{
      label: 'Année',
      value: 'year'
    }, {
      label: 'Mois',
      value: 'month'
    }];
  }
};
var SELECTED_VARLIST = undefined;
var ARIAVIEW_SITES = [{
  name: 'LAGOA',
  label: 'LAGOA',
  type: 'airq',
  visu: 'LcS'
}, {
  name: 'NOSDO',
  label: 'NOSDO',
  type: 'airq',
  visu: 'LcS'
}];
var useStyles$P = makeStyles(function (theme) {
  var _drawer, _drawerOpen, _contentShift, _footerShift;
  return {
    root: {
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      height: '100%'
    },
    toolbar: theme.mixins.toolbar,
    appBar: {
      zIndex: theme.zIndex.drawer + 1
    },
    drawer: (_drawer = {}, _drawer[theme.breakpoints.down('xs')] = {
      width: fullWidth$1
    }, _drawer[theme.breakpoints.between('sm', 'md')] = {
      width: halfWidth$1
    }, _drawer[theme.breakpoints.up('md')] = {
      width: mdWidth$1
    }, _drawer.width = drawerWidth$1, _drawer.flexShrink = 0, _drawer.whiteSpace = 'nowrap', _drawer),
    drawerOpen: (_drawerOpen = {
      width: drawerWidth$1,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    }, _drawerOpen[theme.breakpoints.down('xs')] = {
      width: fullWidth$1
    }, _drawerOpen[theme.breakpoints.between('sm', 'md')] = {
      width: halfWidth$1
    }, _drawerOpen[theme.breakpoints.up('md')] = {
      width: mdWidth$1
    }, _drawerOpen),
    drawerClose: {
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      }),
      overflowX: 'hidden',
      width: theme.spacing(5)
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(0.2),
      background: '#666',
      display: 'flex',
      flexDirection: 'column',
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      }),
      marginLeft: theme.spacing(5)
    },
    contentShift: (_contentShift = {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen
      }),
      marginLeft: drawerWidth$1
    }, _contentShift[theme.breakpoints.down('xs')] = {
      marginLeft: fullWidth$1
    }, _contentShift[theme.breakpoints.between('sm', 'md')] = {
      marginLeft: halfWidth$1
    }, _contentShift[theme.breakpoints.up('md')] = {
      marginLeft: mdWidth$1
    }, _contentShift),
    footer: {
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(0.5),
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      }),
      marginLeft: theme.spacing(5),
      overflowY: 'auto'
    },
    footerShift: (_footerShift = {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen
      }),
      marginLeft: drawerWidth$1
    }, _footerShift[theme.breakpoints.down('xs')] = {
      marginLeft: fullWidth$1
    }, _footerShift[theme.breakpoints.between('sm', 'md')] = {
      marginLeft: halfWidth$1
    }, _footerShift[theme.breakpoints.up('md')] = {
      marginLeft: mdWidth$1
    }, _footerShift.overflowY = 'auto', _footerShift),
    madeWith: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    marginLink: {
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5)
    },
    logo: {
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5)
    }
  };
});
var AriaApp = function AriaApp(_ref) {
  var _clsx, _clsx2, _clsx3, _clsx4;
  var type = _ref.type,
    withDrawer = _ref.withDrawer,
    withInfoPanel = _ref.withInfoPanel,
    clickOnExitHandler = _ref.clickOnExitHandler,
    userinfo = _ref.userinfo,
    organisation = _ref.organisation,
    project = _ref.project,
    logo = _ref.logo,
    logo2 = _ref.logo2,
    sites = _ref.sites,
    studyCase = _ref.studyCase,
    epsg = _ref.epsg,
    title = _ref.title,
    userDataLayer = _ref.userDataLayer;
  var classes = useStyles$P();
  var matches = useMediaQuery(function (theme) {
    return theme.breakpoints.up('md');
  });
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var mapObj = React.useRef(null);
  var _React$useState = React.useState(withDrawer && matches),
    open = _React$useState[0],
    setOpen = _React$useState[1];
  var toggleDrawer = function toggleDrawer() {
    setOpen(function (x) {
      return !x;
    });
  };
  var _React$useState2 = React.useState(studyCase || ''),
    site = _React$useState2[0],
    setSite = _React$useState2[1];
  var _useState = useState({
      name: ''
    }),
    dataset = _useState[0],
    setDataset = _useState[1];
  var _useState2 = useState(undefined),
    currentDate = _useState2[0],
    setCurrentDate = _useState2[1];
  var _useState3 = useState(undefined),
    currentTime = _useState3[0],
    setCurrentTime = _useState3[1];
  var _useState4 = useState({
      name: ''
    }),
    currentVariable = _useState4[0],
    setCurrentVariable = _useState4[1];
  var _useState5 = useState(0.75),
    opacity = _useState5[0],
    setOpacity = _useState5[1];
  var _useState6 = useState(undefined),
    domain = _useState6[0];
  var _useState7 = useState({}),
    interestedZone = _useState7[0],
    setInterestedZone = _useState7[1];
  var _useState8 = useState(false),
    isExtracting = _useState8[0],
    setIsExtracting = _useState8[1];
  var _useState9 = useState('avg'),
    dataModifierValue = _useState9[0],
    setDataModifierValue = _useState9[1];
  var _useState10 = useState('year'),
    timeavgMode = _useState10[0],
    setTimeavgMode = _useState10[1];
  var _useState11 = useState('YEAR'),
    timeavgValue = _useState11[0],
    setTimeavgValue = _useState11[1];
  var _useState12 = useState('rcp85'),
    RCPValue = _useState12[0],
    setRCPValue = _useState12[1];
  var _useState13 = useState({}),
    gouvernorat = _useState13[0],
    setGouvernorat = _useState13[1];
  var onChangeSiteHandler = useCallback(function (s) {
    setSite(s);
  }, []);
  var onChangeDatasetHandler = useCallback(function (ds) {
    setDataset(ds);
  }, []);
  var onChangeVariableHandler = useCallback(function (v) {
    setCurrentVariable(v);
  }, []);
  var onChangeDateHandler = useCallback(function (v) {
    setCurrentDate(v);
  }, []);
  var onChangeTimeHandler = useCallback(function (v) {
    setCurrentTime(v);
  }, []);
  var onChangeOpacityHandler = useCallback(function (v) {
    setOpacity(v);
  }, []);
  var onChangeDataModifierHandler = React.useCallback(function (v) {
    setDataModifierValue(v);
  }, []);
  var onChangeTimeAveragingModeHandler = React.useCallback(function (v) {
    setTimeavgMode(v);
    if (v === 'year') {
      setTimeavgValue('YEAR');
    } else if (v === 'month') {
      setTimeavgValue('JAN');
    } else if (v === 'season') {
      setTimeavgValue('DJF');
    }
  }, []);
  var onSelectTimeAveragingValueHandler = React.useCallback(function (v) {
    setTimeavgValue(v);
  }, []);
  var onChangeRCPHandler = React.useCallback(function (v) {
    setRCPValue(v);
  }, []);
  var onClickHideControlPanel = React.useCallback(function (open) {
    setOpen(open);
  }, []);
  var onFeatureClickedHandler = React.useCallback(function (featCollection, layer, style) {
    var featname = featCollection.features[0].properties['ADM1_NAME'];
    setGouvernorat({
      name: featname,
      layer: layer,
      style: style
    });
  }, []);
  var onRunningExtraction = React.useCallback(function (val) {
    setIsExtracting(val);
  }, []);
  useEffect(function () {
    setTimeout(function () {
      if (mapObj && mapObj.current) {
        mapObj.current.leafletElement.invalidateSize({
          pan: true
        });
      }
    }, 300);
  }, [open]);
  useEffect(function () {
    setOpen(matches);
  }, [matches]);
  return /*#__PURE__*/React.createElement(MuiPickersUtilsProvider, {
    utils: MomentUtils
  }, /*#__PURE__*/React.createElement(AriaAppStoreProvider, null, /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, type !== 'climat' && /*#__PURE__*/React.createElement(CssBaseline, null), /*#__PURE__*/React.createElement(AriaAppBar, {
    hidden: type === 'climat',
    withoutLogout: type === 'climat',
    drawerIsOpen: open,
    organisation: organisation,
    logo: logo,
    logo2: logo2,
    title: title,
    toggleDrawer: toggleDrawer,
    onClickOnExit: clickOnExitHandler,
    userinfo: userinfo
  }), withDrawer && /*#__PURE__*/React.createElement(Drawer, {
    variant: "permanent",
    className: clsx(classes.drawer, (_clsx = {}, _clsx[classes.drawerOpen] = open, _clsx[classes.drawerClose] = !open, _clsx)),
    classes: {
      paper: clsx((_clsx2 = {}, _clsx2[classes.drawerOpen] = open, _clsx2[classes.drawerClose] = !open, _clsx2))
    }
  }, type !== 'climat' && /*#__PURE__*/React.createElement("div", {
    className: classes.toolbar
  }), /*#__PURE__*/React.createElement(AriaControlPanel, {
    onClickHideControlPanel: onClickHideControlPanel,
    drawerIsOpen: open,
    withToolbar: true,
    toolbarButtons: ['Help', 'Info', 'Report'],
    infoFilename: "Info.pdf",
    helpFilename: "Help.pdf"
  }, type === 'climat' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AriaRadioInput, {
    buttons: [{
      label: 'Moyenne',
      value: 'avg'
    }, {
      label: 'Anormalie',
      value: 'ano'
    }],
    selected: "avg",
    selectHandler: onChangeDataModifierHandler,
    disabled: isExtracting
  }), /*#__PURE__*/React.createElement(AriaRadioInput, {
    withLabel: "Sc\xE9nario climatique",
    buttons: [{
      label: '4.5',
      value: 'rcp45'
    }, {
      label: '8.5',
      value: 'rcp85'
    }],
    selected: "rcp85",
    selectHandler: onChangeRCPHandler,
    disabled: isExtracting
  }), /*#__PURE__*/React.createElement(AriaDatasetSelect, {
    title: "Select dataset",
    project: project,
    site: RCPValue,
    dataType: "clim",
    disabled: isExtracting,
    currentVariable: currentVariable.name,
    hidden: true,
    selectedVarlist: timeavgMode === 'month' ? SELECTED_VARLIST : undefined,
    onChangeDatasetHandler: onChangeDatasetHandler,
    onChangeVariableHandler: onChangeVariableHandler
  }), /*#__PURE__*/React.createElement(AriaRadioInput, {
    withLabel: "Echelle temporelle",
    buttons: tavgButtons(),
    selected: timeavgMode,
    disabled: isExtracting,
    selectHandler: onChangeTimeAveragingModeHandler
  }, timeavgMode === 'season' && /*#__PURE__*/React.createElement(AriaSelect, {
    options: SEASONLABELS,
    selected: "DJF",
    disabled: isExtracting,
    onSelectHandler: onSelectTimeAveragingValueHandler
  }), timeavgMode === 'month' && /*#__PURE__*/React.createElement(AriaSelect, {
    options: MONTHLABELS,
    selected: "JAN",
    disabled: isExtracting,
    onSelectHandler: onSelectTimeAveragingValueHandler
  })), /*#__PURE__*/React.createElement(AriaDateSelect, {
    title: "Select a date",
    isUTC: true,
    dateformat: "{y}",
    dataset: dataset.name,
    hidden: true,
    onChangeDateHandler: onChangeDateHandler,
    disabled: isExtracting
  }), /*#__PURE__*/React.createElement(TimeSliderControl, {
    title: "Moyenne 20 ans centr\xE9e sur :",
    isUTC: true,
    date: currentDate,
    dataset: dataset.name,
    variable: currentVariable.name,
    epsg: dataset.epsg || epsg || 4326,
    modifier: dataModifierValue,
    timeavg: timeavgValue,
    datetimeFormat: "{y}",
    onChangeTimeframeHandler: onChangeTimeHandler,
    disabled: isExtracting
  }), /*#__PURE__*/React.createElement(AriaOpacitySlider, {
    title: "Opacit\xE9",
    onChangeOpacityHandler: onChangeOpacityHandler
  })), type === 'standard' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AriaSiteSelect, {
    title: "Select a user case",
    sites: sites,
    onChangeHandler: onChangeSiteHandler
  }), /*#__PURE__*/React.createElement(AriaDatasetSelect, {
    title: "Select dataset",
    project: project,
    site: site.name,
    dataType: site.type,
    visuType: site.visu,
    onChangeDatasetHandler: onChangeDatasetHandler,
    onChangeVariableHandler: onChangeVariableHandler
  }), /*#__PURE__*/React.createElement(AriaDateSelect, {
    title: "Select a date",
    isUTC: true,
    dataset: dataset.name,
    onChangeDateHandler: onChangeDateHandler
  }), /*#__PURE__*/React.createElement(TimelineControl, {
    title: "Select a timeframe",
    isUTC: true,
    date: currentDate,
    dataset: dataset.name,
    variable: currentVariable.name,
    epsg: dataset.epsg || epsg || 4326,
    onChangeTimeframeHandler: onChangeTimeHandler
  }), /*#__PURE__*/React.createElement(AriaOpacitySlider, {
    title: "Opacit\xE9",
    onChangeOpacityHandler: onChangeOpacityHandler
  })), type === 'demo' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AriaDatasetSelect, {
    title: "Select dataset",
    project: project,
    site: site.name,
    dataType: site.type,
    visuType: site.visu,
    onChangeDatasetHandler: onChangeDatasetHandler,
    onChangeVariableHandler: onChangeVariableHandler
  }), /*#__PURE__*/React.createElement(AriaDateSelect, {
    title: "Select a date",
    isUTC: true,
    dateformat: "{y}-{m}-{d}",
    dataset: dataset.name,
    onChangeDateHandler: onChangeDateHandler
  }), /*#__PURE__*/React.createElement(TimelineControl, {
    title: "Select a timeframe",
    isUTC: true,
    date: currentDate,
    dataset: dataset.name,
    variable: currentVariable.name,
    epsg: dataset.epsg || epsg || 4326,
    onChangeTimeframeHandler: onChangeTimeHandler
  }), /*#__PURE__*/React.createElement(AriaOpacitySlider, {
    title: "Opacit\xE9",
    onChangeOpacityHandler: onChangeOpacityHandler
  })), type === 'ariaview' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AriaDatasetSelect, {
    title: "Select dataset",
    project: 'ARIAVIEW',
    site: ARIAVIEW_SITES[1].name,
    dataType: ARIAVIEW_SITES[1].type,
    visuType: ARIAVIEW_SITES[1].visu,
    hidden: true,
    selectedDataset: 'ARIAVIEW_NOSDO_RESULT_LcS'
  }), /*#__PURE__*/React.createElement(AriaDatePicker, {
    title: t('ControlPanel.Select_a_date')
  }), /*#__PURE__*/React.createElement(TimelineControl, {
    title: t('ControlPanel.Select_a_timeframe'),
    isUTC: false,
    datetimeFormat: "{h}:{i}"
  }), /*#__PURE__*/React.createElement(AriaComplainHistory, {
    title: t('ControlPanel.Complain_history')
  })))), /*#__PURE__*/React.createElement("main", {
    className: clsx(classes.content, (_clsx3 = {}, _clsx3[classes.contentShift] = withDrawer && open, _clsx3))
  }, type === 'climat' && /*#__PURE__*/React.createElement(AriaMap, {
    mapObj: mapObj,
    dom: dataset.domain || domain,
    dataset: dataset,
    site: RCPValue,
    epsg: 4326,
    variable: currentVariable,
    date: currentDate,
    time: currentTime,
    modifier: dataModifierValue,
    timeavg: timeavgValue,
    stat: "mean",
    opacity: opacity,
    userDataLayer: userDataLayer,
    onFeatureClickedHandler: onFeatureClickedHandler
  }, withInfoPanel && /*#__PURE__*/React.createElement(AriaDrawToolbar, {
    setInterestedZone: setInterestedZone,
    preLoadedLayers: gouvernorat,
    limitingZone: userDataLayer.polygon
  })), type === 'standard' && /*#__PURE__*/React.createElement(AriaMap, {
    mapObj: mapObj,
    dom: dataset.domain || domain,
    dataset: dataset,
    site: site.name,
    epsg: dataset.epsg || epsg || 4326,
    variable: currentVariable,
    date: currentDate,
    time: currentTime,
    opacity: opacity
  }, withInfoPanel && /*#__PURE__*/React.createElement(AriaDrawToolbar, {
    setInterestedZone: setInterestedZone
  })), type === 'demo' && /*#__PURE__*/React.createElement(AriaMap, {
    mapObj: mapObj,
    dom: dataset.domain || domain,
    dataset: dataset,
    site: site.name,
    epsg: dataset.epsg || epsg || 4326,
    variable: currentVariable,
    date: currentDate,
    time: currentTime,
    opacity: opacity
  }, withInfoPanel && /*#__PURE__*/React.createElement(AriaDrawToolbar, {
    setInterestedZone: setInterestedZone
  })), type === 'ariaview' && /*#__PURE__*/React.createElement(AriaMap, {
    mapObj: mapObj,
    opacity: opacity,
    withComplains: true
  })), /*#__PURE__*/React.createElement("footer", {
    className: clsx(classes.footer, (_clsx4 = {}, _clsx4[classes.footerShift] = withDrawer && open, _clsx4))
  }, withInfoPanel && /*#__PURE__*/React.createElement(React.Fragment, null, type === 'ariaview' && /*#__PURE__*/React.createElement(AriaInfoPanel, {
    infoType: withInfoPanel.type,
    datetimeFormat: "{y}-{m}-{d} {h}h"
  }), type === 'climat' && /*#__PURE__*/React.createElement(AriaInfoPanel, {
    infoType: withInfoPanel.type,
    variable: currentVariable,
    dataset: dataset.name,
    epsg: dataset.epsg || epsg || 4326,
    interestedZone: interestedZone,
    date: currentDate,
    time: currentTime,
    stats: 'mean,q10,q90',
    modifier: dataModifierValue,
    timeavg: timeavgValue,
    datetimeFormat: "{y}",
    onRunningExtraction: onRunningExtraction
  })), /*#__PURE__*/React.createElement(Typography, {
    className: classes.madeWith,
    variant: "caption",
    color: "textSecondary"
  }, /*#__PURE__*/React.createElement("img", {
    alt: process.env.REACT_APP_COPYRIGHT,
    src: logo,
    height: logoHeight,
    className: classes.logo
  }), " " + t('Footer.Copyright') + " ", /*#__PURE__*/React.createElement(Link, {
    color: "inherit",
    href: "http://www.aria.fr/",
    target: "_blank",
    className: classes.marginLink
  }, process.env.REACT_APP_COPYRIGHT), " " + process.env.REACT_APP_COPYRIGHT_YEAR + " - V" + process.env.REACT_APP_VERSION)))));
};
AriaApp.propTypes = {};

function MadeWithLove() {
  return /*#__PURE__*/React.createElement(Typography$1, {
    variant: "body2",
    color: "textSecondary",
    align: "center"
  }, 'Copyright ', /*#__PURE__*/React.createElement(Link, {
    color: "inherit",
    href: "https://www.aria.fr/"
  }, "ARIA Technologies"), ' 2020.');
}
var useStyles$Q = makeStyles(function (theme) {
  return {
    '@global': {
      body: {
        backgroundColor: theme.palette.background
      }
    },
    paper: {
      marginTop: theme.spacing(8),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main
    },
    form: {
      width: '100%',
      marginTop: theme.spacing(1)
    },
    submit: {
      margin: theme.spacing(3, 0, 2)
    },
    alert: {
      marginTop: theme.spacing(1),
      width: '100%'
    },
    linearProgress: {
      marginTop: theme.spacing(1),
      height: '5px',
      width: '100%'
    }
  };
});
function LogIn(_ref) {
  var tokenHandler = _ref.tokenHandler,
    anonymous = _ref.anonymous;
  var classes = useStyles$Q();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(''),
    username = _useState[0],
    setUsername = _useState[1];
  var _useState2 = useState(''),
    password = _useState2[0],
    setPassword = _useState2[1];
  var _useState3 = useState(undefined),
    error = _useState3[0],
    setError = _useState3[1];
  var _useState4 = useState(false),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var onLogin = React.useCallback(function (username, password) {
    setIsLoading(true);
    setError(false);
    var authserv = process.env.REACT_APP_API_AUTH_SERVICE || 'api-token';
    var _url = getUrlService(authserv);
    log(_url);
    fetch(_url, {
      method: 'POST',
      body: JSON.stringify({
        username: username,
        password: password,
        group: process.env.REACT_APP_PROJECT
      }),
      headers: {
        'Content-Type': 'application/json; charset=UTF-8'
      }
    }).then(function (response) {
      if (response.status === 200) {
        return response.json();
      } else if (response.status === 403) {
        return response.json();
      } else if (response.status === 404) {
        var errmsg = t('Login.Authentication_service_not_found');
        setError(errmsg);
        setIsLoading(false);
        return Promise.reject(new Error(errmsg));
      } else if (response.status === 401) {
        var _errmsg = response.statusText || t('Login.No_handled_error');
        setError(_errmsg);
        setIsLoading(false);
        return Promise.reject(new Error(_errmsg));
      } else {
        var _errmsg2 = response.statusText || t('Login.No_handled_error');
        setError(_errmsg2);
        setIsLoading(false);
        return Promise.reject(new Error(_errmsg2));
      }
    }).then(function (user) {
      setIsLoading(false);
      if (user) {
        log(user, 'User info', 'info');
        if (user.token) {
          setToken(user.token);
          if (typeof tokenHandler === 'function') {
            if (user.name) {
              tokenHandler(user.token, user.name);
            } else {
              tokenHandler(user.token);
            }
          }
        }
        if (user.name) {
          setUser(user.name);
        }
        if (user.error) {
          console.error(user.message);
          setError(user.message);
        }
      }
    })["catch"](function (error) {
      console.error(error);
      setError(error.toString());
      setIsLoading(false);
    });
  }, [tokenHandler]);
  React.useEffect(function () {
    if (typeof anonymous == 'object') {
      setTimeout(function () {
        onLogin(anonymous.username, anonymous.password);
      }, 500);
    }
  }, [anonymous, onLogin]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, typeof anonymous == 'undefined' ? /*#__PURE__*/React.createElement(Container, {
    component: "main",
    maxWidth: "xs"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.paper
  }, /*#__PURE__*/React.createElement(Avatar, {
    className: classes.avatar
  }, /*#__PURE__*/React.createElement(LockOutlinedIcon, null)), /*#__PURE__*/React.createElement(Typography$1, {
    component: "h1",
    variant: "h5"
  }, t('Login.Sign_in')), /*#__PURE__*/React.createElement("form", {
    className: classes.form,
    noValidate: true,
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      return false;
    }
  }, /*#__PURE__*/React.createElement(TextField$1, {
    variant: "outlined",
    margin: "normal",
    required: true,
    fullWidth: true,
    id: "username",
    label: t('Login.User_name'),
    name: "username",
    autoComplete: "username",
    autoFocus: true,
    value: username,
    onChange: function onChange(e) {
      return setUsername(e.target.value);
    },
    "data-testid": "user-field"
  }), /*#__PURE__*/React.createElement(TextField$1, {
    variant: "outlined",
    margin: "normal",
    required: true,
    fullWidth: true,
    name: "password",
    label: t('Login.Password'),
    type: "password",
    id: "password",
    autoComplete: "current-password",
    value: password,
    onChange: function onChange(e) {
      return setPassword(e.target.value);
    }
  }), /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    fullWidth: true,
    variant: "contained",
    color: "primary",
    className: classes.submit,
    "data-testid": "login-button",
    onClick: function onClick() {
      return onLogin(username, password);
    }
  }, t('Login.Login'))), isLoading && /*#__PURE__*/React.createElement(LinearProgress, {
    className: classes.linearProgress
  }), error && /*#__PURE__*/React.createElement(Alert$2, {
    severity: "error",
    className: classes.alert
  }, t('Login.User_or_Password_is_incorrect'))), /*#__PURE__*/React.createElement(Box, {
    mt: 5
  }, /*#__PURE__*/React.createElement(MadeWithLove, null))) : error && /*#__PURE__*/React.createElement(Container, {
    component: "main",
    maxWidth: "xs"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.paper
  }, /*#__PURE__*/React.createElement(Alert$2, {
    severity: "error",
    className: classes.alert
  }, t('Login.Authentication_problem'), " !"))));
}

var useStyles$R = makeStyles(function (theme) {
  return {
    formControl: {
      margin: theme.spacing(1),
      marginBottom: theme.spacing(2),
      width: '95%',
      minWidth: '50%'
    },
    linearProgress: {
      marginTop: theme.spacing(1)
    },
    themeToggleButton: {
      width: 'auto',
      '&$selected': {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.main
      }
    },
    formLabel: {
      marginBottom: theme.spacing(2)
    },
    hidden: {
      display: 'None'
    }
  };
});
var REMOVEDED_VARLIST$2 = ['u', 'v', 'winz', 'winm'];
var marks$1 = [{
  value: 0,
  label: '0%'
}, {
  value: 10,
  label: '20%'
}, {
  value: 25,
  label: '50%'
}, {
  value: 40,
  label: '80%'
}, {
  value: 50,
  label: '100%'
}, {
  value: 60,
  label: '120%'
}, {
  value: 75,
  label: '150%'
}, {
  value: 100,
  label: '200%'
}];
var AriaVariableSlider = (function (_ref) {
  var title = _ref.title,
    project = _ref.project,
    site = _ref.site,
    dataType = _ref.dataType,
    selectedVarlist = _ref.selectedVarlist,
    onLoadingDatasets = _ref.onLoadingDatasets,
    onChangeDatasetHandler = _ref.onChangeDatasetHandler,
    onToggleButtonChangeHandler = _ref.onToggleButtonChangeHandler,
    onChangeVariableHandler = _ref.onChangeVariableHandler,
    withTypeSelect = _ref.withTypeSelect,
    currentVariable = _ref.currentVariable,
    hidden = _ref.hidden,
    selectedDataset = _ref.selectedDataset,
    dv_name = _ref.dv_name,
    disabled = _ref.disabled,
    toggleButtons = _ref.toggleButtons,
    group = _ref.group,
    externalSourcesButton = _ref.externalSourcesButton;
  var classes = useStyles$R();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _React$useState = React.useState(undefined),
    error = _React$useState[0],
    setError = _React$useState[1];
  var _React$useState2 = React.useState(false),
    isLoading = _React$useState2[0],
    setIsLoading = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    actionToDo = _React$useState3[0],
    setActionToDo = _React$useState3[1];
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0],
    dispatch = _useAriaAppStore[1];
  var datasets = store['datasets'];
  var dataset = store['dataset'];
  var modeltype = site || store['case'];
  var _React$useState4 = React.useState(dataType || store['data_type']),
    type = _React$useState4[0],
    setType = _React$useState4[1];
  var _React$useState5 = React.useState([]),
    variables = _React$useState5[0],
    setVariables = _React$useState5[1];
  var _React$useState6 = React.useState(currentVariable || ''),
    setVariable = _React$useState6[1];
  var _React$useState7 = React.useState(),
    derivedVariables = _React$useState7[0],
    setDerivedVariables = _React$useState7[1];
  var _React$useState8 = React.useState(false),
    trigger = _React$useState8[0],
    setTrigger = _React$useState8[1];
  var _React$useState9 = React.useState(true),
    takeExternalSources = _React$useState9[0],
    setTakeExternalSources = _React$useState9[1];
  var datasetChangeHandler = useCallback(function (selectedDataset, datasets) {
    var gotDataset = selectedDataset;
    if (typeof selectedDataset === 'string' && Array.isArray(datasets)) {
      gotDataset = datasets.find(function (ds) {
        return ds.name === selectedDataset;
      });
    }
    if (gotDataset) {
      dispatch({
        type: 'SET_DATASET',
        value: gotDataset
      });
      dispatch({
        type: 'SET_OPEN_CHART',
        value: 'TIMEFRAME'
      });
      var filteredVars = gotDataset.variables.filter(function (varobj) {
        return REMOVEDED_VARLIST$2.indexOf(varobj.name.toLowerCase()) == -1;
      }).filter(function (v) {
        return v.group === group;
      });
      if (Array.isArray(selectedVarlist)) {
        filteredVars = filteredVars.filter(function (varobj) {
          return selectedVarlist.indexOf(varobj.name.toUpperCase()) > -1;
        });
      }
      log(filteredVars, 'filteredVars: ');
      setTrigger(true);
      setVariables(filteredVars);
      setDerivedVariables(filteredVars.filter(function (variable) {
        return variable.isTotal === 0;
      }));
      if (typeof onChangeDatasetHandler === 'function') {
        onChangeDatasetHandler(gotDataset);
      }
    }
  }, [onChangeDatasetHandler, selectedVarlist, group]);
  var handleButtonChange = function handleButtonChange(newVal, buttons) {
    setType(newVal);
    dispatch({
      type: 'SET_OPEN_CHART',
      value: 'TIMEFRAME'
    });
    var selectedBut = buttons.find(function (but) {
      return but.value === newVal;
    });
    if (typeof onToggleButtonChangeHandler === 'function') {
      onToggleButtonChangeHandler(selectedBut.value);
    }
  };
  var onCoeffAChange = function onCoeffAChange(event, newVal, variable) {
    setTrigger(false);
    var newVariables = variables.filter(function (variable) {
      return variable.isTotal === 0;
    }).filter(function (v) {
      return v.group === group;
    }).map(function (v, index) {
      if (v.name === variable.name) {
        return _extends({}, v, {
          transformA: v.transformA * (newVal * 2) / 100
        });
      }
      return derivedVariables[index];
    });
    setDerivedVariables(newVariables);
  };
  var handleSave = function handleSave() {
    var derivedVariablesCopy = [].concat(derivedVariables);
    if (!derivedVariablesCopy) return;
    dispatch({
      type: 'SET_EXTERNAL_SOURCES',
      value: true
    });
    if (!takeExternalSources) {
      dispatch({
        type: 'SET_EXTERNAL_SOURCES',
        value: false
      });
      derivedVariablesCopy = derivedVariablesCopy.map(function (v, index) {
        if (v.transform == 0) {
          return _extends({}, v, {
            transform: 1,
            transformA: 0
          });
        }
        return derivedVariables[index];
      });
    }
    var datasetName = store['dataset']['name'];
    var qp = {};
    var pp = [datasetName, 'derived_variables'];
    var _url = getUrlService('datasets', pp, qp);
    if (actionToDo === 'post') {
      fetch(_url, {
        method: 'POST',
        body: JSON.stringify({
          name: dvname,
          variables: derivedVariablesCopy,
          dataset: store['dataset']['id'],
          user: store['dataset']['user'],
          group: store['dataset']['group']
        }),
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        }
      }).then(function (response) {
        setActionToDo('put');
        return response.json();
      }).then(function (json) {
        dispatch({
          type: 'SET_DERIVED_VARIABLE',
          value: json
        });
      });
    } else if (actionToDo === 'put') {
      console.log(dv_name, 'dv_name **');
      pp = [datasetName, 'derived_variables', dv_name];
      var _url2 = getUrlService('datasets', pp, qp);
      fetch(_url2, {
        method: 'PUT',
        body: JSON.stringify({
          name: dv_name,
          variables: derivedVariablesCopy,
          dataset: store['dataset']['id'],
          user: store['dataset']['user'],
          group: store['dataset']['group']
        }),
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        }
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        dispatch({
          type: 'SET_DERIVED_VARIABLE',
          value: json
        });
      });
    }
  };
  var changeSwitchValue = useCallback(function (value) {
    setTakeExternalSources(value);
  });
  var variableChangeHandler = useCallback(function (selectedVariable, variables) {
    var gotVar = selectedVariable;
    if (typeof selectedVariable === 'string' && Array.isArray(variables)) {
      gotVar = variables.find(function (v) {
        return v.name === selectedVariable;
      });
    }
    setVariable(selectedVariable);
    if (gotVar) {
      dispatch({
        type: 'SET_VARIABLE',
        value: gotVar
      });
      if (typeof onChangeVariableHandler === 'function') {
        onChangeVariableHandler(gotVar);
      }
    }
    dispatch({
      type: 'SET_OPEN_CHART',
      value: 'TIMEFRAME'
    });
  }, [onChangeVariableHandler]);
  React.useEffect(function () {
    if (!isEmpty(selectedDataset)) {
      setIsLoading(true);
      setError(false);
      var qp = {};
      var pp = [selectedDataset];
      var _url = getUrlService('datasets', pp, qp);
      log(_url, 'URL datasets services', 'info');
      fetch(_url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        }
      }).then(function (response) {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 403) {
          var jr = response.json();
          setError(jr.message);
          setIsLoading(false);
          return response.json();
        } else if (response.status === 401) {
          var errmsg = response.statusText || 'No handled error';
          setError(errmsg);
          setIsLoading(false);
          return Promise.reject(new Error(errmsg));
        }
        return response.json();
      }).then(function (json) {
        setIsLoading(false);
        log(json, 'Fetch dataset', 'info');
        if (json.error) {
          setError(json.message);
          setIsLoading(false);
          dispatch({
            type: 'SET_DATASET',
            value: undefined
          });
        } else if (json.data) {
          if (typeof onLoadingDatasets === 'function') {
            onLoadingDatasets(json.data);
          }
          dispatch({
            type: 'SET_DATASETS',
            value: [json.data]
          });
          datasetChangeHandler(json.data);
        }
      })["catch"](function (error) {
        console.error(error);
        setError(error.toString());
        setIsLoading(false);
      });
    }
  }, [selectedDataset]);
  React.useEffect(function () {
    var datasetName = store['dataset']['name'];
    var qp = {};
    var pp = [datasetName, 'derived_variables'];
    var _url = getUrlService('datasets', pp, qp);
    fetch(_url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8'
      }
    }).then(function (response) {
      if (response.status === 200) {
        setActionToDo('put');
        return response.json();
      } else if (response.status === 403) {
        var jr = response.json();
        return response.json();
      } else if (response.status === 401) {
        var errmsg = response.statusText || 'No handled error';
        return Promise.reject(new Error(errmsg));
      } else if (response.status === 404) {
        setActionToDo('post');
      }
      return response.json();
    })["catch"](function (error) {
      console.error(error);
    });
  }, [group]);
  React.useEffect(function () {
    if (trigger) {
      handleSave();
    }
  }, [derivedVariables]);
  React.useEffect(function () {
    if (selectedDataset !== undefined) return null;
    if (!isEmpty(project) && !isEmpty(modeltype) && !isEmpty(type)) {
      setIsLoading(true);
      setError(false);
      var qp = {
        project: project,
        "case": modeltype.toUpperCase(),
        type: type
      };
      var pp = [];
      var _url = getUrlService('datasets', pp, qp);
      log(_url, 'URL datasets services', 'info');
      fetch(_url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        }
      }).then(function (response) {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 403) {
          var jr = response.json();
          setError(jr.message);
          setIsLoading(false);
          return response.json();
        } else if (response.status === 401) {
          var errmsg = response.statusText || 'No handled error';
          setError(errmsg);
          setIsLoading(false);
          return Promise.reject(new Error(errmsg));
        }
        return response.json();
      }).then(function (json) {
        setIsLoading(false);
        log(json, 'Fetch datasets', 'info');
        if (json.error) {
          setError(json.message || json.status);
          setIsLoading(false);
          dispatch({
            type: 'SET_DATASETS',
            value: undefined
          });
        } else if (Array.isArray(json.data)) {
          if (typeof onLoadingDatasets === 'function') {
            onLoadingDatasets(json.data);
          }
          dispatch({
            type: 'SET_DATASETS',
            value: json.data
          });
        } else {
          if (typeof onLoadingDatasets === 'function') {
            onLoadingDatasets([json.data]);
          }
          dispatch({
            type: 'SET_DATASETS',
            value: [json.data]
          });
        }
      })["catch"](function (error) {
        console.error(error);
        setError(error.toString());
        setIsLoading(false);
      });
    }
  }, [onLoadingDatasets, project, modeltype, type]);
  React.useEffect(function () {
    if (Array.isArray(datasets)) {
      if (datasets.length > 0) {
        datasetChangeHandler(datasets[0], datasets);
      }
    }
  }, [datasetChangeHandler, datasets]);
  React.useEffect(function () {
    console.log(currentVariable, 'currentVariablevvv');
    if (Array.isArray(variables)) {
      if (variables.length > 0) {
        var curvar = variables[0].name;
        if (currentVariable && !isEmpty(currentVariable)) {
          curvar = currentVariable;
        } else if (variables.length > 1) {
          var variableTotal = variables.filter(function (varr) {
            return varr.isTotal == 1;
          })[0];
          if (variableTotal) curvar = variableTotal.name;
        }
        setVariable(curvar);
        variableChangeHandler(curvar, variables);
      }
    }
  }, [variableChangeHandler, variables, currentVariable]);
  React.useEffect(function () {
    if (!isEmpty(dataType)) {
      setType(dataType);
    }
  }, [dataType]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, error && /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, t('ControlPanel.Error_loading_message')), withTypeSelect && !error && /*#__PURE__*/React.createElement(FormControl$1, {
    fullWidth: true,
    className: classes.formControl
  }, /*#__PURE__*/React.createElement(FormLabel, {
    className: classes.formLabel
  }, t('ControlPanel.Select_data_type')), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    direction: "column",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    size: "small",
    value: type,
    exclusive: true,
    onChange: function onChange(e, newval) {
      return handleButtonChange(newval, toggleButtons);
    }
  }, toggleButtons && toggleButtons.map(function (but, id) {
    return but.visible && /*#__PURE__*/React.createElement(ToggleButton, {
      disabled: disabled,
      key: id,
      value: but.value,
      className: classes.themeToggleButton
    }, /*#__PURE__*/React.createElement(Typography$1, {
      variant: "button",
      style: {
        textTransform: 'capitalize'
      }
    }, but.label));
  }))))), !error && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormControl$1, {
    className: hidden ? classes.hidden : classes.formControl
  }, /*#__PURE__*/React.createElement(FormLabel, {
    htmlFor: "dataset"
  }, title), isLoading ? /*#__PURE__*/React.createElement(LinearProgress, {
    className: classes.linearProgress
  }) : error ? /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, "Impossible de charger les donn\xE9es.") : dataset && /*#__PURE__*/React.createElement(Select, {
    disabled: disabled,
    value: dataset,
    onChange: function onChange(e) {
      return datasetChangeHandler(e.target.value, datasets);
    },
    inputProps: {
      name: 'dataset',
      id: 'dataset'
    }
  }, datasets && datasets.map(function (dataset, index) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: index,
      value: dataset
    }, dataset.title);
  }))), /*#__PURE__*/React.createElement(FormControl$1, {
    className: classes.formControl,
    key: group
  }, isLoading ? /*#__PURE__*/React.createElement(LinearProgress, {
    className: classes.linearProgress
  }) : error ? /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, "Impossible de charger les variables.") : /*#__PURE__*/React.createElement(Accordion, {
    elevation: 0
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null),
    "aria-controls": "panel1a-content",
    id: "panel1a-header"
  }, /*#__PURE__*/React.createElement(Typography$1, {
    color: "primary"
  }, "List of Source Editors")), /*#__PURE__*/React.createElement(AccordionDetails, null, /*#__PURE__*/React.createElement(Box, {
    sx: {
      mt: 2,
      width: '95%'
    }
  }, derivedVariables && derivedVariables.filter(function (variable) {
    return variable.isTotal === 0 && variable.transform === 1;
  }).length != 0 ? derivedVariables.filter(function (variable) {
    return variable.isTotal === 0 && variable.transform === 1;
  }).map(function (variable, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, /*#__PURE__*/React.createElement(Typography$1, null, variable.title), /*#__PURE__*/React.createElement(Slider, {
      key: index,
      "aria-label": "Restricted values",
      defaultValue: 50,
      step: null,
      marks: marks$1,
      onChange: function onChange(event, newVal) {
        return onCoeffAChange(event, newVal, variable);
      }
    }));
  }) : /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, "Aucune variable pour ce groupe \xE0 ce site"))), externalSourcesButton && /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Switch$1, {
      defaultChecked: true,
      color: "primary",
      onChange: function onChange(e) {
        return changeSwitchValue(e.target.checked);
      }
    }),
    label: t('ControlPanel.Add_external_sources')
  })), /*#__PURE__*/React.createElement(Box, {
    sx: {
      mt: 2,
      width: '95%'
    },
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleSave,
    color: "primary",
    variant: "outlined"
  }, "Apply"))))));
});

var useStyles$S = makeStyles(function (theme) {
  return {
    formControl: {
      margin: theme.spacing(1),
      marginBottom: theme.spacing(2),
      width: '95%',
      minWidth: '50%'
    },
    linearProgress: {
      marginTop: theme.spacing(1)
    },
    themeToggleButton: {
      width: 'auto',
      '&$selected': {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.main
      }
    },
    formLabel: {
      marginBottom: theme.spacing(2)
    },
    hidden: {
      display: 'None'
    }
  };
});
var index$3 = (function (_ref) {
  var title = _ref.title,
    project = _ref.project,
    selectedDataset = _ref.selectedDataset,
    dv_name = _ref.dv_name,
    externalSourcesButton = _ref.externalSourcesButton;
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0],
    dispatch = _useAriaAppStore[1];
  var classes = useStyles$S();
  var _React$useState = React.useState(undefined),
    error = _React$useState[0];
  var _React$useState2 = React.useState(false),
    isLoading = _React$useState2[0];
  var _React$useState3 = React.useState(Date.now()),
    setId = _React$useState3[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var sourcesContributionGroups = store['sources_contribution_groups'];
  var _React$useState4 = React.useState(''),
    group = _React$useState4[0],
    setGroup = _React$useState4[1];
  var groupChangeHandler = useCallback(function (selectedGroup, sources) {
    var gotGroup = selectedGroup;
    if (typeof selectedGroup === 'string' && Array.isArray(sourcesContributionGroups)) {
      gotGroup = sourcesContributionGroups.find(function (v) {
        return v === selectedGroup;
      });
    }
    setGroup(selectedGroup);
    setId(Date.now());
    dispatch({
      type: 'SET_EXTRACTION_ZONES',
      value: {
        infoType: undefined
      }
    });
    dispatch({
      type: 'SET_OPEN_CHART',
      value: 'TIMEFRAME'
    });
  }, []);
  React.useEffect(function () {
    if (Array.isArray(sourcesContributionGroups)) {
      if (sourcesContributionGroups.length > 0) {
        var curGroup = sourcesContributionGroups[0];
        setGroup(curGroup);
      }
    }
  }, [sourcesContributionGroups]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormControl$1, {
    className: classes.formControl
  }, /*#__PURE__*/React.createElement(FormLabel, {
    htmlFor: "group"
  }, t('ControlPanel.List_of_sources_contribution_groups')), isLoading ? /*#__PURE__*/React.createElement(LinearProgress, null) : error ? /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, "Impossible de charger les variables.") : /*#__PURE__*/React.createElement(Select, {
    value: group,
    onChange: function onChange(e) {
      return groupChangeHandler(e.target.value, sourcesContributionGroups);
    }
  }, sourcesContributionGroups && sourcesContributionGroups.map(function (group, index) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: index,
      value: group
    }, group);
  })))), group && /*#__PURE__*/React.createElement(AriaVariableSlider, {
    title: title,
    project: project,
    selectedDataset: selectedDataset,
    dv_name: dv_name,
    hidden: true,
    group: group,
    externalSourcesButton: externalSourcesButton,
    backgroundPollutionButton: backgroundPollutionButton
  }));
});

var useStyles$T = makeStyles(function (theme) {
  return {
    formControl: {
      margin: theme.spacing(1),
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(2),
      width: '90%',
      marginLeft: '5%'
    },
    slider: {
      padding: '10px 0px'
    }
  };
});
var index$4 = (function (_ref) {
  var title = _ref.title,
    onChangeKLevelHandler = _ref.onChangeKLevelHandler;
  var classes = useStyles$T();
  var _useAriaAppStore = useAriaAppStore$1(),
    store = _useAriaAppStore[0],
    dispatch = _useAriaAppStore[1];
  var max = 0;
  var marks = [];
  var klevels = store['dataset'].k_levels;
  var _useState = useState(100 * store['klevel']),
    klevel = _useState[0],
    setKLevel = _useState[1];
  var data_type = store['data_type'];
  if (typeof klevels != 'undefined' && klevels != null) {
    max = Math.max.apply(Math, store['dataset'].k_levels);
    klevels.map(function (k) {
      return marks.push({
        value: k
      });
    });
  }
  var onChangeKLevel = useCallback(function (event, KVal) {
    setKLevel(KVal);
    if (typeof onChangeKLevelHandler === 'function') {
      onChangeKLevelHandler(KVal);
    }
    if (dispatch) {
      dispatch({
        type: 'SET_KLEVEL',
        value: KVal
      });
    }
  }, [onChangeKLevelHandler]);
  return /*#__PURE__*/React.createElement("div", null, typeof klevels != 'undefined' && klevels != null && data_type === 'airq' && /*#__PURE__*/React.createElement(FormControl$1, {
    className: classes.formControl
  }, /*#__PURE__*/React.createElement(FormLabel, {
    id: "klevel-slider"
  }, title), /*#__PURE__*/React.createElement(Slider, {
    value: klevel,
    "aria-labelledby": "klevel-slider",
    onChange: onChangeKLevel,
    className: classes.slider,
    marks: marks,
    min: 0,
    max: max,
    step: null,
    valueLabelDisplay: "auto"
  })));
});

var ExportDataContext$2 = React.createContext([{}, null]);
var contextData$1 = {
  dataset: 'ARIAVIEW_NOSDO_RESULT_LcS',
  site: 'NOSDO',
  chrono: {
    datedeb: {
      value: new Date(1633874400000)
    },
    datefin: {
      value: new Date(1633874400000 + 24 * 60 * 60 * 1000)
    },
    autoValidate: 0
  },
  receptors: {
    'R1': {
      id: 'R1',
      name: 'I.T.S.O.S. "Albe Steiner" - ViaS. Dionigi, Milano',
      x: 517022,
      y: 5031079,
      epsg: 32632
    },
    'R2': {
      id: 'R2',
      name: 'Scuola dell\'infanzia "A.Osimo" - Via A. Osimo, Milano',
      x: 517671,
      y: 5031264,
      epsg: 32632
    },
    'R3': {
      id: 'R3',
      name: 'Scuola Sec. I Grado"Lombardini" - Via Mincio, Milano',
      x: 517073,
      y: 5031756,
      epsg: 32632
    },
    'R4': {
      id: 'R4',
      name: 'Scuola Sec. I grado “A.Toscanini” - Via dei Guarneri, Milano',
      x: 516036,
      y: 5030300,
      epsg: 32632
    },
    'R5': {
      id: 'R5',
      name: 'Scuola Primaria "Wolf Ferrari" - Via E. Wolf Ferrari, Milano',
      x: 516000,
      y: 5030848,
      epsg: 32632
    },
    'R6': {
      id: 'R6',
      name: 'Scuole Paritarie "Regina Mundi" - Via C.Boncompagni, Milano',
      x: 517757,
      y: 5031862,
      epsg: 32632
    },
    'R7': {
      id: 'R7',
      name: 'Abbazia di Chiaravalle - Via Sant\'Arialdo, Milano',
      x: 518450,
      y: 5029243,
      epsg: 32632
    },
    'R8': {
      id: 'R8',
      name: 'Abitazioni - Via F.G. Pizzi, Milano',
      x: 515875,
      y: 5031545,
      epsg: 32632
    },
    'R9': {
      id: 'R9',
      name: 'IEO - Istituto Europeo di Oncologia - Via G.Ripamonti, Milano',
      x: 516256,
      y: 5028980,
      epsg: 32632
    },
    'R10': {
      id: 'R10',
      name: 'Scuola Primaria "M. Candia"- Via Vallarsa, Milano',
      x: 516449,
      y: 5032134,
      epsg: 32632
    },
    'R11': {
      id: 'R11',
      name: 'Abitazioni - Via Z. Bugatto, Milano',
      x: 515452,
      y: 5030662,
      epsg: 32632
    },
    'R12': {
      id: 'R12',
      name: 'Scuola Primaria "R. Pezzani"- Viale Puglie, Milano',
      x: 517582,
      y: 5032373,
      epsg: 32632
    },
    'R13': {
      id: 'R13',
      name: 'I.C. Statale "P. Sottocorno"- Via Monte Piana, Milano',
      x: 519320,
      y: 5030831,
      epsg: 32632
    },
    'R14': {
      id: 'R14',
      name: 'Scuola dell\'Infanzia"Savinio"- Via Savinio, Milano',
      x: 519143,
      y: 5031595,
      epsg: 32632
    },
    'R15': {
      id: 'R15',
      name: 'Scuola Primaria "Antonini"- Via G. Antonini, Milano',
      x: 515217,
      y: 5031502,
      epsg: 32632
    },
    'R16': {
      id: 'R16',
      name: 'Abitazioni - Via Rogoredo, S. Donato Milanese',
      x: 519777,
      y: 5030192,
      epsg: 32632
    },
    'R17': {
      id: 'R17',
      name: 'Abitazioni - Via delle Cascine, fraz. Sorigherio, S. Donato Milanese',
      x: 518177,
      y: 5028150,
      epsg: 32632
    },
    'R18': {
      id: 'R18',
      name: 'Scuola Primaria "S. Giovanni Bosco"- Via L. Sordello, Milano',
      x: 519224,
      y: 5032309,
      epsg: 32632
    },
    'R19': {
      id: 'R19',
      name: 'Scuola Primaria "I. Calvino"- Via Unica Poasco, fraz. Poasco, S. Donato Milanese',
      x: 517998,
      y: 5027654,
      epsg: 32632
    }
  }
};
var ExportReducer$1 = function ExportReducer(state, action) {
  switch (action.type) {
    case 'SET_DATES':
      return Object.assign(_extends({}, state), {
        chrono: _extends({}, state.chrono, {
          datedeb: action.datedeb,
          datefin: action.datefin
        })
      });
    case 'SET_CHRONO':
      return Object.assign(_extends({}, state), {
        chrono: action.value
      });
    case 'SET_AUTO_VALIDATE':
      return Object.assign(_extends({}, state), {
        chrono: _extends({}, state.chrono, {
          autoValidate: action.value
        })
      });
    default:
      {
        throw new Error("Unsupported action type: " + action.type);
      }
  }
};
var ExportDataProvider$1 = function ExportDataProvider(props) {
  var _React$useReducer = React.useReducer(ExportReducer$1, contextData$1),
    store = _React$useReducer[0],
    dispatch = _React$useReducer[1];
  var value = React.useMemo(function () {
    return [store, dispatch];
  }, [store]);
  return /*#__PURE__*/React.createElement(ExportDataContext$2.Provider, _extends({
    value: value
  }, props));
};

var useStyles$U = makeStyles(function (theme) {
  var _chart;
  return {
    hidden: {
      display: 'None'
    },
    bottomLinearProgress: {
      position: 'absolute',
      bottom: 0,
      left: 16,
      zIndex: 1,
      width: '95%'
    },
    chart: (_chart = {
      height: '35vh'
    }, _chart[theme.breakpoints.down('md')] = {
      height: '65vh'
    }, _chart)
  };
});
var DEFAULT_DATASET$4 = {
  label: 'Référence',
  fill: false,
  borderColor: 'rgb(119,136,153)',
  backgroundColor: 'rgb(63, 81, 181)',
  pointBackgroundColor: [],
  pointBorderWidth: 1,
  pointHoverRadius: 6,
  pointHoverBackgroundColor: 'rgba(63, 81, 181, 1.0)',
  pointHoverBorderColor: 'rgb(220,220,220)',
  pointHoverBorderWidth: 2,
  pointRadius: [],
  pointHitRadius: 10,
  data: []
};
var AriaChartReceptors$1 = (function (_ref) {
  var htmlId = _ref.htmlId,
    variable = _ref.variable,
    chrono = _ref.chrono,
    extractionZone = _ref.extractionZone,
    onLoadingChange = _ref.onLoadingChange,
    onDataChange = _ref.onDataChange,
    useContext = _ref.useContext,
    useAriaStore = _ref.useAriaStore,
    options = _ref.options;
  var classes = useStyles$U();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var store = {
      chrono: chrono
    };
  if (useAriaStore) {
    var _useAriaAppStore = useAriaAppStore();
  } else if (useContext) {
    var context = React.useContext(ExportDataContext$2);
    if (!Array.isArray(context)) {
      throw new Error("AriaDatetimeWindowSelect => ExportDataContext return non array object");
    }
    store = context[0];
  }
  log(store, 'Store in AriaChart', 'warning');
  var _React$useState = React.useState(variable || store['variable'] || ''),
    currentVariable = _React$useState[0];
  var _React$useState2 = React.useState('atomic'),
    selectedDataFile = _React$useState2[0];
  var _React$useState3 = React.useState(options),
    chartOptions = _React$useState3[0];
  var getExtractionZone = React.useCallback(function () {
    log(extractionZone, "extractionZone", "error");
    var _extractionZone = undefined;
    if (!isEmpty(extractionZone)) {
      _extractionZone = extractionZone;
    }
    return _extractionZone;
  }, [extractionZone]);
  var _useFetchAria = useFetchAria('points/ts/', [store['dataset']], {
      variables: currentVariable.name,
      epsg: 32632,
      is_atomic: 1,
      start_date: store['chrono'] ? store['chrono'].datedeb.value ? parseTime(store['chrono'].datedeb.value, '{y}-{m}-{d}T{h}:{i}:{s}') : undefined : undefined,
      end_date: store['chrono'] ? store['chrono'].datefin.value ? parseTime(store['chrono'].datefin.value, '{y}-{m}-{d}T{h}:{i}:{s}') : undefined : undefined
    }, {
      method: 'POST',
      body: JSON.stringify(getExtractionZone())
    }, [currentVariable.name, store['chrono'].datedeb.value, store['chrono'].datefin.value, getExtractionZone]),
    isLoading = _useFetchAria.isLoading,
    hasError = _useFetchAria.hasError,
    tsdata = _useFetchAria.response;
  log(tsdata, 'tsdata');
  var computeChartDataset = React.useMemo(function () {
    if (tsdata) {
      var chartData = {
        labels: [],
        datasets: []
      };
      try {
        var varnames = Object.keys(tsdata);
        if (isEmpty(varnames)) return chartData;
        if (varnames.indexOf(currentVariable.name) === -1) return chartData;
        var datafiles = Object.keys(tsdata[currentVariable.name]);
        if (isEmpty(datafiles)) return chartData;
        if (datafiles.indexOf(selectedDataFile) === -1) return chartData;
        var pnts = Object.keys(tsdata[currentVariable.name][selectedDataFile].values);
        if (isEmpty(pnts)) return chartData;
        var tims = tsdata[currentVariable.name][selectedDataFile].times;
        pnts.forEach(function (pnt, id) {
          var vals = tsdata[currentVariable.name][selectedDataFile].values[pnt];
          chartData.datasets.push(Object.assign({}, DEFAULT_DATASET$4));
          var cnt = chartData.datasets.length - 1;
          chartData.datasets[cnt].backgroundColor = "rgb(" + Math.random() * 255 + ", " + Math.random() * 255 + ", " + Math.random() * 255 + ")";
          chartData.datasets[cnt].borderColor = "rgb(" + Math.random() * 255 + ", " + Math.random() * 255 + ", " + Math.random() * 255 + ")";
          if (!chartData.times && chartData.labels.length == 0) {
            chartData.times = tims;
            var timeLabels = tims.map(function (time) {
              return parseTime(time, chartOptions.datetimeFormat);
            });
            chartData.labels = timeLabels;
          }
          chartData.datasets[cnt].data = vals;
          chartData.datasets[cnt].label = "" + pnt;
        });
        return chartData;
      } catch (err) {
        if (process.env.NODE_ENV === 'development') {
          log(err.message, 'Error found in compute the chart data', 'error');
        }
        return chartData;
      }
    } else {
      return DEFAULT_DATASET$4;
    }
  }, [tsdata, currentVariable.name, selectedDataFile, chartOptions]);
  React.useEffect(function () {
    if (computeChartDataset) {
      if (typeof onDataChange === 'function') {
        onDataChange(computeChartDataset);
      }
    }
  }, [computeChartDataset]);
  React.useEffect(function () {
    if (typeof onLoadingChange === 'function') {
      onLoadingChange(isLoading);
    }
  }, [isLoading]);
  return /*#__PURE__*/React.createElement(Paper, {
    elevation: 0,
    className: isLoading ? '' : classes.chart
  }, isLoading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography$1, {
    color: "textSecondary",
    variant: "body1"
  }, t('Chart.Chart_is_loading') + "..."), /*#__PURE__*/React.createElement(LinearProgress, {
    className: classes.linearProgress
  })) : hasError ? /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, t('Chart.Error_loading_message')) : /*#__PURE__*/React.createElement(Line, {
    id: htmlId,
    data: computeChartDataset,
    options: {
      maintainAspectRatio: false,
      responsive: true,
      animation: false,
      title: {
        display: true,
        text: "" + t('ExportDialog.Chart_title')
      },
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: currentVariable.title + ' (' + currentVariable.unit + ')'
          },
          ticks: {
            beginAtZero: true,
            min: 0
          }
        }],
        xAxes: [{
          scaleLabel: {
            display: true,
            labelString: t('Chart.Time')
          }
        }]
      }
    },
    redraw: true
  }));
});

var useStyles$V = makeStyles(function (theme) {
  var _chart;
  return {
    hidden: {
      display: 'None'
    },
    bottomLinearProgress: {
      position: 'absolute',
      bottom: 0,
      left: 16,
      zIndex: 1,
      width: '95%'
    },
    chart: (_chart = {
      height: '35vh'
    }, _chart[theme.breakpoints.down('md')] = {
      height: '65vh'
    }, _chart)
  };
});
var DEFAULT_DATASET$5 = {
  label: 'Référence',
  fill: false,
  borderColor: 'rgb(119,136,153)',
  backgroundColor: 'rgb(63, 81, 181)',
  pointBackgroundColor: [],
  pointBorderWidth: 1,
  pointHoverRadius: 6,
  pointHoverBackgroundColor: 'rgba(63, 81, 181, 1.0)',
  pointHoverBorderColor: 'rgb(220,220,220)',
  pointHoverBorderWidth: 2,
  pointRadius: [],
  pointHitRadius: 10,
  data: []
};
var AriaChartObservations$1 = (function (_ref) {
  var htmlId = _ref.htmlId,
    variable = _ref.variable,
    chrono = _ref.chrono,
    extractionZone = _ref.extractionZone,
    onLoadingChange = _ref.onLoadingChange,
    onDataChange = _ref.onDataChange,
    useContext = _ref.useContext,
    useAriaStore = _ref.useAriaStore,
    options = _ref.options;
  var classes = useStyles$V();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var store = {
      chrono: chrono
    };
  if (useAriaStore) {
    var _useAriaAppStore = useAriaAppStore();
  } else if (useContext) {
    var context = React.useContext(ExportDataContext$2);
    if (!Array.isArray(context)) {
      throw new Error("AriaDatetimeWindowSelect => ExportDataContext return non array object");
    }
    store = context[0];
  }
  log(store, 'Store in AriaChart', 'warning');
  var _React$useState = React.useState(variable || store['variable'] || ''),
    currentVariable = _React$useState[0];
  var _React$useState2 = React.useState('atomic'),
    selectedDataFile = _React$useState2[0];
  var _React$useState3 = React.useState(options),
    chartOptions = _React$useState3[0];
  var getExtractionZone = React.useCallback(function () {
    log(extractionZone, "extractionZone", "error");
    var _extractionZone = undefined;
    if (!isEmpty(extractionZone)) {
      _extractionZone = extractionZone;
    }
    return _extractionZone;
  }, [extractionZone]);
  var getObservationSensors = React.useMemo(function () {
    var _extractionZone = undefined;
    if (!isEmpty(extractionZone)) {
      _extractionZone = Object.keys(extractionZone);
      _extractionZone = _extractionZone.join("#");
    }
    return _extractionZone;
  }, [extractionZone]);
  var _useFetchAria = useFetchAria('ariaview/observations', [], {
      epsg: 32632,
      is_atomic: 1,
      site: store['site'],
      obs_type: 'aq',
      timezone: store["timezone"],
      stations: getObservationSensors,
      start_date: store['chrono'] ? store['chrono'].datedeb.value ? parseTime(store['chrono'].datedeb.value, '{y}-{m}-{d}T{h}:{i}:{s}') : undefined : undefined,
      end_date: store['chrono'] ? store['chrono'].datefin.value ? parseTime(store['chrono'].datefin.value, '{y}-{m}-{d}T{h}:{i}:{s}') : undefined : undefined
    }, {
      method: 'GET',
      body: JSON.stringify(getExtractionZone())
    }, [currentVariable.name, store['chrono'].datedeb.value, store['chrono'].datefin.value, getExtractionZone, getObservationSensors]),
    isLoading = _useFetchAria.isLoading,
    hasError = _useFetchAria.hasError,
    tsdata = _useFetchAria.response;
  log(tsdata, 'tsdata');
  var computeChartDataset = React.useMemo(function () {
    if (tsdata) {
      var chartData = {
        labels: [],
        datasets: []
      };
      try {
        var varnames = Object.keys(tsdata);
        if (isEmpty(varnames)) return chartData;
        if (varnames.indexOf(currentVariable.name) === -1) return chartData;
        var datafiles = Object.keys(tsdata[currentVariable.name]);
        if (isEmpty(datafiles)) return chartData;
        if (datafiles.indexOf(selectedDataFile) === -1) return chartData;
        var pnts = Object.keys(tsdata[currentVariable.name][selectedDataFile].values);
        if (isEmpty(pnts)) return chartData;
        var tims = tsdata[currentVariable.name][selectedDataFile].times;
        pnts.forEach(function (pnt, id) {
          var vals = tsdata[currentVariable.name][selectedDataFile].values[pnt];
          chartData.datasets.push(Object.assign({}, DEFAULT_DATASET$5));
          var cnt = chartData.datasets.length - 1;
          chartData.datasets[cnt].backgroundColor = "rgb(" + Math.random() * 255 + ", " + Math.random() * 255 + ", " + Math.random() * 255 + ")";
          chartData.datasets[cnt].borderColor = "rgb(" + Math.random() * 255 + ", " + Math.random() * 255 + ", " + Math.random() * 255 + ")";
          if (!chartData.times && chartData.labels.length == 0) {
            chartData.times = tims;
            var timeLabels = tims.map(function (time) {
              return parseTime(time, chartOptions.datetimeFormat);
            });
            chartData.labels = timeLabels;
          }
          chartData.datasets[cnt].data = vals;
          chartData.datasets[cnt].label = "" + pnt;
        });
        return chartData;
      } catch (err) {
        if (process.env.NODE_ENV === 'development') {
          log(err.message, 'Error found in compute the chart data', 'error');
        }
        return chartData;
      }
    } else {
      return DEFAULT_DATASET$5;
    }
  }, [tsdata, currentVariable.name, selectedDataFile, chartOptions]);
  React.useEffect(function () {
    if (computeChartDataset) {
      if (typeof onDataChange === 'function') {
        onDataChange(computeChartDataset);
      }
    }
  }, [computeChartDataset]);
  React.useEffect(function () {
    if (typeof onLoadingChange === 'function') {
      onLoadingChange(isLoading);
    }
  }, [isLoading]);
  return /*#__PURE__*/React.createElement(Paper, {
    elevation: 0,
    className: isLoading ? '' : classes.chart
  }, isLoading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography$1, {
    color: "textSecondary",
    variant: "body1"
  }, t('Chart.Chart_is_loading') + "..."), /*#__PURE__*/React.createElement(LinearProgress, {
    className: classes.linearProgress
  })) : hasError ? /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, t('Chart.Error_loading_message')) : /*#__PURE__*/React.createElement(Line, {
    id: htmlId,
    data: computeChartDataset,
    options: {
      maintainAspectRatio: false,
      responsive: true,
      animation: false,
      title: {
        display: true,
        text: "" + t('ExportDialog.Chart_title')
      },
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: currentVariable.title + ' (' + currentVariable.unit + ')'
          },
          ticks: {
            beginAtZero: true,
            min: 0
          }
        }],
        xAxes: [{
          scaleLabel: {
            display: true,
            labelString: t('Chart.Time')
          }
        }]
      }
    },
    redraw: true
  }));
});

var useStyles$W = makeStyles(function (theme) {
  var _chart;
  return {
    hidden: {
      display: 'None'
    },
    bottomLinearProgress: {
      position: 'absolute',
      bottom: 0,
      left: 16,
      zIndex: 1,
      width: '95%'
    },
    chart: (_chart = {
      height: '35vh'
    }, _chart[theme.breakpoints.down('md')] = {
      height: '65vh'
    }, _chart)
  };
});
var DEFAULT_DATASET$6 = {
  label: 'Référence',
  fill: false,
  borderColor: 'rgb(119,136,153)',
  backgroundColor: 'rgb(63, 81, 181)',
  pointBackgroundColor: [],
  pointBorderWidth: 1,
  pointHoverRadius: 6,
  pointHoverBackgroundColor: 'rgba(63, 81, 181, 1.0)',
  pointHoverBorderColor: 'rgb(220,220,220)',
  pointHoverBorderWidth: 2,
  pointRadius: [],
  pointHitRadius: 10,
  data: []
};
var AriaChartWeather$1 = (function (_ref) {
  var htmlId = _ref.htmlId,
    variable = _ref.variable,
    chrono = _ref.chrono,
    apiService = _ref.apiService,
    extractionZone = _ref.extractionZone,
    onLoadingChange = _ref.onLoadingChange,
    onDataChange = _ref.onDataChange,
    useContext = _ref.useContext,
    useAriaStore = _ref.useAriaStore,
    options = _ref.options;
  var classes = useStyles$W();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var store = {
      chrono: chrono
    };
  if (useAriaStore) {
    var _useAriaAppStore = useAriaAppStore();
  } else if (useContext) {
    var context = React.useContext(ExportDataContext$2);
    if (!Array.isArray(context)) {
      throw new Error("AriaDatetimeWindowSelect => ExportDataContext return non array object");
    }
    store = context[0];
  }
  log(store, 'Store in AriaChart', 'warning');
  var _React$useState = React.useState(variable || store['variable'] || ''),
    currentVariable = _React$useState[0];
  var _React$useState2 = React.useState('atomic'),
    selectedDataFile = _React$useState2[0];
  var _React$useState3 = React.useState(options),
    chartOptions = _React$useState3[0];
  var getExtractionZone = React.useCallback(function () {
    log(extractionZone, "extractionZone", "error");
    var _extractionZone = undefined;
    if (!isEmpty(extractionZone)) {
      _extractionZone = extractionZone;
    }
    return _extractionZone;
  }, [extractionZone]);
  var _useFetchAria = useFetchAria('ariaview/observations', [], {
      epsg: 32632,
      is_atomic: 1,
      site: store['site'],
      obs_type: 'met',
      timezone: store["timezone"],
      start_date: store['chrono'] ? store['chrono'].datedeb.value ? parseTime(store['chrono'].datedeb.value, '{y}-{m}-{d}T{h}:{i}:{s}') : undefined : undefined,
      end_date: store['chrono'] ? store['chrono'].datefin.value ? parseTime(store['chrono'].datefin.value, '{y}-{m}-{d}T{h}:{i}:{s}') : undefined : undefined
    }, {
      method: 'GET',
      body: JSON.stringify(getExtractionZone())
    }, [currentVariable.name, store['chrono'].datedeb.value, store['chrono'].datefin.value, getExtractionZone, apiService]),
    isLoading = _useFetchAria.isLoading,
    hasError = _useFetchAria.hasError,
    tsdata = _useFetchAria.response;
  log(tsdata, 'tsdata');
  var computeChartDataset = React.useMemo(function () {
    if (tsdata) {
      var chartData = {
        labels: [],
        datasets: []
      };
      try {
        var varnames = Object.keys(tsdata);
        if (isEmpty(varnames)) return chartData;
        if (varnames.indexOf(currentVariable.name) === -1) return chartData;
        var datafiles = Object.keys(tsdata[currentVariable.name]);
        if (isEmpty(datafiles)) return chartData;
        if (datafiles.indexOf(selectedDataFile) === -1) return chartData;
        var pnts = Object.keys(tsdata[currentVariable.name][selectedDataFile].values);
        if (isEmpty(pnts)) return chartData;
        var tims = tsdata[currentVariable.name][selectedDataFile].times;
        pnts.forEach(function (pnt, id) {
          var vals = tsdata[currentVariable.name][selectedDataFile].values[pnt];
          chartData.datasets.push(Object.assign({}, DEFAULT_DATASET$6));
          var cnt = chartData.datasets.length - 1;
          chartData.datasets[cnt].backgroundColor = "rgb(" + Math.random() * 255 + ", " + Math.random() * 255 + ", " + Math.random() * 255 + ")";
          chartData.datasets[cnt].borderColor = "rgb(" + Math.random() * 255 + ", " + Math.random() * 255 + ", " + Math.random() * 255 + ")";
          if (!chartData.times && chartData.labels.length == 0) {
            chartData.times = tims;
            var timeLabels = tims.map(function (time) {
              return parseTime(time, chartOptions.datetimeFormat);
            });
            chartData.labels = timeLabels;
          }
          chartData.datasets[cnt].data = vals;
          chartData.datasets[cnt].label = "" + pnt;
        });
        return chartData;
      } catch (err) {
        if (process.env.NODE_ENV === 'development') {
          log(err.message, 'Error found in compute the chart data', 'error');
        }
        return chartData;
      }
    } else {
      return DEFAULT_DATASET$6;
    }
  }, [tsdata, currentVariable.name, selectedDataFile, chartOptions]);
  React.useEffect(function () {
    if (computeChartDataset) {
      if (typeof onDataChange === 'function') {
        onDataChange(computeChartDataset);
      }
    }
  }, [computeChartDataset]);
  React.useEffect(function () {
    if (typeof onLoadingChange === 'function') {
      onLoadingChange(isLoading);
    }
  }, [isLoading]);
  return /*#__PURE__*/React.createElement(Paper, {
    elevation: 0,
    className: isLoading ? '' : classes.chart
  }, isLoading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography$1, {
    color: "textSecondary",
    variant: "body1"
  }, t('Chart.Chart_is_loading') + "..."), /*#__PURE__*/React.createElement(LinearProgress, {
    className: classes.linearProgress
  })) : hasError ? /*#__PURE__*/React.createElement(Typography$1, {
    color: "error",
    variant: "caption"
  }, t('Chart.Error_loading_message')) : /*#__PURE__*/React.createElement(Line, {
    id: htmlId,
    data: computeChartDataset,
    options: {
      maintainAspectRatio: false,
      responsive: true,
      animation: false,
      title: {
        display: true,
        text: "" + t('ExportDialog.Chart_title')
      },
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: currentVariable.title + ' (' + currentVariable.unit + ')'
          },
          ticks: {
            beginAtZero: true,
            min: 0
          }
        }],
        xAxes: [{
          scaleLabel: {
            display: true,
            labelString: t('Chart.Time')
          }
        }]
      }
    },
    redraw: true
  }));
});

function write2Image$2(canvasId) {
  var canvas = document.getElementById(canvasId);
  var context = canvas.getContext('2d');
  context.fillStyle = 'gray';
  var url_base64png = canvas.toDataURL('image/png');
  var link = document.getElementById('download');
  if (!link) {
    link = document.createElement('a');
    link.setAttribute('id', 'download');
  }
  link.download = "ChartImage.png";
  link.href = url_base64png;
  link.click();
}
function writeToCSVLine$2(chartData, variable, typeGraphic) {
  log(chartData, 'chartData');
  var csvContent = [];
  csvContent[0] = [];
  var header = ['id', 'name', 'timeserie', 'location', 'geometry'];
  var datasets = chartData.datasets;
  var timeframes = chartData.times;
  var markers = [];
  datasets.forEach(function (ds) {
    markers.push({
      label: ds.label
    });
  });
  var varlabel = variable ? variable.title || 'variable' : 'variable';
  if (typeGraphic === 'boxplot') {
    header.push(varname + "_min");
    header.push(varname + "_max");
    header.push(varname + "_mediane");
    header.push(varname + "_q1");
    header.push(varname + "_q3");
  } else {
    header.push(varlabel);
  }
  csvContent[0] = header;
  var il = 0;
  var _loop = function _loop() {
    var lat = null;
    var lng = null;
    var loc = '-';
    var geom = '-';
    try {
      geom = 'POINT';
      lat = im.lat ? im.lat.toFixed(5) : '-';
      lng = im.lon ? im.lon.toFixed(5) : '-';
      loc = "[" + lat + ", " + lng + "]";
    } catch (e) {}
    if (typeGraphic === 'line' || typeGraphic === 'season_cycle') ; else if (typeGraphic === 'boxplot') ; else {
      datasets.forEach(function (ds) {
        var dat = ds.data;
        var lbl = ds.label;
        dat.forEach(function (d, di) {
          il++;
          csvContent[il] = [];
          var dtstr = parseTime(timeframes[di], '{y}-{m}-{d} {h}h');
          var dline = [il, lbl, dtstr, loc, geom, d.toFixed(3)];
          csvContent[il] = dline;
        });
      });
    }
  };
  for (var im in markers) {
    _loop();
  }
  var fileContent = '';
  csvContent.forEach(function (line, id) {
    fileContent += line.join(';') + '\r\n';
  });
  writeContentToFile$2(fileContent, 'csv');
}
function writeContentToFile$2(csvContent, fileType) {
  var type = fileType || 'csv';
  var blob = new Blob([csvContent], {
    encoding: 'UTF-8',
    type: 'text/' + type + ';charset=UTF-8'
  });
  if (Browser.ie) {
    window.navigator.msSaveBlob(blob, 'timeseries.' + type);
  } else {
    var url = URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'timeseries.' + type);
    var clickEvent = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: false
    });
    link.dispatchEvent(clickEvent);
  }
}

var useStyles$X = makeStyles(function (theme) {
  return {
    formControl: {
      margin: theme.spacing(1),
      marginBottom: theme.spacing(2),
      width: '100%',
      minWidth: '50%'
    },
    selectEmpty: {
      marginTop: theme.spacing(2)
    },
    hidden: {
      display: 'None'
    }
  };
});
var ZONETYPES$1 = [{
  value: 'receptors',
  label: 'Receptors'
}, {
  value: 'emission_sensors',
  label: 'Observations'
}, {
  value: 'weather_sensors',
  label: 'Weathers'
}];
var index$5 = (function (_ref) {
  var title = _ref.title,
    opened = _ref.opened,
    onCloseCallback = _ref.onCloseCallback,
    useAriaStore = _ref.useAriaStore;
  var classes = useStyles$X();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var chartHtmlId = 'chart-export-dialog';
  var theme = useTheme();
  var fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  var store = {};
  if (useAriaStore) {
    var _useAriaAppStore = useAriaAppStore();
    store = _useAriaAppStore[0];
  }
  log(store, 'Store in AriaExportDialog', 'error');
  var _React$useState = React.useState(false),
    open = _React$useState[0],
    setOpen = _React$useState[1];
  var _useState = useState(false),
    chartIsLoading = _useState[0],
    setChartIsLoading = _useState[1];
  var _useState2 = useState(undefined),
    chartData = _useState2[0],
    setChartData = _useState2[1];
  var _React$useState2 = React.useState("receptors"),
    zoneType = _React$useState2[0],
    setZoneType = _React$useState2[1];
  var _React$useState3 = React.useState([]),
    exportVariables = _React$useState3[0],
    setExportVariables = _React$useState3[1];
  var _React$useState4 = React.useState(undefined),
    exportVariable = _React$useState4[0],
    setExportVariable = _React$useState4[1];
  React.useEffect(function () {
    setOpen(opened);
  }, [opened]);
  var handleClose = function handleClose() {
    setOpen(false);
    if (typeof onCloseCallback === 'function') {
      onCloseCallback(false);
    }
  };
  var validateDateChangeHandler = function validateDateChangeHandler() {};
  var onChartLoadingChangeHandler = React.useCallback(function (isLoading) {
    setChartIsLoading(isLoading);
  }, []);
  var onSaveImageClickHandler = React.useCallback(function (e) {
    if (!isEmpty(chartHtmlId)) {
      write2Image$2(chartHtmlId);
    }
  }, [chartHtmlId]);
  var onSaveChartDataHandler = React.useCallback(function () {
    var grpData = chartData;
    if (grpData && !isEmpty(exportVariable)) {
      writeToCSVLine$2(grpData, exportVariable);
    }
  }, [chartData, exportVariable]);
  var onChartDataChangeHandler = React.useCallback(function (cData) {
    setChartData(cData);
  }, []);
  var onSelectZoneTypeHandler = React.useCallback(function (zType) {
    setZoneType(zType);
  }, []);
  var onSelectVariableHandler = React.useCallback(function (evar) {
    if (Array.isArray(exportVariables) && exportVariables.length > 0) {
      var found = exportVariables.find(function (_var) {
        return _var.value === evar;
      });
      if (Array.isArray(found)) {
        setExportVariable(found[0]);
      }
    }
  }, [exportVariables]);
  log(exportVariable, 'exportVariable');
  log(exportVariables, 'exportVariables');
  React.useEffect(function () {
    console.log("*******ZONETYPE*******", zoneType);
    if (zoneType === 'receptors') {
      log(store['dataset'], 'STORE DATASET', 'error');
      if (store['dataset'] && store['dataset'].variables) {
        var vars = store['dataset'].variables.map(function (v) {
          return {
            value: v.name,
            unit: v.unit,
            title: v.title
          };
        });
        if (vars.length > 0) {
          setExportVariables(vars);
        }
      }
    }
  }, [zoneType, store['dataset']]);
  log(zoneType, 'zoneType');
  return /*#__PURE__*/React.createElement(ExportDataProvider$1, null, /*#__PURE__*/React.createElement(Dialog, {
    fullScreen: fullScreen,
    open: open,
    onClose: handleClose,
    "aria-labelledby": "form-dialog-title"
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    id: "form-dialog-title"
  }, title), /*#__PURE__*/React.createElement(DialogContent, {
    dividers: true,
    style: {
      overflowY: 'auto'
    }
  }, /*#__PURE__*/React.createElement(MuiPickersUtilsProvider, {
    utils: MomentUtils
  }, /*#__PURE__*/React.createElement(AriaDatetimeWindowSelect, {
    title: t('ExportDialog.Timewindow_selector_title'),
    disabled: chartIsLoading,
    dataContext: ExportDataContext$2,
    onValidateCallback: validateDateChangeHandler
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 1,
    alignItems: "flex-start",
    justifyContent: "center",
    className: classes.pickers
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(AriaSelect, {
    label: t('ExportDialog.Select_data_type'),
    fullWidth: true,
    options: ZONETYPES$1,
    selected: zoneType,
    onSelectHandler: onSelectZoneTypeHandler
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(AriaSelect, {
    label: t('ExportDialog.Select_variable'),
    fullWidth: true,
    options: exportVariables,
    selected: exportVariable,
    onSelectHandler: onSelectVariableHandler
  }))), zoneType === 'receptors' && /*#__PURE__*/React.createElement(AriaChartReceptors$1, {
    htmlId: chartHtmlId,
    variable: exportVariable,
    extractionZone: store[zoneType],
    useContext: true,
    options: {
      datetimeFormat: '{y}-{m}-{d} {h}h'
    },
    onLoadingChange: onChartLoadingChangeHandler,
    onDataChange: onChartDataChangeHandler
  }), zoneType === 'emission_sensors' && /*#__PURE__*/React.createElement(AriaChartObservations$1, {
    htmlId: chartHtmlId,
    variable: exportVariable,
    extractionZone: store[zoneType],
    useContext: true,
    options: {
      datetimeFormat: '{y}-{m}-{d} {h}h'
    },
    onLoadingChange: onChartLoadingChangeHandler,
    onDataChange: onChartDataChangeHandler
  }), zoneType === 'weather_sensors' && /*#__PURE__*/React.createElement(AriaChartWeather$1, {
    htmlId: chartHtmlId,
    variable: exportVariable,
    extractionZone: store[zoneType],
    useContext: true,
    options: {
      datetimeFormat: '{y}-{m}-{d} {h}h'
    },
    onLoadingChange: onChartLoadingChangeHandler,
    onDataChange: onChartDataChangeHandler
  })), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement("label", {
    htmlFor: "icon-cancel-button"
  }, /*#__PURE__*/React.createElement(IconButton, {
    color: "primary",
    "aria-label": "Cancel button",
    component: "span",
    onClick: handleClose
  }, /*#__PURE__*/React.createElement(CancelIcon, null))), /*#__PURE__*/React.createElement("label", {
    htmlFor: "icon-save-csv-button"
  }, /*#__PURE__*/React.createElement(IconButton, {
    color: "primary",
    "aria-label": "Save picture",
    component: "span",
    onClick: onSaveChartDataHandler
  }, /*#__PURE__*/React.createElement(TimelineIcon, null))), /*#__PURE__*/React.createElement("label", {
    htmlFor: "icon-save-image-button"
  }, /*#__PURE__*/React.createElement(IconButton, {
    color: "primary",
    "aria-label": "Save picture",
    component: "span",
    onClick: onSaveImageClickHandler
  }, /*#__PURE__*/React.createElement(PhotoCamera, null))))));
});

var useStyles$Y = makeStyles(function (theme) {
  return {
    formControl: {
      margin: theme.spacing(1),
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(2),
      width: '90%',
      marginLeft: '5%'
    },
    slider: {
      padding: '10px 0px'
    }
  };
});
var index$6 = (function (_ref) {
  var title = _ref.title;
  var _useAriaAppStore = useAriaAppStore(),
    store = _useAriaAppStore[0],
    dispatch = _useAriaAppStore[1];
  var data_type = store['data_type'];
  var classes = useStyles$Y();
  var _React$useState = React.useState(false),
    windAnimation = _React$useState[0],
    setWindAnimation = _React$useState[1];
  React.useEffect(function () {
    setTimeout(function () {
      dispatch({
        type: 'SET_WIND_ANIMATION',
        value: windAnimation
      });
    }, 100);
  }, [windAnimation]);
  return /*#__PURE__*/React.createElement(FormControl, {
    className: classes.formControl
  }, /*#__PURE__*/React.createElement(FormLabel$1, {
    id: "wind-tail"
  }, title), data_type === 'met' && /*#__PURE__*/React.createElement(FormControlLabel$1, {
    value: "top",
    control: /*#__PURE__*/React.createElement(Switch, {
      size: "small",
      color: "primary",
      checked: windAnimation,
      onChange: function onChange(e) {
        return setWindAnimation(e.target.checked);
      }
    }),
    label: "Wind Tails",
    labelPlacement: "top"
  }));
});

export { index$3 as AriaAnalyzeOnline, AriaApp, AriaAppBar, AriaAppStoreProvider, AriaComplainHistory, AriaControlLayout, AriaControlPanel, index$1 as AriaDataLayer, AriaDatasetSelect, AriaDatePicker, AriaDateSelect, AriaDatetimeWindowSelect, index$5 as AriaExportDialog, index$4 as AriaKLevelSelect, AriaLayout, LogIn as AriaLogin, AriaLogo, AriaMap, AriaMapLayout, AriaOpacitySlider, index$2 as AriaPointLayer, AriaRadioInput, AriaSelect, AriaSiteSelect, AriaSources, theme as AriaTheme, TimeSliderControl as AriaTimeSliderControl, TimelineControl as AriaTimelineControl, index$6 as AriaWindTail, getToken, getUser, useAriaAppStore, index as utils };
//# sourceMappingURL=index.modern.js.map
